(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[34],{

/***/ 25640:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(88187);
var icon = __webpack_require__(82402);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(71993);
__webpack_require__(24774);

const ARROW_LEFT = 'M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z';
const IconArrowLeft = lib.variant('IconArrowLeft', icon.Icon, {
    path: ARROW_LEFT,
});

exports.D = IconArrowLeft;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 64459:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(88187);
var icon = __webpack_require__(82402);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(71993);
__webpack_require__(24774);

const FULLSCREEN_EXIT = 'M14,14H19V16H16V19H14V14M5,14H10V19H8V16H5V14M8,5H10V10H5V8H8V5M19,8V10H14V5H16V8H19Z';
const IconFullscreenExit = lib.variant('IconFullscreenExit', icon.Icon, {
    path: FULLSCREEN_EXIT,
});

exports.Q = IconFullscreenExit;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 54234:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(88187);
var icon = __webpack_require__(82402);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(71993);
__webpack_require__(24774);

const SHOPPING_CART = 'M17.4173 17.4087C17.9065 17.4087 18.3237 17.5889 18.6691 17.9495C19.0144 18.3101 19.187 18.7356 19.187 19.226C19.187 19.7163 19.0144 20.1346 18.6691 20.4808C18.3237 20.8269 17.9065 21 17.4173 21C16.9281 21 16.5036 20.8269 16.1439 20.4808C15.7842 20.1346 15.6043 19.7163 15.6043 19.226C15.6043 18.7356 15.7842 18.3101 16.1439 17.9495C16.5036 17.5889 16.9281 17.4087 17.4173 17.4087ZM3 3H5.95683L6.79856 4.77404H20.1151C20.3597 4.77404 20.5683 4.86418 20.741 5.04447C20.9137 5.22476 21 5.44471 21 5.70433C21 5.86298 20.9568 6 20.8705 6.11538L17.6763 11.9567C17.518 12.2308 17.2986 12.4543 17.018 12.6274C16.7374 12.8005 16.4317 12.887 16.1007 12.887H9.41007L8.61151 14.3582L8.56835 14.488C8.56835 14.5457 8.58993 14.5962 8.63309 14.6394C8.67626 14.6827 8.72662 14.7043 8.78417 14.7043H19.187V16.5216H8.39568C7.90647 16.5216 7.48921 16.3413 7.14388 15.9808C6.79856 15.6202 6.6259 15.1947 6.6259 14.7043C6.6259 14.4303 6.69784 14.149 6.84173 13.8606L8.05036 11.6106L4.81295 4.77404H3V3ZM8.39568 17.4087C8.88489 17.4087 9.30935 17.5889 9.66906 17.9495C10.0288 18.3101 10.2086 18.7356 10.2086 19.226C10.2086 19.7163 10.0288 20.1346 9.66906 20.4808C9.30935 20.8269 8.88489 21 8.39568 21C7.90647 21 7.48921 20.8269 7.14388 20.4808C6.79856 20.1346 6.6259 19.7163 6.6259 19.226C6.6259 18.7356 6.79856 18.3101 7.14388 17.9495C7.48921 17.5889 7.90647 17.4087 8.39568 17.4087Z';
const IconShoppingCart = lib.variant('IconShoppingCart', icon.Icon, {
    path: SHOPPING_CART,
});

exports.w = IconShoppingCart;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 20403:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(88187);
var icon = __webpack_require__(82402);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(71993);
__webpack_require__(24774);

const STAR = 'M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z';
const IconStar = lib.variant('IconStar', icon.Icon, {
    path: STAR,
});

exports.G = IconStar;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 41782:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(88187);
var icon = __webpack_require__(82402);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(71993);
__webpack_require__(24774);

const TRASH = 'M8.58008 2H15.4441L16.5714 3.10257H20V5.3077H4V3.10257H7.42857L8.58008 2ZM18.8891 6.41027H5.14286V19.3538C5.14286 20.8153 6.32759 22 7.78902 22H16.243C17.7044 22 18.8891 20.8153 18.8891 19.3538V6.41027Z';
const IconTrash = lib.variant('IconTrash', icon.Icon, {
    path: TRASH,
});

exports.I = IconTrash;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 73490:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(88187);
var icon = __webpack_require__(82402);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(71993);
__webpack_require__(24774);

const VIEW_COMPACT_LIST = 'M3 3.5C3 3.22386 3.22386 3 3.5 3H7.5C7.77614 3 8 3.22386 8 3.5V7.15C8 7.42614 7.77614 7.65 7.5 7.65H3.5C3.22386 7.65 3 7.42614 3 7.15V3.5Z M10 3.5C10 3.22386 10.2239 3 10.5 3H20.5C20.7761 3 21 3.22386 21 3.5V7.15C21 7.42614 20.7761 7.65 20.5 7.65H10.5C10.2239 7.65 10 7.42614 10 7.15V3.5Z M3 10.15C3 9.87385 3.22386 9.64999 3.5 9.64999H7.5C7.77614 9.64999 8 9.87385 8 10.15V13.8C8 14.0761 7.77614 14.3 7.5 14.3H3.5C3.22386 14.3 3 14.0761 3 13.8V10.15Z M10 10.15C10 9.87385 10.2239 9.64999 10.5 9.64999H20.5C20.7761 9.64999 21 9.87385 21 10.15V13.8C21 14.0761 20.7761 14.3 20.5 14.3H10.5C10.2239 14.3 10 14.0761 10 13.8V10.15Z M3 16.8C3 16.5238 3.22386 16.3 3.5 16.3H7.5C7.77614 16.3 8 16.5238 8 16.8V20.45C8 20.7261 7.77614 20.95 7.5 20.95H3.5C3.22386 20.95 3 20.7261 3 20.45V16.8Z M10 16.8C10 16.5238 10.2239 16.3 10.5 16.3H20.5C20.7761 16.3 21 16.5238 21 16.8V20.45C21 20.7261 20.7761 20.95 20.5 20.95H10.5C10.2239 20.95 10 20.7261 10 20.45V16.8Z';
const IconViewCompactList = lib.variant('IconViewCompactList', icon.Icon, {
    path: VIEW_COMPACT_LIST,
});

exports.e = IconViewCompactList;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 89593:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(88187);
var icon = __webpack_require__(82402);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(71993);
__webpack_require__(24774);

const VIEW_GRID = 'M4 3C3.44772 3 3 3.44772 3 4V10C3 10.5523 3.44772 11 4 11H10C10.5523 11 11 10.5523 11 10V4C11 3.44772 10.5523 3 10 3H4ZM14 3C13.4477 3 13 3.44772 13 4V10C13 10.5523 13.4477 11 14 11H20C20.5523 11 21 10.5523 21 10V4C21 3.44772 20.5523 3 20 3H14ZM3 14C3 13.4477 3.44772 13 4 13H10C10.5523 13 11 13.4477 11 14V20C11 20.5523 10.5523 21 10 21H4C3.44772 21 3 20.5523 3 20V14ZM14 13C13.4477 13 13 13.4477 13 14V20C13 20.5523 13.4477 21 14 21H20C20.5523 21 21 20.5523 21 20V14C21 13.4477 20.5523 13 20 13H14Z';
const IconViewGrid = lib.variant('IconViewGrid', icon.Icon, {
    path: VIEW_GRID,
});

exports.M = IconViewGrid;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 87269:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 88987:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hashClear = __webpack_require__(71519),
    hashDelete = __webpack_require__(82999),
    hashGet = __webpack_require__(76111),
    hashHas = __webpack_require__(50506),
    hashSet = __webpack_require__(80845);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 175:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var listCacheClear = __webpack_require__(2173),
    listCacheDelete = __webpack_require__(33752),
    listCacheGet = __webpack_require__(10548),
    listCacheHas = __webpack_require__(63410),
    listCacheSet = __webpack_require__(3564);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 35922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 9440:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var mapCacheClear = __webpack_require__(7140),
    mapCacheDelete = __webpack_require__(56504),
    mapCacheGet = __webpack_require__(88833),
    mapCacheHas = __webpack_require__(80953),
    mapCacheSet = __webpack_require__(70724);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 6795:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 81956:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 78188:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var MapCache = __webpack_require__(9440),
    setCacheAdd = __webpack_require__(96659),
    setCacheHas = __webpack_require__(97230);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 5929:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175),
    stackClear = __webpack_require__(40551),
    stackDelete = __webpack_require__(4090),
    stackGet = __webpack_require__(47694),
    stackHas = __webpack_require__(86220),
    stackSet = __webpack_require__(68958);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 92210:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(29165);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 69477:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 48969:
/***/ ((module) => {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 45170:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIndexOf = __webpack_require__(13807);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ 94936:
/***/ ((module) => {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ 79809:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseTimes = __webpack_require__(39739),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isBuffer = __webpack_require__(61563),
    isIndex = __webpack_require__(91010),
    isTypedArray = __webpack_require__(73806);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 75697:
/***/ ((module) => {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 28486:
/***/ ((module) => {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 49499:
/***/ ((module) => {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 62718:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var eq = __webpack_require__(42448);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 92504:
/***/ ((module) => {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 97499:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var castPath = __webpack_require__(60399),
    toKey = __webpack_require__(77817);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 38084:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayPush = __webpack_require__(28486),
    isArray = __webpack_require__(24669);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 71664:
/***/ ((module) => {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 13807:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseFindIndex = __webpack_require__(92504),
    baseIsNaN = __webpack_require__(99940),
    strictIndexOf = __webpack_require__(3729);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 84742:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 6620:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsEqualDeep = __webpack_require__(83977),
    isObjectLike = __webpack_require__(55073);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 83977:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Stack = __webpack_require__(5929),
    equalArrays = __webpack_require__(22684),
    equalByTag = __webpack_require__(7456),
    equalObjects = __webpack_require__(18120),
    getTag = __webpack_require__(81887),
    isArray = __webpack_require__(24669),
    isBuffer = __webpack_require__(61563),
    isTypedArray = __webpack_require__(73806);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 27122:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Stack = __webpack_require__(5929),
    baseIsEqual = __webpack_require__(6620);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 99940:
/***/ ((module) => {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 58939:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isFunction = __webpack_require__(92042),
    isMasked = __webpack_require__(90654),
    isObject = __webpack_require__(36838),
    toSource = __webpack_require__(51059);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 22882:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isLength = __webpack_require__(17216),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 5673:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseMatches = __webpack_require__(3772),
    baseMatchesProperty = __webpack_require__(30493),
    identity = __webpack_require__(48148),
    isArray = __webpack_require__(24669),
    property = __webpack_require__(51798);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 87473:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isPrototype = __webpack_require__(92963),
    nativeKeys = __webpack_require__(844);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 3772:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsMatch = __webpack_require__(27122),
    getMatchData = __webpack_require__(67487),
    matchesStrictComparable = __webpack_require__(78857);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 30493:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsEqual = __webpack_require__(6620),
    get = __webpack_require__(65439),
    hasIn = __webpack_require__(28281),
    isKey = __webpack_require__(2610),
    isStrictComparable = __webpack_require__(92769),
    matchesStrictComparable = __webpack_require__(78857),
    toKey = __webpack_require__(77817);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 17498:
/***/ ((module) => {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 71000:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGet = __webpack_require__(97499);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 39739:
/***/ ((module) => {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 73150:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(74396),
    arrayMap = __webpack_require__(75697),
    isArray = __webpack_require__(24669),
    isSymbol = __webpack_require__(16764);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 58792:
/***/ ((module) => {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 95453:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var SetCache = __webpack_require__(78188),
    arrayIncludes = __webpack_require__(45170),
    arrayIncludesWith = __webpack_require__(94936),
    cacheHas = __webpack_require__(29880),
    createSet = __webpack_require__(17319),
    setToArray = __webpack_require__(79967);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ 29880:
/***/ ((module) => {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 60399:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArray = __webpack_require__(24669),
    isKey = __webpack_require__(2610),
    stringToPath = __webpack_require__(77057),
    toString = __webpack_require__(8389);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 36633:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(29165);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 17319:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Set = __webpack_require__(81956),
    noop = __webpack_require__(43226),
    setToArray = __webpack_require__(79967);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ 22684:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var SetCache = __webpack_require__(78188),
    arraySome = __webpack_require__(49499),
    cacheHas = __webpack_require__(29880);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 7456:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(74396),
    Uint8Array = __webpack_require__(92210),
    eq = __webpack_require__(42448),
    equalArrays = __webpack_require__(22684),
    mapToArray = __webpack_require__(65831),
    setToArray = __webpack_require__(79967);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 18120:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getAllKeys = __webpack_require__(69698);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 69698:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetAllKeys = __webpack_require__(38084),
    getSymbols = __webpack_require__(97482),
    keys = __webpack_require__(50579);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 67707:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isKeyable = __webpack_require__(3880);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 67487:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isStrictComparable = __webpack_require__(92769),
    keys = __webpack_require__(50579);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 47758:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsNative = __webpack_require__(58939),
    getValue = __webpack_require__(9149);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 97482:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayFilter = __webpack_require__(48969),
    stubArray = __webpack_require__(68036);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 81887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DataView = __webpack_require__(87269),
    Map = __webpack_require__(35922),
    Promise = __webpack_require__(6795),
    Set = __webpack_require__(81956),
    WeakMap = __webpack_require__(69477),
    baseGetTag = __webpack_require__(80732),
    toSource = __webpack_require__(51059);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 9149:
/***/ ((module) => {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 18554:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var castPath = __webpack_require__(60399),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isIndex = __webpack_require__(91010),
    isLength = __webpack_require__(17216),
    toKey = __webpack_require__(77817);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 71519:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 82999:
/***/ ((module) => {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 76111:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 50506:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 80845:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 91010:
/***/ ((module) => {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 2610:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArray = __webpack_require__(24669),
    isSymbol = __webpack_require__(16764);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 3880:
/***/ ((module) => {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 90654:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var coreJsData = __webpack_require__(36633);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 92963:
/***/ ((module) => {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 92769:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(36838);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 2173:
/***/ ((module) => {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 33752:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 10548:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 63410:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 3564:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 7140:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Hash = __webpack_require__(88987),
    ListCache = __webpack_require__(175),
    Map = __webpack_require__(35922);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 56504:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 88833:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 80953:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 70724:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 65831:
/***/ ((module) => {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 78857:
/***/ ((module) => {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 45171:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var memoize = __webpack_require__(34736);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 37722:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 844:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var overArg = __webpack_require__(75542);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 8478:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(96476);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 75542:
/***/ ((module) => {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 96659:
/***/ ((module) => {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 97230:
/***/ ((module) => {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 79967:
/***/ ((module) => {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 40551:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 4090:
/***/ ((module) => {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 47694:
/***/ ((module) => {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 86220:
/***/ ((module) => {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 68958:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175),
    Map = __webpack_require__(35922),
    MapCache = __webpack_require__(9440);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 3729:
/***/ ((module) => {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 77057:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var memoizeCapped = __webpack_require__(45171);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 77817:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isSymbol = __webpack_require__(16764);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 51059:
/***/ ((module) => {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 42448:
/***/ ((module) => {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 65439:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGet = __webpack_require__(97499);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 28281:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseHasIn = __webpack_require__(71664),
    hasPath = __webpack_require__(18554);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 48148:
/***/ ((module) => {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 30353:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsArguments = __webpack_require__(84742),
    isObjectLike = __webpack_require__(55073);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 24669:
/***/ ((module) => {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 47428:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isFunction = __webpack_require__(92042),
    isLength = __webpack_require__(17216);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 61563:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(29165),
    stubFalse = __webpack_require__(84193);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 82691:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseKeys = __webpack_require__(87473),
    getTag = __webpack_require__(81887),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isArrayLike = __webpack_require__(47428),
    isBuffer = __webpack_require__(61563),
    isPrototype = __webpack_require__(92963),
    isTypedArray = __webpack_require__(73806);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ 92042:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isObject = __webpack_require__(36838);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 17216:
/***/ ((module) => {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 73806:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsTypedArray = __webpack_require__(22882),
    baseUnary = __webpack_require__(58792),
    nodeUtil = __webpack_require__(8478);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 50579:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayLikeKeys = __webpack_require__(79809),
    baseKeys = __webpack_require__(87473),
    isArrayLike = __webpack_require__(47428);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 34736:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var MapCache = __webpack_require__(9440);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 43226:
/***/ ((module) => {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 51798:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseProperty = __webpack_require__(17498),
    basePropertyDeep = __webpack_require__(71000),
    isKey = __webpack_require__(2610),
    toKey = __webpack_require__(77817);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 68036:
/***/ ((module) => {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 84193:
/***/ ((module) => {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 8389:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseToString = __webpack_require__(73150);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 2600:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIteratee = __webpack_require__(5673),
    baseUniq = __webpack_require__(95453);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),

/***/ 13066:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ campaign_group)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(63073);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
// EXTERNAL MODULE: ./src/areas/campaign/components/link/index.js + 1 modules
var components_link = __webpack_require__(85732);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(35967);
;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-group/styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  border-color: ",
        ";\n  border-style: solid;\n  border-width: 1px;\n  border-radius: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var CampaignListItem = (0,styled_components_browser_esm["default"])(list_variants.GridColumn).withConfig({
    displayName: "CampaignListItem",
    componentId: "sc-0-0"
})(_templateObject(), base/* colors.borderLightGray */.O9.borderLightGray, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var RowWithWrap = (0,styled_components_browser_esm["default"])(list_variants.GridRow).withConfig({
    displayName: "RowWithWrap",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing400 */.bK.measurements.spacing400);

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-group/index.js








var CampaignGroup = function(param) {
    var campaigns = param.campaigns, title = param.title, className = param.className;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    if (!(campaigns === null || campaigns === void 0 ? void 0 : campaigns.length)) return null;
    return /*#__PURE__*/ react.createElement(panel/* Panel */.s_, {
        className: className
    }, title && /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, title), /*#__PURE__*/ react.createElement(RowWithWrap, null, campaigns.map(function(campaign) {
        return /*#__PURE__*/ react.createElement(CampaignListItem, {
            key: campaign.id
        }, /*#__PURE__*/ react.createElement(variants.H4Text, null, campaign.title.short), /*#__PURE__*/ react.createElement(variants.BodySmallText, {
            container: "p"
        }, campaign.description.short), /*#__PURE__*/ react.createElement(components_link/* default */.Z, {
            campaign: campaign,
            linkContent: t("campaigns", "link.visit-campaign"),
            onClick: function() {
                return (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.CAMPAIGN_GO_TO */.U.CAMPAIGN_GO_TO,
                    nextPage: campaign.web_uri.responsive
                });
            }
        }));
    })));
};
var arrayOf = (prop_types_default()).arrayOf, number = (prop_types_default()).number, shape = (prop_types_default()).shape, string = (prop_types_default()).string;
CampaignGroup.propTypes = {
    title: string,
    campaigns: arrayOf(shape({
        id: number.isRequired,
        slug: string,
        title: shape({
            short: string,
            long: string
        }),
        description: shape({
            short: string,
            long: string
        })
    }).isRequired),
    className: string
};
CampaignGroup.defaultProps = {
    title: undefined,
    className: undefined
};
/* harmony default export */ const campaign_group = (CampaignGroup);


/***/ }),

/***/ 85732:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ components_link)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
;// CONCATENATED MODULE: ./src/areas/campaign/components/link/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 1 auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TitleMediumTextLink = (0,styled_components_browser_esm["default"])(variants.TitleMediumText).withConfig({
    displayName: "TitleMediumTextLink",
    componentId: "sc-0-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/areas/campaign/components/link/index.js





var CampaignLink = function(props) {
    var renderMode = (0,react.useContext)(app_context/* AppContext */.Il).renderMode;
    var campaign = props.campaign, linkContent = props.linkContent, onClick = props.onClick;
    if (!linkContent) {
        return null;
    }
    if (renderMode === "native") {
        return /*#__PURE__*/ react.createElement(TitleMediumTextLink, {
            container: "a",
            containerProps: {
                href: campaign.web_uri.mobile,
                "data-test": props["data-test"],
                onClick: onClick
            }
        }, linkContent);
    }
    return /*#__PURE__*/ react.createElement(TitleMediumTextLink, {
        container: react_router_dom/* Link */.rU,
        containerProps: {
            to: "".concat(campaign.web_uri.responsive).concat(props.queryString || ""),
            "data-test": props["data-test"],
            onClick: onClick
        }
    }, linkContent);
};
var shape = (prop_types_default()).shape, string = (prop_types_default()).string, node = (prop_types_default()).node, func = (prop_types_default()).func;
CampaignLink.propTypes = {
    linkContent: node,
    queryString: string,
    campaign: shape({
        title: shape({
            short: string
        }),
        description: shape({
            short: string
        }),
        web_uri: shape({
            desktop: string,
            mobile: string
        })
    }).isRequired,
    className: string,
    "data-test": string,
    onClick: func
};
CampaignLink.defaultProps = {
    linkContent: "",
    className: null,
    queryString: null,
    "data-test": undefined,
    onClick: undefined
};
/* harmony default export */ const components_link = (CampaignLink);


/***/ }),

/***/ 36785:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": () => (/* binding */ ProductCard)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/product-of-the-year/hooks.ts
var hooks = __webpack_require__(44266);
// EXTERNAL MODULE: ./src/components/badges/image-badges.tsx
var image_badges = __webpack_require__(21244);
// EXTERNAL MODULE: ./src/components/offer/price/price-label/index.tsx + 1 modules
var price_label = __webpack_require__(75695);
// EXTERNAL MODULE: ./src/components/store-logo/index.tsx
var store_logo = __webpack_require__(46256);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-tools@1.7.2/node_modules/styled-tools/dist/es/index.js + 7 modules
var es = __webpack_require__(55703);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/base/styles/variables.ts
var variables = __webpack_require__(76323);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var rating = __webpack_require__(34990);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(95088);
// EXTERNAL MODULE: ./src/components/product-checkbox/index.tsx + 1 modules
var product_checkbox = __webpack_require__(53692);
;// CONCATENATED MODULE: ./src/components/product-card-oldest/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 1 0 ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 50%;\n  align-self: stretch;\n  width: 100%;\n  min-height: 100%;\n  min-width: ",
        ";\n  max-width: ",
        ";\n  text-align: ",
        ";\n  border-bottom: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    padding: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      &::before {\n        ",
        ";\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 auto;\n  position: relative;\n  outline: none;\n  padding: ",
        ";\n  ",
        "\n\n  ",
        "\n\n  @media (pointer: fine) {\n    &:hover::after,\n    &.focus-visible::after {\n      ",
        "\n    }\n    ",
        ":focus-within &::after {\n      ",
        "\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  left: ",
        ";\n  z-index: 2;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  box-sizing: content-box;\n  order: 0;\n  text-align: center;\n  height: ",
        ";\n  width: ",
        ";\n  margin: 0 auto 20px auto;\n  background: ",
        ";\n  border-radius: ",
        ";\n\n  img {\n    max-height: 100%;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  max-height: 55px;\n  max-width: 55px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 1rem;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    padding: 0;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex: ",
        ";\n  padding: 0 ",
        ";\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: 100%;\n  padding: 2px;\n  align-self: center;\n  background: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    margin-top: ",
        ";\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  overflow-wrap: break-word;\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: 12px;\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 10px;\n  padding-top: 10px;\n  font-size: 13px;\n  color: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  position: relative;\n  outline: none;\n\n  @media (pointer: fine) {\n    ",
        ":hover + &::after,\n    ",
        ":focus + &::after {\n      ",
        "\n    }\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  padding: 0 1rem 1rem;\n  position: relative;\n  outline: none;\n\n  @media (pointer: fine) {\n    ",
        ":hover + &::after,\n    ",
        ":focus + &::after {\n      ",
        "\n    }\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  box-sizing: border-box;\n\n  && {\n    text-transform: none;\n  }\n\n  &:hover,\n  &:focus {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n    top: ",
        ";\n    left: ",
        ";\n  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  ",
        "\n  padding: 0.1rem 0.4rem;\n  font-weight: 600;\n  color: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  left: ",
        ";\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 10px;\n  max-width: 40%;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n    padding: 0;\n    margin-top: ",
        ";\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 ",
        ";\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 10px;\n  left: 10px;\n\n  ",
        ":hover & {\n    ",
        "\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}








var Card = styled_components_browser_esm["default"].div.attrs({
    "data-test": "ProductCard"
}).withConfig({
    displayName: "Card",
    componentId: "sc-0-0"
})(_templateObject1(), base/* layout.productCardMinWidthMobile */.bK.productCardMinWidthMobile, base/* layout.productCardMaxWidth */.bK.productCardMaxWidth, (0,es/* ifProp */.fq)("textCenter", "center", "left"), function(p) {
    return p.hasDivider ? "1px solid ".concat(p.theme.lines.primary) : "none";
}, base/* media.mediumUp */.BC.mediumUp(_templateObject(), base/* layout.productCardMinWidth */.bK.productCardMinWidth));
var ProductLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ProductLink",
    componentId: "sc-0-1"
})(_templateObject4(), base/* layout.productCardPaddingSmall */.bK.productCardPaddingSmall, base/* media.mediumUp */.BC.mediumUp(_templateObject2(), base/* layout.productCardPaddingLarge */.bK.productCardPaddingLarge), function(props) {
    return props.selected && (0,styled_components_browser_esm.css)(_templateObject3(), base/* styledUtils.overlay */.au.overlay(props.theme.bg.productCompareLight));
}, base/* styledUtils.overlay */.au.overlay(), Card, base/* styledUtils.overlay */.au.overlay());
var CampaignBadge = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CampaignBadge",
    componentId: "sc-0-2"
})(_templateObject5(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ProductImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductImage",
    componentId: "sc-0-3"
})(_templateObject6(), base/* layout.productCardImageSize */.bK.productCardImageSize, base/* layout.productCardImageSize */.bK.productCardImageSize, function(p) {
    return p.theme.colors.base200;
}, base/* layout.borderRadius */.bK.borderRadius);
var BrandLogo = styled_components_browser_esm["default"].span.withConfig({
    displayName: "BrandLogo",
    componentId: "sc-0-4"
})(_templateObject7());
var ProductDetails = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductDetails",
    componentId: "sc-0-5"
})(_templateObject9(), (0,es/* ifProp */.fq)("stretch", "1 0 auto", "0 0 auto"), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* media.mediumUp */.BC.mediumUp(_templateObject8()));
var Rating = (0,styled_components_browser_esm["default"])(rating/* default */.Z).withConfig({
    displayName: "Rating",
    componentId: "sc-0-6"
})(_templateObject10(), function(p) {
    return p.theme.colors.base0;
});
var ProductName = styled_components_browser_esm["default"].div.attrs({
    "data-test": "ProductName"
}).withConfig({
    displayName: "ProductName",
    componentId: "sc-0-7"
})(_templateObject12(), base/* media.mediumUp */.BC.mediumUp(_templateObject11(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025));
var Subtitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-8"
})(_templateObject14(), function(p) {
    return p.theme.text.tertiary;
}, (0,variables/* remCalc */.vR)(13), base/* media.mediumUp */.BC.mediumUp(_templateObject13(), (0,variables/* remCalc */.vR)(12)));
var ExtraFooter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExtraFooter",
    componentId: "sc-0-9"
})(_templateObject16(), function(p) {
    return p.theme.text.tertiary;
}, base/* media.mediumUp */.BC.mediumUp(_templateObject15()));
var Footer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Footer",
    componentId: "sc-0-10"
})(_templateObject17(), ProductLink, ProductLink, base/* styledUtils.overlay */.au.overlay());
var CategoryArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CategoryArea",
    componentId: "sc-0-11"
})(_templateObject18(), ProductLink, ProductLink, base/* styledUtils.overlay */.au.overlay());
var CategoryLink = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).withConfig({
    displayName: "CategoryLink",
    componentId: "sc-0-12"
})(_templateObject19(), function(p) {
    return p.theme.text.callToActionHover;
});
var DiffPercentageCore = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DiffPercentageCore",
    componentId: "sc-0-13"
})(_templateObject21(), function(p) {
    return p.theme.colors.redio500;
}, base/* media.mediumUp */.BC.mediumUp(_templateObject20(), base/* layout.productCardPaddingLarge */.bK.productCardPaddingLarge, base/* layout.productCardPaddingLarge */.bK.productCardPaddingLarge), function(p) {
    return p.theme.colors.base0;
}, base/* layout.borderRadius */.bK.borderRadius);
var DiffPercentage = (0,styled_components_browser_esm["default"])(DiffPercentageCore).withConfig({
    displayName: "DiffPercentage",
    componentId: "sc-0-14"
})(_templateObject22(), base/* layout.productCardPaddingSmall */.bK.productCardPaddingSmall, base/* layout.productCardPaddingSmall */.bK.productCardPaddingSmall);
var StoreLogo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StoreLogo",
    componentId: "sc-0-15"
})(_templateObject23());
var PriceInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceInfo",
    componentId: "sc-0-16"
})(_templateObject25(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* media.mediumUp */.BC.mediumUp(_templateObject24(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025));
var Checkbox = (0,styled_components_browser_esm["default"])(product_checkbox/* ProductCheckbox */.WX).attrs(function() {
    return {
        vertical: false
    };
}).withConfig({
    displayName: "Checkbox",
    componentId: "sc-0-17"
})(_templateObject26(), Card, product_checkbox/* productCheckboxHoverStyle */.lo);

;// CONCATENATED MODULE: ./src/components/product-card-oldest/index.js
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}







var ProductCard = function(param) {
    var id = param.id, onClick = param.onClick, category = param.category, linkAttributes = param.linkAttributes, link = param.link, campaignBadge = param.campaignBadge, image = param.image, brandLogo = param.brandLogo, productCoreProps = param.productCoreProps, rating = param.rating, ratingCount = param.ratingCount, ratingCountTranslation = param.ratingCountTranslation, name = param.name, highlightedName = param.highlightedName, subtitle = param.subtitle, price = param.price, diffPercentage = param.diffPercentage, isCampaignItem = param.isCampaignItem, hasDivider = param.hasDivider, store = param.store, className = param.className, children = param.children, footer = param.footer, selectable = param.selectable, selected = param.selected, onSelect = param.onSelect, onDeselect = param.onDeselect, externalLink = param.externalLink, onCategoryLinkClick = param.onCategoryLinkClick;
    var onToggle = selected ? onDeselect : onSelect;
    var clickHandler = (0,react.useCallback)(function(e) {
        if (selectable) {
            e.preventDefault();
            onToggle();
            return;
        }
        if (externalLink) {
            e.preventDefault();
            window.location.href = e.currentTarget.href;
        }
        onClick(e);
    }, [
        selectable,
        onToggle,
        externalLink,
        onClick
    ]);
    var productProperties = productCoreProps ? productCoreProps.map(function(p, i, arr) {
        if (p.pretty === null) return "";
        if (arr.length - 1 === i) {
            return p.pretty;
        }
        return "".concat(p.pretty, ", ");
    }) : null;
    var productOfTheYearAward = (0,hooks/* useGetProductOfTheYear */.i)(id || undefined);
    return /*#__PURE__*/ react.createElement(Card, {
        className: className,
        hasDivider: hasDivider
    }, (productOfTheYearAward === null || productOfTheYearAward === void 0 ? void 0 : productOfTheYearAward.awardLogo) && /*#__PURE__*/ react.createElement(image_badges/* GridCardImageBadge */.ni, {
        badgeUrl: productOfTheYearAward.awardLogo,
        title: "".concat(productOfTheYearAward.awardName, " ").concat(productOfTheYearAward.year)
    }), campaignBadge && /*#__PURE__*/ react.createElement(CampaignBadge, null, campaignBadge), /*#__PURE__*/ react.createElement(ProductLink, _extends({
        onClick: clickHandler
    }, linkAttributes, {
        to: link,
        "aria-label": name,
        selected: selected
    }), diffPercentage && /*#__PURE__*/ react.createElement(DiffPercentage, null, "-", Math.round(diffPercentage), "%"), image && /*#__PURE__*/ react.createElement(ProductImage, null, image, brandLogo && /*#__PURE__*/ react.createElement(BrandLogo, null, brandLogo)), /*#__PURE__*/ react.createElement(ProductDetails, {
        stretch: isCampaignItem
    }, /*#__PURE__*/ react.createElement(ProductName, null, highlightedName || name), subtitle && /*#__PURE__*/ react.createElement(Subtitle, null, subtitle), /*#__PURE__*/ react.createElement(Subtitle, null, productProperties), /*#__PURE__*/ react.createElement(Rating, {
        hide: rating === null || rating === undefined,
        rate: rating,
        centerAlign: true,
        count: ratingCount,
        countTranslation: ratingCountTranslation,
        showCounter: true,
        size: "small"
    })), /*#__PURE__*/ react.createElement(PriceInfo, null, price && /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
        value: price
    })), store && /*#__PURE__*/ react.createElement(store_logo/* StoreLogo */.Xv, {
        variant: store_logo/* StoreLogoVariant.CAMPAIGN */.mA.CAMPAIGN,
        name: store.name,
        storeId: store.id,
        featured: true,
        hasImage: store.hasLogo
    })), children && /*#__PURE__*/ react.createElement(ExtraFooter, null, children)), category && category.pathName && /*#__PURE__*/ react.createElement(CategoryArea, null, /*#__PURE__*/ react.createElement(CategoryLink, {
        size: "small",
        color: "secondary",
        variant: "outlined",
        href: category.pathName,
        truncate: true,
        onClick: function() {
            if (onCategoryLinkClick) {
                onCategoryLinkClick({
                    url: category.pathName
                });
            }
        }
    }, category.name)), footer && /*#__PURE__*/ react.createElement(Footer, null, footer), selectable && /*#__PURE__*/ react.createElement(Checkbox, {
        selected: selected,
        onSelect: onSelect,
        onDeselect: onDeselect,
        "aria-label": name
    }));
};
var func = (prop_types_default()).func, string = (prop_types_default()).string, number = (prop_types_default()).number, oneOfType = (prop_types_default()).oneOfType, arrayOf = (prop_types_default()).arrayOf, product_card_oldest_element = (prop_types_default()).element, node = (prop_types_default()).node, shape = (prop_types_default()).shape, bool = (prop_types_default()).bool;
ProductCard.propTypes = {
    onClick: func,
    link: string.isRequired,
    image: node,
    name: oneOfType([
        string.isRequired,
        node.isRequired
    ]),
    highlightedName: node,
    rating: number,
    ratingCount: number,
    ratingCountTranslation: shape({
        domain: string,
        key: string
    }),
    price: oneOfType([
        string,
        number,
        product_card_oldest_element
    ]),
    diffPercentage: number,
    isCampaignItem: bool,
    children: node,
    campaignBadge: product_card_oldest_element,
    subtitle: node,
    brandLogo: node,
    productCoreProps: arrayOf(shape({
        id: string,
        isCore: bool,
        name: string,
        pretty: string,
        prettyTable: string,
        type: string,
        unit: string,
        value: string
    })),
    linkAttributes: shape({
        target: string,
        rel: string
    }),
    category: shape({
        name: string.isRequired,
        pathName: string
    }),
    store: shape({
        name: string.isRequired,
        id: number.isRequired,
        hasLogo: bool.isRequired
    }),
    hasDivider: bool,
    className: string,
    footer: node,
    selectable: bool,
    selected: bool,
    onSelect: func,
    onDeselect: func,
    externalLink: bool,
    onCategoryLinkClick: func
};
var noop = function() {};
ProductCard.defaultProps = {
    onClick: noop,
    image: undefined,
    highlightedName: undefined,
    rating: undefined,
    ratingCount: undefined,
    ratingCountTranslation: {
        domain: "product",
        key: "product-card.n-ratings"
    },
    price: undefined,
    diffPercentage: undefined,
    isCampaignItem: false,
    children: undefined,
    campaignBadge: undefined,
    subtitle: undefined,
    brandLogo: undefined,
    productCoreProps: undefined,
    linkAttributes: undefined,
    category: undefined,
    store: undefined,
    hasDivider: false,
    className: undefined,
    footer: undefined,
    selectable: false,
    selected: false,
    onSelect: noop,
    onDeselect: noop,
    externalLink: false,
    onCategoryLinkClick: noop
};


/***/ }),

/***/ 76590:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CategoryLoader": () => (/* binding */ CategoryLoader),
  "default": () => (/* binding */ category_category)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./src/components/breadcrumbs/index.tsx
var breadcrumbs = __webpack_require__(88999);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(12321);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/collapsible/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      max-height: 3em;\n      overflow: hidden;\n      /* Fade out towards the bottom */\n      &::after {\n        content: '';\n        display: block;\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        height: 2em;\n        background: linear-gradient(\n          to bottom,\n          rgba(255, 255, 255, 0),\n          rgba(255, 255, 255, 0.8)\n        );\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  background: transparent;\n  color: transparent;\n  cursor: pointer;\n  display: block;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  transition: background-color ",
        ";\n  width: 100%;\n  z-index: 1;\n\n  &:focus {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var CollapsibleWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CollapsibleWrapper",
    componentId: "sc-0-0"
})(_templateObject1(), function(param) {
    var collapsed = param.collapsed;
    return collapsed && (0,styled_components_browser_esm.css)(_templateObject());
});
var ExpandButton = styled_components_browser_esm["default"].button.attrs({
    type: "button"
}).withConfig({
    displayName: "ExpandButton",
    componentId: "sc-0-1"
})(_templateObject2(), base/* layout.animations.buttonTransition */.bK.animations.buttonTransition, function(p) {
    return base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(p.theme.colors.maybeBlue700, "0.5");
});

;// CONCATENATED MODULE: ./src/components/collapsible/index.tsx


var Collapsible = function(param) {
    var children = param.children, collapsed = param.collapsed, expandText = param.expandText, onExpand = param.onExpand, className = param.className;
    return /*#__PURE__*/ react.createElement(CollapsibleWrapper, {
        collapsed: collapsed,
        className: className
    }, children, collapsed && /*#__PURE__*/ react.createElement(ExpandButton, {
        onClick: onExpand
    }, expandText));
};

// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(84234);
// EXTERNAL MODULE: ./src/components/campaign-banners/promo-banner/index.tsx + 2 modules
var promo_banner = __webpack_require__(38911);
// EXTERNAL MODULE: ./src/components/recently-visited/index.ts
var recently_visited = __webpack_require__(24068);
// EXTERNAL MODULE: ./src/components/no-scroll/index.tsx
var no_scroll = __webpack_require__(83464);
// EXTERNAL MODULE: ./src/components/compare-products-basket/index.tsx + 1 modules
var compare_products_basket = __webpack_require__(62960);
// EXTERNAL MODULE: ./src/hooks/compare-products-selection.ts
var compare_products_selection = __webpack_require__(51836);
// EXTERNAL MODULE: ./src/areas/category/actions/filter.js
var filter = __webpack_require__(67536);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(7336);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(95088);
;// CONCATENATED MODULE: ./src/areas/category/components/sub-category-listing/components/toggle/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n    width: auto;\n    borderRadius: 20px;\n    padding: 2px 5px 2px 10px;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n    width: 'auto',\n    borderRadius: '20px',\n    padding: '2px 5px 2px 10px',\n  "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100;\n  ",
        "\n  ",
        "\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var ToggleVisibilityButton = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).withConfig({
    displayName: "ToggleVisibilityButton",
    componentId: "sc-0-0"
})(styles_templateObject2(), base/* media.largeUp */.BC.largeUp(styles_templateObject()), function() {
    return (0,styled_components_browser_esm.css)(styles_templateObject1());
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-down/index.js
var chevron_down = __webpack_require__(70796);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-up/index.js
var chevron_up = __webpack_require__(912);
;// CONCATENATED MODULE: ./src/areas/category/components/sub-category-listing/components/toggle/index.tsx




var VisibilityToggle = function(param) {
    var _active = param.active, active = _active === void 0 ? false : _active, _styling = param.styling, styling = _styling === void 0 ? "default" : _styling, onToggle = param.onToggle, label = param.label, _chip = param.chip, chip = _chip === void 0 ? false : _chip;
    return /*#__PURE__*/ react.createElement(ToggleVisibilityButton, {
        color: "primary",
        chip: chip,
        size: styling === "small" ? "small" : "medium",
        variant: !active || styling === "default" ? "outlined" : "default",
        onClick: function() {
            return onToggle(!active);
        },
        icon: active ? /*#__PURE__*/ react.createElement(chevron_up.IconChevronUp, null) : /*#__PURE__*/ react.createElement(chevron_down/* IconChevronDown */.C, null),
        iconPosition: "right"
    }, label);
};
/* harmony default export */ const toggle = (VisibilityToggle);

// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
;// CONCATENATED MODULE: ./src/areas/category/components/sub-category-listing/components/inline-list/styles.ts
function inline_list_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function inline_list_styles_templateObject() {
    var data = inline_list_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  "
    ]);
    inline_list_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function inline_list_styles_templateObject1() {
    var data = inline_list_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  margin-bottom: ",
        ";\n  flex-wrap: wrap;\n\n  ",
        "\n\n  > * {\n    white-space: nowrap;\n    margin-top: ",
        ";\n    margin-right: ",
        ";\n  }\n"
    ]);
    inline_list_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var RelatedResources = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RelatedResources",
    componentId: "sc-0-0"
})(inline_list_styles_templateObject1(), base/* layout.margins.component.desktop.rem */.bK.margins.component.desktop.rem, base/* media.mediumDown */.BC.mediumDown(inline_list_styles_templateObject(), base/* layout.margins.component.mobile.rem */.bK.margins.component.mobile.rem), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/category/components/sub-category-listing/components/inline-list/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var SubCategoryInlineList = function(props) {
    var ref = _slicedToArray(react.useState(true), 2), collapse = ref[0], setCollapse = ref[1];
    var _categories = props.categories, categories = _categories === void 0 ? [] : _categories, _limit = props.limit, limit = _limit === void 0 ? 6 : _limit;
    var context = (0,app_context/* useAppContext */.bp)();
    return /*#__PURE__*/ react.createElement(RelatedResources, null, categories.map(function(cat, index) {
        return index < limit || !collapse ? /*#__PURE__*/ react.createElement(variants.TagButton, {
            key: cat.id,
            container: clickable/* Clickable */.P,
            containerProps: {
                to: cat.pathName
            }
        }, cat.name) : null;
    }), categories && categories.length > limit && /*#__PURE__*/ react.createElement(toggle, {
        styling: "small",
        active: !collapse,
        onToggle: function() {
            return setCollapse(!collapse);
        },
        label: collapse ? context.t("category", "category-limit.show-more") : context.t("category", "category-limit.show-less")
    }));
};
/* harmony default export */ const inline_list = (SubCategoryInlineList);

// EXTERNAL MODULE: ./src/components/list-item/index.tsx
var list_item = __webpack_require__(91441);
;// CONCATENATED MODULE: ./src/areas/category/components/sub-category-listing/components/list/styles.ts
function list_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function list_styles_templateObject() {
    var data = list_styles_taggedTemplateLiteral([
        "\n          max-height: 0;\n          margin-bottom: 0;\n        "
    ]);
    list_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function list_styles_templateObject1() {
    var data = list_styles_taggedTemplateLiteral([
        "\n  margin: 0;\n  max-height: calc(40px * 25);\n  transition:\n    max-height 0.3s linear,\n    margin-bottom 0.1s linear 0.1s;\n  overflow: hidden;\n  margin-bottom: ",
        ";\n  ",
        "\n"
    ]);
    list_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var RelatedResourcesList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RelatedResourcesList",
    componentId: "sc-0-0"
})(list_styles_templateObject1(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, function(props) {
    return props.collapse ? (0,styled_components_browser_esm.css)(list_styles_templateObject()) : null;
});

;// CONCATENATED MODULE: ./src/areas/category/components/sub-category-listing/components/list/index.tsx



var SubCategoryList = function(param) {
    var categories = param.categories, collapse = param.collapse;
    return /*#__PURE__*/ react.createElement(RelatedResourcesList, {
        collapse: collapse
    }, categories.map(function(category) {
        return /*#__PURE__*/ react.createElement(list_item/* ListItem */.H, {
            key: category.id,
            name: category.name,
            link: category.pathName,
            showArrow: true
        });
    }));
};
/* harmony default export */ const list = (SubCategoryList);

;// CONCATENATED MODULE: ./src/areas/category/components/sub-category-listing/index.tsx
function sub_category_listing_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return sub_category_listing_arrayLikeToArray(arr);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || sub_category_listing_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function sub_category_listing_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return sub_category_listing_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sub_category_listing_arrayLikeToArray(o, minLen);
}



var SubCategoryListing = function(props) {
    var ref;
    var styling = props.styling;
    var _brands, ref1;
    var categories = _toConsumableArray((_brands = props.brands) !== null && _brands !== void 0 ? _brands : []).concat(_toConsumableArray((ref1 = (ref = props.categories) === null || ref === void 0 ? void 0 : ref.nodes) !== null && ref1 !== void 0 ? ref1 : []));
    if (categories.length === 0) {
        return null;
    }
    switch(styling){
        case "inline-list":
            {
                return /*#__PURE__*/ react.createElement(inline_list, _extends({}, props, {
                    categories: categories
                }));
            }
        case "list":
            {
                return /*#__PURE__*/ react.createElement(list, _extends({}, props, {
                    categories: categories
                }));
            }
        default:
            return null;
    }
};
/* harmony default export */ const sub_category_listing = (SubCategoryListing);

// EXTERNAL MODULE: ./src/areas/category/components/filter/index.tsx
var components_filter = __webpack_require__(6116);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(37702);
;// CONCATENATED MODULE: ./src/areas/category/components/filter/components/mobile-toggle/styles.ts
function mobile_toggle_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function mobile_toggle_styles_templateObject() {
    var data = mobile_toggle_styles_taggedTemplateLiteral([
        "\n    display: block;\n  "
    ]);
    mobile_toggle_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function mobile_toggle_styles_templateObject1() {
    var data = mobile_toggle_styles_taggedTemplateLiteral([
        "\n  display: none;\n  margin-bottom: ",
        ";\n\n  ",
        ";\n"
    ]);
    mobile_toggle_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var FilterMobileToggle = styled_components_browser_esm["default"].div.attrs({
    "data-test": "FilterMobileToggle"
}).withConfig({
    displayName: "FilterMobileToggle",
    componentId: "sc-0-0"
})(mobile_toggle_styles_templateObject1(), base/* layout.margins.component.mobile.rem */.bK.margins.component.mobile.rem, base/* media.mediumDown */.BC.mediumDown(mobile_toggle_styles_templateObject()));


;// CONCATENATED MODULE: ./src/areas/category/components/filter/components/counter/types.ts
var Variant;
(function(Variant) {
    Variant["LIGHT"] = "light";
    Variant["DARK"] = "dark";
})(Variant || (Variant = {}));
var Color;
(function(Color) {
    Color["PRIMARY"] = "primary";
    Color["SECONDARY"] = "secondary";
    Color["TERTIARY"] = "tertiary";
    Color["QUARTERNARY"] = "quarternary";
})(Color || (Color = {}));

;// CONCATENATED MODULE: ./src/areas/category/components/filter/components/counter/styles.ts
function counter_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function counter_styles_templateObject() {
    var data = counter_styles_taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n  border-radius: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.5;\n\n  background: ",
        ";\n  color: ",
        ";\n"
    ]);
    counter_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Counter = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Counter",
    componentId: "sc-0-0"
})(counter_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.fontSizeMedium */.bK.measurements.fontSizeMedium, function(p) {
    return p.variant === Variant.DARK ? p.theme.buttons[p.color].bg : p.theme.buttons[p.color].text;
}, function(p) {
    return p.variant === Variant.DARK ? p.theme.buttons[p.color].text : p.theme.buttons[p.color].bg;
});

;// CONCATENATED MODULE: ./src/areas/category/components/filter/components/counter/index.tsx



var counter_Counter = function(param) {
    var count = param.count, _hide = param.hide, hide = _hide === void 0 ? false : _hide, _variant = param.variant, variant = _variant === void 0 ? Variant.LIGHT : _variant, _color = param.color, color = _color === void 0 ? Color.PRIMARY : _color;
    if (hide) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(Counter, {
        variant: variant,
        color: color
    }, count);
};
/* harmony default export */ const counter = (counter_Counter);

;// CONCATENATED MODULE: ./src/areas/category/components/filter/components/mobile-toggle/index.tsx







var mobile_toggle_FilterMobileToggle = function(props) {
    var _filterSettings = props.filterSettings, filterSettings = _filterSettings === void 0 ? {} : _filterSettings;
    var isOpen = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.category.filter.mobileOpen;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var count = Object.keys(filterSettings).length;
    return /*#__PURE__*/ react.createElement(FilterMobileToggle, null, /*#__PURE__*/ react.createElement(variants.PrimaryButton, {
        style: {
            width: "100%"
        },
        onClick: function() {
            return dispatch((0,filter/* toggleMobile */.fs)(!isOpen));
        }
    }, count > 0 && /*#__PURE__*/ react.createElement(counter, {
        count: count
    }), /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "filter"
    }, "button.filter")));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(71016);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(35967);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(17658);
// EXTERNAL MODULE: ./src/components/word-cloud/index.tsx + 1 modules
var word_cloud = __webpack_require__(55330);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(92873);
;// CONCATENATED MODULE: ./src/areas/category/styles.ts
function category_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function category_styles_templateObject() {
    var data = category_styles_taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    category_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function category_styles_templateObject1() {
    var data = category_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  width: 100%;\n  max-width: 1000px;\n"
    ]);
    category_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function category_styles_templateObject2() {
    var data = category_styles_taggedTemplateLiteral([
        "\n  flex: 1;\n  flex-basis: 60%;\n"
    ]);
    category_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = category_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = category_styles_taggedTemplateLiteral([
        "\n  max-width: 500px;\n  color: ",
        ";\n\n  ul {\n    margin-left: 15px;\n    color: ",
        ";\n\n    &::after {\n      content: '';\n      clear: both;\n      display: table;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = category_styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = category_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-flow: row wrap;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = category_styles_taggedTemplateLiteral([
        "\n    border-top: 1px solid ",
        ";\n    padding-top: ",
        ";\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = category_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = category_styles_taggedTemplateLiteral([
        "\n  min-width: 0;\n  flex: 1 1 0;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = category_styles_taggedTemplateLiteral([
        "\n    max-width: 220px;\n    padding-right: ",
        ";\n\n    @supports (position: sticky) {\n      position: sticky;\n      top: ",
        ";\n      overflow-x: hidden;\n      overflow-y: auto;\n      max-height: calc(100vh - ",
        ");\n      margin-bottom: 10px;\n      margin-right: ",
        ";\n      scroll-behavior: smooth;\n      z-index: 5;\n    }\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = category_styles_taggedTemplateLiteral([
        "\n    display: ",
        ";\n    background: ",
        ";\n    position: fixed;\n    padding-right: ",
        ";\n    padding-left: ",
        ";\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: ",
        ";\n    overflow: auto;\n    overflow-y: scroll; /* has to be scroll, not auto */\n    -webkit-overflow-scrolling: touch;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = category_styles_taggedTemplateLiteral([
        "\n  min-width: 0;\n  flex: 1 1 0;\n\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = category_styles_taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = category_styles_taggedTemplateLiteral([
        "\n  width: 88px;\n  height: 31px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = category_styles_taggedTemplateLiteral([
        "\n  && {\n    flex: 0 1 auto;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = category_styles_taggedTemplateLiteral([
        "\n  align-items: center;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = category_styles_taggedTemplateLiteral([
        "\n  align-items: center;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = category_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = category_styles_taggedTemplateLiteral([
        "\n  max-height: ",
        ";\n  margin-right: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = category_styles_taggedTemplateLiteral([
        "\n  padding-right: 0.8rem;\n  padding-left: 0.8rem;\n  min-width: 0;\n\n  flex: 0 0 ",
        ";\n  max-width: ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = category_styles_taggedTemplateLiteral([
        "\n  margin: ",
        ";\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = category_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}









var buttonHeight = "40px";
var CategoryPageGutter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CategoryPageGutter",
    componentId: "sc-0-0"
})(category_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var CategoryPageWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CategoryPageWrapper",
    componentId: "sc-0-1"
})(category_styles_templateObject1());
var CategoryPageHeader = (0,styled_components_browser_esm["default"])(page/* PageHeader */.mr).withConfig({
    displayName: "CategoryPageHeader",
    componentId: "sc-0-2"
})(category_styles_templateObject2());
var CategoryPageHeaderWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CategoryPageHeaderWrapper",
    componentId: "sc-0-3"
})(_templateObject3());
var CategoryPageHeaderDescription = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CategoryPageHeaderDescription",
    componentId: "sc-0-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.text.secondary;
}, function(param) {
    var theme = param.theme;
    return theme.text.secondary;
});
var CategoryPageHeaderAliases = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CategoryPageHeaderAliases",
    componentId: "sc-0-5"
})(_templateObject5(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var CategoryPageSubHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CategoryPageSubHeader",
    componentId: "sc-0-6"
})(_templateObject6());
var CategoryPageProductWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CategoryPageProductWrapper",
    componentId: "sc-0-7"
})(_templateObject8(), base/* media.mediumUp */.BC.mediumUp(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.lines.secondary;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var CategoryPageProducts = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CategoryPageProducts",
    componentId: "sc-0-8"
})(_templateObject9(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var Filter = (0,styled_components_browser_esm["default"])(components_filter/* default */.Z).withConfig({
    displayName: "Filter",
    componentId: "sc-0-9"
})(_templateObject12(), base/* media.largeUp */.BC.largeUp(_templateObject10(), (0,base/* remCalc */.vR)(11), base/* layout.headerHeight.desktop.rem */.bK.headerHeight.desktop.rem, base/* layout.headerHeight.desktop.rem */.bK.headerHeight.desktop.rem, base/* layout.pageContent.gutter.rem */.bK.pageContent.gutter.rem), base/* media.mediumDown */.BC.mediumDown(_templateObject11(), function(props) {
    return props.open ? "block" : "none";
}, function(p) {
    return p.theme.bg.primary;
}, base/* layout.pageContent.gutter.rem */.bK.pageContent.gutter.rem, base/* layout.pageContent.gutter.rem */.bK.pageContent.gutter.rem, zindex/* zindex.menu.filter */.Y.menu.filter));
var BrandLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "BrandLink",
    componentId: "sc-0-10"
})(_templateObject13(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var BrandLogo = styled_components_browser_esm["default"].img.withConfig({
    displayName: "BrandLogo",
    componentId: "sc-0-11"
})(_templateObject14());
var PanelHeaderActions = (0,styled_components_browser_esm["default"])(list_variants.Row).withConfig({
    displayName: "PanelHeaderActions",
    componentId: "sc-0-12"
})(_templateObject15());
var PanelHeaderButtons = (0,styled_components_browser_esm["default"])(list_variants.Row).withConfig({
    displayName: "PanelHeaderButtons",
    componentId: "sc-0-13"
})(_templateObject16());
var PanelHeader = (0,styled_components_browser_esm["default"])(list_variants.Row).withConfig({
    displayName: "PanelHeader",
    componentId: "sc-0-14"
})(_templateObject17());
var FilterButton = (0,styled_components_browser_esm["default"])(ui_button.Button).withConfig({
    displayName: "FilterButton",
    componentId: "sc-0-15"
})(_templateObject19(), buttonHeight, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumDown */.BC.mediumDown(_templateObject18()));
var Column = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Column",
    componentId: "sc-0-16"
})(_templateObject20(), function(p) {
    return p.fullWidth ? "100%" : "50%";
}, function(p) {
    return p.fullWidth ? "100%" : "50%";
});
var BreadCrumbWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BreadCrumbWrapper",
    componentId: "sc-0-17"
})(_templateObject21(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var WordCloud = (0,styled_components_browser_esm["default"])(word_cloud/* default */.Z).withConfig({
    displayName: "WordCloud",
    componentId: "sc-0-18"
})(_templateObject22(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(63073);
// EXTERNAL MODULE: ./src/areas/category/components/category-information/index.tsx + 1 modules
var category_information = __webpack_require__(90912);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/view-grid/index.js
var view_grid = __webpack_require__(89593);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/view-compact-list/index.js
var view_compact_list = __webpack_require__(73490);
;// CONCATENATED MODULE: ./src/components/layout-picker/styles.ts
function layout_picker_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function layout_picker_styles_templateObject() {
    var data = layout_picker_styles_taggedTemplateLiteral([
        "\n  align-self: stretch;\n  display: flex;\n  justify-content: center;\n"
    ]);
    layout_picker_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function layout_picker_styles_templateObject1() {
    var data = layout_picker_styles_taggedTemplateLiteral([
        "\n  outline: none;\n  cursor: pointer;\n  padding: 0 8px;\n  position: relative;\n  fill: ",
        ";\n\n  svg g,\n  svg path {\n    fill: ",
        ";\n  }\n\n  &:hover {\n    svg g,\n    svg path {\n      fill: ",
        ";\n    }\n  }\n"
    ]);
    layout_picker_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var LayoutPickerContainer = styled_components_browser_esm["default"].div.attrs({
    "data-test": "LayoutPicker"
}).withConfig({
    displayName: "LayoutPickerContainer",
    componentId: "sc-0-0"
})(layout_picker_styles_templateObject());
var StyledButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "StyledButton",
    componentId: "sc-0-1"
})(layout_picker_styles_templateObject1(), function(p) {
    return p.theme.colors.base400;
}, function(p) {
    return p.theme.colors.base400;
}, function(p) {
    return p.theme.colors.maybeBlue500;
});

;// CONCATENATED MODULE: ./src/components/layout-picker/index.tsx





function layout_picker_translate(transFunc, domain, field, data) {
    return transFunc ? transFunc(domain, field, data) : field;
}
var LayoutPicker = function(param) {
    var _mode = param.mode, mode = _mode === void 0 ? "row" : _mode, _onClick = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    onClick, onClick = _onClick === void 0 ? function() {} : _onClick;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(LayoutPickerContainer, null, /*#__PURE__*/ react.createElement(StyledButton, {
        onClick: function() {
            return onClick(mode === "grid" ? "row" : "grid");
        },
        "aria-label": layout_picker_translate(t, "symbols", "symbol.card-layout")
    }, mode === "row" ? /*#__PURE__*/ react.createElement(view_grid/* IconViewGrid */.M, {
        size: 24
    }) : /*#__PURE__*/ react.createElement(view_compact_list/* IconViewCompactList */.e, {
        size: 24
    })));
};
/* harmony default export */ const layout_picker = (/*#__PURE__*/(0,react.memo)(LayoutPicker));

// EXTERNAL MODULE: ./src/components/compare-products-toggle/index.tsx + 1 modules
var compare_products_toggle = __webpack_require__(25687);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/filter.js
var actions_filter = __webpack_require__(44291);
// EXTERNAL MODULE: ./src/areas/category/actions/category.js
var category = __webpack_require__(75554);
// EXTERNAL MODULE: ./src/areas/sidebar/constants.ts
var constants = __webpack_require__(90081);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/filter/index.js
var icon_filter = __webpack_require__(93438);
// EXTERNAL MODULE: ./src/areas/category/constants.ts
var category_constants = __webpack_require__(83220);
;// CONCATENATED MODULE: ./src/areas/category/sort/dropdown-sort-options.ts
function dropdown_sort_options_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function dropdown_sort_options_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return dropdown_sort_options_arrayLikeToArray(arr);
}
function dropdown_sort_options_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function dropdown_sort_options_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function dropdown_sort_options_toConsumableArray(arr) {
    return dropdown_sort_options_arrayWithoutHoles(arr) || dropdown_sort_options_iterableToArray(arr) || dropdown_sort_options_unsupportedIterableToArray(arr) || dropdown_sort_options_nonIterableSpread();
}
function dropdown_sort_options_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return dropdown_sort_options_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return dropdown_sort_options_arrayLikeToArray(o, minLen);
}

var getDropdownSortOptions = function(sort, t) {
    var bothDirectionsOptions = category_constants/* bothDirectionsSortOptions.filter */.I8.filter(function(x) {
        var ref;
        return sort === null || sort === void 0 ? void 0 : (ref = sort.available) === null || ref === void 0 ? void 0 : ref.includes(x);
    }).reduce(function(arr, option) {
        return [
            {
                name: t("common", "sort.".concat(option, ":asc")),
                value: "".concat(option, ":asc")
            },
            {
                name: t("common", "sort.".concat(option, ":desc")),
                value: "".concat(option, ":desc")
            }
        ].concat(dropdown_sort_options_toConsumableArray(arr));
    }, []).filter(function(x) {
        return x.value !== "".concat(sort === null || sort === void 0 ? void 0 : sort.name, ":").concat(sort === null || sort === void 0 ? void 0 : sort.direction);
    });
    return category_constants/* sortOptions.filter */.Fo.filter(function(x) {
        var ref;
        return sort === null || sort === void 0 ? void 0 : (ref = sort.available) === null || ref === void 0 ? void 0 : ref.includes(x);
    }).filter(function(x) {
        return x !== (sort === null || sort === void 0 ? void 0 : sort.name) && !category_constants/* bothDirectionsSortOptions.includes */.I8.includes(x);
    }).map(function(option) {
        return {
            name: t("common", "sort.".concat(option)),
            value: "".concat(option)
        };
    }).concat(bothDirectionsOptions);
};

;// CONCATENATED MODULE: ./src/areas/category/sort/dropdown-sort-selected.ts

var getDropdownSortSelected = function(sort, t) {
    return (sort === null || sort === void 0 ? void 0 : sort.name) && sort.name.indexOf("property:") !== 0 ? t("common", "sort.".concat(sort.name).concat(category_constants/* bothDirectionsSortOptions.includes */.I8.includes(sort.name) ? ":".concat(sort.direction) : "")) : "";
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/dropdown/index.js
var dropdown = __webpack_require__(42654);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(54262);
// EXTERNAL MODULE: ./src/components/dropdown-item/index.ts + 1 modules
var dropdown_item = __webpack_require__(28839);
;// CONCATENATED MODULE: ./src/areas/category/category-header-actions.tsx



















var CategoryHeaderActions = function(param) {
    var mode = param.mode, onSortChange = param.onSortChange, pageInfo = param.pageInfo, showHorizontalFilter = param.showHorizontalFilter, compareProductSelection = param.compareProductSelection;
    var dispatch = (0,es/* useDispatch */.I0)();
    var t = (0,app_context/* useAppContext */.bp)().t;
    var sidebarSettings = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.sidebar;
    });
    var categorySettings = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.category;
    });
    var _filter = categorySettings.filter, filterError = _filter.error, query = _filter.query;
    var abortProductSelectionFromCompareButton = (0,react.useCallback)(function() {
        return compareProductSelection.abortProductSelection();
    }, [
        compareProductSelection
    ]);
    var count = Object.keys(query).length;
    var filterIsOpen = sidebarSettings && sidebarSettings.tab === constants/* SIDEBAR_STATE.FILTER */.$J.FILTER;
    var dropdownSortOptions = (0,react.useMemo)(function() {
        return getDropdownSortOptions(pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.sort, t);
    }, [
        pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.sort,
        t
    ]);
    var dropdownSortSelected = (0,react.useMemo)(function() {
        return getDropdownSortSelected(pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.sort, t);
    }, [
        t,
        pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.sort
    ]);
    var filterOnClickHandler = function() {
        return dispatch((0,actions_filter/* toggleFilter */.c)());
    };
    var layoutOnClickHandler = function(m) {
        return dispatch((0,category/* categoryLayoutRequest */.VV)(m));
    };
    return /*#__PURE__*/ react.createElement(PanelHeaderActions, null, !filterError && !showHorizontalFilter && /*#__PURE__*/ react.createElement(FilterButton, {
        type: filterIsOpen ? variants.ButtonType.PRIMARY : variants.ButtonType.OUTLINED,
        onClick: filterOnClickHandler,
        elevation: ui_button.ButtonElevation.NONE
    }, /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, count ? /*#__PURE__*/ react.createElement(counter, {
        count: count,
        variant: filterIsOpen ? Variant.LIGHT : Variant.DARK,
        color: Color.PRIMARY
    }) : /*#__PURE__*/ react.createElement(icon_filter/* IconFilter */.w, {
        size: 18
    })), /*#__PURE__*/ react.createElement(ui_button.ButtonText, null, t("filter", "filter.title"))), /*#__PURE__*/ react.createElement(dropdown/* Dropdown */.Lt, {
        closeOnItemClick: true,
        containerProps: {
            "data-test": "SortOrderDropdown"
        }
    }, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
        type: variants.ButtonType.OUTLINED,
        showActiveIcon: true,
        containerProps: {
            "data-test": "DropdownToggle"
        }
    }, dropdownSortSelected), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        placement: ui/* Direction.Down */.Nm.Down
    }, dropdownSortOptions.map(function(option) {
        return /*#__PURE__*/ react.createElement(dropdown_item/* DropdownItem */.h, {
            "data-test": "DropdownOption",
            containerProps: {
                "data-test-value": option.value
            },
            key: option.value,
            onClick: function() {
                return onSortChange(option.value);
            }
        }, option.name);
    }))), /*#__PURE__*/ react.createElement(PanelHeaderButtons, null, /*#__PURE__*/ react.createElement(layout_picker, {
        mode: mode,
        onClick: layoutOnClickHandler
    }), /*#__PURE__*/ react.createElement(compare_products_toggle/* default */.Z, {
        active: compareProductSelection.isSelectingProducts,
        activate: compareProductSelection.startProductSelection,
        deactivate: abortProductSelectionFromCompareButton
    })));
};

;// CONCATENATED MODULE: ./src/areas/category/category-header.tsx









var CategoryHeader = function(param) {
    var mode = param.mode, onSortChange = param.onSortChange, pageInfo = param.pageInfo, showHorizontalFilter = param.showHorizontalFilter, immediateProducts = param.immediateProducts, categoryName = param.categoryName, productCount = param.productCount, storesCount = param.storesCount, compareProductSelection = param.compareProductSelection;
    var ref, ref1;
    var ref2 = (0,app_context/* useAppContext */.bp)(), t = ref2.t, market = ref2.market;
    var productCountText = t("category", "products.count", {
        n: productCount,
        count: productCount
    });
    return /*#__PURE__*/ react.createElement(react.Fragment, null, immediateProducts ? /*#__PURE__*/ react.createElement(PanelHeader, null, /*#__PURE__*/ react.createElement(list_variants.Column, null, /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, {
        container: "h2",
        containerProps: {
            "data-test": "PanelHeader"
        }
    }, t("category", "products.title"))), /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, null, productCountText))), /*#__PURE__*/ react.createElement(CategoryHeaderActions, {
        mode: mode,
        onSortChange: onSortChange,
        pageInfo: pageInfo,
        showHorizontalFilter: showHorizontalFilter,
        compareProductSelection: compareProductSelection
    })) : /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, {
        container: "h2"
    }, t("category", "popular-products.title", {
        categoryName: categoryName
    })), ((ref = market.modules) === null || ref === void 0 ? void 0 : (ref1 = ref.categoryInfo) === null || ref1 === void 0 ? void 0 : ref1.enabled) && /*#__PURE__*/ react.createElement(category_information/* default */.Z, {
        statistics: {
            productsCount: productCount,
            storesCount: storesCount
        }
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(14727);
// EXTERNAL MODULE: ./node_modules/.pnpm/query-string-for-all@6.8.3/node_modules/query-string-for-all/dist/index.js
var dist = __webpack_require__(25932);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/components/number-pagination/index.tsx + 3 modules
var number_pagination = __webpack_require__(49192);
// EXTERNAL MODULE: ./src/components/scroll/index.ts + 2 modules
var components_scroll = __webpack_require__(40763);
// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(95242);
// EXTERNAL MODULE: ./src/components/lazy/index.tsx
var lazy = __webpack_require__(85518);
// EXTERNAL MODULE: ./src/components/ads/index.tsx
var components_ads = __webpack_require__(13261);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(714);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/dropdown-down/index.js
var dropdown_down = __webpack_require__(19258);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/dropdown-up/index.js
var dropdown_up = __webpack_require__(12641);
;// CONCATENATED MODULE: ./src/areas/category/components/header/styles.ts
function header_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function header_styles_templateObject() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_styles_templateObject1() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  font-size: 12px;\n  display: table-header-group;\n  border-bottom: 1px solid ",
        ";\n\n  ",
        "\n"
    ]);
    header_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function header_styles_templateObject2() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  display: none;\n"
    ]);
    header_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = header_styles_taggedTemplateLiteral([
        "\n          color: ",
        ";\n          & ",
        ", & ",
        " {\n            display: inline-flex;\n          }\n        "
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = header_styles_taggedTemplateLiteral([
        "\n          width: ",
        "px;\n        "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  display: table-cell;\n  padding: 10px 8px 10px 0px;\n  vertical-align: middle;\n  line-height: 18px;\n  position: relative;\n  outline: 0;\n\n  &:hover,\n  &:focus {\n    color: ",
        ";\n    & ",
        ", & ",
        " {\n      display: inline-flex;\n    }\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = header_styles_taggedTemplateLiteral([
        "\n          flex-direction: row-reverse;\n          padding-right: ",
        ";\n        "
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n\n  ",
        "\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var ProductListingHeaderRoot = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductListingHeaderRoot",
    componentId: "sc-0-0"
})(header_styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.bg.secondary;
}, function(param) {
    var theme = param.theme;
    return theme.lines.secondary;
}, base/* media.mediumDown */.BC.mediumDown(header_styles_templateObject()));
var iconStyles = (0,styled_components_browser_esm.css)(header_styles_templateObject2());
var SortAscIcon = (0,styled_components_browser_esm["default"])(dropdown_up.IconDropdownUp).attrs({
    color: "base800"
}).withConfig({
    displayName: "SortAscIcon",
    componentId: "sc-0-1"
})(styles_templateObject3(), iconStyles);
var SortDescIcon = (0,styled_components_browser_esm["default"])(dropdown_down.IconDropdownDown).attrs({
    color: "base800"
}).withConfig({
    displayName: "SortDescIcon",
    componentId: "sc-0-2"
})(styles_templateObject4(), iconStyles);
var ProductListingHeaderCell = styled_components_browser_esm["default"].a.withConfig({
    displayName: "ProductListingHeaderCell",
    componentId: "sc-0-3"
})(styles_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.text.secondary;
}, function(param) {
    var theme = param.theme;
    return theme.text.primary;
}, SortAscIcon, SortDescIcon, function(props) {
    return props.selected ? (0,styled_components_browser_esm.css)(styles_templateObject5(), function(param) {
        var theme = param.theme;
        return theme.text.primary;
    }, SortAscIcon, SortDescIcon) : null;
}, function(props) {
    return props.width ? (0,styled_components_browser_esm.css)(styles_templateObject6(), props.width) : null;
});
var ProductListingHeaderCellContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductListingHeaderCellContent",
    componentId: "sc-0-4"
})(styles_templateObject9(), function(props) {
    return props.right ? (0,styled_components_browser_esm.css)(styles_templateObject8(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050) : null;
});

;// CONCATENATED MODULE: ./src/areas/category/components/header/index.tsx
function header_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function header_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return header_arrayLikeToArray(arr);
}
function header_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function header_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function header_toConsumableArray(arr) {
    return header_arrayWithoutHoles(arr) || header_iterableToArray(arr) || header_unsupportedIterableToArray(arr) || header_nonIterableSpread();
}
function header_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return header_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return header_arrayLikeToArray(o, minLen);
}





var truncate = function(maxLength, text) {
    return text.length > maxLength ? "".concat(text.substr(0, maxLength), "…") : text;
};
var getSortIcon = function(sortInfo, name) {
    return sortInfo && sortInfo.name === name && sortInfo.direction === "asc" ? /*#__PURE__*/ react.createElement(SortAscIcon, {
        size: 16
    }) : /*#__PURE__*/ react.createElement(SortDescIcon, {
        size: 16
    });
};
var isPriceSortMode = function(sortInfo) {
    return /^price/.test(sortInfo.name);
};
var getPriceSortMode = function(sortInfo) {
    return isPriceSortMode(sortInfo) && sortInfo.name;
};
var getPriceColumnLabel = function(sortInfo) {
    var defaultLabel = /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "category"
    }, "product-list.price-column-heading");
    switch(getPriceSortMode(sortInfo)){
        case "price":
            return defaultLabel;
        case "price_include_shipping":
            return /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
                domain: "category"
            }, "product-list.price-shipping-column-heading");
        default:
            return defaultLabel;
    }
};
var getWidth = function(numProperties) {
    if (numProperties === 2) return 160;
    if (numProperties === 3) return 120;
    if (numProperties > 4) return 100;
    return undefined;
};
var createRange = function(range) {
    return header_toConsumableArray(Array(range).keys());
};
var ProductListingHeader = function(param) {
    var selectedProperties = param.selectedProperties, onSortChange = param.onSortChange, sortInfo = param.sortInfo, firstColumnIndent = param.firstColumnIndent;
    /*#__PURE__*/ return react.createElement(ProductListingHeaderRoot, null, firstColumnIndent > 0 && createRange(firstColumnIndent).map(function(i) {
        return /*#__PURE__*/ react.createElement(ProductListingHeaderCell, {
            key: "indent_".concat(i)
        });
    }), /*#__PURE__*/ react.createElement(ProductListingHeaderCell, {
        key: "name",
        selected: sortInfo.name === "name",
        role: "link",
        tabIndex: 0,
        onClick: function() {
            return onSortChange("name");
        }
    }, /*#__PURE__*/ react.createElement(ProductListingHeaderCellContent, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "category"
    }, "product-list.name-column-heading"), getSortIcon(sortInfo, "name"))), /*#__PURE__*/ react.createElement(ProductListingHeaderCell, {
        key: "price",
        selected: sortInfo.name === getPriceSortMode(sortInfo),
        role: "link",
        tabIndex: 0,
        onClick: function() {
            return onSortChange(getPriceSortMode(sortInfo) || "price");
        }
    }, /*#__PURE__*/ react.createElement(ProductListingHeaderCellContent, {
        right: true
    }, getPriceColumnLabel(sortInfo), getSortIcon(sortInfo, getPriceSortMode(sortInfo)))), selectedProperties === null || selectedProperties === void 0 ? void 0 : selectedProperties.map(function(prop) {
        var propertyName = "property:".concat(prop.id);
        var isPropertySelected = sortInfo.name === propertyName;
        var shouldTruncateName = selectedProperties.length > 2 && prop.name !== truncate(20, prop.name);
        return /*#__PURE__*/ react.createElement(ProductListingHeaderCell, {
            key: prop.id,
            width: getWidth(selectedProperties.length),
            selected: isPropertySelected,
            "aria-label": shouldTruncateName ? prop.name : undefined,
            role: "link",
            tabIndex: 0,
            onClick: function() {
                return onSortChange(propertyName);
            }
        }, shouldTruncateName ? /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
            placement: ui/* Direction.Left */.Nm.Left,
            renderOnMouseOver: true,
            title: prop.name
        }, /*#__PURE__*/ react.createElement(ProductListingHeaderCellContent, null, truncate(20, prop.name), getSortIcon(sortInfo, propertyName))) : /*#__PURE__*/ react.createElement(ProductListingHeaderCellContent, null, prop.name, getSortIcon(sortInfo, propertyName)));
    }));
};
/* harmony default export */ const components_header = (ProductListingHeader);

// EXTERNAL MODULE: ./src/components/product-row/index.tsx + 1 modules
var product_row = __webpack_require__(24562);
// EXTERNAL MODULE: ./src/components/product-card-oldest/index.js + 1 modules
var product_card_oldest = __webpack_require__(36785);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/offer/price/price-label/index.tsx + 1 modules
var price_label = __webpack_require__(75695);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var rating = __webpack_require__(34990);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/shopping-cart/index.js
var shopping_cart = __webpack_require__(54234);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-tools@1.7.2/node_modules/styled-tools/dist/es/index.js + 7 modules
var dist_es = __webpack_require__(55703);
// EXTERNAL MODULE: ./src/components/product-checkbox/index.tsx + 1 modules
var product_checkbox = __webpack_require__(53692);
;// CONCATENATED MODULE: ./src/components/product-list-item/styles.tsx
function styles_extends() {
    styles_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return styles_extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function product_list_item_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_list_item_styles_templateObject() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: center;\n  "
    ]);
    product_list_item_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_list_item_styles_templateObject1() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: table-row;\n  border-bottom: 1px solid ",
        ";\n  ",
        ";\n"
    ]);
    product_list_item_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function product_list_item_styles_templateObject2() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n      &::before {\n        ",
        "\n      }\n    "
    ]);
    product_list_item_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function product_list_item_styles_templateObject3() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n  display: table-cell;\n  position: relative;\n  vertical-align: middle;\n\n  ",
        "\n\n  ",
        ":hover &::after,\n  ",
        ":focus-within &::after {\n    ",
        "\n  }\n"
    ]);
    product_list_item_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function product_list_item_styles_templateObject4() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n  order: 0;\n  width: 40px;\n  text-align: center;\n  height: auto;\n  padding: 10px 5px;\n"
    ]);
    product_list_item_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function product_list_item_styles_templateObject5() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n  width: 40px;\n  height: 40px;\n\n  img {\n    display: block;\n    max-width: 40px;\n    max-height: 40px;\n    width: auto;\n    height: auto;\n  }\n"
    ]);
    product_list_item_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function product_list_item_styles_templateObject6() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n    max-width: 230px;\n  "
    ]);
    product_list_item_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function product_list_item_styles_templateObject7() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n  flex: 1;\n  min-width: 200px;\n  position: relative;\n  padding: 0px ",
        " 0 5px;\n  ",
        ";\n"
    ]);
    product_list_item_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function product_list_item_styles_templateObject8() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n  display: inline-block;\n"
    ]);
    product_list_item_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function product_list_item_styles_templateObject9() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n  margin: 5px 0px 0px 0px;\n"
    ]);
    product_list_item_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 12px;\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 0;\n  bottom: 20px;\n  display: flex;\n  align-items: center;\n  flex-direction: column-reverse;\n  justify-content: space-around;\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n  display: block;\n  z-index: 2;\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n  outline: none;\n  flex: 0 0 20%;\n  text-align: right;\n  order: 2;\n  padding-right: 20px;\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  font-size: 12px;\n  color: ",
        ";\n  fill: ",
        ";\n  align-items: center;\n\n  svg {\n    height: 16px !important;\n    width: 16px !important;\n    margin-left: 2px;\n  }\n"
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n  outline: none;\n  font-size: 12px;\n  padding-right: 8px;\n  color: ",
        ";\n  width: ",
        ";\n  ",
        ";\n"
    ]);
    styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function styles_templateObject17() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n      &::before {\n        ",
        "\n      }\n    "
    ]);
    styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function styles_templateObject18() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  display: table-cell;\n  position: relative;\n  padding: 0 ",
        ";\n  vertical-align: middle;\n  width: ",
        "px;\n\n  ",
        "\n\n  ",
        ":hover &::after,\n  ",
        ":focus-within &::after {\n    ",
        "\n  }\n"
    ]);
    styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function styles_templateObject19() {
    var data = product_list_item_styles_taggedTemplateLiteral([
        "\n  box-sizing: border-box;\n  margin: 10px 2px;\n  width: ",
        "px;\n\n  ",
        ":hover & {\n    ",
        "\n  }\n"
    ]);
    styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}






// We want to exclude the hasExtra prop from forwarding, as it would otherwise be set on Link's DOM
// element, which triggers a React warning.
var Link = function(_param) /*#__PURE__*/ {
    var hasExtra = _param.hasExtra, props = _objectWithoutProperties(_param, [
        "hasExtra"
    ]);
    return react.createElement(react_router_dom/* Link */.rU, styles_extends({}, props));
};
var TableRow = styled_components_browser_esm["default"].div.attrs({
    "data-test": "ProductListRow"
}).withConfig({
    displayName: "TableRow",
    componentId: "sc-0-0"
})(product_list_item_styles_templateObject1(), function(p) {
    return p.theme.colors.base200;
}, base/* media.mediumDown */.BC.mediumDown(product_list_item_styles_templateObject()));
var LinkCell = (0,styled_components_browser_esm["default"])(Link).withConfig({
    displayName: "LinkCell",
    componentId: "sc-0-1"
})(product_list_item_styles_templateObject3(), function(props) {
    return props.selected && (0,styled_components_browser_esm.css)(product_list_item_styles_templateObject2(), base/* styledUtils.overlay */.au.overlay(props.theme.bg.productCompareLight));
}, TableRow, TableRow, base/* styledUtils.overlay */.au.overlay());
var ImageWrapper = (0,styled_components_browser_esm["default"])(LinkCell).withConfig({
    displayName: "ImageWrapper",
    componentId: "sc-0-2"
})(product_list_item_styles_templateObject4());
var Image = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Image",
    componentId: "sc-0-3"
})(product_list_item_styles_templateObject5(), function(p) {
    return p.theme.colors.base200;
}, base/* layout.borderRadius */.bK.borderRadius);
var BasicInfo = (0,styled_components_browser_esm["default"])(LinkCell).withConfig({
    displayName: "BasicInfo",
    componentId: "sc-0-4"
})(product_list_item_styles_templateObject7(), function(props) {
    return props.hasExtra ? "90px" : "5px";
}, base/* media.largeUp */.BC.largeUp(product_list_item_styles_templateObject6()));
var ProductDetails = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductDetails",
    componentId: "sc-0-5"
})(product_list_item_styles_templateObject8());
var ProductName = styled_components_browser_esm["default"].div.attrs({
    "data-test": "ProductName"
}).withConfig({
    displayName: "ProductName",
    componentId: "sc-0-6"
})(product_list_item_styles_templateObject9());
var Subtitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-7"
})(styles_templateObject10(), function(p) {
    return p.theme.colors.base500;
});
var BadgeArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BadgeArea",
    componentId: "sc-0-8"
})(styles_templateObject11());
var CampaignBadge = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CampaignBadge",
    componentId: "sc-0-9"
})(styles_templateObject12());
var PriceLabelWrapper = (0,styled_components_browser_esm["default"])(LinkCell).withConfig({
    displayName: "PriceLabelWrapper",
    componentId: "sc-0-10"
})(styles_templateObject13());
var StoreCount = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StoreCount",
    componentId: "sc-0-11"
})(styles_templateObject14(), function(p) {
    return p.theme.text.tertiary;
}, function(p) {
    return p.theme.icons.tertiary;
});
var PropertyCell = (0,styled_components_browser_esm["default"])(LinkCell).withConfig({
    displayName: "PropertyCell",
    componentId: "sc-0-12"
})(styles_templateObject16(), function(p) {
    return p.theme.text.tertiary;
}, (0,dist_es/* switchProp */.db)("width", {
    narrow: "160px",
    narrower: "120px",
    narrowest: "100px"
}, "auto"), base/* media.mediumDown */.BC.mediumDown(styles_templateObject15()));
var SelectBoxCell = styled_components_browser_esm["default"].label.withConfig({
    displayName: "SelectBoxCell",
    componentId: "sc-0-13"
})(styles_templateObject18(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, product_checkbox/* PRODUCT_CHECKBOX_SIZE */.mr, function(props) {
    return props.selected && (0,styled_components_browser_esm.css)(styles_templateObject17(), base/* styledUtils.overlay */.au.overlay(props.theme.bg.productCompareLight));
}, TableRow, TableRow, base/* styledUtils.overlay */.au.overlay());
var SelectBox = (0,styled_components_browser_esm["default"])(product_checkbox/* ProductCheckbox */.WX).withConfig({
    displayName: "SelectBox",
    componentId: "sc-0-14"
})(styles_templateObject19(), product_checkbox/* PRODUCT_CHECKBOX_SIZE */.mr, TableRow, product_checkbox/* productCheckboxHoverStyle */.lo);

;// CONCATENATED MODULE: ./src/components/product-list-item/index.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_list_item_extends() {
    product_list_item_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return product_list_item_extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var propertyCellWidth = function(propertyCount) {
    if (propertyCount >= 4) {
        return "narrowest";
    }
    if (propertyCount === 3) {
        return "narrower";
    }
    return "narrow";
};
var ProductListItem = function(props) {
    var selectAction = function(e) {
        e.preventDefault();
        if (props.selected) {
            props.onDeselect();
        } else {
            props.onSelect();
        }
    };
    var linkProps = _objectSpreadProps(_objectSpread({}, props.linkAttributes), {
        onClick: function(e) {
            if (props.selectable) {
                selectAction(e);
                return;
            }
            // prevent internal routing and force window.replace
            if (props.externalLink) {
                e.preventDefault();
                window.location.href = e.currentTarget.href;
            }
            props.onClick(e);
        },
        to: props.link
    });
    return /*#__PURE__*/ react.createElement(TableRow, {
        as: props.as,
        selectable: props.selectable,
        selected: props.selected,
        className: props.className
    }, props.selectable && /*#__PURE__*/ react.createElement(SelectBoxCell, null, /*#__PURE__*/ react.createElement(SelectBox, {
        selected: props.selected,
        onSelect: props.onSelect,
        onDeselect: props.onDeselect,
        "aria-label": props.name
    })), props.image && /*#__PURE__*/ react.createElement(ImageWrapper, product_list_item_extends({}, linkProps, {
        tabIndex: "-1"
    }), /*#__PURE__*/ react.createElement(Image, null, props.image)), /*#__PURE__*/ react.createElement(BasicInfo, product_list_item_extends({
        hasExtra: !!props.campaignBadge
    }, linkProps, {
        "aria-label": props.name
    }), /*#__PURE__*/ react.createElement(ProductDetails, null, /*#__PURE__*/ react.createElement(ProductName, null, props.name), props.rating ? /*#__PURE__*/ react.createElement(rating/* default */.Z, {
        hide: props.rating === null,
        rate: props.rating,
        showRate: true,
        size: "small",
        count: props.count,
        countTranslation: props.countTranslation,
        showCounter: true
    }) : undefined, props.subtitle && /*#__PURE__*/ react.createElement(Subtitle, null, props.subtitle)), /*#__PURE__*/ react.createElement(BadgeArea, null, props.campaignBadge && /*#__PURE__*/ react.createElement(CampaignBadge, null, props.campaignBadge))), props.price && /*#__PURE__*/ react.createElement(PriceLabelWrapper, product_list_item_extends({}, linkProps, {
        tabIndex: "-1"
    }), /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
        value: props.price
    }), props.storesCount !== null && /*#__PURE__*/ react.createElement(StoreCount, {
        title: props.storesCountTranslation
    }, /*#__PURE__*/ react.createElement("span", null, props.storesCount), " ", /*#__PURE__*/ react.createElement(shopping_cart/* IconShoppingCart */.w, {
        color: "base400",
        size: 16
    }))), props.properties && props.properties.length > 0 && props.properties.map(function(prop, index) {
        return /*#__PURE__*/ react.createElement(PropertyCell, product_list_item_extends({}, linkProps, {
            tabIndex: "-1",
            key: index.toString(),
            width: propertyCellWidth(props.properties.length)
        }), prop);
    }));
};
var func = (prop_types_default()).func, arrayOf = (prop_types_default()).arrayOf, object = (prop_types_default()).object, string = (prop_types_default()).string, number = (prop_types_default()).number, oneOfType = (prop_types_default()).oneOfType, product_list_item_element = (prop_types_default()).element, node = (prop_types_default()).node, shape = (prop_types_default()).shape, bool = (prop_types_default()).bool, elementType = (prop_types_default()).elementType;
ProductListItem.propTypes = {
    onClick: func,
    link: string.isRequired,
    image: node,
    name: string.isRequired,
    rating: number,
    count: number,
    countTranslation: shape({
        domain: string,
        key: string
    }),
    price: oneOfType([
        string,
        number,
        product_list_item_element
    ]),
    campaignBadge: product_list_item_element,
    subtitle: node,
    properties: oneOfType([
        arrayOf(string),
        arrayOf(object)
    ]),
    linkAttributes: shape({
        target: string,
        rel: string
    }),
    storesCount: number,
    storesCountTranslation: string,
    selectable: bool,
    selected: bool,
    onSelect: func,
    onDeselect: func,
    as: elementType,
    externalLink: bool,
    className: string
};
var noop = function() {};
ProductListItem.defaultProps = {
    onClick: noop,
    image: null,
    rating: undefined,
    count: undefined,
    countTranslation: {
        domain: "product",
        key: "product-card.n-ratings"
    },
    price: undefined,
    campaignBadge: null,
    subtitle: undefined,
    properties: [],
    linkAttributes: {},
    storesCount: null,
    storesCountTranslation: "",
    selectable: false,
    selected: false,
    onSelect: noop,
    onDeselect: noop,
    as: "div",
    externalLink: false
};

;// CONCATENATED MODULE: ./src/areas/category/components/product-listing/components/product/index.tsx







var renderPropertyValue = function(property, t) {
    if (property.type === "boolean") {
        if (property.prettyTable === null) return "-";
        return property.prettyTable === "true" ? t("category", "property.boolean-true") : t("category", "property.boolean-false");
    }
    return property.prettyTable;
};
var Product = function(param) {
    var id = param.id, mode = param.mode, link = param.link, name = param.name, image = param.image, price = param.price, rating = param.rating, ratingCount = param.ratingCount, category = param.category, campaignBadge = param.campaignBadge, brand = param.brand, storesCount = param.storesCount, storesCountText = param.storesCountText, _properties = param.properties, properties = _properties === void 0 ? [] : _properties, selectable = param.selectable, selected = param.selected, _onSelect = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    onSelect, onSelect = _onSelect === void 0 ? function() {} : _onSelect, _onDeselect = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    onDeselect, onDeselect = _onDeselect === void 0 ? function() {} : _onDeselect, _onClick = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    onClick, onClick = _onClick === void 0 ? function() {} : _onClick, className = param.className, onCategoryLinkClick = param.onCategoryLinkClick;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var select = (0,react.useCallback)(function() {
        return onSelect(id, "productCard");
    }, [
        id,
        onSelect
    ]);
    var deselect = (0,react.useCallback)(function() {
        return onDeselect(id, "productCard");
    }, [
        id,
        onDeselect
    ]);
    switch(mode){
        case "row":
            return /*#__PURE__*/ react.createElement(product_row/* default */.Z, {
                link: link,
                name: name,
                image: image,
                price: price,
                rating: rating,
                ratingCount: ratingCount,
                subtitle: category && category.name,
                campaignBadge: campaignBadge,
                storesCount: storesCount,
                storesCountText: storesCountText,
                showDivider: true,
                selectable: selectable,
                selected: selected,
                onSelect: select,
                onDeselect: deselect,
                onClick: onClick,
                className: className
            });
        case "grid":
            return /*#__PURE__*/ react.createElement(product_card_oldest/* ProductCard */.I, {
                id: id,
                link: link,
                name: name,
                image: image,
                price: price,
                rating: rating,
                ratingCount: ratingCount,
                category: category,
                campaignBadge: campaignBadge,
                brandLogo: brand && brand.featured && brand.logo ? /*#__PURE__*/ react.createElement("img", {
                    src: brand.logo,
                    alt: brand.name
                }) : null,
                selectable: selectable,
                selected: selected,
                onSelect: select,
                onDeselect: deselect,
                onClick: onClick,
                className: className,
                onCategoryLinkClick: onCategoryLinkClick
            });
        case "table":
            return /*#__PURE__*/ react.createElement(ProductListItem, {
                as: "li",
                link: link,
                name: name,
                image: image,
                price: price,
                rating: rating,
                count: ratingCount,
                campaignBadge: campaignBadge,
                storesCount: storesCount,
                storesCountTranslation: storesCountText,
                properties: properties.map(function(property) {
                    return /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
                        key: property.id,
                        placement: ui/* Direction.Left */.Nm.Left,
                        title: // eslint-disable-next-line no-nested-ternary
                        property.prettyTable !== null ? property.type === "boolean" ? "".concat(property.name, ": ").concat(renderPropertyValue(property, t)) : property.prettyVerbose : undefined
                    }, renderPropertyValue(property, t));
                }),
                selectable: selectable,
                selected: selected,
                onSelect: select,
                onDeselect: deselect,
                onClick: onClick,
                className: className
            });
        default:
            return null;
    }
};
/* harmony default export */ const components_product = (/*#__PURE__*/(0,react.memo)(Product));

// EXTERNAL MODULE: ./src/components/badges/deals-badge/index.tsx + 1 modules
var deals_badge = __webpack_require__(48285);
// EXTERNAL MODULE: ./src/hooks/experiments.ts + 1 modules
var experiments = __webpack_require__(11396);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/areas/category/components/product-listing/styles.ts
function product_listing_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_listing_styles_templateObject() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n        &.desktop-inline-ad {\n          display: block;\n          order: 3;\n        }\n      "
    ]);
    product_listing_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_listing_styles_templateObject1() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n        &.desktop-inline-ad {\n          display: table-row;\n          order: 3;\n        }\n      "
    ]);
    product_listing_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function product_listing_styles_templateObject2() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n    ",
        "\n\n    ",
        "\n  "
    ]);
    product_listing_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function product_listing_styles_templateObject3() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n        &.desktop-inline-ad {\n          display: block;\n          order: 4;\n        }\n      "
    ]);
    product_listing_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function product_listing_styles_templateObject4() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n        &.desktop-inline-ad {\n          display: table-row;\n          order: 4;\n        }\n      "
    ]);
    product_listing_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function product_listing_styles_templateObject5() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n    ",
        "\n\n    ",
        "\n  "
    ]);
    product_listing_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function product_listing_styles_templateObject6() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n        &.mobile-inline-ad-2 {\n          display: block;\n          order: 21;\n        }\n      "
    ]);
    product_listing_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function product_listing_styles_templateObject7() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n        min-width: 33%;\n        flex: 1 1 33%;\n\n        &.mobile-inline-ad-2 {\n          display: block;\n          order: 12;\n        }\n\n        &.mobile-inline-ad-3 {\n          display: block;\n          order: 18;\n        }\n      "
    ]);
    product_listing_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function product_listing_styles_templateObject8() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n    &.mobile-inline-ad-1 {\n      display: block;\n      order: 6;\n    }\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    product_listing_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function product_listing_styles_templateObject9() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n        &.mobile-inline-ad-2 {\n          display: block;\n          order: 14;\n        }\n      "
    ]);
    product_listing_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function product_listing_styles_templateObject10() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n        min-width: 50%;\n        flex: 1 1 50%;\n\n        &.mobile-inline-ad-2 {\n          display: block;\n          order: 8;\n        }\n\n        &.mobile-inline-ad-3 {\n          display: block;\n          order: 14;\n        }\n      "
    ]);
    product_listing_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function product_listing_styles_templateObject11() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n    &.mobile-inline-ad-1 {\n      display: block;\n      order: 2;\n    }\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    product_listing_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function product_listing_styles_templateObject12() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n      min-width: 100%;\n      flex: 1 1 100%;\n    "
    ]);
    product_listing_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function product_listing_styles_templateObject13() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n        &[class*='inline-ad'] {\n          display: table-row;\n        }\n      "
    ]);
    product_listing_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function product_listing_styles_templateObject14() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n      display: table-row;\n\n      > * {\n        display: table-cell;\n        // HACK: Without this, the first cell of the table will grow too much breaking the\n        // whole layout. Max width prevents that behavior\n        max-width: 10px;\n      }\n\n      ",
        "\n    "
    ]);
    product_listing_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function product_listing_styles_templateObject15() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n  min-width: 25%;\n  flex: 1 1 25%;\n\n  &.desktop-inline-ad,\n  &.mobile-inline-ad-1,\n  &.mobile-inline-ad-2,\n  &.mobile-inline-ad-3 {\n    display: none;\n    flex: 1 1 100%;\n  }\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    product_listing_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function product_listing_styles_templateObject16() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n          opacity: 0.5;\n          transition: opacity 0.5s;\n        "
    ]);
    product_listing_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function product_listing_styles_templateObject17() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n          display: table;\n          border-collapse: collapse;\n          width: 100%;\n        "
    ]);
    product_listing_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function product_listing_styles_templateObject18() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n    & .desktop-inline-ad {\n      display: block;\n      min-width: 100%;\n    }\n  "
    ]);
    product_listing_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function product_listing_styles_templateObject19() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  width: 100%;\n  opacity: 1;\n  transition: opacity 0.5s;\n  list-style: none;\n  line-height: 1.4;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    product_listing_styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function styles_templateObject20() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n          opacity: 0.5;\n          transition: opacity 0.5s;\n        "
    ]);
    styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function styles_templateObject21() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n  display: table-row-group;\n  list-style: none;\n  margin: 0;\n  opacity: 1;\n  transition: opacity 0.5s;\n\n  ",
        "\n"
    ]);
    styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function styles_templateObject22() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  font-style: italic;\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = product_listing_styles_taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}


var ProductListingItem = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductListingItem",
    componentId: "sc-0-0"
})(product_listing_styles_templateObject15(), base/* media.mediumUp */.BC.mediumUp(product_listing_styles_templateObject2(), function(props) {
    return props.mode === "grid" && (0,styled_components_browser_esm.css)(product_listing_styles_templateObject());
}, function(props) {
    return props.mode === "table" && (0,styled_components_browser_esm.css)(product_listing_styles_templateObject1());
}), base/* media.largeUp */.BC.largeUp(product_listing_styles_templateObject5(), function(props) {
    return props.mode === "grid" && (0,styled_components_browser_esm.css)(product_listing_styles_templateObject3());
}, function(props) {
    return props.mode === "table" && (0,styled_components_browser_esm.css)(product_listing_styles_templateObject4());
}), base/* media.mediumDown */.BC.mediumDown(product_listing_styles_templateObject8(), function(props) {
    return props.mode === "row" && (0,styled_components_browser_esm.css)(product_listing_styles_templateObject6());
}, function(props) {
    return props.mode === "grid" && (0,styled_components_browser_esm.css)(product_listing_styles_templateObject7());
}), base/* media.smallOnly */.BC.smallOnly(product_listing_styles_templateObject11(), function(props) {
    return props.mode === "row" && (0,styled_components_browser_esm.css)(product_listing_styles_templateObject9());
}, function(props) {
    return props.mode === "grid" && (0,styled_components_browser_esm.css)(product_listing_styles_templateObject10());
}), function(props) {
    return props.mode === "row" && (0,styled_components_browser_esm.css)(product_listing_styles_templateObject12());
}, function(props) {
    return props.mode === "table" && (0,styled_components_browser_esm.css)(product_listing_styles_templateObject14(), base/* media.smallOnly */.BC.smallOnly(product_listing_styles_templateObject13()));
});
var ProductListingWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductListingWrapper",
    componentId: "sc-0-1"
})(product_listing_styles_templateObject19(), function(props) {
    return props.$loading && props.$mode !== "table" ? (0,styled_components_browser_esm.css)(product_listing_styles_templateObject16()) : undefined;
}, function(props) {
    return props.$mode === "table" ? (0,styled_components_browser_esm.css)(product_listing_styles_templateObject17()) : undefined;
}, base/* media.largeUp */.BC.largeUp(product_listing_styles_templateObject18()));
var ProductListingTableBody = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductListingTableBody",
    componentId: "sc-0-2"
})(styles_templateObject21(), function(props) {
    return props.$loading ? (0,styled_components_browser_esm.css)(styles_templateObject20()) : undefined;
});
var ProductListingInformation = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductListingInformation",
    componentId: "sc-0-3"
})(styles_templateObject22(), function(param) {
    var theme = param.theme;
    return theme.text.quaternary;
}, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ProductListingFooter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductListingFooter",
    componentId: "sc-0-4"
})(_templateObject23(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

;// CONCATENATED MODULE: ./src/areas/category/components/product-listing/index.tsx
function product_listing_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_listing_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_listing_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function product_listing_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_listing_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_listing_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


















var SCROLL_KEY = "Product Listing";
var addStickyOffset = function() {
    if (window.innerWidth < 640) {
        return 50;
    }
    return 70;
};
var getSelectedProductProperties = function(properties, selectedProperties) {
    if (!properties || properties.length === 0 || !selectedProperties || selectedProperties.length === 0) {
        return [];
    }
    var selectedIds = selectedProperties.map(function(x) {
        return x.id;
    });
    // Sort properties into the correct order to match headers
    return properties.filter(function(x) {
        return selectedIds.includes(x.id);
    }).sort(function(a, b) {
        return selectedIds.indexOf(a.id) - selectedIds.indexOf(b.id);
    });
};
var getPriceBySortMode = function(product, sortMode) {
    var defaultPrice = product.priceSummary.regular || product.priceSummary.alternative;
    if (!sortMode || !sortMode.name) {
        return defaultPrice;
    }
    switch(sortMode.name){
        case "price":
            return defaultPrice;
        case "price_include_shipping":
            return product.priceSummary.includeShipping || defaultPrice;
        default:
            return defaultPrice;
    }
};
var ProductListing = function(param) {
    var children = param.children, header = param.header, products = param.products, mode = param.mode, _selectedProperties = param.selectedProperties, selectedProperties = _selectedProperties === void 0 ? [] : _selectedProperties, _onSortChange = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    onSortChange, onSortChange = _onSortChange === void 0 ? function() {} : _onSortChange, fallbackImage = param.fallbackImage, _showPagination = param.showPagination, showPagination = _showPagination === void 0 ? false : _showPagination, _showRatings = param.showRatings, showRatings = _showRatings === void 0 ? false : _showRatings, _showCategory = param.showCategory, showCategory = _showCategory === void 0 ? false : _showCategory, _showProductSelector = param.showProductSelector, showProductSelector = _showProductSelector === void 0 ? false : _showProductSelector, feedbackPrompt = param.feedbackPrompt, feedbackPromptPosition = param.feedbackPromptPosition, _onProductSelect = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    onProductSelect, onProductSelect = _onProductSelect === void 0 ? function() {} : _onProductSelect, _onProductDeselect = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    onProductDeselect, onProductDeselect = _onProductDeselect === void 0 ? function() {} : _onProductDeselect, _onProductClicked = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    onProductClicked, onProductClicked = _onProductClicked === void 0 ? function() {} : _onProductClicked, _selectedProducts = param.selectedProducts, selectedProducts = _selectedProducts === void 0 ? [] : _selectedProducts, _adverts = param.adverts, adverts = _adverts === void 0 ? {} : _adverts, _productCount = param.productCount, productCount = _productCount === void 0 ? 0 : _productCount, className = param.className;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var search = (0,react_router/* useLocation */.TH)().search;
    var nodes = products.nodes, pageInfo = products.pageInfo;
    var newAdsExperiment = (0,experiments/* useNewAds */.Lf)();
    var loading = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.category.productList.loading;
    });
    var generatePaginationUrl = (0,react.useCallback)(function(pageNumber) {
        return pageInfo ? "?".concat(dist_default().stringify(product_listing_objectSpreadProps(product_listing_objectSpread({}, dist_default().parse(search.substring(1))), {
            offset: pageNumber > 1 ? (pageNumber - 1) * pageInfo.limit : undefined
        }))) : "";
    }, [
        search,
        pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.limit
    ]);
    var productListItems = nodes.map(function(product, index) {
        var ref, ref1, ref2, ref3, ref4;
        var campaign = ((ref = product.dealInfo) === null || ref === void 0 ? void 0 : ref.dealPercentage) > 0;
        return /*#__PURE__*/ react.createElement(components_product, {
            key: product.id,
            id: product.id,
            mode: mode,
            link: product.pathName,
            name: product.name,
            image: /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
                offset: 0
            }, /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                name: product.name,
                src: product.media.first,
                fallback: fallbackImage
            })),
            price: getPriceBySortMode(product, pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.sort),
            rating: showRatings ? ((ref1 = product.aggregatedRating) === null || ref1 === void 0 ? void 0 : ref1.score) || product.userReviewSummary.rating : undefined,
            ratingCount: ((ref2 = product.aggregatedRating) === null || ref2 === void 0 ? void 0 : ref2.count) || ((ref3 = product.userReviewSummary) === null || ref3 === void 0 ? void 0 : ref3.count),
            category: showCategory ? product.category : undefined,
            campaignBadge: campaign ? /*#__PURE__*/ react.createElement(deals_badge/* DealsBadge */.T, {
                badgeType: deals_badge/* BadgeTypeEnum.BADGE */.Q.BADGE,
                "data-testid": "DealsBadge",
                priceDrop: (ref4 = product.dealInfo) === null || ref4 === void 0 ? void 0 : ref4.dealPercentage,
                price: getPriceBySortMode(product, pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.sort) || 0,
                popoverUniqueId: "product-page-offer"
            }) : null,
            brand: product.brand,
            storesCount: product.priceSummary.count,
            storesCountText: t("campaigns", "item.sold-by-n-stores", {
                n: product.priceSummary.count
            }),
            properties: getSelectedProductProperties(product.properties && product.properties.nodes, selectedProperties),
            selectable: showProductSelector,
            selected: showProductSelector && Boolean(selectedProducts.find(function(selectedProduct) {
                return selectedProduct.id === product.id;
            })),
            onSelect: onProductSelect,
            onDeselect: onProductDeselect,
            onCategoryLinkClick: function(clickInfo) {
                return (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.PRODUCT_LISTING_PRODUCT_CARD_CATEGORY_LINK */.U.PRODUCT_LISTING_PRODUCT_CARD_CATEGORY_LINK,
                    nextPage: clickInfo.url,
                    index: index
                });
            },
            onClick: function() {
                var offset = (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.offset) ? pageInfo.offset : 0;
                var clickIndex = index + 1 + offset;
                onProductClicked(clickIndex, product.pathName);
            }
        });
    });
    var advertSpacing = {
        top: "10px",
        bottom: "10px"
    };
    var ads = product_listing_objectSpread({
        desktopInline: /*#__PURE__*/ react.createElement(components_ads/* default */.Z, {
            scalable: true,
            scaleBase: ".pj-ui-panel",
            scaleOrigin: "left center",
            placement: "panorama_extra",
            format: "panorama_1_wde",
            min: 861,
            max: 10000,
            spacing: advertSpacing
        }),
        mobileInline1: /*#__PURE__*/ react.createElement(components_ads/* default */.Z, {
            placement: "dubbelpanorama1",
            format: "panorama_1",
            min: 0,
            max: 860,
            spacing: advertSpacing
        }),
        mobileInline2: /*#__PURE__*/ react.createElement(components_ads/* default */.Z, {
            placement: "dubbelpanorama2",
            format: "panorama_2",
            min: 0,
            max: 860,
            spacing: advertSpacing,
            triggerPoint: 100
        }),
        mobileInline3: /*#__PURE__*/ react.createElement(components_ads/* default */.Z, {
            placement: "dubbelpanorama2",
            format: "panorama_3",
            min: 0,
            max: 860,
            spacing: advertSpacing,
            triggerPoint: 100
        })
    }, adverts);
    var adWrapper = react.useCallback(function(ad, adClass) {
        return /*#__PURE__*/ react.createElement(ProductListingItem, {
            mode: mode,
            className: adClass
        }, ad);
    }, [
        mode
    ]);
    if (productListItems.length === 0) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(components_scroll/* ScrollElement */.xL, {
        name: SCROLL_KEY,
        className: className
    }, /*#__PURE__*/ react.createElement(panel/* Panel */.s_, {
        "data-test-type": "product-listing"
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, header, /*#__PURE__*/ react.createElement(ProductListingWrapper, {
        $loading: loading,
        $mode: mode
    }, mode !== "table" ? /*#__PURE__*/ react.createElement(react.Fragment, null, !newAdsExperiment && /*#__PURE__*/ react.createElement(react.Fragment, null, adWrapper(ads.desktopInline, "desktop-inline-ad"), adWrapper(ads.mobileInline1, "mobile-inline-ad-1"), nodes.length > 9 && adWrapper(ads.mobileInline2, "mobile-inline-ad-2"), mode === "grid" && nodes.length > 18 && adWrapper(ads.mobileInline3, "mobile-inline-ad-3")), feedbackPrompt && /*#__PURE__*/ react.createElement(ProductListingItem, {
        mode: mode,
        key: "feedback",
        style: {
            order: feedbackPromptPosition
        }
    }, feedbackPrompt), productListItems.map(function(prod, index) {
        return /*#__PURE__*/ react.createElement(ProductListingItem, {
            mode: mode,
            key: prod.key,
            style: {
                order: index
            }
        }, prod);
    })) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(components_header, {
        firstColumnIndent: showProductSelector ? 2 : 1,
        selectedProperties: selectedProperties,
        onSortChange: onSortChange,
        sortInfo: pageInfo.sort
    }), /*#__PURE__*/ react.createElement(ProductListingTableBody, {
        $loading: loading,
        "data-test": "ProductTable"
    }, productListItems.slice(0, 2), adWrapper(ads.mobileInline1, "mobile-inline-ad-1"), adWrapper(ads.desktopInline, "desktop-inline-ad"), productListItems.slice(2, 10), productListItems.length > 9 && adWrapper(ads.mobileInline2, "mobile-inline-ad-2"), productListItems.slice(10)))), children, showPagination && /*#__PURE__*/ react.createElement(ProductListingFooter, null, showPagination && productCount > 0 && pageInfo && /*#__PURE__*/ react.createElement(components_scroll/* ScrollLink */.Rv, {
        to: SCROLL_KEY,
        shouldScroll: function(param) {
            var tagName = param.tagName;
            return tagName === "A";
        },
        calculateOffset: addStickyOffset
    }, /*#__PURE__*/ react.createElement(number_pagination/* NumberPagination */.O, {
        currentPage: Math.floor(pageInfo.offset / pageInfo.limit) + 1,
        totalPages: Math.ceil(productCount / pageInfo.limit),
        linkToPage: generatePaginationUrl
    })), nodes.length > 0 && /*#__PURE__*/ react.createElement(ProductListingInformation, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "category"
    }, "product-list.data-information"))))));
};
/* harmony default export */ const product_listing = (/*#__PURE__*/(0,react.memo)(ProductListing));

// EXTERNAL MODULE: ./src/globals/actions/index.ts
var actions = __webpack_require__(99311);
// EXTERNAL MODULE: ./node_modules/.pnpm/querystring@0.2.1/node_modules/querystring/index.js
var querystring = __webpack_require__(97150);
// EXTERNAL MODULE: ./src/globals/tracking/filter.ts
var tracking_filter = __webpack_require__(15301);
// EXTERNAL MODULE: ./src/areas/product/actions/product.ts + 1 modules
var product = __webpack_require__(69140);
// EXTERNAL MODULE: ./src/globals/helpers/navigation-action.js
var navigation_action = __webpack_require__(83104);
;// CONCATENATED MODULE: ./src/areas/category/category-product-listing.tsx
function category_product_listing_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function category_product_listing_extends() {
    category_product_listing_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return category_product_listing_extends.apply(this, arguments);
}
function category_product_listing_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            category_product_listing_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function category_product_listing_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function category_product_listing_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        category_product_listing_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}













var CategoryProductListing = function(param) {
    var products = param.products, defaultLayoutMode = param.defaultLayoutMode, immediateProducts = param.immediateProducts, storesCount = param.storesCount, productCount = param.productCount, categoryName = param.categoryName, logo = param.logo, compareProductSelection = param.compareProductSelection;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var history = (0,react_router/* useHistory */.k6)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var categorySettings = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.category;
    });
    var showHorizontalFilter = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.category.filter.showHorizontalFilter;
    });
    var comparing = categorySettings.filter.comparing;
    var selectedProperties = products === null || products === void 0 ? void 0 : (ref = products.pageInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.selectedProperties) === null || ref1 === void 0 ? void 0 : ref1.filter(function(x) {
        return comparing.includes(x === null || x === void 0 ? void 0 : x.id);
    });
    var mode = !immediateProducts && "grid" || categorySettings.category && categorySettings.category.mode || defaultLayoutMode || "grid";
    var selectProductById = (0,react.useCallback)(function(productId) {
        var selectedProduct = products.nodes.find(function(p) {
            return p.id === productId;
        });
        if (selectedProduct) {
            compareProductSelection.selectProduct(selectedProduct);
        }
    }, [
        products,
        compareProductSelection
    ]);
    var deselectProductById = (0,react.useCallback)(function(productId) {
        var ref;
        var deselectedProduct = products === null || products === void 0 ? void 0 : (ref = products.nodes) === null || ref === void 0 ? void 0 : ref.find(function(p) {
            return (p === null || p === void 0 ? void 0 : p.id) === productId;
        });
        if (deselectedProduct) {
            compareProductSelection.deselectProduct(deselectedProduct);
        }
    }, [
        products,
        compareProductSelection
    ]);
    var trackProductCardClick = function(index, link) {
        dispatch((0,product/* productNavigation */.$0)(navigation_action/* POPULAR_CLICK */.LT, index + 1));
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.POPULAR_PRODUCTS_PRODUCT_CARD */.U.POPULAR_PRODUCTS_PRODUCT_CARD,
            nextPage: link,
            index: index
        });
    };
    var onSortChange = (0,react.useCallback)(function(key) {
        var ref, ref1;
        if (key == null) return;
        var value = String(key);
        var location = history.location;
        var qs = querystring.decode(location.search.substr(1));
        var selectedSortProperty = value.replace(/:(asc|desc)$/, "");
        var selectedSortDirection = value.match(/:(asc|desc)$/);
        var currentSortDirection = products === null || products === void 0 ? void 0 : (ref = products.pageInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.sort) === null || ref1 === void 0 ? void 0 : ref1.direction;
        var data = {
            replaceHistory: true,
            value: ""
        };
        if (selectedSortDirection) {
            // Sort direction was selected from dropdown
            data.value = "".concat(selectedSortProperty, ":").concat(selectedSortDirection[1]);
        } else if (qs.sort === selectedSortProperty) {
            // Same sort property, then we toggle the current sort direction
            data.value = "".concat(selectedSortProperty, ":").concat(currentSortDirection === "asc" ? "desc" : "asc");
        } else {
            // Changed to a new sort property
            data.value = "".concat(selectedSortProperty);
        }
        delete qs.offset;
        (0,tracking_filter/* trackSortingSelectEvent */.Em)({
            category: categoryName,
            property: selectedSortProperty,
            value: data.value,
            scope: tracking_filter/* PageScope.CATEGORY */.VN.CATEGORY
        });
        dispatch((0,actions/* sortChange */.rB)(data));
    }, [
        categoryName,
        dispatch,
        history.location,
        products === null || products === void 0 ? void 0 : (ref2 = products.pageInfo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sort) === null || ref3 === void 0 ? void 0 : ref3.direction
    ]);
    var sortedProducts = (0,react.useMemo)(function() {
        if (!products || immediateProducts) {
            return products;
        }
        // For non-leaf categories, we want to re-sort the fetched products to showcase more sub-categories,
        // and only render the first 12
        return category_product_listing_objectSpreadProps(category_product_listing_objectSpread({}, products), {
            nodes: products.nodes ? products.nodes.sort(function(a, b) {
                var ref, ref1, ref2, ref3;
                if ((a === null || a === void 0 ? void 0 : (ref = a.popularity) === null || ref === void 0 ? void 0 : ref.inCategory) === (b === null || b === void 0 ? void 0 : (ref1 = b.popularity) === null || ref1 === void 0 ? void 0 : ref1.inCategory)) {
                    var ref4, ref5;
                    return ((a === null || a === void 0 ? void 0 : (ref4 = a.popularity) === null || ref4 === void 0 ? void 0 : ref4.total) || 0) > ((b === null || b === void 0 ? void 0 : (ref5 = b.popularity) === null || ref5 === void 0 ? void 0 : ref5.total) || 0) ? 1 : -1;
                }
                return ((a === null || a === void 0 ? void 0 : (ref2 = a.popularity) === null || ref2 === void 0 ? void 0 : ref2.inCategory) || 0) > ((b === null || b === void 0 ? void 0 : (ref3 = b.popularity) === null || ref3 === void 0 ? void 0 : ref3.inCategory) || 0) ? 1 : -1;
            }).slice(0, 12) : products.nodes
        });
    }, [
        products,
        immediateProducts
    ]);
    var productListingAdverts = (0,react.useMemo)(function() {
        return {
            desktopInline: /*#__PURE__*/ react.createElement(components_ads/* default */.Z, category_product_listing_extends({
                scalable: true,
                scaleBase: ".pj-ui-panel",
                scaleOrigin: "left center",
                min: 861,
                max: 10000,
                spacing: {
                    bottom: "10px"
                }
            }, immediateProducts ? {
                placement: "panorama_extra",
                format: "panorama_1_wde"
            } : {
                placement: "panorama_target",
                format: "panorama_3_wde",
                triggerPoint: 100
            }))
        };
    }, [
        immediateProducts
    ]);
    var showProductSelector = immediateProducts && compareProductSelection.isSelectingProducts;
    var DesktopProductListing = /*#__PURE__*/ react.createElement(product_listing, {
        header: /*#__PURE__*/ react.createElement(CategoryHeader, {
            mode: mode,
            storesCount: storesCount,
            productCount: productCount,
            onSortChange: onSortChange,
            pageInfo: products === null || products === void 0 ? void 0 : products.pageInfo,
            immediateProducts: immediateProducts,
            categoryName: categoryName,
            showHorizontalFilter: showHorizontalFilter,
            compareProductSelection: compareProductSelection
        }),
        products: sortedProducts,
        selectedProperties: selectedProperties,
        mode: getListRenderMode(mode, immediateProducts, true),
        onSortChange: onSortChange,
        fallbackImage: logo,
        showPagination: immediateProducts && ((products === null || products === void 0 ? void 0 : (ref4 = products.pageInfo) === null || ref4 === void 0 ? void 0 : ref4.hasNext) || (products === null || products === void 0 ? void 0 : (ref5 = products.pageInfo) === null || ref5 === void 0 ? void 0 : ref5.hasPrevious)),
        showRatings: immediateProducts,
        showCategory: !immediateProducts,
        showProductSelector: showProductSelector,
        selectedProducts: compareProductSelection.selectedProducts,
        onProductSelect: selectProductById,
        onProductDeselect: deselectProductById,
        onProductClicked: trackProductCardClick,
        adverts: productListingAdverts,
        productCount: productCount
    });
    var MobileProductListing = /*#__PURE__*/ react.cloneElement(DesktopProductListing, category_product_listing_objectSpreadProps(category_product_listing_objectSpread({}, DesktopProductListing.props), {
        mode: getListRenderMode(mode, immediateProducts, false)
    }));
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, DesktopProductListing), /*#__PURE__*/ react.createElement(block/* MediumDown */.H5, null, MobileProductListing));
};
function getListRenderMode(mode, immediateProducts, isDesktop) {
    // Render row mode as a table if category has filter and everything
    if (mode === "row" && immediateProducts && isDesktop) {
        return "table";
    }
    return mode;
}

// EXTERNAL MODULE: ./src/components/featured-article/index.tsx + 5 modules
var featured_article = __webpack_require__(83068);
;// CONCATENATED MODULE: ./src/areas/category/category-articles.tsx





var CategoryArticles = function(param) {
    var articles = param.articles;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var featuredArticle = articles ? articles.find(function(item) {
        return item.featured;
    }) : null;
    if (!featuredArticle) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(CategoryPageGutter, null, /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, t("category", "article.related-articles")), /*#__PURE__*/ react.createElement(featured_article/* FeaturedArticle */.h, {
        article: featuredArticle,
        related: articles
    })));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/redux-saga@1.0.3/node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js + 1 modules
var redux_saga_effects_npm_proxy_esm = __webpack_require__(38247);
// EXTERNAL MODULE: ./src/globals/api/requests.js
var requests = __webpack_require__(15287);
;// CONCATENATED MODULE: ./src/areas/category/sagas/index.js
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};



function changeLayout(param) {
    var mode, response, e;
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                mode = param.mode;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    6,
                    ,
                    8
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,category/* categoryLayoutChanged */.GW)(mode))
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* putSession */.hO, "categoryLayout", mode)
                ];
            case 3:
                response = _state.sent();
                if (!(response.status !== 200)) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,category/* categoryLayoutFailed */.xV)("Failed with response code: ".concat(response.status)))
                ];
            case 4:
                _state.sent();
                _state.label = 5;
            case 5:
                return [
                    3,
                    8
                ];
            case 6:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,category/* categoryLayoutFailed */.xV)(e.message))
                ];
            case 7:
                _state.sent();
                return [
                    3,
                    8
                ];
            case 8:
                return [
                    2
                ];
        }
    });
}
function mySaga() {
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeEvery */.ib)("CATEGORY_LAYOUT_REQUEST", changeLayout)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
if (true) {
    window.registerSaga(mySaga);
}
/* harmony default export */ const sagas = ((/* unused pure expression or super */ null && (mySaga)));

// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(42281);
// EXTERNAL MODULE: ./src/areas/category/query.graphql
var query_graphql = __webpack_require__(48472);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(48458);
;// CONCATENATED MODULE: ./src/areas/category/queries/use-category-page-query.ts


function useCategoryPageQuery(variables) {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (query_graphql_default()),
        routeName: "category",
        variables: variables
    });
}

// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(62619);
// EXTERNAL MODULE: ./src/components/category-list/index.tsx + 9 modules
var category_list = __webpack_require__(75318);
;// CONCATENATED MODULE: ./src/areas/category/components/services/index.tsx
function services_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function services_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return services_arrayLikeToArray(arr);
}
function services_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function services_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function services_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function services_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            services_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function services_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function services_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        services_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function services_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function services_toConsumableArray(arr) {
    return services_arrayWithoutHoles(arr) || services_iterableToArray(arr) || services_unsupportedIterableToArray(arr) || services_nonIterableSpread();
}
function services_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return services_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return services_arrayLikeToArray(o, minLen);
}
function services_templateObject() {
    var data = services_taggedTemplateLiteral([
        "\n  padding-left: 0.8rem;\n  padding-right: 0.8rem;\n"
    ]);
    services_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var icon = "https://cdn.pji.nu/g/cat/192/tjanster.png";
var Gutter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Gutter",
    componentId: "sc-0-0"
})(services_templateObject());
var Services = function(param) {
    var data = param.data;
    var ref, ref1;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var categoryTree = data.categoryTree;
    var services = categoryTree && ((ref = categoryTree[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.children) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(acc, child) {
        var newChild = child ? services_objectSpreadProps(services_objectSpread({}, child), {
            logo: {
                192: child.logo
            }
        }) : null;
        return newChild ? services_toConsumableArray(acc).concat([
            newChild
        ]) : acc;
    }, []));
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(BreadCrumbWrapper, null, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        crumbs: [
            {
                title: t("category", "service-list.title")
            }
        ]
    })), /*#__PURE__*/ react.createElement(page/* PageHeader */.mr, {
        media: /*#__PURE__*/ react.createElement(page/* PageHeaderMedia */.WH, {
            alt: t("category", "service-list.title"),
            src: icon
        }),
        title: t("category", "service-list.title"),
        description: t("category", "service-list.description")
    }), /*#__PURE__*/ react.createElement(Gutter, null, /*#__PURE__*/ react.createElement(category_list/* CategoryList */.o, {
        categories: services !== null && services !== void 0 ? services : [],
        withAds: true
    })));
};

// EXTERNAL MODULE: ./src/areas/product-collection/components/products/layout-grid/index.tsx + 18 modules
var layout_grid = __webpack_require__(14232);
// EXTERNAL MODULE: ./src/areas/product/components/carousel-products/index.tsx
var carousel_products = __webpack_require__(23013);
// EXTERNAL MODULE: ./src/areas/product/components/carousel-products/types.ts
var types = __webpack_require__(57048);
// EXTERNAL MODULE: ./src/areas/product/components/carousel-products/utils.ts
var utils = __webpack_require__(603);
// EXTERNAL MODULE: ./src/components/campaign-deals/index.ts
var campaign_deals = __webpack_require__(87341);
// EXTERNAL MODULE: ./src/components/category-description/index.tsx + 1 modules
var category_description = __webpack_require__(7688);
// EXTERNAL MODULE: ./src/areas/product-collection/components/navigation/navigation-component.tsx + 4 modules
var navigation_component = __webpack_require__(51772);
;// CONCATENATED MODULE: ./src/areas/category/components/segment/styles.ts
function segment_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function segment_styles_templateObject() {
    var data = segment_styles_taggedTemplateLiteral([
        "\n    gap: ",
        ";\n  "
    ]);
    segment_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function segment_styles_templateObject1() {
    var data = segment_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  padding: 0 ",
        ";\n  margin-bottom: ",
        ";\n  ",
        "\n"
    ]);
    segment_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function segment_styles_templateObject2() {
    var data = segment_styles_taggedTemplateLiteral([
        "\n  margin: ",
        ";\n"
    ]);
    segment_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function segment_styles_templateObject3() {
    var data = segment_styles_taggedTemplateLiteral([
        "\n  margin: 0;\n"
    ]);
    segment_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function segment_styles_templateObject4() {
    var data = segment_styles_taggedTemplateLiteral([
        "\n  margin: 0 -",
        ";\n"
    ]);
    segment_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function segment_styles_templateObject5() {
    var data = segment_styles_taggedTemplateLiteral([
        "\n  /* The negative margin are for the border bottom to go all the way to the edge on mobile.*/\n  margin-left: -",
        ";\n  margin-right: -",
        ";\n"
    ]);
    segment_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-0"
})(segment_styles_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* media.mediumUp */.BC.mediumUp(segment_styles_templateObject(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150));
var ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ContentWrapper",
    componentId: "sc-0-1"
})(segment_styles_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Header = (0,styled_components_browser_esm["default"])(page/* PageHeader */.mr).withConfig({
    displayName: "Header",
    componentId: "sc-0-2"
})(segment_styles_templateObject3());
var Navigation = (0,styled_components_browser_esm["default"])(navigation_component/* NavigationSliceView */.B).withConfig({
    displayName: "Navigation",
    componentId: "sc-0-3"
})(segment_styles_templateObject4(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var CategoryList = (0,styled_components_browser_esm["default"])(category_list/* CategoryList */.o).withConfig({
    displayName: "CategoryList",
    componentId: "sc-0-4"
})(segment_styles_templateObject5(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./src/components/layout-buttons/types.ts
var layout_buttons_types = __webpack_require__(21068);
;// CONCATENATED MODULE: ./src/areas/category/components/segment/index.tsx
function segment_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}






















var Segment = function(param) {
    var data = param.data;
    var ref = (0,app_context/* useAppContext */.bp)(), t = ref.t, linkTo = ref.linkTo;
    var dispatch = (0,es/* useDispatch */.I0)();
    var history = (0,react_router_dom/* useHistory */.k6)();
    var category = data.category, categoryTree = data.categoryTree, campaignDeals = data.campaignDeals, newProducts = data.newProducts;
    var path = category.path, aliases = category.aliases, description = category.description, name = category.name, popularProducts = category.popularProducts, newPopularSearchTerms = category.newPopularSearchTerms, trendingProducts = category.trendingProducts;
    var newAdsExperiment = (0,experiments/* useNewAds */.Lf)();
    var popularKeywords = (newPopularSearchTerms === null || newPopularSearchTerms === void 0 ? void 0 : newPopularSearchTerms.popularKeywords) && (newPopularSearchTerms === null || newPopularSearchTerms === void 0 ? void 0 : newPopularSearchTerms.popularKeywords.length) ? newPopularSearchTerms.popularKeywords : null;
    var ref1;
    var trendingKeywords = (ref1 = newPopularSearchTerms === null || newPopularSearchTerms === void 0 ? void 0 : newPopularSearchTerms.trendingKeywords) !== null && ref1 !== void 0 ? ref1 : [];
    var newProductReleases = newProducts === null || newProducts === void 0 ? void 0 : newProducts.newReleases;
    var ref2;
    var formattedNavigationLinks = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref2 = (ref = categoryTree[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.children) === null || ref1 === void 0 ? void 0 : ref1.map(function(child) {
            var imageUrl = child.logo;
            var linkPath = linkTo("category", child);
            var value = child.name;
            return {
                id: child.id,
                value: value,
                path: linkPath,
                imageUrl: imageUrl,
                selected: false,
                indexable: true
            };
        })) !== null && ref2 !== void 0 ? ref2 : [];
    }, [
        categoryTree
    ]);
    var _name;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(ContentWrapper, null, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        crumbs: path.map(function(param, index) {
            var title = param.name, href = param.pathName;
            return {
                href: path.length - 1 !== index ? href : undefined,
                title: title
            };
        })
    })), /*#__PURE__*/ react.createElement(Content, null, category.name && /*#__PURE__*/ react.createElement(Header, {
        title: category.name,
        media: category.logo && /*#__PURE__*/ react.createElement(page/* PageHeaderMedia */.WH, {
            src: category.logo,
            alt: (_name = category.name) !== null && _name !== void 0 ? _name : undefined
        })
    }), /*#__PURE__*/ react.createElement(Navigation, {
        links: formattedNavigationLinks,
        onClickPreventDefault: true,
        onClick: function(link) {
            if (link.path) history.push(link.path);
        }
    }), category.categoryTree && /*#__PURE__*/ react.createElement(react.Fragment, null, !newAdsExperiment && /*#__PURE__*/ react.createElement(block/* MobileOnly */.iB, null, /*#__PURE__*/ react.createElement(components_ads/* default */.Z, {
        onlyWithServices: [
            "appnexus"
        ],
        placement: "dubbelpanorama1",
        format: "panorama_1",
        min: 0,
        max: 860,
        spacing: {
            top: "0",
            bottom: "10px"
        }
    })), /*#__PURE__*/ react.createElement(CategoryList, {
        categories: category.categoryTree
    }), !newAdsExperiment && /*#__PURE__*/ react.createElement(components_ads/* default */.Z, {
        scalable: true,
        scaleBase: ".category-page--adWrapper",
        placement: "panorama_extra",
        format: "panorama_1_wde",
        min: 861,
        max: 10000,
        spacing: {
            top: "0",
            bottom: "10px"
        }
    })), popularProducts && category.name ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(text_variants.H3Text, {
        container: "h2"
    }, t("category", "popular-products.title", {
        categoryName: category.name
    })), /*#__PURE__*/ react.createElement(layout_grid/* GridLayout */.M, {
        expert: null,
        onClick: function(_productId, _productName, _type, index) {
            if (index) dispatch((0,product/* productNavigation */.$0)(navigation_action/* SEGMENT_PRODUCT_CLICK */.gv, index + 1));
        },
        products: popularProducts.nodes,
        showCategoryButton: true,
        adsLayoutConfig: segment_defineProperty({}, layout_buttons_types/* LayoutMode.GRID */.X.GRID, {
            panorama_extra: {
                show: true,
                row: 2,
                customPlacement: "desktopPanorama1"
            },
            dubbelpanorama1: {
                show: true,
                row: 2,
                customPlacement: "mobilePanorama1"
            },
            dubbelpanorama2: {
                show: true,
                row: 8,
                customPlacement: "mobilePanorama2"
            }
        })
    })) : null, newProductReleases ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(text_variants.H3Text, {
        container: "h2"
    }, t("landing", "personalized-releases.title")), /*#__PURE__*/ react.createElement(layout_grid/* GridLayout */.M, {
        expert: null,
        onClick: function(_productId, _productName, _type, index) {
            if (index) dispatch((0,product/* productNavigation */.$0)(navigation_action/* SEGMENT_PRODUCT_CLICK */.gv, index + 1));
        },
        products: newProductReleases.nodes,
        showCategoryButton: true,
        adsLayoutConfig: segment_defineProperty({}, layout_buttons_types/* LayoutMode.GRID */.X.GRID, {
            panorama_extra: {
                show: true,
                row: 2,
                customPlacement: "desktopPanorama2"
            },
            dubbelpanorama1: {
                show: true,
                row: 2,
                customPlacement: "mobilePanorama3"
            },
            dubbelpanorama2: {
                show: true,
                row: 8,
                customPlacement: "mobilePanorama4"
            }
        })
    })) : null, Array.isArray(trendingProducts) && trendingProducts.length > 0 ? /*#__PURE__*/ react.createElement(ContentWrapper, null, /*#__PURE__*/ react.createElement(carousel_products/* CarouselProducts */.S, {
        title: t("landing", "trending-products.title"),
        products: (0,utils/* mapCarouselProducts */.b)(trendingProducts) || [],
        carouselType: types/* CarouselTypeEnum.TRENDING_PRODUCTS */.c.TRENDING_PRODUCTS
    })) : null, /*#__PURE__*/ react.createElement(category_description/* default */.Z, {
        name: name,
        description: description,
        aliases: aliases
    }), (campaignDeals === null || campaignDeals === void 0 ? void 0 : campaignDeals.length) ? /*#__PURE__*/ react.createElement(campaign_deals/* default */.Z, {
        deals: campaignDeals,
        negativeMargin: true,
        categoryId: category.id
    }) : null, /*#__PURE__*/ react.createElement(recently_visited/* default */.Z, null), Array.isArray(trendingKeywords) && trendingKeywords.length ? /*#__PURE__*/ react.createElement(word_cloud/* default */.Z, {
        title: t("search", "search.trending-searches"),
        items: trendingKeywords,
        showMoreUrl: linkTo("keywordListing", category),
        numberOfVisibleItems: 10
    }) : null, Array.isArray(popularKeywords) && popularKeywords.length ? /*#__PURE__*/ react.createElement(word_cloud/* default */.Z, {
        title: t("search", "search.related-searches"),
        items: popularKeywords,
        showMoreUrl: linkTo("keywordListing", category),
        numberOfVisibleItems: 35
    }) : null));
};


;// CONCATENATED MODULE: ./src/areas/category/category.tsx
function category_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function category_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function category_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function category_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function category_slicedToArray(arr, i) {
    return category_arrayWithHoles(arr) || category_iterableToArrayLimit(arr, i) || category_unsupportedIterableToArray(arr, i) || category_nonIterableRest();
}
function category_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return category_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return category_arrayLikeToArray(o, minLen);
}


























var isVirtualCategory = function(categoryId) {
    return /^v/.test(categoryId);
};
var CategoryLoader = function() {
    var ref, ref1, ref2, ref3;
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var ref4 = useCategoryPageQuery(route.variables), data = ref4.data, isLoading = ref4.isLoading, isSuccess = ref4.isSuccess;
    if (!isLoading && !isSuccess) {
        return null;
    }
    if (isLoading) {
        return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
            "data-test": "CategoryPage"
        }, /*#__PURE__*/ react.createElement(loader/* default */.Z, null));
    }
    var categoryPath = data === null || data === void 0 ? void 0 : (ref = data.category) === null || ref === void 0 ? void 0 : ref.path.map(function(item) {
        return item.id;
    });
    var adsConfig = {
        pageType: "category",
        placementsToRequest: [
            "desktopPanorama1",
            "mobilePanorama1",
            "desktopPanorama2",
            "mobilePanorama2",
            "mobilePanorama3"
        ],
        categoryPath: categoryPath
    };
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        withAds: true,
        "data-test": "CategoryPage",
        adsConfig: adsConfig
    }, isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : null, isSuccess && ((ref1 = data.category) === null || ref1 === void 0 ? void 0 : ref1.immediateProducts) ? /*#__PURE__*/ react.createElement(Category, {
        data: data
    }) : null, isSuccess && data.categoryTree && (route === null || route === void 0 ? void 0 : (ref2 = route.variables) === null || ref2 === void 0 ? void 0 : ref2.id) === "v1004" ? /*#__PURE__*/ react.createElement(Services, {
        data: data
    }) : null, isSuccess && ((ref3 = data.category) === null || ref3 === void 0 ? void 0 : ref3.immediateProducts) === false ? /*#__PURE__*/ react.createElement(Segment, {
        data: data
    }) : null);
};
var Category = function(props) {
    var ref;
    var ref1 = category_slicedToArray((0,react.useState)(true), 2), subCategoriesCollapsed = ref1[0], setSubCategoriesCollapsed = ref1[1];
    var toggleSubCategoriesCollapsed = (0,react.useCallback)(function() {
        return setSubCategoriesCollapsed(!subCategoriesCollapsed);
    }, [
        subCategoriesCollapsed
    ]);
    var ref2 = (0,app_context/* useAppContext */.bp)(), t = ref2.t, linkTo = ref2.linkTo;
    var compareProductSelection = (0,compare_products_selection/* useCompareProductsSelection */.C)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var categorySettings = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.category;
    });
    var campaignBanners = (0,es/* useSelector */.v9)(function(state) {
        return state.globals.campaignBanners;
    });
    var showHorizontalFilter = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.category.filter.showHorizontalFilter;
    });
    var _category = props.data.category, id = _category.id, immediateProducts = _category.immediateProducts, products = _category.products, categories = _category.categories, brand = _category.brand, brands = _category.brands, name = _category.name, aliases = _category.aliases, description = _category.description, logo = _category.logo, path = _category.path, pathName = _category.pathName, defaultLayoutMode = _category.defaultLayoutMode, productCount = _category.productCount, storesCount = _category.storesCount, articles = _category.articles, newPopularSearchTerms = _category.newPopularSearchTerms;
    var ref3 = category_slicedToArray((0,react.useState)(true), 2), categoryIsCollapsed = ref3[0], setCategoryIsCollapsed = ref3[1];
    var abortProductSelectionFromBasket = (0,react.useCallback)(function() {
        return compareProductSelection.abortProductSelection();
    }, [
        compareProductSelection
    ]);
    var deselectProductById = (0,react.useCallback)(function(productId) {
        var deselectedProduct = products.nodes.find(function(p) {
            return p.id === productId;
        });
        if (deselectedProduct) {
            compareProductSelection.deselectProduct(deselectedProduct);
        }
    }, [
        products,
        compareProductSelection
    ]);
    // Return 404 on empty brand category pages to properly sunset
    // indexed pages that become empty when category tree is reorganized
    if (!immediateProducts && brand && !(products === null || products === void 0 ? void 0 : (ref = products.nodes) === null || ref === void 0 ? void 0 : ref.length)) {
        var error = new Error("Page not found");
        error.status = 404; // TODO: Fix any
        error.level = "warn";
        throw error;
    }
    var toggleHorizontalFilter = (0,react.useCallback)(function() {
        dispatch((0,filter/* setHorizontalFilter */.Du)(!showHorizontalFilter));
    }, [
        dispatch,
        showHorizontalFilter
    ]);
    var mode = !immediateProducts && "grid" || categorySettings.category && categorySettings.category.mode || defaultLayoutMode;
    var _filter = categorySettings.filter, mobileOpen = _filter.mobileOpen, query = _filter.query, filterError = _filter.error;
    var hasSubCategories = categories && categories.nodes.length > 0;
    var hasSubBrandCategories = !isVirtualCategory(id) && brands && brands.nodes.length > 0;
    var brandCategories = hasSubBrandCategories ? brands.nodes.map(function(categoryBrand) {
        return {
            id: "".concat(id, ":").concat(categoryBrand.id),
            name: "".concat(categoryBrand.name, " ").concat(name),
            pathName: linkTo("brandCategory", {
                id: id,
                pathName: pathName,
                brandId: categoryBrand.id
            })
        };
    }) : [];
    var campaignPromoBanners = {
        before: campaignBanners && campaignBanners.active.filter(function(b) {
            return b && b.type === "BEFORE_PROMO_BANNER";
        }),
        during: campaignBanners && campaignBanners.active.filter(function(b) {
            return b && b.type === "DURING_PROMO_BANNER";
        })
    };
    var showFilter = immediateProducts && !filterError;
    var popularKeywords = (newPopularSearchTerms === null || newPopularSearchTerms === void 0 ? void 0 : newPopularSearchTerms.popularKeywords) && (newPopularSearchTerms === null || newPopularSearchTerms === void 0 ? void 0 : newPopularSearchTerms.popularKeywords.length) ? newPopularSearchTerms.popularKeywords : null;
    var ref4;
    var trendingKeywords = (ref4 = newPopularSearchTerms === null || newPopularSearchTerms === void 0 ? void 0 : newPopularSearchTerms.trendingKeywords) !== null && ref4 !== void 0 ? ref4 : [];
    var categoryDescription = (0,react.useMemo)(function() {
        if (brand || !description && (aliases === null || aliases === void 0 ? void 0 : aliases.length) <= 0) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(CategoryPageHeaderDescription, {
            "data-test": "CategoryDescription"
        }, /*#__PURE__*/ react.createElement("span", {
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: description
            }
        }), aliases && aliases.length > 0 && /*#__PURE__*/ react.createElement(CategoryPageHeaderAliases, null, t("category", "category.alias", {
            alias: aliases.join(", ")
        })));
    }, [
        aliases,
        brand,
        description,
        t
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, campaignPromoBanners.during && campaignPromoBanners.during.length > 0 && /*#__PURE__*/ react.createElement(CategoryPageGutter, null, /*#__PURE__*/ react.createElement(promo_banner/* default */.Z, {
        banners: campaignPromoBanners.during
    })), /*#__PURE__*/ react.createElement(BreadCrumbWrapper, null, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        crumbs: path.map(function(param, index) {
            var title = param.name, href = param.pathName;
            return {
                href: path.length - 1 !== index ? href : undefined,
                title: title
            };
        })
    })), /*#__PURE__*/ react.createElement(CategoryPageWrapper, null, /*#__PURE__*/ react.createElement(CategoryPageHeaderWrapper, null, /*#__PURE__*/ react.createElement(CategoryPageHeader, {
        media: logo && /*#__PURE__*/ react.createElement(page/* PageHeaderMedia */.WH, {
            alt: name,
            src: logo
        }),
        title: name,
        description: categoryDescription && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(block/* MobileOnly */.iB, null, /*#__PURE__*/ react.createElement(Collapsible, {
            collapsed: categoryIsCollapsed,
            expandText: t("symbols", "symbol.expand"),
            onExpand: function() {
                return setCategoryIsCollapsed(false);
            }
        }, categoryDescription)), /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, categoryDescription))
    }), brand && brand.featured && brand.logo ? /*#__PURE__*/ react.createElement(BrandLink, {
        to: linkTo("brand", brand)
    }, /*#__PURE__*/ react.createElement(BrandLogo, {
        src: brand.logo,
        alt: brand.name
    })) : null), (hasSubCategories || hasSubBrandCategories) && immediateProducts && /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, /*#__PURE__*/ react.createElement(CategoryPageGutter, null, /*#__PURE__*/ react.createElement(sub_category_listing, {
        styling: "inline-list",
        categories: categories,
        brands: brandCategories
    }))), showFilter && !mobileOpen && /*#__PURE__*/ react.createElement(CategoryPageSubHeader, null, /*#__PURE__*/ react.createElement(Column, {
        fullWidth: !hasSubCategories
    }, /*#__PURE__*/ react.createElement(mobile_toggle_FilterMobileToggle, {
        filterSettings: query
    })), hasSubCategories && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(block/* MediumDown */.H5, null, /*#__PURE__*/ react.createElement(Column, null, /*#__PURE__*/ react.createElement(toggle, {
        active: !subCategoriesCollapsed,
        onToggle: toggleSubCategoriesCollapsed,
        label: t("category", "subcategories.show")
    }))), /*#__PURE__*/ react.createElement(block/* MediumDown */.H5, null, /*#__PURE__*/ react.createElement(Column, {
        fullWidth: true
    }, /*#__PURE__*/ react.createElement(sub_category_listing, {
        styling: "list",
        categories: categories,
        collapse: subCategoriesCollapsed
    }))))), /*#__PURE__*/ react.createElement(react.Fragment, null, showFilter && showHorizontalFilter && /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(components_filter/* HorizontalFilter */.P, {
        brand: brand,
        productCount: productCount,
        canCompare: mode === "row",
        quickFilters: [],
        toggleFilter: toggleHorizontalFilter,
        expanded: showHorizontalFilter
    }))), (products.nodes.length > 0 || immediateProducts) && /*#__PURE__*/ react.createElement(CategoryPageGutter, null, /*#__PURE__*/ react.createElement(CategoryPageProductWrapper, null, showFilter && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(block/* MediumDown */.H5, null, /*#__PURE__*/ react.createElement(no_scroll/* default */.Z, {
        mobile: true,
        enabled: mobileOpen
    })), /*#__PURE__*/ react.createElement(block/* MediumDown */.H5, null, /*#__PURE__*/ react.createElement(Filter, {
        open: mobileOpen,
        categoryId: id,
        brand: brand,
        productCount: productCount,
        canCompare: mode === "row",
        quickFilters: [],
        toggleFilter: toggleHorizontalFilter
    }))), /*#__PURE__*/ react.createElement(CategoryPageProducts, {
        "data-test": "ProductListing",
        "data-test-category": id
    }, /*#__PURE__*/ react.createElement(CategoryProductListing, {
        productCount: productCount,
        products: products,
        defaultLayoutMode: defaultLayoutMode,
        immediateProducts: immediateProducts,
        storesCount: storesCount,
        categoryName: name,
        showHorizontalFilter: showHorizontalFilter,
        logo: logo,
        compareProductSelection: compareProductSelection
    }), compareProductSelection.isSelectingProducts && /*#__PURE__*/ react.createElement(compare_products_basket/* default */.Z, {
        products: compareProductSelection.selectedProducts,
        compareUrl: compareProductSelection.selectedProducts.length > 1 ? linkTo("productCompare", {
            category: props.data.category,
            products: compareProductSelection.selectedProducts
        }) : undefined,
        onEmpty: abortProductSelectionFromBasket,
        onProductDelete: deselectProductById
    }))))), campaignPromoBanners.before && campaignPromoBanners.before.length > 0 && /*#__PURE__*/ react.createElement(CategoryPageGutter, null, /*#__PURE__*/ react.createElement(promo_banner/* default */.Z, {
        inverted: true,
        banners: campaignPromoBanners.before
    })), /*#__PURE__*/ react.createElement(CategoryArticles, {
        articles: articles
    }), /*#__PURE__*/ react.createElement(CategoryPageGutter, null, /*#__PURE__*/ react.createElement(recently_visited/* default */.Z, null))), (immediateProducts || !brand) && Array.isArray(trendingKeywords) && trendingKeywords.length ? /*#__PURE__*/ react.createElement(CategoryPageGutter, {
        key: "trending-word-cloud"
    }, /*#__PURE__*/ react.createElement(WordCloud, {
        title: t("search", "search.trending-searches"),
        items: trendingKeywords,
        showMoreUrl: linkTo("keywordListing", props.data.category),
        numberOfVisibleItems: 10
    })) : null, (immediateProducts || !brand) && Array.isArray(popularKeywords) && popularKeywords.length ? /*#__PURE__*/ react.createElement(CategoryPageGutter, {
        key: "word-cloud"
    }, /*#__PURE__*/ react.createElement(WordCloud, {
        title: t("search", "search.related-searches"),
        items: popularKeywords,
        showMoreUrl: linkTo("keywordListing", props.data.category),
        numberOfVisibleItems: 35
    })) : null);
};
/* harmony default export */ const category_category = (CategoryLoader);


/***/ }),

/***/ 90912:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ category_information)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/category/components/category-information/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var CategoryInformation = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CategoryInformation",
    componentId: "sc-0-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.tertiary;
}, base/* layout.fontSizes.base.desktop.rem */.bK.fontSizes.base.desktop.rem, base/* layout.measurements.spacing125 */.bK.measurements.spacing125);
var CategoryInformationPTag = styled_components_browser_esm["default"].p.withConfig({
    displayName: "CategoryInformationPTag",
    componentId: "sc-0-1"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/areas/category/components/category-information/index.tsx



var category_information_CategoryInformation = function(param) {
    var statistics = param.statistics;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(CategoryInformation, null, statistics && t("category", "product-list.product-and-store-count", {
        products: statistics.productsCount,
        stores: statistics.storesCount
    }), /*#__PURE__*/ react.createElement(CategoryInformationPTag, null, t("category", "product-list.rank-information")));
};
/* harmony default export */ const category_information = (/*#__PURE__*/(0,react.memo)(category_information_CategoryInformation));


/***/ }),

/***/ 26214:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ panel)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(714);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(54262);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/areas/category/actions/filter.js
var filter = __webpack_require__(67536);
// EXTERNAL MODULE: ./src/globals/helpers/is-numeric.js
var is_numeric = __webpack_require__(53541);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-tools@1.7.2/node_modules/styled-tools/dist/es/index.js + 7 modules
var dist_es = __webpack_require__(55703);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-up/index.js
var chevron_up = __webpack_require__(912);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-down/index.js
var chevron_down = __webpack_require__(70796);
;// CONCATENATED MODULE: ./src/components/filters/styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  outline: 0;\n  opacity: 0;\n  position: absolute;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n      box-shadow: 0 0 0 1px ",
        ";\n      border: 5px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  vertical-align: top;\n  margin-left: 2px;\n  margin-top: 2px;\n  margin-right: 10px;\n  width: 16px;\n  height: 16px;\n  border-radius: 100%;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      font-weight: 600;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  height: 2.6rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n  padding-right: ",
        "px;\n  color: ",
        ";\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 5px;\n  margin-right: 5px;\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: ",
        ";\n  flex-wrap: wrap;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  user-select: none;\n  position: relative;\n  padding-left: ",
        ";\n  font-weight: ",
        ";\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: 8px;\n  padding-bottom: 8px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n      border: 1px solid ",
        ";\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  display: flex;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-grow: 1;\n  color: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  word-break: break-word;\n  word-wrap: break-word;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  align-self: center;\n  color: ",
        ";\n  margin-left: 5px;\n  margin-right: 5px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: auto;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: rgba(",
        ", 0.4);\n      &:hover,\n      &:active,\n      &:focus {\n        background-color: rgba(",
        ", 0.4);\n      }\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  cursor: pointer;\n  width: ",
        "rem;\n  height: ",
        "rem;\n  padding: 0;\n  text-align: center;\n\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}




var listSidePadding = "0.6rem";
/* stylelint-disable property-no-vendor-prefix */ var HiddenInput = styled_components_browser_esm["default"].input.withConfig({
    displayName: "HiddenInput",
    componentId: "sc-0-0"
})(_templateObject());
/* stylelint-enable property-no-vendor-prefix */ var listSideHeight = 2.6; // rem
var RadioButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RadioButton",
    componentId: "sc-0-1"
})(_templateObject2(), function(props) {
    return props.theme.colors.base0;
}, function(props) {
    return props.theme.colors.base300;
}, function(props) {
    return props.checked && (0,styled_components_browser_esm.css)(_templateObject1(), props.theme.colors.base0, props.theme.colors.base300, props.theme.colors.maybeBlue700, props.theme.colors.base700);
});
var Label = styled_components_browser_esm["default"].label.withConfig({
    displayName: "Label",
    componentId: "sc-0-2"
})(_templateObject4(), (0,dist_es/* ifProp */.fq)({
    layout: "horizontal"
}, 20, 0), function(props) {
    return props.theme.colors.base600;
}, function(props) {
    return props.theme.colors.base100;
}, function(props) {
    return props.selected && (0,styled_components_browser_esm.css)(_templateObject3());
});
var Counter = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Counter",
    componentId: "sc-0-3"
})(_templateObject5(), function(props) {
    return props.theme.colors.base500;
});
var Layout = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Layout",
    componentId: "sc-0-4"
})(_templateObject6(), (0,dist_es/* ifProp */.fq)({
    layout: "horizontal"
}, "flex", "block"));
var ListItem = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListItem",
    componentId: "sc-0-5"
})(_templateObject7(), listSidePadding, (0,dist_es/* ifProp */.fq)("selected", "600", "normal"), function(props) {
    return props.theme.colors.base100;
});
var ListLabel = styled_components_browser_esm["default"].label.withConfig({
    displayName: "ListLabel",
    componentId: "sc-0-6"
})(_templateObject8());
var Checkbox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Checkbox",
    componentId: "sc-0-7"
})(_templateObject10(), listSidePadding, function(props) {
    return props.theme.colors.white;
}, function(props) {
    return props.theme.colors.base300;
}, function(props) {
    return (props.checked || props.partial) && (0,styled_components_browser_esm.css)(_templateObject9(), props.theme.colors.maybeBlue700, props.theme.colors.maybeBlue700);
});
var ListLabelText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ListLabelText",
    componentId: "sc-0-8"
})(_templateObject11(), function(props) {
    return props.theme.colors.base600;
});
var ListLabelName = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ListLabelName",
    componentId: "sc-0-9"
})(_templateObject12());
var ListLabelByline = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ListLabelByline",
    componentId: "sc-0-10"
})(_templateObject13(), function(props) {
    return props.theme.colors.base500;
});
var ExpandWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ExpandWrapper",
    componentId: "sc-0-11"
})(_templateObject14());
var ExpandButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "ExpandButton",
    componentId: "sc-0-12"
})(_templateObject16(), listSideHeight, listSideHeight / 2, function(props) {
    return props.expanded && (0,styled_components_browser_esm.css)(_templateObject15(), props.theme.colors.base200, props.theme.colors.base200);
});
var ArrowUp = (0,styled_components_browser_esm["default"])(chevron_up.IconChevronUp).attrs({
    color: "base300"
}).withConfig({
    displayName: "ArrowUp",
    componentId: "sc-0-13"
})(_templateObject17());
var ArrowDown = (0,styled_components_browser_esm["default"])(chevron_down/* IconChevronDown */.C).attrs({
    color: "base300"
}).withConfig({
    displayName: "ArrowDown",
    componentId: "sc-0-14"
})(_templateObject18());

;// CONCATENATED MODULE: ./src/components/filters/radio.js
/* eslint-disable jsx-a11y/label-has-for */ 


var Radio = function(props) {
    var values = props.values, selected = props.selected, layout = props.layout, onChange = props.onChange;
    return /*#__PURE__*/ react.createElement(Layout, {
        layout: layout
    }, values.map(function(value) {
        return /*#__PURE__*/ react.createElement(Label, {
            key: value.id,
            layout: layout
        }, /*#__PURE__*/ react.createElement(HiddenInput, {
            checked: selected === value.id,
            onChange: function(e) {
                onChange({
                    id: value.id,
                    checked: e.currentTarget.checked
                });
            },
            name: props.id,
            type: "radio",
            value: String(value.id)
        }), /*#__PURE__*/ react.createElement(RadioButton, {
            checked: selected === value.id
        }), value.text, value.products !== undefined && /*#__PURE__*/ react.createElement(Counter, null, "(", value.products, ")"));
    }));
};
var string = (prop_types_default()).string, number = (prop_types_default()).number, arrayOf = (prop_types_default()).arrayOf, shape = (prop_types_default()).shape, oneOfType = (prop_types_default()).oneOfType, oneOf = (prop_types_default()).oneOf, bool = (prop_types_default()).bool, func = (prop_types_default()).func;
Radio.propTypes = {
    id: oneOfType([
        string,
        number
    ]).isRequired,
    values: arrayOf(shape({
        id: oneOfType([
            string,
            number,
            bool
        ]),
        text: string,
        products: number
    })).isRequired,
    selected: oneOfType([
        string,
        number,
        bool
    ]),
    onChange: func,
    layout: oneOf([
        "vertical",
        "horizontal"
    ])
};
Radio.defaultProps = {
    selected: null,
    onChange: function() {},
    layout: "vertical"
};
/* harmony default export */ const filters_radio = (Radio);

;// CONCATENATED MODULE: ./src/components/filters/range/constants.js
var KEY_LEFT = "from";
var KEY_RIGHT = "to";
var TYPE_INTEGER = "integer";
var TYPE_DATE_YEAR = "date-year";
var TYPE_DECIMAL = "decimal";

// EXTERNAL MODULE: ./src/components/base/styles/variables.ts
var variables = __webpack_require__(76323);
;// CONCATENATED MODULE: ./src/components/filters/range/styles.js
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n      margin-top: 0;\n      margin-bottom: 10px;\n    "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-top: 10px;\n  margin-bottom: 30px;\n  display: flex;\n  flex-flow: ",
        ";\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  flex: 1;\n  margin: 0 20px 15px;\n  margin-top: ",
        ";\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: ",
        "px;\n  margin-top: 5px;\n  display: flex;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n      width: 100%;\n      height: 100%;\n      background-color: ",
        ";\n    "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  flex: 1;\n  position: relative;\n  padding: 3px 1px 0 1px;\n  height: 100%;\n  text-align: center;\n  display: flex;\n  align-items: flex-end;\n  cursor: pointer;\n\n  ",
        "\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  background-color: ",
        ";\n  width: 100%;\n  max-width: 30px;\n  margin: 0 auto;\n  min-height: ",
        ";\n  transition: height 0.3s ease;\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n  touch-action: pan-y;\n  position: absolute;\n  z-index: 1;\n  display: inline-flex;\n  width: 30px;\n  height: 30px;\n  padding-top: 5px;\n  justify-content: center;\n  cursor: pointer;\n  opacity: ",
        ";\n  left: ",
        "%;\n  transform: translateX(-50%) translateY(-",
        "px);\n  transition: ",
        ";\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n      border-color: ",
        ";\n      background-color: ",
        ";\n    "
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n  border-radius: 50%;\n  width: ",
        "px;\n  height: ",
        "px;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  ",
        "\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  height: ",
        "px;\n  background-color: ",
        ";\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ",
        ";\n  display: ",
        ";\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: stretch;\n  justify-content: space-between;\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  font-size: 11px;\n  color: ",
        ";\n  margin-top: ",
        "px;\n"
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = styles_taggedTemplateLiteral([
        "\n      color: ",
        ";\n    "
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  text-align: center;\n  transform: translateX(-50%);\n  cursor: pointer;\n  padding: 5px 0;\n  ",
        "\n"
    ]);
    styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function styles_templateObject17() {
    var data = styles_taggedTemplateLiteral([
        "\n      border-color: ",
        ";\n      background-color: ",
        "];\n    "
    ]);
    styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function styles_templateObject18() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 70px;\n  text-align: center;\n  color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  font-size: 12px;\n  ",
        "\n"
    ]);
    styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = styles_taggedTemplateLiteral([
        "\n      width: 180px;\n      order: 2;\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-self: center;\n  ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}



var lineThickness = 3; // px
var dotSize = 17; // px
var handleColor = variables/* colors.lightTheme.base500 */.O9.lightTheme.base500;
var numberColor = variables/* colors.lightTheme.base600 */.O9.lightTheme.base600;
var numberColorInactive = variables/* colors.lightTheme.base500 */.O9.lightTheme.base500;
var textColor = variables/* colors.lightTheme.base600 */.O9.lightTheme.base600;
var textBorder = variables/* colors.lightTheme.base500 */.O9.lightTheme.base500;
var textBorderInvalid = variables/* colors.lightTheme.base500 */.O9.lightTheme.base500;
var textBackgroundInvalid = variables/* colors.lightTheme.base500 */.O9.lightTheme.base500;
var barActive = variables/* colors.lightTheme.base700 */.O9.lightTheme.base700;
var barInactive = variables/* colors.lightTheme.base300 */.O9.lightTheme.base300;
var styles_Layout = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Layout",
    componentId: "sc-0-0"
})(styles_templateObject1(), (0,dist_es/* ifProp */.fq)({
    layout: "horizontal"
}, "row", "column"), function(param) {
    var layout = param.layout;
    return layout === "horizontal" && (0,styled_components_browser_esm.css)(styles_templateObject());
});
var SliderWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SliderWrapper",
    componentId: "sc-0-1"
})(styles_templateObject2(), function(param) {
    var showBars = param.showBars;
    return showBars ? "0px" : "15px";
});
var styles_Bars = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Bars",
    componentId: "sc-0-2"
})(styles_templateObject3(), (0,dist_es/* ifProp */.fq)({
    layout: "horizontal"
}, 13, 25));
var styles_Bar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Bar",
    componentId: "sc-0-3"
})(styles_templateObject5(), function(props) {
    return props.inactive && (0,styled_components_browser_esm.css)(styles_templateObject4(), barInactive);
});
var Filler = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Filler",
    componentId: "sc-0-4"
})(styles_templateObject6(), barActive, function(param) {
    var empty = param.empty;
    return empty ? 0 : "2px";
});
var styles_Handles = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Handles",
    componentId: "sc-0-5"
})(styles_templateObject7());
var styles_Handle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Handle",
    componentId: "sc-0-6"
})(styles_templateObject8(), (0,dist_es/* ifProp */.fq)("invalid", 0.4, 1), (0,dist_es/* ifProp */.fq)({
    direction: "from"
}, 0, 100), dotSize - lineThickness, (0,dist_es/* ifProp */.fq)("dragging", "none", "all 0.2s ease"));
var HandleDot = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HandleDot",
    componentId: "sc-0-7"
})(styles_templateObject10(), dotSize, dotSize, variables/* colors.lightTheme.base0 */.O9.lightTheme.base0, handleColor, function(param) {
    var selected = param.selected, dragging = param.dragging;
    return (selected || dragging) && (0,styled_components_browser_esm.css)(styles_templateObject9(), variables/* colors.lightTheme.base0 */.O9.lightTheme.base0, variables/* colors.lightTheme.maybeBlue700 */.O9.lightTheme.maybeBlue700);
});
var LineWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LineWrapper",
    componentId: "sc-0-8"
})(styles_templateObject11(), (0,dist_es/* ifProp */.fq)({
    layout: "horizontal"
}, 1, lineThickness), variables/* colors.lightTheme.base300 */.O9.lightTheme.base300);
var styles_Line = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Line",
    componentId: "sc-0-9"
})(styles_templateObject12(), variables/* colors.lightTheme.base700 */.O9.lightTheme.base700, function(param) {
    var invalid = param.invalid;
    return invalid ? "none" : "block";
});
var NumberWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NumberWrapper",
    componentId: "sc-0-10"
})(styles_templateObject13());
var styles_Number = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Number",
    componentId: "sc-0-11"
})(styles_templateObject14(), numberColor, (0,dist_es/* ifProp */.fq)({
    layout: "horizontal"
}, 3, 6));
var NumberValue = styled_components_browser_esm["default"].button.withConfig({
    displayName: "NumberValue",
    componentId: "sc-0-12"
})(styles_templateObject16(), function(param) {
    var inactive = param.inactive;
    return inactive && (0,styled_components_browser_esm.css)(styles_templateObject15(), numberColorInactive);
});
var Input = styled_components_browser_esm["default"].input.withConfig({
    displayName: "Input",
    componentId: "sc-0-13"
})(styles_templateObject18(), textColor, textBorder, function(param) {
    var invalid = param.invalid;
    return invalid && (0,styled_components_browser_esm.css)(styles_templateObject17(), textBorderInvalid, textBackgroundInvalid);
});
var InputWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InputWrapper",
    componentId: "sc-0-14"
})(_templateObject20(), function(param) {
    var layout = param.layout;
    return layout === "horizontal" && (0,styled_components_browser_esm.css)(_templateObject19());
});

;// CONCATENATED MODULE: ./src/components/filters/range/bar.js
/* eslint-disable jsx-a11y/no-static-element-interactions */ function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



var Bar = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Bar, Component);
    var _super = _createSuper(Bar);
    function Bar(props) {
        _classCallCheck(this, Bar);
        var _this;
        _this = _super.call(this, props);
        _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
        return _this;
    }
    _createClass(Bar, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                if (this.props.fillData.fill !== nextProps.fillData.fill) {
                    return true;
                }
                if (this.props.max !== nextProps.max) {
                    return true;
                }
                if (this.props.products !== nextProps.products) {
                    return true;
                }
                return false;
            }
        },
        {
            key: "onChange",
            value: function onChange() {
                this.props.onChange({
                    from: this.props.from,
                    to: this.props.to
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, products = _props.products, max = _props.max, fillData = _props.fillData;
                var fillPercentage = fillData.fill;
                var style = Bar.getHeight(products, max);
                var opacityStyle = {
                    opacity: 1 - fillPercentage
                };
                return /*#__PURE__*/ react.createElement(styles_Bar, {
                    onClick: this.onChange
                }, /*#__PURE__*/ react.createElement(Filler, {
                    style: style,
                    "data-opacity": fillPercentage,
                    empty: !products
                }, /*#__PURE__*/ react.createElement(styles_Bar, {
                    inactive: true,
                    style: opacityStyle
                })));
            }
        }
    ], [
        {
            key: "getHeight",
            value: function getHeight(products, max) {
                return {
                    height: "".concat(100 * (products / max), "%")
                };
            }
        }
    ]);
    return Bar;
}(react.Component);

Bar.propTypes = {
    id: (prop_types_default()).number.isRequired,
    fillData: prop_types_default().shape({
        fill: (prop_types_default()).number,
        from: (prop_types_default()).bool,
        to: (prop_types_default()).bool
    }).isRequired,
    products: (prop_types_default()).number.isRequired,
    max: (prop_types_default()).number.isRequired,
    onChange: (prop_types_default()).func.isRequired,
    to: (prop_types_default()).number.isRequired,
    from: (prop_types_default()).number.isRequired
};

;// CONCATENATED MODULE: ./src/components/filters/range/bars.js
function bars_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function bars_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function bars_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function bars_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) bars_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) bars_defineProperties(Constructor, staticProps);
    return Constructor;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function bars_getPrototypeOf(o) {
    bars_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return bars_getPrototypeOf(o);
}
function bars_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) bars_setPrototypeOf(subClass, superClass);
}
function bars_possibleConstructorReturn(self, call) {
    if (call && (bars_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return bars_assertThisInitialized(self);
}
function bars_setPrototypeOf(o, p) {
    bars_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return bars_setPrototypeOf(o, p);
}
var bars_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function bars_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function bars_createSuper(Derived) {
    var hasNativeReflectConstruct = bars_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = bars_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = bars_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return bars_possibleConstructorReturn(this, result);
    };
}




var Bars = /*#__PURE__*/ function(Component) {
    "use strict";
    bars_inherits(Bars, Component);
    var _super = bars_createSuper(Bars);
    function Bars() {
        bars_classCallCheck(this, Bars);
        return _super.apply(this, arguments);
    }
    bars_createClass(Bars, [
        {
            key: "renderBar",
            value: function renderBar(data, index) {
                var fillData = this.props.getSectionFillData(index);
                return /*#__PURE__*/ react.createElement(Bar, _extends({
                    key: "bar".concat(index),
                    id: index,
                    max: this.props.values.max_matching_products,
                    onChange: this.props.onChange,
                    fillData: fillData
                }, data));
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ react.createElement(styles_Bars, {
                    layout: this.props.layout
                }, this.props.values.values.map(this.renderBar, this));
            }
        }
    ]);
    return Bars;
}(react.Component);

Bars.propTypes = {
    layout: prop_types_default().oneOf([
        "vertical",
        "horizontal"
    ]).isRequired,
    values: prop_types_default().shape({
        max_matching_products: (prop_types_default()).number,
        max_value: (prop_types_default()).number,
        min_value: (prop_types_default()).number,
        values: prop_types_default().arrayOf(prop_types_default().shape({
            from: (prop_types_default()).number,
            to: (prop_types_default()).number,
            max: (prop_types_default()).number,
            products: (prop_types_default()).number
        }))
    }).isRequired,
    getSectionFillData: (prop_types_default()).func.isRequired,
    onChange: (prop_types_default()).func.isRequired
};

;// CONCATENATED MODULE: ./src/components/filters/range/line.js
function line_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function line_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function line_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function line_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) line_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) line_defineProperties(Constructor, staticProps);
    return Constructor;
}
function line_getPrototypeOf(o) {
    line_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return line_getPrototypeOf(o);
}
function line_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) line_setPrototypeOf(subClass, superClass);
}
function line_possibleConstructorReturn(self, call) {
    if (call && (line_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return line_assertThisInitialized(self);
}
function line_setPrototypeOf(o, p) {
    line_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return line_setPrototypeOf(o, p);
}
var line_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function line_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function line_createSuper(Derived) {
    var hasNativeReflectConstruct = line_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = line_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = line_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return line_possibleConstructorReturn(this, result);
    };
}



var Line = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    line_inherits(Line, _PureComponent);
    var _super = line_createSuper(Line);
    function Line() {
        line_classCallCheck(this, Line);
        return _super.apply(this, arguments);
    }
    line_createClass(Line, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ react.createElement(LineWrapper, {
                    layout: this.props.layout
                }, /*#__PURE__*/ react.createElement(styles_Line, {
                    invalid: this.props.invalid,
                    style: Line.getFilledStyle(this.props.from, this.props.to)
                }));
            }
        }
    ], [
        {
            key: "getFilledStyle",
            value: function getFilledStyle(from, to) {
                var leftValue = 100 * from;
                var rightValue = 100 - 100 * to;
                return {
                    left: "".concat(leftValue, "%"),
                    right: "".concat(rightValue, "%")
                };
            }
        }
    ]);
    return Line;
}(react.PureComponent);
Line.propTypes = {
    layout: prop_types_default().oneOf([
        "vertical",
        "horizontal"
    ]).isRequired,
    invalid: (prop_types_default()).bool.isRequired,
    from: (prop_types_default()).number.isRequired,
    to: (prop_types_default()).number.isRequired
};
/* harmony default export */ const line = (Line);

;// CONCATENATED MODULE: ./src/components/filters/range/text-input.js
function text_input_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function text_input_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function text_input_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function text_input_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) text_input_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) text_input_defineProperties(Constructor, staticProps);
    return Constructor;
}
function text_input_getPrototypeOf(o) {
    text_input_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return text_input_getPrototypeOf(o);
}
function text_input_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) text_input_setPrototypeOf(subClass, superClass);
}
function text_input_possibleConstructorReturn(self, call) {
    if (call && (text_input_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return text_input_assertThisInitialized(self);
}
function text_input_setPrototypeOf(o, p) {
    text_input_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return text_input_setPrototypeOf(o, p);
}
var text_input_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function text_input_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function text_input_createSuper(Derived) {
    var hasNativeReflectConstruct = text_input_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = text_input_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = text_input_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return text_input_possibleConstructorReturn(this, result);
    };
}



var TextInput = /*#__PURE__*/ function(Component) {
    "use strict";
    text_input_inherits(TextInput, Component);
    var _super = text_input_createSuper(TextInput);
    function TextInput(props) {
        text_input_classCallCheck(this, TextInput);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            tempValue: null,
            valid: true
        };
        _this.handleKeyUp = _this.handleKeyUp.bind(text_input_assertThisInitialized(_this));
        _this.handleBlur = _this.handleBlur.bind(text_input_assertThisInitialized(_this));
        _this.handleChange = _this.handleChange.bind(text_input_assertThisInitialized(_this));
        return _this;
    }
    text_input_createClass(TextInput, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                if (this.props.selected !== nextProps.selected) {
                    return true;
                }
                if (this.state.tempValue !== nextState.tempValue) {
                    return true;
                }
                return false;
            }
        },
        {
            key: "handleKeyUp",
            value: function handleKeyUp(event) {
                // eslint-disable-next-line default-case
                switch(event.keyCode){
                    case 27:
                        this.resetInput();
                    // fall through
                    case 13:
                        event.target.blur();
                        break;
                }
            }
        },
        {
            key: "resetInput",
            value: function resetInput() {
                this.setState({
                    tempValue: null,
                    valid: true
                });
            }
        },
        {
            key: "handleBlur",
            value: function handleBlur() {
                if (this.state.tempValue === null) {
                    // Dont update filter if value never changed
                    return;
                }
                var newValue = TextInput.validate(this.state.tempValue || this.props.default);
                this.resetInput();
                if (isNaN(newValue)) {
                    return;
                }
                this.props.onChange({
                    id: this.props.id,
                    value: newValue
                });
            }
        },
        {
            key: "handleChange",
            value: function handleChange(event) {
                this.setState({
                    tempValue: event.target.value,
                    valid: !isNaN(TextInput.validate(event.target.value))
                });
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                // Want to be able to erase the entire input field
                if (this.state.tempValue !== null && this.state.tempValue.length === 0) {
                    return "";
                }
                return this.state.tempValue || this.props.selected || this.props.default;
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ react.createElement(Input, {
                    type: "text",
                    invalid: !this.state.valid,
                    value: this.getValue(),
                    onKeyUp: this.handleKeyUp,
                    onBlur: this.handleBlur,
                    onChange: this.handleChange
                });
            }
        }
    ], [
        {
            key: "validate",
            value: function validate(num) {
                return +num.replace(",", ".");
            }
        }
    ]);
    return TextInput;
}(react.Component);

TextInput.propTypes = {
    id: (prop_types_default()).string.isRequired,
    onChange: (prop_types_default()).func.isRequired,
    default: (prop_types_default()).string.isRequired,
    selected: (prop_types_default()).number
};
TextInput.defaultProps = {
    selected: null
};

;// CONCATENATED MODULE: ./src/components/filters/range/text-inputs.js
function text_inputs_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function text_inputs_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function text_inputs_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function text_inputs_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) text_inputs_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) text_inputs_defineProperties(Constructor, staticProps);
    return Constructor;
}
function text_inputs_getPrototypeOf(o) {
    text_inputs_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return text_inputs_getPrototypeOf(o);
}
function text_inputs_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) text_inputs_setPrototypeOf(subClass, superClass);
}
function text_inputs_possibleConstructorReturn(self, call) {
    if (call && (text_inputs_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return text_inputs_assertThisInitialized(self);
}
function text_inputs_setPrototypeOf(o, p) {
    text_inputs_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return text_inputs_setPrototypeOf(o, p);
}
var text_inputs_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function text_inputs_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function text_inputs_createSuper(Derived) {
    var hasNativeReflectConstruct = text_inputs_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = text_inputs_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = text_inputs_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return text_inputs_possibleConstructorReturn(this, result);
    };
}




var TextInputs = /*#__PURE__*/ function(Component) {
    "use strict";
    text_inputs_inherits(TextInputs, Component);
    var _super = text_inputs_createSuper(TextInputs);
    function TextInputs() {
        text_inputs_classCallCheck(this, TextInputs);
        return _super.apply(this, arguments);
    }
    text_inputs_createClass(TextInputs, [
        {
            key: "renderTextInput",
            value: function renderTextInput(key) {
                var defaultValue = this.props.minMax[key];
                var selected = this.props.selected ? this.props.selected[key] : null;
                return /*#__PURE__*/ react.createElement(TextInput, {
                    key: "input-".concat(key, "-").concat(defaultValue),
                    id: key,
                    default: "".concat(defaultValue),
                    selected: selected,
                    onChange: this.props.onChange
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ react.createElement(InputWrapper, {
                    layout: this.props.layout
                }, this.props.keys.map(this.renderTextInput, this));
            }
        }
    ]);
    return TextInputs;
}(react.Component);

TextInputs.propTypes = {
    layout: prop_types_default().oneOf([
        "vertical",
        "horizontal"
    ]).isRequired,
    keys: prop_types_default().arrayOf((prop_types_default()).string).isRequired,
    minMax: prop_types_default().shape({
        from: (prop_types_default()).number,
        to: (prop_types_default()).number
    }).isRequired,
    onChange: (prop_types_default()).func.isRequired,
    selected: prop_types_default().oneOfType([
        (prop_types_default()).string,
        prop_types_default().shape({
            from: (prop_types_default()).number,
            to: (prop_types_default()).number
        })
    ])
};
TextInputs.defaultProps = {
    selected: {
        from: null,
        to: null
    }
};

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/throttle.js
var throttle = __webpack_require__(38209);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ./src/components/filters/range/handle.js
/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/interactive-supports-focus */ function handle_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function handle_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function handle_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function handle_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) handle_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) handle_defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function handle_getPrototypeOf(o) {
    handle_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return handle_getPrototypeOf(o);
}
function handle_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) handle_setPrototypeOf(subClass, superClass);
}
function handle_possibleConstructorReturn(self, call) {
    if (call && (handle_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return handle_assertThisInitialized(self);
}
function handle_setPrototypeOf(o, p) {
    handle_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return handle_setPrototypeOf(o, p);
}
var handle_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function handle_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function handle_createSuper(Derived) {
    var hasNativeReflectConstruct = handle_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = handle_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = handle_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return handle_possibleConstructorReturn(this, result);
    };
}




var Handle = /*#__PURE__*/ function(Component) {
    "use strict";
    handle_inherits(Handle, Component);
    var _super = handle_createSuper(Handle);
    function Handle(props) {
        handle_classCallCheck(this, Handle);
        var _this;
        _this = _super.call(this, props);
        _defineProperty(handle_assertThisInitialized(_this), "startDrag", function(event) {
            _this.setState({
                dragging: true
            });
            // Prevent default to get rid of the "issue" where the user might select text when dragging
            event.preventDefault();
            var sliderWidth = _this.props.getSliderWidth();
            _this.pixelSize = 100 / sliderWidth;
            _this.initialPointerX = Handle.getPointerX(event);
            _this.currentPointerX = _this.initialPointerX;
            _this.initialPosition = _this.props.positionData.position * 100;
            var throttledDragHelper = throttle_default()(_this.dragPositionHelper, 1000 / 60);
            _this.dragHelper = function(moveEvent) {
                // this is necessary because if the preventDefault is throttled
                // the page will be able to be panned when dragging a handle. (touch only)
                // UPDATE: might not be necessary if touch-action works as advertised.
                moveEvent.preventDefault();
                throttledDragHelper(moveEvent);
            };
            _this.props.startDragging(function() {
                requestAnimationFrame(_this.handleDrag);
                _this.addMoveEventListeners();
                _this.removeEndEventListeners(); // make sure any dangling events are removed before adding new
                _this.addEndEventListeners();
            });
        });
        _defineProperty(handle_assertThisInitialized(_this), "handleDrag", function() {
            if (!_this.props.dragging) {
                return;
            }
            // if no movement, skip calculation, wait for next frame
            if (_this.currentPointerX === _this.prevPointerX) {
                requestAnimationFrame(_this.handleDrag);
                return;
            }
            var deltaX = _this.currentPointerX - _this.initialPointerX;
            var percentageMoved = deltaX * _this.pixelSize;
            var positionPercentage = _this.initialPosition + percentageMoved;
            _this.prevPointerX = _this.currentPointerX;
            _this.props.updateSlider({
                id: _this.props.id,
                position: positionPercentage
            });
            if (_this.props.dragging) {
                requestAnimationFrame(_this.handleDrag);
            }
        });
        _defineProperty(handle_assertThisInitialized(_this), "stopDrag", function() {
            _this.setState({
                dragging: false
            });
            _this.removeMoveEventListeners();
            _this.removeEndEventListeners();
            _this.initialPointerX = null;
            _this.initialPosition = null;
            _this.props.stopDragging();
        });
        _defineProperty(handle_assertThisInitialized(_this), "dragPositionHelper", function(event) {
            _this.currentPointerX = Handle.getPointerX(event);
        });
        _this.state = {
            dragging: false
        };
        return _this;
    }
    handle_createClass(Handle, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                if (this.props.positionData.position !== nextProps.positionData.position) {
                    return true;
                }
                if (this.props.dragging !== nextProps.dragging) {
                    return true;
                }
                return false;
            }
        },
        {
            key: "addMoveEventListeners",
            value: function addMoveEventListeners() {
                var _this = this;
                [
                    "touchmove",
                    "mousemove"
                ].forEach(function(eventName) {
                    document.addEventListener(eventName, _this.dragHelper);
                });
            }
        },
        {
            key: "removeMoveEventListeners",
            value: function removeMoveEventListeners() {
                var _this = this;
                [
                    "touchmove",
                    "mousemove"
                ].forEach(function(eventName) {
                    document.removeEventListener(eventName, _this.dragHelper);
                });
            }
        },
        {
            key: "addEndEventListeners",
            value: function addEndEventListeners() {
                var _this = this;
                [
                    "touchend",
                    "mouseup"
                ].forEach(function(eventName) {
                    document.addEventListener(eventName, _this.stopDrag);
                });
            }
        },
        {
            key: "removeEndEventListeners",
            value: function removeEndEventListeners() {
                var _this = this;
                [
                    "touchend",
                    "mouseup"
                ].forEach(function(eventName) {
                    document.removeEventListener(eventName, _this.stopDrag);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ react.createElement(styles_Handle, {
                    direction: this.props.id,
                    onMouseDown: this.startDrag,
                    onTouchStart: this.startDrag,
                    dragging: this.state.dragging,
                    style: {
                        left: "".concat(this.props.positionData.position * 100, "%")
                    }
                }, /*#__PURE__*/ react.createElement(HandleDot, {
                    selected: this.props.selected,
                    dragging: this.state.dragging
                }));
            }
        }
    ], [
        {
            key: "getPointerX",
            value: function getPointerX(event) {
                if (event.clientX) {
                    return event.clientX;
                }
                return event.touches ? event.touches[0].clientX : null;
            }
        }
    ]);
    return Handle;
}(react.Component);

Handle.defaultProps = {
    selected: false
};
Handle.propTypes = {
    id: (prop_types_default()).string.isRequired,
    selected: (prop_types_default()).bool,
    positionData: prop_types_default().shape({
        fill: (prop_types_default()).number,
        position: (prop_types_default()).number,
        section: (prop_types_default()).number
    }).isRequired,
    startDragging: (prop_types_default()).func.isRequired,
    stopDragging: (prop_types_default()).func.isRequired,
    getSliderWidth: (prop_types_default()).func.isRequired,
    updateSlider: (prop_types_default()).func.isRequired,
    dragging: (prop_types_default()).bool.isRequired
};

;// CONCATENATED MODULE: ./src/components/filters/range/handles.js
function handles_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function handles_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function handles_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function handles_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) handles_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) handles_defineProperties(Constructor, staticProps);
    return Constructor;
}
function handles_getPrototypeOf(o) {
    handles_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return handles_getPrototypeOf(o);
}
function handles_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) handles_setPrototypeOf(subClass, superClass);
}
function handles_possibleConstructorReturn(self, call) {
    if (call && (handles_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return handles_assertThisInitialized(self);
}
function handles_setPrototypeOf(o, p) {
    handles_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return handles_setPrototypeOf(o, p);
}
var handles_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function handles_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function handles_createSuper(Derived) {
    var hasNativeReflectConstruct = handles_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = handles_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = handles_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return handles_possibleConstructorReturn(this, result);
    };
}




var Handles = /*#__PURE__*/ function(Component) {
    "use strict";
    handles_inherits(Handles, Component);
    var _super = handles_createSuper(Handles);
    function Handles() {
        handles_classCallCheck(this, Handles);
        return _super.apply(this, arguments);
    }
    handles_createClass(Handles, [
        {
            key: "renderHandle",
            value: function renderHandle(key) {
                return /*#__PURE__*/ react.createElement(Handle, {
                    key: "handle-".concat(key),
                    id: key,
                    selected: this.props.selected && Boolean(this.props.selected[key]),
                    positionData: this.props.positionData[key],
                    startDragging: this.props.startDragging,
                    stopDragging: this.props.stopDragging,
                    getSliderWidth: this.props.getSliderWidth,
                    updateSlider: this.props.updateSlider,
                    dragging: this.props.dragging
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ react.createElement(styles_Handles, null, this.props.keys.map(this.renderHandle, this));
            }
        }
    ]);
    return Handles;
}(react.Component);

Handles.defaultProps = {
    selected: {
        from: false,
        to: false
    }
};
Handles.propTypes = {
    keys: prop_types_default().arrayOf((prop_types_default()).string).isRequired,
    selected: prop_types_default().shape({
        from: (prop_types_default()).bool,
        to: (prop_types_default()).bool
    }),
    positionData: prop_types_default().shape({
        from: prop_types_default().shape({
            fill: (prop_types_default()).number,
            position: (prop_types_default()).number,
            section: (prop_types_default()).number
        }),
        to: prop_types_default().shape({
            fill: (prop_types_default()).number,
            position: (prop_types_default()).number,
            section: (prop_types_default()).number
        })
    }).isRequired,
    startDragging: (prop_types_default()).func.isRequired,
    stopDragging: (prop_types_default()).func.isRequired,
    getSliderWidth: (prop_types_default()).func.isRequired,
    updateSlider: (prop_types_default()).func.isRequired,
    dragging: (prop_types_default()).bool.isRequired
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@18.2.0_react@18.2.0/node_modules/react-dom/index.js
var react_dom = __webpack_require__(10422);
;// CONCATENATED MODULE: ./src/components/filters/range/number.js
function number_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function number_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function number_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function number_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) number_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) number_defineProperties(Constructor, staticProps);
    return Constructor;
}
function number_getPrototypeOf(o) {
    number_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return number_getPrototypeOf(o);
}
function number_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) number_setPrototypeOf(subClass, superClass);
}
function number_possibleConstructorReturn(self, call) {
    if (call && (number_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return number_assertThisInitialized(self);
}
function number_setPrototypeOf(o, p) {
    number_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return number_setPrototypeOf(o, p);
}
var number_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function number_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function number_createSuper(Derived) {
    var hasNativeReflectConstruct = number_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = number_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = number_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return number_possibleConstructorReturn(this, result);
    };
}



var number_Number = /*#__PURE__*/ function(Component) {
    "use strict";
    number_inherits(Number, Component);
    var _super = number_createSuper(Number);
    function Number(props) {
        number_classCallCheck(this, Number);
        var _this;
        _this = _super.call(this, props);
        _this.onClick = _this.onClick.bind(number_assertThisInitialized(_this));
        return _this;
    }
    number_createClass(Number, [
        {
            key: "onClick",
            value: function onClick() {
                this.props.onChange({
                    index: this.props.index,
                    value: this.props.value
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ react.createElement(styles_Number, {
                    layout: this.props.layout
                }, /*#__PURE__*/ react.createElement(NumberValue, {
                    inactive: !this.props.selected,
                    onClick: this.onClick
                }, this.props.value));
            }
        }
    ]);
    return Number;
}(react.Component);

number_Number.propTypes = {
    layout: prop_types_default().oneOf([
        "vertical",
        "horizontal"
    ]).isRequired,
    value: (prop_types_default()).number.isRequired,
    onChange: (prop_types_default()).func.isRequired,
    index: (prop_types_default()).number.isRequired,
    selected: (prop_types_default()).bool
};
number_Number.defaultProps = {
    selected: true
};

;// CONCATENATED MODULE: ./src/components/filters/range/numbers.js
function numbers_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function numbers_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function numbers_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function numbers_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) numbers_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) numbers_defineProperties(Constructor, staticProps);
    return Constructor;
}
function numbers_extends() {
    numbers_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return numbers_extends.apply(this, arguments);
}
function numbers_getPrototypeOf(o) {
    numbers_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return numbers_getPrototypeOf(o);
}
function numbers_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) numbers_setPrototypeOf(subClass, superClass);
}
function numbers_possibleConstructorReturn(self, call) {
    if (call && (numbers_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return numbers_assertThisInitialized(self);
}
function numbers_setPrototypeOf(o, p) {
    numbers_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return numbers_setPrototypeOf(o, p);
}
var numbers_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function numbers_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function numbers_createSuper(Derived) {
    var hasNativeReflectConstruct = numbers_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = numbers_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = numbers_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return numbers_possibleConstructorReturn(this, result);
    };
}





var Numbers = /*#__PURE__*/ function(Component) {
    "use strict";
    numbers_inherits(Numbers, Component);
    var _super = numbers_createSuper(Numbers);
    function Numbers(props) {
        numbers_classCallCheck(this, Numbers);
        var _this;
        _this = _super.call(this, props);
        _this.numberRefs = [];
        _this.wrapper = null;
        return _this;
    }
    numbers_createClass(Numbers, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.adjustVisibleNumbers();
            }
        },
        {
            key: "getSectionValues",
            value: function getSectionValues() {
                var _this = this;
                return this.props.sections.reduce(function(values, section, index) {
                    var fillData = _this.props.getSectionFillData(index);
                    if (index === 0) {
                        values.push({
                            value: section.from,
                            index: index,
                            selected: fillData.from
                        });
                    }
                    values.push({
                        value: section.to,
                        index: index + 1,
                        selected: fillData.to
                    });
                    return values;
                }, []);
            }
        },
        {
            /* eslint-disable no-plusplus, react/no-find-dom-node, no-continue, no-constant-condition */ key: "adjustVisibleNumbers",
            value: function adjustVisibleNumbers() {
                if (!this.wrapper) {
                    return;
                }
                var lastVisibleNode = null;
                var selector = "button";
                var length = this.getSectionValues().length;
                if (true) {
                    for(var i = 0; i < length; i++){
                        var numberNode = react_dom.findDOMNode(this.numberRefs["number".concat(i)]);
                        if (!numberNode) {
                            continue;
                        }
                        var currentNode = numberNode.querySelector("".concat(selector));
                        if (!currentNode) {
                            continue;
                        }
                        currentNode.style.display = "block";
                        if (lastVisibleNode === null) {
                            lastVisibleNode = numberNode.querySelector("".concat(selector));
                            continue;
                        }
                        var lastVisibleRect = lastVisibleNode.getBoundingClientRect();
                        var currentRect = currentNode.getBoundingClientRect();
                        var distance = currentRect.left - lastVisibleRect.right;
                        // we need some distance between the numbers,
                        // i.e we do not want to show number too close to each other like 2030, we want 20 30.
                        if (distance < 5) {
                            // numbers are overlapping, hide current node UNLESS current node is the last node.
                            // Because we do want to show the edge numbers they are more important than the others.
                            if (i === length - 1) {
                                currentNode = lastVisibleNode;
                            }
                            currentNode.style.display = "none";
                        } else {
                            lastVisibleNode = currentNode;
                        }
                    }
                    this.visibleNumbersAdjusted = true;
                }
            }
        },
        {
            key: "renderNumber",
            value: function renderNumber(section, index) {
                var _this = this;
                return /*#__PURE__*/ react.createElement(number_Number, numbers_extends({
                    key: "number".concat(index),
                    layout: this.props.layout,
                    ref: function(c) {
                        _this.numberRefs["number".concat(index)] = c;
                    },
                    value: section.value,
                    index: section.index,
                    onChange: this.props.onChange
                }, section));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var sectionValues = this.getSectionValues();
                return /*#__PURE__*/ react.createElement(NumberWrapper, {
                    ref: function(node) {
                        _this.wrapper = node;
                    }
                }, sectionValues.map(this.renderNumber, this));
            }
        }
    ]);
    return Numbers;
}(react.Component);

Numbers.propTypes = {
    layout: prop_types_default().oneOf([
        "vertical",
        "horizontal"
    ]).isRequired,
    sections: prop_types_default().arrayOf(prop_types_default().shape({
        from: (prop_types_default()).number,
        to: (prop_types_default()).number,
        products: (prop_types_default()).number
    })).isRequired,
    getSectionFillData: (prop_types_default()).func.isRequired,
    onChange: (prop_types_default()).func.isRequired
};

;// CONCATENATED MODULE: ./src/components/filters/range/range.js
function range_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function range_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function range_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function range_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) range_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) range_defineProperties(Constructor, staticProps);
    return Constructor;
}
function range_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function range_getPrototypeOf(o) {
    range_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return range_getPrototypeOf(o);
}
function range_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) range_setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            range_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function range_possibleConstructorReturn(self, call) {
    if (call && (range_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return range_assertThisInitialized(self);
}
function range_setPrototypeOf(o, p) {
    range_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return range_setPrototypeOf(o, p);
}
var range_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function range_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function range_createSuper(Derived) {
    var hasNativeReflectConstruct = range_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = range_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = range_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return range_possibleConstructorReturn(this, result);
    };
}









var Range = /*#__PURE__*/ function(Component) {
    "use strict";
    range_inherits(Range, Component);
    var _super = range_createSuper(Range);
    function Range(props) {
        range_classCallCheck(this, Range);
        var _this;
        _this = _super.call(this, props);
        range_defineProperty(range_assertThisInitialized(_this), "getSectionFillData", function(index) {
            // | = section, [---] = selection
            var _positionData = _this.state.positionData, from = _positionData.from, to = _positionData.to;
            // whole section inside selection. ie [--|--|--]
            if (index > from.section && index < to.section) {
                return {
                    from: true,
                    to: true,
                    fill: 1
                };
            }
            // section touches from right. ie |-[-|----]
            if (index === from.section && index !== to.section) {
                return {
                    from: from.fill === 0,
                    to: true,
                    fill: 1 - from.fill
                };
            }
            // section touches from left. ie [----|-]-|
            if (index !== from.section && index === to.section) {
                return {
                    from: true,
                    to: to.fill === 1,
                    fill: to.fill
                };
            }
            // whole selection inside section. . ie |-[-]-|
            if (index === from.section && index === to.section) {
                return {
                    from: false,
                    to: false,
                    fill: to.fill - from.fill
                };
            }
            // section outside selection. ie [----]-|--|
            return {
                from: false,
                to: false,
                fill: 0
            };
        });
        range_defineProperty(range_assertThisInitialized(_this), "getSliderWidth", function() {
            var sliderNode = _this.slider;
            return sliderNode.offsetWidth;
        });
        range_defineProperty(range_assertThisInitialized(_this), "startDragging", function(callback) {
            _this.setState({
                dragging: true
            }, callback);
        });
        range_defineProperty(range_assertThisInitialized(_this), "stopDragging", function() {
            _this.setState({
                dragging: false
            }, function() {
                _this.commitChanges(_this.state.selected);
            });
        });
        range_defineProperty(range_assertThisInitialized(_this), "updateValueFromPosition", function(key, positionPercentage) {
            var sectionCount = _this.props.values.values.length;
            var rawValueMapping = positionPercentage / (100 / sectionCount);
            var index = Math.floor(rawValueMapping);
            var fill = parseFloat((rawValueMapping % 1).toFixed(4));
            // make sure inside outer bounds
            var bounds = Range.getSectionBounds(sectionCount);
            if (index < bounds.from.section) {
                index = bounds.from.section;
                fill = bounds.from.fill;
            } else if (index > bounds.to.section) {
                index = bounds.to.section;
                fill = bounds.to.fill;
            }
            var newSelected = _objectSpreadProps(_objectSpread({}, _this.props.selected), range_defineProperty({}, key, Range.getSectionValue(_this.props.values.values[index], fill)));
            return newSelected;
        });
        range_defineProperty(range_assertThisInitialized(_this), "adjustValueForPropertyType", function(value) {
            var step = null;
            var type = _this.props.type;
            switch(type){
                case TYPE_INTEGER:
                case TYPE_DATE_YEAR:
                    step = 1;
                    break;
                case TYPE_DECIMAL:
                default:
                    step = 10;
            }
            return Math.round(value * step) / step;
        });
        range_defineProperty(range_assertThisInitialized(_this), "moveClosestHandle", function(value, index) {
            var _positionData = _this.state.positionData, from = _positionData.from, to = _positionData.to;
            var fromDifference = Math.abs(from.section + from.fill - index);
            var toDifference = Math.abs(to.section + to.fill - index);
            var newSelected = {};
            if (fromDifference < toDifference) {
                newSelected.from = value;
            } else {
                newSelected.to = value;
            }
            return newSelected;
        });
        range_defineProperty(range_assertThisInitialized(_this), "normalizeSelected", function(selected, data) {
            var realMinMax = _this.state.realMinMax;
            var newSelected = _objectSpread({}, realMinMax, selected, data);
            newSelected.from = _this.adjustValueForPropertyType(newSelected.from);
            newSelected.to = _this.adjustValueForPropertyType(newSelected.to);
            if (newSelected.from > newSelected.to) {
                var tempValue = newSelected.from;
                newSelected.from = newSelected.to;
                newSelected.to = tempValue;
            }
            return newSelected;
        });
        range_defineProperty(range_assertThisInitialized(_this), "onChange", function(event) {
            var selected = _this.updateValueFromPosition(event.id, event.position);
            _this.update(selected);
        });
        range_defineProperty(range_assertThisInitialized(_this), "onTextInputChange", function(event) {
            var selected = range_defineProperty({}, event.id, event.value);
            _this.commitChanges(selected);
        });
        range_defineProperty(range_assertThisInitialized(_this), "onBarClick", function(event) {
            _this.commitChanges(event);
        });
        range_defineProperty(range_assertThisInitialized(_this), "onNumberClick", function(event) {
            var selected = _this.moveClosestHandle(event.value, event.index);
            _this.commitChanges(selected);
        });
        range_defineProperty(range_assertThisInitialized(_this), "commitChanges", function(selected) {
            _this.props.onChange(_this.update(selected));
        });
        range_defineProperty(range_assertThisInitialized(_this), "update", function(selected) {
            var newSelected = _this.normalizeSelected(_this.state.selected, selected);
            var positionData = Range.calculatePositionData(_this.props.values, newSelected);
            _this.setState({
                positionData: positionData,
                selected: newSelected
            });
            return newSelected;
        });
        var realMinMax = Range.getRealMinMax(props.values.values);
        var positionData = Range.calculatePositionData(props.values, props.selected);
        _this.state = {
            positionData: positionData,
            realMinMax: realMinMax,
            selected: props.selected,
            dragging: false
        };
        return _this;
    }
    range_createClass(Range, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (!this.props.selected && prevProps.selected !== this.props.selected) {
                    // eslint-disable-next-line
                    this.setState({
                        positionData: Range.calculatePositionData(this.props.values, this.props.selected),
                        selected: this.props.selected
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, showBars = _props.showBars, values = _props.values, layout = _props.layout;
                var _positionData = this.state.positionData, from = _positionData.from, to = _positionData.to;
                var _state = this.state, selected = _state.selected, realMinMax = _state.realMinMax, dragging = _state.dragging;
                var isSelected = {
                    from: selected ? selected.from > realMinMax.from : false,
                    to: selected ? selected.to < realMinMax.to : false
                };
                return /*#__PURE__*/ react.createElement(styles_Layout, {
                    layout: layout
                }, /*#__PURE__*/ react.createElement(TextInputs, {
                    keys: [
                        KEY_LEFT,
                        KEY_RIGHT
                    ],
                    selected: this.state.selected,
                    onChange: this.onTextInputChange,
                    minMax: realMinMax,
                    layout: layout
                }), /*#__PURE__*/ react.createElement(SliderWrapper, {
                    ref: function(c) {
                        _this.slider = c;
                    },
                    showBars: showBars
                }, showBars && /*#__PURE__*/ react.createElement(Bars, {
                    values: values,
                    onChange: this.onBarClick,
                    getSectionFillData: this.getSectionFillData,
                    layout: layout
                }), /*#__PURE__*/ react.createElement(line, {
                    invalid: !this.props.isValid,
                    from: from.position,
                    to: to.position,
                    layout: layout
                }), /*#__PURE__*/ react.createElement(Handles, {
                    keys: [
                        KEY_LEFT,
                        KEY_RIGHT
                    ],
                    selected: isSelected,
                    invalid: !this.props.isValid,
                    positionData: this.state.positionData,
                    updateSlider: this.onChange,
                    startDragging: this.startDragging,
                    stopDragging: this.stopDragging,
                    getSliderWidth: this.getSliderWidth,
                    dragging: dragging
                }), /*#__PURE__*/ react.createElement(Numbers, {
                    sections: values.values,
                    onChange: this.onNumberClick,
                    getSectionFillData: this.getSectionFillData,
                    layout: layout
                })));
            }
        }
    ], [
        {
            key: "getRealMinMax",
            value: /**
   * We can't use props.values.max_values/min_values since they refer to
   * min max for actual products, not what the range contains.
   * @param values
   */ function getRealMinMax(values) {
                var maxIndex = values.length - 1;
                return {
                    from: values[0].from,
                    to: values[maxIndex].to
                };
            }
        },
        {
            key: "getSectionFill",
            value: function getSectionFill(section, value) {
                var range = section.to - section.from;
                var valueInRange = value - section.from;
                return valueInRange / range;
            }
        },
        {
            key: "getSectionValue",
            value: function getSectionValue(section, fill) {
                var range = section.to - section.from;
                return parseFloat((section.from + range * fill).toFixed(4));
            }
        },
        {
            key: "getSectionBounds",
            value: function getSectionBounds(sectionCount) {
                var _obj;
                return _obj = {}, range_defineProperty(_obj, KEY_LEFT, {
                    section: 0,
                    fill: 0,
                    position: 0
                }), range_defineProperty(_obj, KEY_RIGHT, {
                    section: sectionCount - 1,
                    fill: 1,
                    position: 1
                }), _obj;
            }
        },
        {
            key: "findSectionIndexForValue",
            value: function findSectionIndexForValue(sections, value) {
                return sections.findIndex(function(section) {
                    if (section.from <= value && section.to >= value) {
                        return true;
                    }
                    return false;
                });
            }
        },
        {
            key: "calculatePositionData",
            value: function calculatePositionData(values, selected) {
                var sectionCount = values.values.length;
                if (!selected) {
                    return Range.getSectionBounds(sectionCount);
                }
                return [
                    KEY_LEFT,
                    KEY_RIGHT
                ].reduce(function(positionData, key) {
                    var selectValue = selected[key];
                    // get section value is in.
                    var sectionData = {};
                    var section = Range.findSectionIndexForValue(values.values, selectValue);
                    if (section === -1) {
                        // section not found which means selection is out of bound
                        // (e.g. "I want 1tb RAM" is a valid filter even though 1tb RAM does not (yet) exist)
                        sectionData.section = key === KEY_LEFT ? 0 : sectionCount - 1;
                        sectionData.fill = key === KEY_LEFT ? 0 : 1;
                        sectionData.position = key === KEY_LEFT ? 0 : 1;
                    } else {
                        sectionData.section = section;
                        sectionData.fill = Range.getSectionFill(values.values[section], selectValue);
                        sectionData.position = (section + sectionData.fill) / sectionCount;
                    }
                    return _objectSpreadProps(_objectSpread({}, positionData), range_defineProperty({}, key, sectionData));
                }, {});
            }
        }
    ]);
    return Range;
}(react.Component);

Range.propTypes = {
    layout: prop_types_default().oneOf([
        "horizontal",
        "vertical"
    ]),
    values: prop_types_default().shape({
        max_matching_products: (prop_types_default()).number,
        max_values: (prop_types_default()).number,
        min_values: (prop_types_default()).number,
        values: prop_types_default().arrayOf(prop_types_default().shape([
            prop_types_default().shape({
                from: (prop_types_default()).number,
                to: (prop_types_default()).number,
                products: (prop_types_default()).number
            })
        ]))
    }).isRequired,
    type: (prop_types_default()).string.isRequired,
    showBars: (prop_types_default()).bool,
    isValid: (prop_types_default()).bool,
    onChange: (prop_types_default()).func.isRequired,
    selected: prop_types_default().oneOfType([
        (prop_types_default()).string,
        prop_types_default().shape({
            from: (prop_types_default()).number,
            to: (prop_types_default()).number
        })
    ])
};
Range.defaultProps = {
    layout: "vertical",
    showBars: true,
    isValid: true,
    selected: undefined
};

;// CONCATENATED MODULE: ./src/components/filters/dual-range.js
function dual_range_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function dual_range_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function dual_range_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function dual_range_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) dual_range_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) dual_range_defineProperties(Constructor, staticProps);
    return Constructor;
}
function dual_range_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function dual_range_extends() {
    dual_range_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return dual_range_extends.apply(this, arguments);
}
function dual_range_getPrototypeOf(o) {
    dual_range_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return dual_range_getPrototypeOf(o);
}
function dual_range_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) dual_range_setPrototypeOf(subClass, superClass);
}
function dual_range_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            dual_range_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function dual_range_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function dual_range_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        dual_range_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function dual_range_possibleConstructorReturn(self, call) {
    if (call && (dual_range_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return dual_range_assertThisInitialized(self);
}
function dual_range_setPrototypeOf(o, p) {
    dual_range_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return dual_range_setPrototypeOf(o, p);
}
var dual_range_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function dual_range_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function dual_range_createSuper(Derived) {
    var hasNativeReflectConstruct = dual_range_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = dual_range_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = dual_range_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return dual_range_possibleConstructorReturn(this, result);
    };
}




var DualRange = /*#__PURE__*/ function(_Component) {
    "use strict";
    dual_range_inherits(DualRange, _Component);
    var _super = dual_range_createSuper(DualRange);
    function DualRange(props) {
        dual_range_classCallCheck(this, DualRange);
        var _this;
        _this = _super.call(this, props);
        var _obj;
        _this.defaultValues = (_obj = {}, dual_range_defineProperty(_obj, KEY_LEFT, null), dual_range_defineProperty(_obj, KEY_RIGHT, null), _obj);
        _this.state = {
            selected: _this.props.selected
        };
        return _this;
    }
    dual_range_createClass(DualRange, [
        {
            key: "getPropsForRange",
            value: function getPropsForRange(key) {
                var values = this.props.values;
                var selected = this.state.selected;
                var newProps = dual_range_objectSpreadProps(dual_range_objectSpread({}, this.props), {
                    values: {
                        min_value: values.min_value,
                        max_value: values.max_value,
                        values: values.values[key]
                    }
                });
                if (selected) {
                    newProps = dual_range_objectSpreadProps(dual_range_objectSpread({}, newProps), {
                        selected: selected[key]
                    });
                }
                return newProps;
            }
        },
        {
            key: "onChange",
            value: function onChange(key, evt) {
                // The API requires us to send in both 'from' and 'to', null values are okay however.
                // This merges the nullified values with the selected and finally the changed value
                var newSelected = dual_range_objectSpreadProps(dual_range_objectSpread({}, this.defaultValues, this.state.selected), dual_range_defineProperty({}, key, evt));
                // If both 'from' and 'to' is null we will make the entire setting null(aka, clear it)
                if (DualRange.selectedIsNull(newSelected)) {
                    newSelected = null;
                }
                this.setState({
                    selected: newSelected
                });
                this.props.onChange({
                    value: newSelected
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(Range, dual_range_extends({}, this.getPropsForRange(KEY_LEFT), {
                    onChange: function(evt) {
                        return _this.onChange(KEY_LEFT, evt);
                    }
                })), /*#__PURE__*/ react.createElement(Range, dual_range_extends({}, this.getPropsForRange(KEY_RIGHT), {
                    onChange: function(evt) {
                        return _this.onChange(KEY_RIGHT, evt);
                    }
                })));
            }
        }
    ], [
        {
            key: "deriveStateFromProps",
            value: function deriveStateFromProps(nextProps) {
                return {
                    selected: nextProps.selected
                };
            }
        },
        {
            key: "selectedIsNull",
            value: function selectedIsNull(selected) {
                return Object.keys(selected).filter(function(index) {
                    return selected[index];
                }).length === 0;
            }
        }
    ]);
    return DualRange;
}(react.Component);
DualRange.propTypes = {
    onChange: (prop_types_default()).func.isRequired,
    values: prop_types_default().shape({
        max_matching_products: (prop_types_default()).number,
        max_values: (prop_types_default()).number,
        min_values: (prop_types_default()).number,
        values: prop_types_default().shape({
            from: prop_types_default().arrayOf(prop_types_default().shape({
                from: (prop_types_default()).number,
                to: (prop_types_default()).number,
                products: (prop_types_default()).number
            })),
            to: prop_types_default().arrayOf(prop_types_default().shape({
                from: (prop_types_default()).number,
                to: (prop_types_default()).number,
                products: (prop_types_default()).number
            }))
        })
    }).isRequired,
    selected: prop_types_default().shape({
        from: prop_types_default().shape({
            from: (prop_types_default()).number,
            to: (prop_types_default()).number
        }),
        to: prop_types_default().shape({
            from: (prop_types_default()).number,
            to: (prop_types_default()).number
        })
    }),
    layout: prop_types_default().oneOf([
        "vertical",
        "horizontal"
    ])
};
DualRange.defaultProps = {
    selected: null,
    layout: "vertical"
};
/* harmony default export */ const dual_range = (DualRange);

// EXTERNAL MODULE: ./src/ui/icons/index.ts + 4 modules
var icons = __webpack_require__(13686);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/filters/checkbox.js
function checkbox_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function checkbox_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function checkbox_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function checkbox_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) checkbox_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) checkbox_defineProperties(Constructor, staticProps);
    return Constructor;
}
function checkbox_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function checkbox_getPrototypeOf(o) {
    checkbox_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return checkbox_getPrototypeOf(o);
}
function checkbox_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) checkbox_setPrototypeOf(subClass, superClass);
}
function checkbox_possibleConstructorReturn(self, call) {
    if (call && (checkbox_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return checkbox_assertThisInitialized(self);
}
function checkbox_setPrototypeOf(o, p) {
    checkbox_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return checkbox_setPrototypeOf(o, p);
}
var checkbox_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function checkbox_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function checkbox_createSuper(Derived) {
    var hasNativeReflectConstruct = checkbox_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = checkbox_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = checkbox_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return checkbox_possibleConstructorReturn(this, result);
    };
}




var checkbox_Checkbox = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    checkbox_inherits(Checkbox, _PureComponent);
    var _super = checkbox_createSuper(Checkbox);
    function Checkbox(props) {
        checkbox_classCallCheck(this, Checkbox);
        var _this;
        _this = _super.call(this, props);
        checkbox_defineProperty(checkbox_assertThisInitialized(_this), "handleOnChange", function(e) {
            _this.props.onChange({
                id: _this.props.id,
                value: _this.props.child.id,
                name: _this.props.child.name,
                checked: e.currentTarget.checked,
                children: _this.props.child.children,
                parents: _this.props.parents,
                autoSelectChildren: _this.props.autoSelectChildren
            });
        });
        return _this;
    }
    checkbox_createClass(Checkbox, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ react.createElement(HiddenInput, {
                    checked: this.props.isChecked,
                    onChange: this.handleOnChange,
                    type: "checkbox",
                    value: this.props.child.id
                });
            }
        }
    ]);
    return Checkbox;
}(react.PureComponent);
var checkbox_oneOfType = (prop_types_default()).oneOfType, checkbox_arrayOf = (prop_types_default()).arrayOf, checkbox_string = (prop_types_default()).string, checkbox_bool = (prop_types_default()).bool, checkbox_shape = (prop_types_default()).shape, checkbox_func = (prop_types_default()).func, checkbox_number = (prop_types_default()).number, object = (prop_types_default()).object;
var valueType = {
    id: checkbox_string.isRequired,
    name: checkbox_string.isRequired,
    products: checkbox_number
};
valueType.children = checkbox_arrayOf(checkbox_shape(valueType));
checkbox_Checkbox.propTypes = {
    child: object.isRequired,
    onChange: checkbox_func,
    id: checkbox_oneOfType([
        checkbox_number,
        checkbox_string
    ]).isRequired,
    parents: checkbox_arrayOf(checkbox_shape(valueType)),
    autoSelectChildren: checkbox_bool,
    isChecked: checkbox_bool.isRequired
};
checkbox_Checkbox.defaultProps = {
    parents: [],
    onChange: base/* noop */.ZT,
    autoSelectChildren: true
};
/* harmony default export */ const filters_checkbox = (checkbox_Checkbox);

;// CONCATENATED MODULE: ./src/components/filters/list.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function list_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function list_extends() {
    list_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return list_extends.apply(this, arguments);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function list_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            list_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function list_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function list_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        list_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var generateFakeId = function(parents, child) {
    return [
        child
    ].concat(_toConsumableArray(parents)).map(function(x) {
        return x.name;
    }).join("/");
};
var isSelected = function(selected, child) {
    if (selected === true) return selected;
    if (selected.includes(child.id)) {
        return true;
    }
    if (child.children && child.children.length) {
        return child.children.reduce(isSelected, selected);
    }
    return selected;
};
function hasSelectedChild(selected, children) {
    if (!children || !selected.length) return false;
    return children.reduce(isSelected, selected) === true;
}
function hasSelectedAllChildren(selected, children) {
    if (!children || !children.length || !selected.length) return false;
    var allSelected = children.filter(function(child) {
        return selected.includes(child.id);
    });
    return allSelected.length === children.length;
}
var List = function(props) {
    var id = props.id, values = props.values, selected = props.selected, selectedParent = props.selectedParent, onChange = props.onChange, parents = props.parents, onExpand = props.onExpand, expanded = props.expanded, autoSelectChildren = props.autoSelectChildren, layout = props.layout;
    return /*#__PURE__*/ react.createElement(Layout, {
        layout: layout
    }, values.map(function(value) {
        // Not all options have an id, so we have to generate one that we can use as an identifier
        var child = list_objectSpreadProps(list_objectSpread({}, value), {
            id: value.id || generateFakeId(parents, value)
        });
        var isSelectable = child.selectable !== false;
        var isChecked = isSelectable && (selectedParent && autoSelectChildren || selected.includes(child.id) || selected.includes(parseInt(child.id, 10)) || hasSelectedAllChildren(selected, child.children));
        var isPartiallyChecked = isSelectable && hasSelectedChild(selected, child.children) && !hasSelectedAllChildren(selected, child.children);
        var isExpanded = expanded.includes(child.id);
        // Prevent the box from being checked if it already is partially checked and shouldn't select children
        if (!autoSelectChildren && isPartiallyChecked) {
            isChecked = false;
        }
        var nonSelectableParentProps = {
            as: "span",
            onClick: function(e) {
                return onExpand(e, child.id);
            }
        };
        return /*#__PURE__*/ react.createElement(ListItem, {
            key: child.id,
            selected: isChecked || isPartiallyChecked,
            "data-test": "ListItem"
        }, /*#__PURE__*/ react.createElement(ListLabel, list_extends({}, isSelectable ? {} : nonSelectableParentProps), isSelectable && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(filters_checkbox, list_extends({
            child: child,
            isChecked: isChecked
        }, props)), /*#__PURE__*/ react.createElement(Checkbox, {
            checked: isChecked,
            partial: isPartiallyChecked
        }, /*#__PURE__*/ react.createElement(icons/* CheckIcon */.nQ, {
            styling: "neutral-light",
            strokeWidth: "6",
            height: 14,
            left: 1,
            top: 1,
            checked: isChecked,
            partial: isPartiallyChecked
        }))), /*#__PURE__*/ react.createElement(ListLabelText, {
            "data-test": "ListItemLabelText"
        }, /*#__PURE__*/ react.createElement(ListLabelName, null, child.name), /*#__PURE__*/ react.createElement(ListLabelByline, null, "(", child.products, ")")), child.children && Boolean(child.children.length) && /*#__PURE__*/ react.createElement(ExpandWrapper, null, /*#__PURE__*/ react.createElement(ExpandButton, {
            as: isSelectable ? undefined : "span",
            expanded: isExpanded,
            outlined: !isExpanded,
            onClick: isSelectable ? function(e) {
                return onExpand(e, child.id);
            } : undefined
        }, isExpanded ? /*#__PURE__*/ react.createElement(ArrowUp, null) : /*#__PURE__*/ react.createElement(ArrowDown, null)))), child.children && isExpanded && /*#__PURE__*/ react.createElement(List, {
            id: id,
            values: child.children,
            parents: [
                child
            ].concat(_toConsumableArray(parents)),
            onChange: onChange,
            selected: selected,
            selectedParent: isChecked,
            expanded: expanded,
            onExpand: onExpand,
            autoSelectChildren: autoSelectChildren
        }));
    }));
};
var list_oneOfType = (prop_types_default()).oneOfType, list_arrayOf = (prop_types_default()).arrayOf, list_string = (prop_types_default()).string, list_bool = (prop_types_default()).bool, list_shape = (prop_types_default()).shape, list_func = (prop_types_default()).func, list_number = (prop_types_default()).number, list_oneOf = (prop_types_default()).oneOf;
var list_valueType = {
    id: list_string.isRequired,
    name: list_string.isRequired,
    products: list_number
};
list_valueType.children = list_arrayOf(list_shape(list_valueType));
List.propTypes = {
    id: list_oneOfType([
        list_number,
        list_string
    ]).isRequired,
    values: list_arrayOf(list_shape(list_valueType)).isRequired,
    selectedParent: list_bool,
    selected: list_arrayOf(list_string),
    parents: list_arrayOf(list_shape(list_valueType)),
    onChange: list_func,
    onExpand: list_func,
    expanded: list_arrayOf(list_string),
    autoSelectChildren: list_bool,
    layout: list_oneOf([
        "vertical",
        "horizontal"
    ])
};
List.defaultProps = {
    parents: [],
    onChange: function() {},
    selected: [],
    selectedParent: false,
    onExpand: function() {},
    expanded: [],
    autoSelectChildren: true,
    layout: "vertical"
};
/* harmony default export */ const list = (List);

;// CONCATENATED MODULE: ./src/components/filters/single-range.js
function single_range_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function single_range_extends() {
    single_range_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return single_range_extends.apply(this, arguments);
}
function single_range_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            single_range_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var SingleRange = function(props) {
    return /*#__PURE__*/ react.createElement(Range, single_range_extends({}, props, {
        onChange: function(data) {
            return props.onChange({
                value: data
            });
        }
    }));
};
SingleRange.propTypes = single_range_objectSpread({
    onChange: (prop_types_default()).func.isRequired
}, Range.propTypes);
SingleRange.defaultProps = single_range_objectSpread({
    showBars: true,
    isValid: true
}, Range.defaultProps);
/* harmony default export */ const single_range = (SingleRange);

;// CONCATENATED MODULE: ./src/components/filters/index.ts






;// CONCATENATED MODULE: ./src/areas/category/components/filter/components/filter/styles.ts
function filter_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function filter_styles_templateObject() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n          display: flex;\n          align-items: flex-start;\n        "
    ]);
    filter_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function filter_styles_templateObject1() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    filter_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function filter_styles_templateObject2() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  font-style: italic;\n  margin-bottom: 10px;\n  margin-top: 10px;\n  border: 1px solid ",
        ";\n  padding: 5px;\n  outline: 0;\n\n  &:focus {\n    border-color: ",
        ";\n    box-shadow: inset 0 0 0 1px ",
        ";\n  }\n"
    ]);
    filter_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var FilterWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FilterWrapper",
    componentId: "sc-0-0"
})(filter_styles_templateObject1(), function(props) {
    return props.horizontal ? (0,styled_components_browser_esm.css)(filter_styles_templateObject()) : null;
});
var FilterInput = styled_components_browser_esm["default"].input.withConfig({
    displayName: "FilterInput",
    componentId: "sc-0-1"
})(filter_styles_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.lines.secondary;
}, function(param) {
    var theme = param.theme;
    return theme.lines.highlight;
}, function(param) {
    var theme = param.theme;
    return theme.lines.highlight;
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(7336);
;// CONCATENATED MODULE: ./src/areas/category/components/filter/components/filter/index.tsx
function filter_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function filter_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function filter_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            filter_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function filter_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function filter_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        filter_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || filter_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function filter_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return filter_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return filter_arrayLikeToArray(o, minLen);
}







var Filter = function(props) {
    var handleInputKeyPress = function handleInputKeyPress(event) {
        var target = event.target;
        if (event.key === "Enter") {
            dispatch((0,filter/* filterChangeAction */.Xi)(categoryId, {
                id: displayFilter.id,
                value: target.value,
                children: undefined,
                section: {
                    name: displayFilter.name,
                    unit: displayFilter.unit
                },
                parents: [],
                filterType: "string"
            }));
            target.blur();
        }
    };
    var handleRadioOnChange = function handleRadioOnChange(selected) {
        dispatch((0,filter/* filterChangeAction */.Xi)(categoryId, {
            id: displayFilter.id,
            section: {
                name: displayFilter.name,
                unit: displayFilter.unit
            },
            value: selected.id,
            filterType: "boolean"
        }));
    };
    var handleCheckboxOnChange = function handleCheckboxOnChange(filterType, selected) {
        dispatch((0,filter/* filterChangeAction */.Xi)(categoryId, filter_objectSpreadProps(filter_objectSpread({}, selected), {
            id: displayFilter.id,
            section: {
                name: displayFilter.name,
                unit: displayFilter.unit
            },
            filterType: filterType
        })));
    };
    var handleOnExpand = function handleOnExpand(id, event) {
        event.preventDefault();
        setExpanded(function(prevState) {
            return prevState.includes(id) ? prevState.filter(function(item) {
                return item !== id;
            }) : prevState.concat([
                id
            ]);
        });
    };
    var ref = _slicedToArray(react.useState([]), 2), expanded = ref[0], setExpanded = ref[1];
    var ref1 = _slicedToArray(react.useState(props.query ? props.query[props.displayFilter.id] : ""), 2), inputValue = ref1[0], setInputValue = ref1[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var displayFilter = props.displayFilter, filteredValues = props.filteredValues, query = props.query, layout = props.layout, showAllValues = props.showAllValues, categoryId = props.categoryId, onToggleAllValues = props.onToggleAllValues;
    var t = (0,app_context/* useAppContext */.bp)().t;
    if (!displayFilter.type) return null;
    switch(displayFilter.type){
        case "boolean-reduced":
        case "boolean":
            {
                var filterVal = filteredValues[displayFilter.id] && filteredValues[displayFilter.id].values ? filteredValues[displayFilter.id].values : {};
                return /*#__PURE__*/ react.createElement(filters_radio, {
                    id: displayFilter.id,
                    key: displayFilter.id,
                    selected: query[displayFilter.id],
                    layout: layout,
                    values: [
                        {
                            id: true,
                            text: t("filter", "properties.select-true"),
                            products: filterVal.true
                        },
                        {
                            id: false,
                            text: t("filter", "properties.select-false"),
                            products: filterVal.false
                        }
                    ],
                    onChange: function(selected) {
                        return handleRadioOnChange(selected);
                    }
                });
            }
        case "list-or":
        case "list-and":
        case "list-or-reduced":
        case "list-and-reduced":
        case "list-tree-and":
        case "list-tree-or":
            {
                if (!filteredValues[displayFilter.id].values) {
                    return null;
                }
                var showExpansion = filteredValues[displayFilter.id] ? filteredValues[displayFilter.id].values.length > 5 : false;
                var isLimited = showExpansion && showAllValues === false && props.limitValues;
                var limitedValues = isLimited ? filteredValues[displayFilter.id].values.slice(0, props.limitValues) : filteredValues[displayFilter.id].values;
                return /*#__PURE__*/ react.createElement(FilterWrapper, {
                    key: "".concat(displayFilter.id, "_wrapper"),
                    horizontal: layout === "horizontal"
                }, /*#__PURE__*/ react.createElement(list, {
                    id: displayFilter.id,
                    key: displayFilter.id,
                    values: limitedValues,
                    selected: query[displayFilter.id],
                    autoSelectChildren: false,
                    onExpand: function(event, id) {
                        return handleOnExpand(id, event);
                    },
                    expanded: expanded,
                    layout: layout,
                    onChange: function(selected) {
                        return handleCheckboxOnChange("list", selected);
                    }
                }), showExpansion && layout === "vertical" && /*#__PURE__*/ react.createElement(variants.TextButton, {
                    onClick: function() {
                        return onToggleAllValues(displayFilter.id);
                    },
                    "data-test": "MoreFiltersToggleButton"
                }, t("filter", isLimited ? "properties.quantity-show-more" : "properties.quantity-show-less")));
            }
        case "date-year":
        case "integer":
        case "decimal":
            {
                return /*#__PURE__*/ react.createElement(single_range, {
                    // id={displayFilter.id}
                    key: displayFilter.id,
                    type: displayFilter.type,
                    values: filteredValues[displayFilter.id],
                    selected: query[displayFilter.id],
                    layout: layout,
                    onChange: function(selected) {
                        return handleCheckboxOnChange("slider", selected);
                    }
                });
            }
        case "interval-decimal-touch":
        case "interval-decimal-contain":
        case "interval-decimal-span":
        case "interval-integer-touch":
        case "interval-integer-contain":
        case "interval-integer-span":
            {
                return /*#__PURE__*/ react.createElement(dual_range, {
                    id: displayFilter.id,
                    key: displayFilter.id,
                    type: displayFilter.type,
                    values: filteredValues[displayFilter.id],
                    selected: query[displayFilter.id],
                    layout: layout,
                    onChange: function(selected) {
                        return handleCheckboxOnChange("slider", selected);
                    }
                });
            }
        case "string":
            {
                return /*#__PURE__*/ react.createElement(FilterInput, {
                    key: displayFilter.id,
                    placeholder: displayFilter.name,
                    value: inputValue,
                    onKeyPress: function(event) {
                        return handleInputKeyPress(event);
                    },
                    onChange: function(event) {
                        setInputValue(event.target.value);
                    }
                });
            }
        default:
            {
                return /*#__PURE__*/ react.createElement("div", null, displayFilter.name, " with", displayFilter.type);
            }
    }
};

// EXTERNAL MODULE: ./src/components/error-boundary/index.tsx + 1 modules
var error_boundary = __webpack_require__(52923);
;// CONCATENATED MODULE: ./src/areas/category/components/filter/components/panel/styles.ts
function panel_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function panel_styles_templateObject() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n  flex-grow: 0;\n  flex-shrink: 1;\n"
    ]);
    panel_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function panel_styles_templateObject1() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n  flex-grow: 0;\n  flex-shrink: 1;\n"
    ]);
    panel_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function panel_styles_templateObject2() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n          border-bottom: 1px solid ",
        ";\n        "
    ]);
    panel_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function panel_styles_templateObject3() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n          border-bottom: 0;\n        "
    ]);
    panel_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function panel_styles_templateObject4() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        ";\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    panel_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function panel_styles_templateObject5() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n          display: flex;\n        "
    ]);
    panel_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function panel_styles_templateObject6() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    panel_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function panel_styles_templateObject7() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n          width: 250px;\n          flex: none;\n          align-self: flex-start;\n        "
    ]);
    panel_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function panel_styles_templateObject8() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 ",
        ";\n\n  ",
        "\n"
    ]);
    panel_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function panel_styles_templateObject9() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 150px;\n  flex-direction: row;\n  display: flex;\n  align-items: center;\n"
    ]);
    panel_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function panel_styles_templateObject10() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n  margin: 0;\n  display: block;\n  font-size: 1rem;\n  color: ",
        ";\n  padding: 0.8em 0;\n"
    ]);
    panel_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function panel_styles_templateObject11() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n  margin-left: 5px;\n  color: $text-color-alt;\n"
    ]);
    panel_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function panel_styles_templateObject12() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n          visibility: hidden;\n        "
    ]);
    panel_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function panel_styles_templateObject13() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  display: flex;\n\n  & svg {\n    fill: ",
        ";\n  }\n\n  &:hover svg {\n    fill: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    panel_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function panel_styles_templateObject14() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n    & svg {\n      fill: ",
        ";\n    }\n  "
    ]);
    panel_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function panel_styles_templateObject15() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n    &:hover svg {\n      fill: ",
        ";\n    }\n  "
    ]);
    panel_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function panel_styles_templateObject16() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n    display: flex;\n  "
    ]);
    panel_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function panel_styles_templateObject17() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n  display: none;\n  cursor: pointer;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    panel_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function panel_styles_templateObject18() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n  flex: 1 1;\n"
    ]);
    panel_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}



var ClearFilterTooltip = (0,styled_components_browser_esm["default"])(tooltip/* Tooltip */.u).withConfig({
    displayName: "ClearFilterTooltip",
    componentId: "sc-0-0"
})(panel_styles_templateObject());
var ToggleColumnTooltip = (0,styled_components_browser_esm["default"])(tooltip/* Tooltip */.u).withConfig({
    displayName: "ToggleColumnTooltip",
    componentId: "sc-0-1"
})(panel_styles_templateObject1());
var PanelWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PanelWrapper",
    componentId: "sc-0-2"
})(panel_styles_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.lines.secondary;
}, function(param) {
    var horizontal = param.horizontal, theme = param.theme;
    return horizontal ? (0,styled_components_browser_esm.css)(panel_styles_templateObject2(), theme.lines.primary) : null;
}, function(param) {
    var hideLine = param.hideLine;
    return hideLine ? (0,styled_components_browser_esm.css)(panel_styles_templateObject3()) : null;
});
var PanelInner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PanelInner",
    componentId: "sc-0-3"
})(panel_styles_templateObject6(), function(param) {
    var horizontal = param.horizontal;
    return horizontal ? (0,styled_components_browser_esm.css)(panel_styles_templateObject5()) : null;
});
var PanelHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PanelHeader",
    componentId: "sc-0-4"
})(panel_styles_templateObject8(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075, function(param) {
    var horizontal = param.horizontal;
    return horizontal ? (0,styled_components_browser_esm.css)(panel_styles_templateObject7()) : null;
});
var PanelTitleWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PanelTitleWrapper",
    componentId: "sc-0-5"
})(panel_styles_templateObject9());
var PanelTitle = styled_components_browser_esm["default"].h6.withConfig({
    displayName: "PanelTitle",
    componentId: "sc-0-6"
})(panel_styles_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.text.secondary;
});
var PanelTitleUnit = styled_components_browser_esm["default"].span.withConfig({
    displayName: "PanelTitleUnit",
    componentId: "sc-0-7"
})(panel_styles_templateObject11());
var PanelIcon = styled_components_browser_esm["default"].button.withConfig({
    displayName: "PanelIcon",
    componentId: "sc-0-8"
})(panel_styles_templateObject13(), function(param) {
    var theme = param.theme;
    return theme.icons.callToAction;
}, function(param) {
    var theme = param.theme;
    return theme.icons.callToActionHover;
}, function(param) {
    var hidden = param.hidden;
    return hidden ? (0,styled_components_browser_esm.css)(panel_styles_templateObject12()) : null;
});
var PanelCompareIcon = styled_components_browser_esm["default"].button.withConfig({
    displayName: "PanelCompareIcon",
    componentId: "sc-0-9"
})(panel_styles_templateObject17(), function(param) {
    var selected = param.selected, theme = param.theme;
    return (0,styled_components_browser_esm.css)(panel_styles_templateObject14(), selected ? theme.icons.callToAction : theme.icons.quaternary);
}, function(param) {
    var selected = param.selected, theme = param.theme;
    return (0,styled_components_browser_esm.css)(panel_styles_templateObject15(), selected ? theme.icons.callToActionHover : theme.icons.callToAction);
}, base/* media.largeUp */.BC.largeUp(panel_styles_templateObject16()));
var PanelFilter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PanelFilter",
    componentId: "sc-0-10"
})(panel_styles_templateObject18(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/eye/index.js
var eye = __webpack_require__(31013);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/trash/index.js
var trash = __webpack_require__(41782);
;// CONCATENATED MODULE: ./src/areas/category/components/filter/components/panel/index.tsx
function panel_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function panel_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function panel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function panel_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function panel_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function panel_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            panel_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function panel_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function panel_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        panel_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function panel_slicedToArray(arr, i) {
    return panel_arrayWithHoles(arr) || panel_iterableToArrayLimit(arr, i) || panel_unsupportedIterableToArray(arr, i) || panel_nonIterableRest();
}
function panel_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return panel_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return panel_arrayLikeToArray(o, minLen);
}














function getListItemLimit(param) {
    var type = param.type;
    switch(type){
        case "list-tree-and":
        case "list-tree-or":
            {
                return 4;
            }
        case "list-or":
        case "list-and":
        case "list-or-reduced":
        case "list-and-reduced":
            {
                return 5;
            }
        default:
            {
                return undefined;
            }
    }
}
var FilterPanel = function(props) {
    var handleToggleValues = function handleToggleValues(id) {
        setShowAllValues(function(prevState) {
            return panel_objectSpreadProps(panel_objectSpread({}, prevState), panel_defineProperty({}, id, !prevState[id]));
        });
    };
    var ref = panel_slicedToArray(react.useState({}), 2), showAllValues = ref[0], setShowAllValues = ref[1];
    var categoryId = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.category.filter.categoryId;
    });
    var comparing = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.category.filter.comparing;
    });
    var query = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.category.filter.query;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var filteredValues = props.filteredValues, isBrandFilteredCategory = props.isBrandFilteredCategory, hideName = props.hideName, _canCompare = props.canCompare, canCompare = _canCompare === void 0 ? true : _canCompare, _layout = props.layout, layout = _layout === void 0 ? "vertical" : _layout, displayFilter = props.displayFilter;
    var id = displayFilter.id, name = displayFilter.name, children = displayFilter.children, unit = displayFilter.unit;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var values = filteredValues[id] && filteredValues[id].values;
    // Do not render filters with no values
    if (values && values.length === 0) {
        return null;
    }
    // Never render the Brand-filter if we're in a Brand Filtered Category
    if (isBrandFilteredCategory && id === "brands") {
        return null;
    }
    var limitValues = getListItemLimit(displayFilter);
    var horizontal = layout === "horizontal";
    return /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: function() {
            return null;
        }
    }, /*#__PURE__*/ react.createElement(PanelWrapper, {
        hideLine: hideName || !!children,
        horizontal: horizontal,
        role: "group",
        "aria-labelledby": "filter-panel-title-".concat(id),
        "data-test": "FilterPanel",
        "data-test-title": id
    }, /*#__PURE__*/ react.createElement(PanelInner, {
        horizontal: horizontal
    }, !hideName && /*#__PURE__*/ react.createElement(PanelHeader, {
        horizontal: horizontal
    }, /*#__PURE__*/ react.createElement(PanelTitleWrapper, {
        id: "filter-panel-title-".concat(id)
    }, /*#__PURE__*/ react.createElement(PanelTitle, null, name), unit && unit.length > 0 && /*#__PURE__*/ react.createElement(PanelTitleUnit, null, "(", unit, ")")), query[id] !== undefined && /*#__PURE__*/ react.createElement(ClearFilterTooltip, {
        placement: ui/* Direction.Left */.Nm.Left,
        title: t("filter", "button.clear-filter")
    }, /*#__PURE__*/ react.createElement(PanelIcon, {
        type: "button",
        "aria-label": t("filter", "button.clear-filter"),
        onClick: function() {
            var newQuery = panel_objectSpread({}, query);
            delete newQuery[id];
            dispatch((0,filter/* filterQuery */.DQ)(newQuery));
            dispatch((0,filter/* filterChangeAction */.Xi)(categoryId, newQuery));
        }
    }, /*#__PURE__*/ react.createElement(trash/* IconTrash */.I, {
        color: "maybeBlue700"
    }))), (0,is_numeric/* default */.Z)(id) && canCompare && /*#__PURE__*/ react.createElement(ToggleColumnTooltip, {
        placement: ui/* Direction.Left */.Nm.Left,
        title: t("filter", "properties.toggle-column")
    }, /*#__PURE__*/ react.createElement(PanelCompareIcon, {
        selected: comparing.includes(id),
        type: "button",
        "aria-label": t("filter", "properties.toggle-column"),
        "aria-pressed": comparing.includes(id),
        onClick: function() {
            dispatch((0,filter/* compareProperty */.pS)(id));
        }
    }, /*#__PURE__*/ react.createElement(eye.IconEye, {
        color: "maybeBlue700"
    }))), horizontal && /*#__PURE__*/ react.createElement(PanelIcon, {
        hidden: !values || !limitValues || limitValues >= values.length,
        type: "button",
        "aria-label": showAllValues[id] ? t("filter", "properties.quantity-show-less") : t("filter", "properties.quantity-show-more"),
        onClick: function() {
            handleToggleValues(id);
        },
        "data-test": "MoreFiltersToggleButton"
    }, /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        placement: ui/* Direction.Up */.Nm.Up,
        title: showAllValues[id] ? t("filter", "properties.quantity-show-less") : t("filter", "properties.quantity-show-more")
    }, showAllValues[id] ? /*#__PURE__*/ react.createElement(chevron_up.IconChevronUp, {
        color: "maybeBlue700"
    }) : /*#__PURE__*/ react.createElement(chevron_down/* IconChevronDown */.C, {
        color: "maybeBlue700"
    })))), /*#__PURE__*/ react.createElement(PanelFilter, null, /*#__PURE__*/ react.createElement(Filter, {
        layout: layout,
        displayFilter: displayFilter,
        query: query,
        categoryId: categoryId,
        limitValues: limitValues,
        showAllValues: Boolean(showAllValues[id]),
        onToggleAllValues: function(panelId) {
            handleToggleValues(panelId);
        },
        filteredValues: filteredValues
    }))), children && children.map(function(filter) {
        if (filter.type === "boolean" || filter.type === "string" || filter.children || filteredValues[filter.id] && filteredValues[filter.id].values) {
            return /*#__PURE__*/ react.createElement(FilterPanel, {
                key: filter.id,
                layout: layout,
                displayFilter: filter,
                filteredValues: filteredValues
            });
        }
        return null;
    })));
};
/* harmony default export */ const panel = (FilterPanel);


/***/ }),

/***/ 44975:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ selected_filters)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(15309);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/tag/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    min-height: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n      padding-right: ",
        ";\n      &:active {\n        background: ",
        ";\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  background: ",
        ";\n  border: 1px solid transparent;\n  border-radius: 5px;\n  padding: ",
        ";\n  word-break: break-word;\n  hyphens: auto;\n  min-height: 35px;\n\n  ",
        "\n\n  &:active {\n    background: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  margin-right: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      padding-right: ",
        ";\n      &:active {\n        background: ",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-weight: 600;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-left: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var spacing = "4px";
var StyledTag = styled_components_browser_esm["default"].button.withConfig({
    displayName: "StyledTag",
    componentId: "sc-0-0"
})(_templateObject2(), function(p) {
    return p.theme.colors.maybeBlue700;
}, spacing, base/* media.largeUp */.BC.largeUp(_templateObject()), function(p) {
    return p.theme.colors.maybeBlue700;
}, function(p) {
    return p.clear && (0,styled_components_browser_esm.css)(_templateObject1(), p.theme.colors.base600, spacing, p.theme.colors.base700);
});
var TagGroup = styled_components_browser_esm["default"].span.withConfig({
    displayName: "TagGroup",
    componentId: "sc-0-1"
})(_templateObject3(), function(p) {
    return p.theme.colors.base0;
}, spacing);
var TagValue = styled_components_browser_esm["default"].span.withConfig({
    displayName: "TagValue",
    componentId: "sc-0-2"
})(_templateObject5(), function(p) {
    return p.theme.colors.base0;
}, function(p) {
    return p.clear && (0,styled_components_browser_esm.css)(_templateObject4(), spacing, p.theme.colors.base700);
});
var TagClose = styled_components_browser_esm["default"].span.withConfig({
    displayName: "TagClose",
    componentId: "sc-0-3"
})(_templateObject6(), spacing);

;// CONCATENATED MODULE: ./src/components/tag/index.tsx



var CLEAR = "clear";
var DEFAULT = "default";
var Tag = function(param) {
    var value = param.value, groupName = param.groupName, _type = param.type, type = _type === void 0 ? DEFAULT : _type, _onClick = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    onClick, onClick = _onClick === void 0 ? function() {} : _onClick;
    var isClear = type === CLEAR;
    return /*#__PURE__*/ react.createElement(StyledTag, {
        type: "button",
        onClick: onClick,
        clear: isClear
    }, groupName && type !== CLEAR && /*#__PURE__*/ react.createElement(TagGroup, null, groupName, ":"), /*#__PURE__*/ react.createElement(TagValue, {
        clear: isClear
    }, value), type !== CLEAR && /*#__PURE__*/ react.createElement(TagClose, null, /*#__PURE__*/ react.createElement(icon_close.IconClose, {
        size: 16,
        color: "base0"
    })));
};

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/areas/category/actions/filter.js
var actions_filter = __webpack_require__(67536);
;// CONCATENATED MODULE: ./src/areas/category/components/filter/components/selected-filters/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 0 10px;\n  margin-bottom: ",
        ";\n\n  & > button {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var SelectedFiltersWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SelectedFiltersWrapper",
    componentId: "sc-0-0"
})(styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/areas/category/components/filter/components/selected-filters/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};






function isDoubleSlider(filter) {
    return !!filter.value && filter.filterType === "slider" && (filter.value.from !== null || filter.value.to !== null) && (typeof filter.value.from === "object" || typeof filter.value.to === "object");
}
var SelectedFilters = function(props) {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var className = props.className, categoryId = props.categoryId;
    var query = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.category.filter.query;
    });
    var selected = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.category.filter.selected;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var filters = react.useMemo(function() {
        var onChange = function onChange(key, filter) {
            var action;
            switch(filter.filterType){
                case "list":
                    action = _objectSpreadProps(_objectSpread({}, filter), {
                        checked: false
                    });
                    break;
                default:
                    {
                        var remove = query[key], filtersToKeep = _objectWithoutProperties(query, [
                            key
                        ].map(_toPropertyKey));
                        action = filtersToKeep;
                    }
            }
            dispatch((0,actions_filter/* filterChangeAction */.Xi)(categoryId, action));
        };
        var renderTag = function renderTag(key, filter) {
            var value = null;
            switch(filter.filterType){
                case "slider":
                    {
                        if (isDoubleSlider(filter)) {
                            var _value = filter.value, from = _value.from, to = _value.to;
                            var fromRange = from ? "".concat(from.from, " - ").concat(from.to) : "";
                            var toRange = to ? "".concat(to.from, " - ").concat(to.to) : "";
                            var separator = fromRange && toRange ? "/" : "";
                            value = "".concat(fromRange, " ").concat(separator, " ").concat(toRange);
                        } else {
                            value = filter.value ? "".concat(filter.value.from, " - ").concat(filter.value.to) : null;
                        }
                        break;
                    }
                case "boolean":
                    value = filter.value ? t("filter", "properties.select-true") : t("filter", "properties.select-false");
                    break;
                case "list":
                    value = filter.name;
                    break;
                case "string":
                    value = filter.value;
                    break;
                default:
            }
            return value ? /*#__PURE__*/ react.createElement(Tag, {
                groupName: filter.section && filter.section.name,
                value: value,
                onClick: function() {
                    return onChange(key, filter);
                }
            }) : null;
        };
        return Object.keys(selected).filter(function(key) {
            return selected[key];
        }).map(function(key) {
            return renderTag(key, selected[key]);
        });
    }, [
        selected,
        categoryId,
        dispatch,
        query,
        t
    ]);
    return /*#__PURE__*/ react.createElement(SelectedFiltersWrapper, {
        className: className
    }, filters, filters.length > 1 && /*#__PURE__*/ react.createElement(Tag, {
        type: "clear",
        value: t("filter", "button.clear-filter"),
        onClick: function() {
            return dispatch((0,actions_filter/* filterChangeAction */.Xi)(props.categoryId, {}));
        }
    }));
};
/* harmony default export */ const selected_filters = (SelectedFilters);


/***/ }),

/***/ 74256:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95939);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25349);
/* harmony import */ var src_components_scroll__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40763);
/* harmony import */ var src_components_list_item__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91441);
/* harmony import */ var _prisjakt_ui_panel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63073);
/* harmony import */ var _components_panel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26214);
/* harmony import */ var src_components_filter_overlay_components_apply_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57737);
/* harmony import */ var _components_selected_filters__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44975);
/* harmony import */ var _actions_filter__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67536);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50486);
/* harmony import */ var _prisjakt_ui_icon_chevron_down__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70796);
/* harmony import */ var _prisjakt_ui_icon_chevron_up__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(912);
/* harmony import */ var _prisjakt_ui_icon_close__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15309);














var Filter = function(props) {
    var _canCompare = props.canCompare, canCompare = _canCompare === void 0 ? true : _canCompare;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        return function() {
            dispatch((0,_actions_filter__WEBPACK_IMPORTED_MODULE_9__/* .toggleMobile */ .fs)(false));
            dispatch((0,_actions_filter__WEBPACK_IMPORTED_MODULE_9__/* .propertySearch */ .MW)(""));
        };
    }, [
        dispatch
    ]);
    var closeMobileFilter = function() {
        window.scroll(0, 0);
        dispatch((0,_actions_filter__WEBPACK_IMPORTED_MODULE_9__/* .toggleMobile */ .fs)(false));
    };
    var filter = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.areas.category.filter;
    });
    var expandedCategories = filter.expandedCategories, mobileOpen = filter.mobileOpen;
    var hasFiltered = Object.keys(filter.query).length > 0;
    var t = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .useAppContext */ .bp)().t;
    var search = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.areas.category.search;
    });
    var inputValue = search.inputValue, filteredCore = search.filteredCore, filteredSections = search.filteredSections, filteredValues = search.filteredValues, disabledExpansions = search.disabledExpansions;
    var isBrandedCategory = Boolean(props.brand);
    var isSearching = inputValue.length > 1;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_10__/* .FilterWrapper */ .kI, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_scroll__WEBPACK_IMPORTED_MODULE_3__/* .ScrollElement */ .xL, {
        name: "Filter"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_10__/* .HeaderWrapper */ .Pz, {
        mobileOpen: mobileOpen
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_10__/* .Header */ .h4, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_panel__WEBPACK_IMPORTED_MODULE_5__/* .PanelHeader */ .V9, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_panel__WEBPACK_IMPORTED_MODULE_5__/* .PanelTitle */ .pY, null, t("filter", "filter.title")))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_selected_filters__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        categoryId: props.categoryId
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_10__/* .CloseButton */ .PZ, {
        type: "button",
        onClick: closeMobileFilter,
        mobileOpen: mobileOpen
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_close__WEBPACK_IMPORTED_MODULE_13__.IconClose, null))), props.quickFilters.length > 0 && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, props.quickFilters.map(function(c) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_list_item__WEBPACK_IMPORTED_MODULE_4__/* .ListItem */ .H, {
            key: c.name,
            name: c.name,
            link: c.pathName,
            showArrow: true
        });
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_10__/* .Input */ .II, {
        placeholder: t("filter", "properties.search-placeholder"),
        value: inputValue,
        onChange: function(event) {
            dispatch((0,_actions_filter__WEBPACK_IMPORTED_MODULE_9__/* .propertySearch */ .MW)(event.target.value));
        }
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_10__/* .Filter */ .wn, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, filteredCore.map(function(coreFilter) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_panel__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            key: coreFilter.id,
            canCompare: canCompare,
            isBrandFilteredCategory: isBrandedCategory,
            displayFilter: coreFilter,
            filteredValues: filteredValues
        });
    })), filteredSections.map(function(section) {
        var ref;
        var showSection = isSearching ? disabledExpansions.indexOf(section.name) < 0 // Defaults to expanded
         : expandedCategories.indexOf(section.name) >= 0; // Defaults to collapsed
        // Remove empty sections
        if (((ref = section.children) === null || ref === void 0 ? void 0 : ref.filter(function(subFilter) {
            return subFilter.item_type === "category" && subFilter.children || filteredValues && filteredValues[subFilter.id] && filteredValues[subFilter.id].max_matching_products;
        }).length) === 0) {
            return null;
        }
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            key: section.name
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_10__/* .ButtonWrapper */ .W4, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_10__/* .ExpansionButton */ .KH, {
            type: "button",
            onClick: function() {
                return isSearching ? dispatch((0,_actions_filter__WEBPACK_IMPORTED_MODULE_9__/* .propertySearchToggleExpansion */ .wz)(section.name)) : dispatch((0,_actions_filter__WEBPACK_IMPORTED_MODULE_9__/* .expandSection */ .s0)(section.name));
            }
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, section.name)), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_10__/* .ArrowButton */ .b4, {
            type: "button",
            onClick: function() {
                return isSearching ? dispatch((0,_actions_filter__WEBPACK_IMPORTED_MODULE_9__/* .propertySearchToggleExpansion */ .wz)(section.name)) : dispatch((0,_actions_filter__WEBPACK_IMPORTED_MODULE_9__/* .expandSection */ .s0)(section.name));
            }
        }, showSection ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_chevron_up__WEBPACK_IMPORTED_MODULE_12__.IconChevronUp, null) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_chevron_down__WEBPACK_IMPORTED_MODULE_11__/* .IconChevronDown */ .C, null))), showSection && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_panel__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            key: section.name,
            isBrandFilteredCategory: isBrandedCategory,
            displayFilter: section,
            filteredValues: filteredValues,
            hideName: true
        }));
    }))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_filter_overlay_components_apply_button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        count: props.productCount,
        hasFiltered: hasFiltered,
        onClick: closeMobileFilter
    }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Filter);


/***/ }),

/***/ 31736:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ horizontal_filter)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/list-item/index.tsx
var list_item = __webpack_require__(91441);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(63073);
// EXTERNAL MODULE: ./src/areas/category/components/filter/components/panel/index.tsx + 22 modules
var components_panel = __webpack_require__(26214);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(54262);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/fullscreen-exit/index.js
var fullscreen_exit = __webpack_require__(64459);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/filter.js
var filter = __webpack_require__(44291);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/arrow-left/index.js
var arrow_left = __webpack_require__(25640);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/arrow-right/index.js
var arrow_right = __webpack_require__(86401);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(95088);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(714);
;// CONCATENATED MODULE: ./src/areas/category/components/filter-toggle/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  align-self: stretch;\n  outline: none;\n  cursor: pointer;\n  padding: 0 8px;\n  min-height: 43px;\n  position: relative;\n  fill: ",
        ";\n  background-color: ",
        ";\n  svg {\n    margin-top: -1px;\n  }\n\n  :hover {\n    svg g,\n    svg path {\n      fill: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 1 auto;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var ARROW_ICON_MARGIN = "-3px";
var FilterToggleButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "FilterToggleButton",
    componentId: "sc-0-0"
})(_templateObject(), function(props) {
    return props.active ? props.theme.colors.base700 : props.theme.colors.base400;
}, function(props) {
    return props.active ? props.theme.colors.yellove500 : "transparent";
}, function(props) {
    return props.active ? props.theme.colors.base700 : props.theme.colors.positive500;
});
var ArrowIconLeft = (0,styled_components_browser_esm["default"])(arrow_left/* IconArrowLeft */.D).withConfig({
    displayName: "ArrowIconLeft",
    componentId: "sc-0-1"
})(_templateObject1(), ARROW_ICON_MARGIN);
var ArrowIconRight = (0,styled_components_browser_esm["default"])(arrow_right/* IconArrowRight */.E).withConfig({
    displayName: "ArrowIconRight",
    componentId: "sc-0-2"
})(_templateObject2(), ARROW_ICON_MARGIN);
var SidebarFilterButton = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).withConfig({
    displayName: "SidebarFilterButton",
    componentId: "sc-0-3"
})(_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Tooltip = (0,styled_components_browser_esm["default"])(tooltip/* Tooltip */.u).withConfig({
    displayName: "Tooltip",
    componentId: "sc-0-4"
})(_templateObject4());


;// CONCATENATED MODULE: ./src/areas/category/components/filter-toggle/index.tsx







var FilterToggle = function(param) {
    var expanded = param.expanded, toggleHorizontalFilter = param.toggleHorizontalFilter;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var dispatch = (0,es/* useDispatch */.I0)();
    var label = expanded ? t("filter", "button.toggle-filter") : t("filter", "button.toggle-filter-expand");
    return /*#__PURE__*/ react.createElement(Tooltip, {
        placement: ui/* Direction.Right */.Nm.Right,
        title: label
    }, /*#__PURE__*/ react.createElement(SidebarFilterButton, {
        onClick: function() {
            toggleHorizontalFilter();
            dispatch((0,filter/* toggleFilter */.c)());
        },
        icon: /*#__PURE__*/ react.createElement(fullscreen_exit/* IconFullscreenExit */.Q, {
            size: 30
        }),
        variant: "icon",
        title: label,
        scaleIcon: false,
        size: "large"
    }));
};

// EXTERNAL MODULE: ./src/areas/category/components/filter/styles.ts
var styles = __webpack_require__(50486);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(7336);
;// CONCATENATED MODULE: ./src/areas/category/components/filter/horizontal-filter.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}









var HorizontalFilter = function(props) {
    var ref = _slicedToArray(react.useState(false), 2), showAll = ref[0], setShowAll = ref[1];
    var filter = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.category.filter;
    });
    var expandedCategories = filter.expandedCategories;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var search = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.category.search;
    });
    var inputValue = search.inputValue, filteredCore = search.filteredCore, filteredSections = search.filteredSections, filteredValues = search.filteredValues, disabledExpansions = search.disabledExpansions;
    var isBrandedCategory = Boolean(props.brand);
    var isSearching = inputValue.length > 1;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(styles/* Header */.h4, null, /*#__PURE__*/ react.createElement(panel/* PanelHeader */.V9, null, /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, t("filter", "filter.title")), /*#__PURE__*/ react.createElement(FilterToggle, {
        toggleHorizontalFilter: props.toggleFilter,
        expanded: props.expanded
    }))), props.quickFilters.length > 0 && /*#__PURE__*/ react.createElement("div", null, props.quickFilters.map(function(c) {
        return /*#__PURE__*/ react.createElement(list_item/* ListItem */.H, {
            key: c.name,
            name: c.name,
            link: c.pathName,
            showArrow: true
        });
    })), /*#__PURE__*/ react.createElement(styles/* Filter */.wn, {
        horizontal: true
    }, /*#__PURE__*/ react.createElement("div", null, filteredCore.map(function(coreFilter) {
        return /*#__PURE__*/ react.createElement(components_panel/* default */.Z, {
            key: coreFilter.id,
            layout: "horizontal",
            canCompare: props.canCompare,
            // compareLimit={8}
            isBrandFilteredCategory: isBrandedCategory,
            displayFilter: coreFilter,
            filteredValues: filteredValues
        });
    })), /*#__PURE__*/ react.createElement(styles/* MoreFilters */.AM, null, /*#__PURE__*/ react.createElement(variants.TextButton, {
        onClick: function() {
            return setShowAll(function(prevState) {
                return !prevState;
            });
        }
    }, t("filter", !showAll ? "properties.quantity-show-more" : "properties.quantity-show-less"))), /*#__PURE__*/ react.createElement("div", null, filteredSections.map(function(section) {
        var ref;
        var showSection = showAll || isSearching ? disabledExpansions.indexOf(section.name) < 0 // Defaults to expanded
         : expandedCategories.indexOf(section.name) >= 0; // Defaults to collapsed
        // Remove empty sections
        if (((ref = section.children) === null || ref === void 0 ? void 0 : ref.filter(function(subFilter) {
            return subFilter.item_type === "category" && subFilter.children || filteredValues && filteredValues[subFilter.id] && filteredValues[subFilter.id].max_matching_products;
        }).length) === 0) {
            return null;
        }
        if (!showSection) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(components_panel/* default */.Z, {
            key: section.name,
            layout: "horizontal",
            // compareLimit={8}
            // name={section.name}
            isBrandFilteredCategory: isBrandedCategory,
            displayFilter: section,
            filteredValues: filteredValues,
            hideName: true
        });
    }))));
};
/* harmony default export */ const horizontal_filter = (HorizontalFilter);


/***/ }),

/***/ 6116:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": () => (/* binding */ HorizontalFilter),
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var LoadableFilter = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "category";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | category */ 34).then(__webpack_require__.bind(__webpack_require__, 74256));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(74256);
        }
        return eval("require.resolve")("./filter");
    }
});
var HorizontalFilter = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "category";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | category */ 34).then(__webpack_require__.bind(__webpack_require__, 31736));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(31736);
        }
        return eval("require.resolve")("./horizontal-filter");
    }
});
var Loader = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: props.className
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LoadableFilter, _extends({}, props)));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Loader);


/***/ }),

/***/ 50486:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AM": () => (/* binding */ MoreFilters),
/* harmony export */   "II": () => (/* binding */ Input),
/* harmony export */   "KH": () => (/* binding */ ExpansionButton),
/* harmony export */   "PZ": () => (/* binding */ CloseButton),
/* harmony export */   "Pz": () => (/* binding */ HeaderWrapper),
/* harmony export */   "W4": () => (/* binding */ ButtonWrapper),
/* harmony export */   "b4": () => (/* binding */ ArrowButton),
/* harmony export */   "h4": () => (/* binding */ Header),
/* harmony export */   "kI": () => (/* binding */ FilterWrapper),
/* harmony export */   "wn": () => (/* binding */ Filter)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var src_components_filter_overlay_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55586);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    padding-bottom: 0;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        '\n  /* Makes sure no content is hidden behind the "apply filter" area */\n  padding-bottom: ',
        "px;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n      border-left: none;\n      border-right: none;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    border-left: none;\n    border-right: none;\n    margin-bottom: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  border-top: 1px solid ",
        ";\n  border-left: 1px solid ",
        ";\n  border-right: 1px solid ",
        ";\n  margin-bottom: ",
        ";\n\n  ",
        "\n\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      justify-content: space-between;\n      align-items: center;\n      margin: 10px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  .pj-ui-panel-header--header {\n    justify-content: normal;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  font-size: ",
        ";\n  font-weight: 600;\n  text-align: left;\n  color: ",
        ";\n  margin-left: 10px;\n  height: 35px;\n  flex: 1;\n  justify-content: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  margin-right: 10px;\n  height: 35px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n        display: block;\n        position: fixed;\n        top: 5px;\n        right: 5px;\n        padding: 10px 12px;\n        background: ",
        ";\n        border-radius: 50%;\n        z-index: 100;\n        box-shadow: 0 2px 10px -4px rgba(0,0,0,.5);\n      "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  margin-bottom: 0.5rem;\n  cursor: pointer;\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: 16px;\n  "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n    margin-top: 5px;\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  font-style: italic;\n  margin-bottom: 10px;\n  border: 1px solid ",
        ";\n  padding: 5px;\n  outline: 0;\n\n  ",
        ";\n\n  ",
        ";\n\n  &:focus {\n    border-color: ",
        ";\n    box-shadow: inset 0 0 0 1px ",
        ";\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}



var FilterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "FilterWrapper",
    componentId: "sc-0-0"
})(_templateObject1(), src_components_filter_overlay_constants__WEBPACK_IMPORTED_MODULE_2__/* .applyFilterAreaHeight */ .e, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.largeUp */ .BC.largeUp(_templateObject()));
var Filter = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Filter",
    componentId: "sc-0-1"
})(_templateObject4(), function(p) {
    return p.theme.lines.secondary;
}, function(p) {
    return p.theme.lines.secondary;
}, function(p) {
    return p.theme.lines.secondary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.margins.component.desktop.rem */ .bK.margins.component.desktop.rem, function(props) {
    return props.horizontal && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject2(), props.theme.colors.base100);
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.margins.component.mobile.rem */ .bK.margins.component.mobile.rem));
var HeaderWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "HeaderWrapper",
    componentId: "sc-0-2"
})(_templateObject6(), function(props) {
    return props.mobileOpen && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject5());
});
var Header = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-3"
})(_templateObject7());
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ButtonWrapper",
    componentId: "sc-0-4"
})(_templateObject8(), function(p) {
    return p.theme.lines.secondary;
}, function(p) {
    return p.theme.colors.base100;
});
var ExpansionButton = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].button.withConfig({
    displayName: "ExpansionButton",
    componentId: "sc-0-5"
})(_templateObject9(), (0,src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .remCalc */ .vR)(14), function(p) {
    return p.theme.text.callToAction;
});
var ArrowButton = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].button.withConfig({
    displayName: "ArrowButton",
    componentId: "sc-0-6"
})(_templateObject10());
var CloseButton = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].button.attrs({
    "data-test": "FiltersCloseButton"
}).withConfig({
    displayName: "CloseButton",
    componentId: "sc-0-7"
})(_templateObject13(), function(props) {
    return props.mobileOpen && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject12(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject11(), function(p) {
        return p.theme.bg.primary;
    }));
});
var Input = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].input.withConfig({
    displayName: "Input",
    componentId: "sc-0-8"
})(_templateObject16(), function(p) {
    return p.theme.lines.secondary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject14()), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject15()), function(p) {
    return p.theme.colors.maybeBlue700;
}, function(p) {
    return p.theme.colors.maybeBlue700;
});
var MoreFilters = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "MoreFilters",
    componentId: "sc-0-9"
})(_templateObject17(), function(p) {
    return p.theme.colors.base0;
});


/***/ }),

/***/ 11341:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": () => (/* binding */ Badge)
/* harmony export */ });
/* unused harmony export Text */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71993);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25349);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71016);
/* harmony import */ var src_areas_expert_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46674);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Badge = function(props) {
    var type = props.type;
    var t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il).t;
    var text = (0,src_areas_expert_utils__WEBPACK_IMPORTED_MODULE_5__/* .getTranslationByContentType */ .r)(type, t);
    return text ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, text) : null;
};
var Text = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__.TitleMediumText).withConfig({
    displayName: "Text",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium, function(p) {
    return p.theme.colors.maybeBlue700;
});


/***/ }),

/***/ 69223:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": () => (/* binding */ TrackingSource),
  "Z": () => (/* binding */ list_of_content_cards)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/article-card/index.tsx + 1 modules
var article_card = __webpack_require__(55445);
// EXTERNAL MODULE: ./src/areas/expert/components/card-image/index.tsx
var card_image = __webpack_require__(59669);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/expert/toplists/components/product-images/index.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      &::after {\n        ",
        ";\n        pointer-events: none;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: column;\n  column-gap: ",
        ";\n  position: relative;\n  padding: 0 ",
        ";\n  align-items: center;\n  width: 100%;\n  height: ",
        ";\n\n  img {\n    max-height: 64px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var spacing100 = base/* layout.measurements.spacing100 */.bK.measurements.spacing100;
var Images = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Images",
    componentId: "sc-0-0"
})(_templateObject1(), spacing100, spacing100, function(p) {
    return p.height;
}, function(p) {
    return p.background && (0,styled_components_browser_esm.css)(_templateObject(), base/* styledUtils.overlay */.au.overlay());
});
var ProductImages = function(param) {
    var products = param.products, _selectedPosition = param.selectedPosition, selectedPosition = _selectedPosition === void 0 ? 1 : _selectedPosition, _height = param.height, height = _height === void 0 ? "auto" : _height, _background = param.background, background = _background === void 0 ? true : _background;
    // Select the two closest product images to the selected product
    var visible = 3;
    var productImages = products.filter(function(item) {
        if (selectedPosition === 1) return item.order <= visible;
        if (selectedPosition === products.length) return item.order > products.length - visible;
        return item.order === selectedPosition - 1 || item.order === selectedPosition || item.order === selectedPosition + 1;
    }).map(function(p) {
        var ref, ref1, ref2;
        return (p.image || ((ref = p.media) === null || ref === void 0 ? void 0 : ref.first)) && /*#__PURE__*/ react.createElement("img", {
            alt: p.name,
            key: p.image || ((ref1 = p.media) === null || ref1 === void 0 ? void 0 : ref1.first),
            src: p.image || ((ref2 = p.media) === null || ref2 === void 0 ? void 0 : ref2.first)
        });
    });
    return /*#__PURE__*/ react.createElement(Images, {
        background: background,
        height: height
    }, productImages);
};
/* harmony default export */ const product_images = (ProductImages);

// EXTERNAL MODULE: ./src/areas/expert/types.ts
var types = __webpack_require__(54712);
// EXTERNAL MODULE: ./src/areas/expert/components/badge/index.tsx
var badge = __webpack_require__(11341);
// EXTERNAL MODULE: ./src/areas/expert/components/expert-user-card/index.tsx + 1 modules
var expert_user_card = __webpack_require__(8454);
// EXTERNAL MODULE: ./src/components/advized/tracking.ts
var tracking = __webpack_require__(98864);
// EXTERNAL MODULE: ./src/areas/expert/components/rating/index.tsx
var rating = __webpack_require__(68169);
;// CONCATENATED MODULE: ./src/areas/expert/components/list-of-content-cards/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  left: ",
        ";\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Rating = (0,styled_components_browser_esm["default"])(rating/* default */.Z).withConfig({
    displayName: "Rating",
    componentId: "sc-0-0"
})(styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking_tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/areas/expert/components/list-of-content-cards/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}











var TrackingSource;
(function(TrackingSource) {
    TrackingSource["ADVIZED_WIDGET"] = "advizedWidget";
})(TrackingSource || (TrackingSource = {}));
var ContentCards = function(param) {
    var category = param.category, className = param.className, onClick = param.onClick, items = param.items, _imageSize = param.imageSize, imageSize = _imageSize === void 0 ? 130 : _imageSize, _limit = param.limit, limit = _limit === void 0 ? 0 : _limit, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset, hideExperts = param.hideExperts, trackingSource = param.trackingSource;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), market = ref.market, t = ref.t;
    var numberOfCards = limit ? limit + offset : items.length;
    var getDefaultExpert = function() {
        return {
            avatar: "".concat(market.cdn, "/g/rfe/logos/logo_v2_symbol.svg"),
            name: t("search", "editorial.defaultauthor"),
            url: undefined,
            hideExpertIcon: true
        };
    };
    var getPrismicExpert = function(param) {
        var avatar = param.avatar, author = param.author;
        return {
            avatar: (avatar === null || avatar === void 0 ? void 0 : avatar.url) || "".concat(market.cdn, "/g/rfe/logos/logo_v2_symbol.svg"),
            avatarAlt: (avatar === null || avatar === void 0 ? void 0 : avatar.alt) || "",
            name: author || "",
            url: undefined,
            hideExpertIcon: true
        };
    };
    var getNavigationScope = function(clickInfo) {
        switch(clickInfo.type){
            case types/* ContentTypes.ARTICLE */.b.ARTICLE:
                return tracking_tracking/* InternalNavigationScope.ARTICLE_PAGE_GO_TO */.U.ARTICLE_PAGE_GO_TO;
            case types/* ContentTypes.GUIDE */.b.GUIDE:
                return tracking_tracking/* InternalNavigationScope.GUIDE_PAGE_GO_TO */.U.GUIDE_PAGE_GO_TO;
            case types/* ContentTypes.TEST */.b.TEST:
                return tracking_tracking/* InternalNavigationScope.PRODUCT_TEST_PAGE_GO_TO */.U.PRODUCT_TEST_PAGE_GO_TO;
            case types/* ContentTypes.TOPLIST */.b.TOPLIST:
                return tracking_tracking/* InternalNavigationScope.TOPLIST_PAGE_GO_TO */.U.TOPLIST_PAGE_GO_TO;
            case types/* ContentTypes.TOPLIST_HEADLINE */.b.TOPLIST_HEADLINE:
                return tracking_tracking/* InternalNavigationScope.TOPLIST_PAGE_HEADLINE_GO_TO */.U.TOPLIST_PAGE_HEADLINE_GO_TO;
            default:
                return null;
        }
    };
    var onClickAndTracking = function(clickInfo) {
        onClick === null || onClick === void 0 ? void 0 : onClick(clickInfo);
        switch(trackingSource){
            case TrackingSource.ADVIZED_WIDGET:
                {
                    (0,tracking/* trackCategoryPageExpertCarouselCard */.t)(category === null || category === void 0 ? void 0 : category.url, clickInfo.type);
                    break;
                }
            default:
        }
        var scope = getNavigationScope(clickInfo);
        if (scope) {
            (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                scope: scope,
                nextPage: clickInfo.url,
                index: clickInfo.index
            });
        }
    };
    var getContentCard = function(item, index) {
        switch(item.__typename){
            case types/* ContentTypes.TOPLIST_HEADLINE */.b.TOPLIST_HEADLINE:
                {
                    var ref, ref1, ref2, ref3, ref4;
                    if (!item.toplists || !item.toplists[0]) {
                        return null;
                    }
                    var list = item.toplists[0];
                    var image = (ref = list.description) === null || ref === void 0 ? void 0 : ref.find(function(d) {
                        return d.type === "image";
                    });
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: list.date,
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.name,
                                type: types/* ContentTypes.TOPLIST_HEADLINE */.b.TOPLIST_HEADLINE,
                                url: item.url,
                                index: index
                            });
                        },
                        key: item.id,
                        likes: (ref1 = list.headlineInfo) === null || ref1 === void 0 ? void 0 : ref1.likes,
                        media: (image === null || image === void 0 ? void 0 : image.data) ? /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: image.data,
                            alt: list.title,
                            height: imageSize
                        }) : /*#__PURE__*/ react.createElement(product_images, {
                            height: "".concat(imageSize, "px"),
                            background: false,
                            selectedPosition: 2,
                            products: (ref2 = item.toplists[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.products) === null || ref3 === void 0 ? void 0 : ref3.map(function(p) {
                                return _objectSpread({}, p);
                            })
                        }),
                        titleAndCategory: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(badge/* Badge */.C, {
                            type: types/* ContentTypes.TOPLIST_HEADLINE */.b.TOPLIST_HEADLINE
                        }), ": ", item.name),
                        url: item.url,
                        footer: !hideExperts && list.expert.url ? /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            experts: [
                                list.expert
                            ].concat(_toConsumableArray((list === null || list === void 0 ? void 0 : (ref4 = list.headlineInfo) === null || ref4 === void 0 ? void 0 : ref4.otherExperts) || []))
                        }) : null
                    });
                }
            case types/* ContentTypes.TOPLIST */.b.TOPLIST:
                {
                    var ref5, ref6, ref7, ref8, ref9, ref10;
                    var ref11;
                    var imageUrl = (ref11 = (ref5 = item.image) === null || ref5 === void 0 ? void 0 : ref5.src) !== null && ref11 !== void 0 ? ref11 : (ref7 = (ref6 = item.description) === null || ref6 === void 0 ? void 0 : ref6.find(function(d) {
                        return d.type === "image";
                    })) === null || ref7 === void 0 ? void 0 : ref7.data;
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: item.date,
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.TOPLIST */.b.TOPLIST,
                                url: item.headlineInfo.url,
                                index: index
                            });
                        },
                        key: item.id,
                        likes: (ref8 = item.headlineInfo) === null || ref8 === void 0 ? void 0 : ref8.likes,
                        media: imageUrl ? /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: imageUrl,
                            alt: item.title,
                            height: imageSize
                        }) : /*#__PURE__*/ react.createElement(product_images, {
                            height: "".concat(imageSize, "px"),
                            products: item.products.map(function(p) {
                                return _objectSpread({}, p);
                            }),
                            background: false
                        }),
                        titleAndCategory: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(badge/* Badge */.C, {
                            type: types/* ContentTypes.TOPLIST */.b.TOPLIST
                        }), ": ", item.title),
                        url: item.headlineInfo.url,
                        footer: !hideExperts && ((ref9 = item.expert) === null || ref9 === void 0 ? void 0 : ref9.url) ? /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            experts: [
                                item.expert
                            ].concat(_toConsumableArray(((ref10 = item.headlineInfo) === null || ref10 === void 0 ? void 0 : ref10.otherExperts) || []))
                        }) : null
                    });
                }
            case types/* ContentTypes.TEST */.b.TEST:
                {
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: item.date,
                        grade: item.gradeNotConverted !== undefined && /*#__PURE__*/ react.createElement(Rating, {
                            grade: item.gradeNotConverted
                        }),
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.TEST */.b.TEST,
                                url: item.url,
                                index: index
                            });
                        },
                        key: item.id,
                        likes: item.likes,
                        media: item.imageWithSize && /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: item.imageWithSize.src,
                            alt: item.imageWithSize.alt,
                            height: imageSize
                        }),
                        titleAndCategory: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(badge/* Badge */.C, {
                            type: types/* ContentTypes.TEST */.b.TEST
                        }), ": ", item.title),
                        url: item.url,
                        footer: !hideExperts ? /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            experts: [
                                item.expert
                            ]
                        }) : null
                    });
                }
            case types/* ContentTypes.GUIDE */.b.GUIDE:
                {
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: item.date,
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.GUIDE */.b.GUIDE,
                                url: item.url,
                                index: index
                            });
                        },
                        key: item.id,
                        likes: item.likes,
                        media: item.image && /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: item.image.src,
                            alt: item.image.alt,
                            height: imageSize
                        }),
                        titleAndCategory: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(badge/* Badge */.C, {
                            type: types/* ContentTypes.GUIDE */.b.GUIDE
                        }), ": ", item.title),
                        url: item.url,
                        footer: !hideExperts ? /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            experts: [
                                item.expert
                            ]
                        }) : null
                    });
                }
            case types/* ContentTypes.ARTICLE */.b.ARTICLE:
                {
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: item.date,
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.ARTICLE */.b.ARTICLE,
                                url: item.link,
                                index: index
                            });
                        },
                        key: item.id,
                        media: item.image && /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: item.image.src,
                            alt: item.image.alt,
                            height: imageSize
                        }),
                        titleAndCategory: item.title,
                        url: item.link,
                        footer: /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            pointer: true,
                            experts: [
                                getDefaultExpert()
                            ]
                        }),
                        footerPartOfLink: true
                    });
                }
            case types/* ContentTypes.VIDEO */.b.VIDEO:
                {
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.VIDEO */.b.VIDEO,
                                url: item.youtubeId,
                                index: index
                            });
                        },
                        key: item.id,
                        media: item.previewImage && /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: item.previewImage,
                            alt: "",
                            height: 130
                        }),
                        videoMetadata: {
                            title: item.title,
                            thumbnail: item.previewImage,
                            videoId: item.youtubeId
                        },
                        titleAndCategory: item.title,
                        footer: /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            pointer: true,
                            experts: [
                                getPrismicExpert(item)
                            ]
                        }),
                        footerPartOfLink: true
                    });
                }
            default:
                return null;
        }
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, items.map(function(item, index) {
        if (!item || !item.id || !item.__typename) {
            return null;
        }
        if (index < offset || index >= numberOfCards) {
            return null;
        }
        return getContentCard(item, index);
    }));
};
/* harmony default export */ const list_of_content_cards = (ContentCards);


/***/ }),

/***/ 68169:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_rating_rating_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51362);
/* harmony import */ var src_components_rating__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34990);
/* harmony import */ var _prisjakt_ui_icon_star__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20403);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37009);
/* harmony import */ var _prisjakt_ui_badge__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29242);






var ExpertRating = function(param) {
    var className = param.className, grade = param.grade, text = param.text, _as = param.as, as = _as === void 0 ? "badge" : _as;
    var rating = src_components_rating_rating_helper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].toRoundedString */ .Z.toRoundedString(grade);
    if (as === "stars") {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_4__/* .Stars */ .tS, {
            className: className
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_rating__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            rate: grade,
            expertColors: true,
            size: "large"
        }), " ", /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_4__/* .RatingText */ .mN, null, rating));
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_4__/* .ExpertRating */ .Um, {
        className: className
    }, text && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, null, text, ": "), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_badge__WEBPACK_IMPORTED_MODULE_5__.Badge, {
        color: "BLUE_INVERTED",
        icon: _prisjakt_ui_icon_star__WEBPACK_IMPORTED_MODULE_3__/* .IconStar */ .G,
        text: rating
    }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ExpertRating);


/***/ }),

/***/ 37009:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ct": () => (/* binding */ Badge),
/* harmony export */   "Um": () => (/* binding */ ExpertRating),
/* harmony export */   "mN": () => (/* binding */ RatingText),
/* harmony export */   "tS": () => (/* binding */ Stars),
/* harmony export */   "xv": () => (/* binding */ Text)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  font-weight: 600;\n  font-size: ",
        ";\n  line-height: 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: ",
        " ",
        ";\n  background: ",
        ";\n  border-radius: 20px;\n  justify-self: start;\n  font-weight: 600;\n  color: ",
        ";\n  line-height: 1;\n\n  svg {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 700;\n  font-size: ",
        ";\n  margin-left: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var _measurements = src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements */ .bK.measurements, spacing025 = _measurements.spacing025, spacing050 = _measurements.spacing050;
var ExpertRating = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ExpertRating",
    componentId: "sc-0-0"
})(_templateObject());
var Text = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "Text",
    componentId: "sc-0-1"
})(_templateObject1(), spacing025, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium);
var Badge = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Badge",
    componentId: "sc-0-2"
})(_templateObject2(), spacing025, spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .colorUtils.setRgbaAlpha */ .$n.setRgbaAlpha(src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .brandColors.expert */ .D2.expert, 1), function(p) {
    return p.theme.colors.base0;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var Stars = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Stars",
    componentId: "sc-0-3"
})(_templateObject3());
var RatingText = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "RatingText",
    componentId: "sc-0-4"
})(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);


/***/ }),

/***/ 96674:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": () => (/* binding */ Title),
/* harmony export */   "Gh": () => (/* binding */ FilterContainer),
/* harmony export */   "QE": () => (/* binding */ Subtitle),
/* harmony export */   "VY": () => (/* binding */ Content),
/* harmony export */   "YE": () => (/* binding */ Sidebar),
/* harmony export */   "ck": () => (/* binding */ Item),
/* harmony export */   "d2": () => (/* binding */ Article),
/* harmony export */   "h4": () => (/* binding */ Header),
/* harmony export */   "im": () => (/* binding */ Wrapper),
/* harmony export */   "iz": () => (/* binding */ Divider),
/* harmony export */   "jQ": () => (/* binding */ MediaImage),
/* harmony export */   "ll": () => (/* binding */ CardTitle),
/* harmony export */   "or": () => (/* binding */ Main),
/* harmony export */   "pU": () => (/* binding */ Media),
/* harmony export */   "zB": () => (/* binding */ MediaWrapper)
/* harmony export */ });
/* unused harmony exports AVATAR_SIZE, Info, ContentType */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71016);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  a {\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    grid-template-columns: minmax(0, 1fr);\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        ";\n  padding-top: 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  &&,\n  > * {\n    font-size: ",
        ";\n    font-weight: 700;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n          display: none;\n        "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 0;\n\n      ",
        "\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n          display: none;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n      padding-right: ",
        ";\n\n      ",
        "\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    padding: 0 ",
        ";\n    flex-shrink: 0;\n\n    ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n    padding-bottom: ",
        ";\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  grid-auto-flow: row;\n  padding: ",
        " 0;\n  row-gap: ",
        ";\n  height: max-content;\n\n  h1 {\n    margin: 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n      order: ",
        ";\n\n      &:not(:first-of-type) {\n        margin-top: ",
        ";\n      }\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n    display: grid;\n    grid-auto-flow: row;\n    row-gap: ",
        ";\n    order: 2;\n    margin-top: ",
        ";\n\n    a:not([class]) {\n      color: ",
        ";\n\n      &:hover {\n        color: ",
        ";\n        text-decoration: underline;\n      }\n    }\n\n    ",
        ";\n\n    > h2,\n    > h3,\n    > *:last-child {\n      margin-bottom: 0;\n    }\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: column;\n  align-items: center;\n  justify-content: start;\n  column-gap: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n      max-width: ",
        "px;\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n      border-radius: 8px;\n  "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 16px;\n\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  width: 100%;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n    margin: ",
        " 0;\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  border: none;\n  border-bottom: 1px solid ",
        ";\n  margin: ",
        " 0;\n\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  overflow-x: auto;\n  padding: 2px;\n\n  > button {\n    flex-shrink: 0;\n    margin-bottom: ",
        ";\n\n    :not(:last-child) {\n      margin-right: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}



var AVATAR_SIZE = 32;
var CardTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__.TitleMediumText).withConfig({
    displayName: "CardTitle",
    componentId: "sc-0-0"
})(_templateObject());
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-1"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject1()));
var Main = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].main.withConfig({
    displayName: "Main",
    componentId: "sc-0-2"
})(_templateObject3());
var Article = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].article.withConfig({
    displayName: "Article",
    componentId: "sc-0-3"
})(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var Item = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Item",
    componentId: "sc-0-4"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__.TitleMediumText).withConfig({
    displayName: "Title",
    componentId: "sc-0-5"
})(_templateObject6(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium);
var Sidebar = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].aside.withConfig({
    displayName: "Sidebar",
    componentId: "sc-0-6"
})(function(p) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject11(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject8(), p.viewport === "desktop" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7())), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.largeUp */ .BC.largeUp(_templateObject10(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, p.viewport === "mobile" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject9())));
});
var Header = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].header.withConfig({
    displayName: "Header",
    componentId: "sc-0-7"
})(_templateObject13(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject12(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050));
var _marginTop;
var Content = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-8"
})(function(p) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject15(), p.fontSize || src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium, p.rowGap || src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, (_marginTop = p.marginTop) !== null && _marginTop !== void 0 ? _marginTop : src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, p.theme.text.callToAction, p.theme.text.callToActionHover, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject14(), p.order || 2, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200));
});
var Info = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "Info",
    componentId: "sc-0-9"
})(_templateObject16(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var Subtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__.TitleMediumText).withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-10"
})(_templateObject17());
var MediaWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "MediaWrapper",
    componentId: "sc-0-11"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject19(), props.maxWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject18(), props.maxWidth));
});
var Media = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Media",
    componentId: "sc-0-12"
})(_templateObject20());
var MediaImage = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].img.withConfig({
    displayName: "MediaImage",
    componentId: "sc-0-13"
})(_templateObject22(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject21()));
var ContentType = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ContentType",
    componentId: "sc-0-14"
})(_templateObject23(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall, function(p) {
    return p.theme.text.secondary;
});
var Divider = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].hr.withConfig({
    displayName: "Divider",
    componentId: "sc-0-15"
})(_templateObject25(), function(p) {
    return p.theme.colors.base200;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing300 */ .bK.measurements.spacing300, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject24(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200));
var FilterContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "FilterContainer",
    componentId: "sc-0-16"
})(_templateObject26(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);


/***/ }),

/***/ 46674:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": () => (/* binding */ getTranslationByContentType),
/* harmony export */   "t": () => (/* binding */ compareByDate)
/* harmony export */ });
/* harmony import */ var src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54712);

/**
 * Compare function for sorting Adviced content in arrays
 */ var compareByDate = function(a, b) {
    // If null or undefined, move to bottom of list
    if (!a || !a.publishedAt) return 1;
    if (!b || !b.publishedAt) return -1;
    return parseInt(b.publishedAt, 10) - parseInt(a.publishedAt, 10);
};
var getTranslationByContentType = function(type, t) {
    switch(type){
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.TEST */ .b.TEST:
            return t("expert", "test.test");
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.TOPLIST */ .b.TOPLIST:
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.TOPLIST_HEADLINE */ .b.TOPLIST_HEADLINE:
            return t("expert", "toplist.toplist");
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.GUIDE */ .b.GUIDE:
            return t("expert", "guide.guide");
        default:
            return null;
    }
};


/***/ }),

/***/ 51772:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": () => (/* binding */ NavigationSliceView)
});

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/horizontal-scroll/index.tsx + 1 modules
var horizontal_scroll = __webpack_require__(75081);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
// EXTERNAL MODULE: ./src/components/viewport/index.tsx
var viewport = __webpack_require__(22899);
// EXTERNAL MODULE: ./src/components/lazy/index.tsx
var lazy = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
;// CONCATENATED MODULE: ./src/components/media-button/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  padding: ",
        ";\n\n  &::after {\n    ",
        "\n    border-radius: 50%;\n    transition: background-color 150ms ease;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n  text-align: center;\n  flex: 1 1 auto;\n  width: 100%;\n  height: 100%;\n\n  > *:not(:last-child) {\n    margin-bottom: ",
        ";\n  }\n\n  &:hover {\n    ",
        " {\n      &::after {\n        background-color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Media = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Media",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* styledUtils.overlay */.au.overlay());
var Button = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "Button",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, Media, function(p) {
    return base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(p.theme.colors.base800, 0.08);
});

;// CONCATENATED MODULE: ./src/components/media-button/index.tsx


var MediaButton = function(props) {
    var children = props.children, className = props.className, url = props.url, onClick = props.onClick, media = props.media;
    return /*#__PURE__*/ react.createElement(Button, {
        className: className,
        to: url,
        onClick: onClick
    }, /*#__PURE__*/ react.createElement(Media, null, media), children);
};

;// CONCATENATED MODULE: ./src/areas/product-collection/components/navigation/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n    max-width: calc(100vw - 120px);\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: nowrap;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n      height: 140px;\n      overflow: hidden;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  justify-content: flex-start;\n  grid-template-columns: repeat(auto-fit, minmax(120px, auto));\n  flex-wrap: wrap;\n  list-style: none;\n  flex-grow: 1;\n  margin-bottom: 0;\n  row-gap: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  min-width: ",
        "px;\n  max-width: ",
        "px;\n  min-height: 140px;\n  display: block;\n  margin-left: 5px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n  line-height: ",
        "rem;\n  max-height: ",
        "rem;\n  word-break: break-word;\n  white-space: normal;\n  overflow: hidden;\n  /* stylelint-disable value-no-vendor-prefix  */\n  display: -webkit-box;\n  /* stylelint-disable property-no-vendor-prefix  */\n  -webkit-line-clamp: ",
        ";\n  -webkit-box-orient: vertical;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ",
        "px;\n  height: ",
        "px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n  display: block;\n  grid-column-end: -1;\n  grid-row-start: 1;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var ITEM_WIDTH = 120;
var MEDIA_SIZE = 60;
var Wrapper = styled_components_browser_esm["default"].section.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.largeUp */.BC.largeUp(styles_templateObject()));
var ListWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListWrapper",
    componentId: "sc-0-1"
})(_templateObject2());
var List = styled_components_browser_esm["default"].ul.attrs({
    "data-test": "NavigationList"
}).withConfig({
    displayName: "List",
    componentId: "sc-0-2"
})(_templateObject4(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(p) {
    return !p.$showAll && (0,styled_components_browser_esm.css)(_templateObject3());
});
var listItemStyles = (0,styled_components_browser_esm.css)(_templateObject5(), ITEM_WIDTH, ITEM_WIDTH);
var ListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "ListItem",
    componentId: "sc-0-3"
})(_templateObject6(), listItemStyles);
var ListItemDiv = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListItemDiv",
    componentId: "sc-0-4"
})(_templateObject7(), listItemStyles);
var ListItemText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListItemText",
    componentId: "sc-0-5"
})(_templateObject8());
var numberWithDefault = function(value, defaultValue) {
    return value !== undefined ? value : defaultValue;
};
var LimitedTextField = styled_components_browser_esm["default"].div.attrs(function(param) {
    var lines = param.lines;
    return {
        maxLines: numberWithDefault(lines, 2)
    };
}).withConfig({
    displayName: "LimitedTextField",
    componentId: "sc-0-6"
})(_templateObject9(), function(param) {
    var lineHeight = param.lineHeight;
    return numberWithDefault(lineHeight, 1.2);
}, function(param) {
    var lines = param.lines, lineHeight = param.lineHeight;
    return numberWithDefault(lines, 2) * numberWithDefault(lineHeight, 1.2);
}, function(param) {
    var lines = param.lines;
    return lines !== undefined ? lines : "none";
});
var ListItemImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListItemImage",
    componentId: "sc-0-7"
})(_templateObject10(), MEDIA_SIZE, MEDIA_SIZE);
var ListAction = styled_components_browser_esm["default"].div.attrs({
    "data-test": "NavigationListAction"
}).withConfig({
    displayName: "ListAction",
    componentId: "sc-0-8"
})(_templateObject11(), listItemStyles);
var ListActionButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListActionButton",
    componentId: "sc-0-9"
})(_templateObject12(), MEDIA_SIZE, MEDIA_SIZE);
var NavigationSliceWrapper = styled_components_browser_esm["default"].div.attrs({
    "data-test": "NavigationList"
}).withConfig({
    displayName: "NavigationSliceWrapper",
    componentId: "sc-0-10"
})(_templateObject13(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/product-collection/components/navigation/link.tsx





var NavigationLink = function(param) {
    var link = param.link, selected = param.selected, onClickPreventDefault = param.onClickPreventDefault, Component = param.Component, onClick = param.onClick, _lazyLoadImage = param.lazyLoadImage, lazyLoadImage = _lazyLoadImage === void 0 ? true : _lazyLoadImage;
    var onClickHandler = (0,react.useCallback)(function(e) {
        // Help google with a-links, but handle filter updates via actions
        if (onClick) {
            if (onClickPreventDefault) {
                e.preventDefault();
            }
            onClick(link);
        }
    }, [
        link,
        onClick,
        onClickPreventDefault
    ]);
    var children = (0,react.useMemo)(function() {
        var image = link.imageUrl;
        if (!image) {
            return /*#__PURE__*/ react.createElement(variants.H1Text, {
                container: "span",
                emphasis: variants.FontEmphasis.LOW
            }, link.value.replace(/[^\w]+/, "").charAt(0));
        }
        var img = /*#__PURE__*/ react.createElement("img", {
            src: image,
            alt: link.value
        });
        if (lazyLoadImage) {
            return /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
                offset: 0
            }, img);
        }
        return img;
    }, [
        lazyLoadImage,
        link.imageUrl,
        link.value
    ]);
    var addSpaceBetweenSpecialCharacters = function(input) {
        var specialCharacters = RegExp("([^\\p{L}\\p{N}\\s])", "gu");
        return input.replace(specialCharacters, " $1 ");
    };
    return /*#__PURE__*/ react.createElement(Component, {
        selected: selected,
        "data-test": "NavigationLink",
        "data-cy": link.value
    }, /*#__PURE__*/ react.createElement(MediaButton, {
        media: /*#__PURE__*/ react.createElement(ListItemImage, null, children),
        url: link.indexable && link.path || undefined,
        onClick: onClickHandler
    }, /*#__PURE__*/ react.createElement(ListItemText, null, /*#__PURE__*/ react.createElement(LimitedTextField, {
        lines: 2
    }, /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
        color: variants.FontColor.DARK
    }, addSpaceBetweenSpecialCharacters(link.value))))));
};
/* harmony default export */ const navigation_link = (NavigationLink);

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
// EXTERNAL MODULE: ./src/hooks/resize-observer.ts
var resize_observer = __webpack_require__(32495);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/navigation/navigation-component.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}










var DEFAULT_ITEM_LIMIT = 7;
var renderNavigationLinks = function(param) {
    var links = param.links, onClick = param.onClick, onClickPreventDefault = param.onClickPreventDefault, __showAll = param._showAll, _showAll = __showAll === void 0 ? true : __showAll, _asListItems = param.asListItems, asListItems = _asListItems === void 0 ? false : _asListItems, _itemLimit = param.itemLimit, itemLimit = _itemLimit === void 0 ? DEFAULT_ITEM_LIMIT : _itemLimit;
    return links && links.length ? links.map(function(link, index) {
        var selected = link.selected;
        var Component = asListItems ? ListItem : ListItemDiv;
        return link.path ? /*#__PURE__*/ react.createElement(navigation_link, {
            key: link.value,
            link: link,
            selected: selected,
            onClick: function(facetLink) {
                return onClick === null || onClick === void 0 ? void 0 : onClick(facetLink, index);
            },
            onClickPreventDefault: onClickPreventDefault,
            // Lazy loading is disabled for all initially visible images to enable them
            // to load before React is loaded. The goal of this strategy is to improve
            // our Lighthouse performance score, and specifically the "Largest Contentful
            // Paint" metric.
            lazyLoadImage: index >= itemLimit,
            Component: Component
        }) : null;
    }) : null;
};
var NavigationSliceView = function(param) {
    var links = param.links, onClick = param.onClick, _onClickPreventDefault = param.onClickPreventDefault, onClickPreventDefault = _onClickPreventDefault === void 0 ? false : _onClickPreventDefault, _itemLimit = param.itemLimit, itemLimit = _itemLimit === void 0 ? DEFAULT_ITEM_LIMIT : _itemLimit, _showAll = param.showAll, showAll = _showAll === void 0 ? false : _showAll, className = param.className;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = _slicedToArray((0,react.useState)(false), 2), _showAll1 = ref[0], _setShowAll = ref[1];
    var onShowAll = (0,react.useCallback)(function() {
        return _setShowAll(!_showAll1);
    }, [
        _showAll1,
        _setShowAll
    ]);
    var trackOnClick = function(link, index) {
        if (link.path) (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.NAVIGATION_CAROUSEL */.U.NAVIGATION_CAROUSEL,
            nextPage: link.path,
            index: index
        });
        onClick === null || onClick === void 0 ? void 0 : onClick(link);
    };
    var mobileLinks = renderNavigationLinks({
        links: links,
        onClick: trackOnClick,
        onClickPreventDefault: onClickPreventDefault,
        itemLimit: itemLimit
    });
    var desktopLinks = renderNavigationLinks({
        links: links,
        onClick: trackOnClick,
        onClickPreventDefault: onClickPreventDefault,
        _showAll: _showAll1,
        asListItems: true,
        itemLimit: itemLimit
    });
    var ref1 = (0,resize_observer/* useResizeObserver */.y)(), ref2 = ref1.ref, width = ref1.width;
    var showMore = (0,react.useMemo)(function() {
        if (!(links === null || links === void 0 ? void 0 : links.length) || !width) return false;
        return Math.floor(width / 120) < links.length;
    }, [
        links,
        width
    ]);
    return mobileLinks || desktopLinks ? /*#__PURE__*/ react.createElement(Wrapper, {
        className: className
    }, mobileLinks && /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
        mobile: true,
        tablet: true
    }, /*#__PURE__*/ react.createElement(horizontal_scroll/* HorizontalScroll */.Z, {
        itemWidth: 110,
        loadingHeight: 140,
        showArrows: false
    }, mobileLinks)), desktopLinks && /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
        desktop: true
    }, /*#__PURE__*/ react.createElement(ListWrapper, {
        ref: ref2
    }, /*#__PURE__*/ react.createElement(List, {
        $showAll: showAll || _showAll1,
        $itemLimit: itemLimit
    }, showMore && links && links.length > itemLimit && !showAll ? /*#__PURE__*/ react.createElement(ListAction, null, /*#__PURE__*/ react.createElement(MediaButton, {
        onClick: onShowAll,
        media: /*#__PURE__*/ react.createElement(ListActionButton, null, /*#__PURE__*/ react.createElement(variants.TitleSmallText, null, t("common", _showAll1 ? "button.show-less" : "button.show-more")))
    })) : null, desktopLinks)))) : null;
};


/***/ }),

/***/ 79821:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": () => (/* binding */ OffersGrid)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35632);


var OffersGrid = function(param) {
    var children = param.children, className = param.className, offers = param.offers, isExtraWide = param.isExtraWide, isOffers = param.isOffers;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_1__/* .OffersGrid */ .u5, {
        "data-test": isOffers ? "OfferGrid" : "ProductGrid",
        className: className,
        isExtraWide: isExtraWide
    }, children, offers && react__WEBPACK_IMPORTED_MODULE_0__.Children.map(offers, function(child, index) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_1__/* .OffersGridItem */ .EA, {
            "data-test": isOffers ? "OfferGridCard" : "ProductGridCard",
            style: {
                order: index
            }
        }, child);
    }));
};


/***/ }),

/***/ 35632:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EA": () => (/* binding */ OffersGridItem),
/* harmony export */   "cq": () => (/* binding */ ITEMS),
/* harmony export */   "u5": () => (/* binding */ OffersGrid)
/* harmony export */ });
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94141);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71993);
/* harmony import */ var src_components_base_styles_variables__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76323);
/* eslint-disable no-nested-ternary */ function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n          grid-gap: ",
        "rem;\n          grid-template-columns: repeat(\n            auto-fill,\n            minmax(auto, calc(",
        " - ",
        "))\n          );\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    @supports (grid-template-columns: repeat(auto-fill, minmax(auto, 50%))) {\n      display: grid;\n      flex: 1 0 auto;\n      list-style: none;\n\n      ",
        "\n      ",
        "\n    }\n\n    /* Fallback to flex if grid-template-columns is not supported */\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



// We need to cover ALL breakpoints here since we use '`${breakpoint}Only`'
// If we left out xxl for example, then >1600px would look very weird as it wouldn't be covered by any breakpoint
// (This only works because the smallest and largest breakpoints are open in their respective direction)
var ITEMS = {
    small: 2,
    medium: 3,
    large: 4,
    xlarge: 4,
    xxlarge: 4
};
var GAPS = {
    small: 0.5,
    medium: 1,
    large: 1,
    xlarge: 1,
    xxlarge: 1
};
// These are calculated for each render
var SIZES = {};
var GUTTERS = {};
/**
 * Certain experiments require a different grid layout, which is passed as props
 * Here we determine how many items to show depending on the passed props
 */ function getItemsForExperiments(param) {
    var isExtraWide = param.isExtraWide;
    if (isExtraWide) {
        return {
            large: 4,
            xlarge: 5,
            xxlarge: 6
        };
    }
    return {
        large: 4,
        xlarge: 4,
        xxlarge: 4
    };
}
var OffersGrid = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].ul.withConfig({
    displayName: "OffersGrid",
    componentId: "sc-0-0"
})(function(props) {
    // We need to mutate the object here because src/areas/product-collection/components/products/layout-grid/layout-grid.tsx relies on the current layout configuration, and that depends on getItemsForExperiment
    // We don't want to implement the same logic twice, therefore we need to access this object from somewhere else
    Object.assign(ITEMS, getItemsForExperiments(props));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // I'm not really happy with the current solution, but if we dynamically change ITEMS.large etc. for each render, then we also need to recalculate (gutter) sizes for each render
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for(var _iterator = src_components_base_styles_variables__WEBPACK_IMPORTED_MODULE_2__/* .breakpointNames */ .PS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var bp = _step.value;
            SIZES[bp] = "".concat(100 / ITEMS[bp], "%");
            GUTTERS[bp] = "".concat(GAPS[bp] * (ITEMS[bp] - 1), "rem / ").concat(ITEMS[bp]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject1(), /* This only works because smallOnly and xxlargeOnly have no boundaries in each unset direction i.e. everything larger than xxlarge is considered xxlarge */ null, src_components_base_styles_variables__WEBPACK_IMPORTED_MODULE_2__/* .breakpointNames.map */ .PS.map(function(breakpoint) {
        return src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC["".concat(breakpoint, "Only")](_templateObject(), GAPS[breakpoint], SIZES[breakpoint], GUTTERS[breakpoint]);
    }));
});
var OffersGridItem = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].li.withConfig({
    displayName: "OffersGridItem",
    componentId: "sc-0-1"
})(_templateObject2());


/***/ }),

/***/ 14232:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": () => (/* reexport */ GridLayout)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/layout-buttons/types.ts
var types = __webpack_require__(21068);
// EXTERNAL MODULE: ./src/components/advized/index.tsx
var advized = __webpack_require__(69988);
// EXTERNAL MODULE: ./src/areas/product-collection/utils/products.ts
var utils_products = __webpack_require__(37424);
// EXTERNAL MODULE: ./src/areas/product-collection/components/ads/index.tsx + 1 modules
var ads = __webpack_require__(72943);
// EXTERNAL MODULE: ./src/areas/product-collection/components/offers-grid/index.tsx
var offers_grid = __webpack_require__(79821);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
// EXTERNAL MODULE: ./src/areas/search/tracking.ts
var search_tracking = __webpack_require__(82968);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/constants.ts
var FEEDBACK_PROMPT_ROW_POSITION = 6;
var MIXED_CONTENT_ROW_POSITIONS = [
    // This is the row position of the first mixed content card and the second mixed content card,
    // per breakpoint.
    {
        desktop: 2,
        tablet: 3,
        mobile: 5
    },
    {
        desktop: 5,
        tablet: 7,
        mobile: 13
    },
    {
        desktop: 8,
        tablet: 12,
        mobile: 20
    },
    {
        desktop: 11,
        tablet: 15,
        mobile: 25
    }
];
var MIXED_CONTENT_VISIBILITY_MIN_PRODUCTS_COUNT = [
    // This is the minimum number of products that need to be visible
    // for the first mixed content card and the second mixed content card,
    // per breakpoint.
    {
        isDesktop: 6,
        isTablet: 7,
        isMobile: 6
    },
    {
        isDesktop: 16,
        isTablet: 14,
        isMobile: 14
    },
    {
        isDesktop: 26,
        isTablet: 27,
        isMobile: 26
    },
    {
        isDesktop: 35,
        isTablet: 34,
        isMobile: 34
    }
];

// EXTERNAL MODULE: ./src/areas/expert/types.ts
var expert_types = __webpack_require__(54712);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/utils.ts




var handleOnClick = function(item, url, query) {
    if (!url) return;
    (0,search_tracking/* trackSearchResultExpertArticleClicked */.AA)(item.id, item.title || "", item.__typename, url, query || "");
    (0,tracking/* trackInternalNavigationClick */.p)({
        scope: tracking/* InternalNavigationScope.MIXED_CONTENT_CARD */.U.MIXED_CONTENT_CARD,
        nextPage: url
    });
};
var getLinkByType = function(item) {
    switch(item.__typename){
        case expert_types/* ContentTypes.TOPLIST */.b.TOPLIST:
            return item.headlineInfo.url;
        case expert_types/* ContentTypes.GUIDE */.b.GUIDE:
            return item.url;
        case expert_types/* ContentTypes.ARTICLE */.b.ARTICLE:
            return item.link;
        case expert_types/* ContentTypes.SPONSORED_ARTICLE */.b.SPONSORED_ARTICLE:
            return item.url;
        default:
            return undefined;
    }
};
// Gets the amount of mixed content cards that can be shown based on the number of products in the grid.
var getVisibleCards = function(items, productsCount, currentViewport) {
    try {
        return items.filter(function(_, index) {
            return MIXED_CONTENT_VISIBILITY_MIN_PRODUCTS_COUNT[index][currentViewport] <= productsCount;
        });
    } catch (e) {
        throw e;
    }
};
var getRowPosition = function(index) {
    return MIXED_CONTENT_ROW_POSITIONS[index];
};

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/link-card/description/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  p {\n    margin: 0;\n\n    &:not(:first-child) {\n      display: none;\n    }\n\n    /* stylelint-disable */\n    /* Restrict the box to the specified number of lines of text.\n   * See https://css-tricks.com/almanac/properties/l/line-clamp/ */\n    display: -webkit-box;\n    -webkit-line-clamp: ",
        ";\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledDescription = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledDescription",
    componentId: "sc-0-0"
})(_templateObject(), function(props) {
    return props.$maxLines;
});

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/link-card/description/index.tsx



var MAX_LINES = 7;
var Description = function(param) {
    var item = param.item;
    switch(item.__typename){
        case expert_types/* ContentTypes.TOPLIST */.b.TOPLIST:
            {
                var ref, ref1;
                if (!((ref = item.description) === null || ref === void 0 ? void 0 : ref.length)) return undefined;
                var markup = function(html) {
                    return {
                        __html: html
                    };
                };
                var texts = (ref1 = item.description) === null || ref1 === void 0 ? void 0 : ref1.filter(function(description) {
                    return description.type === "text";
                });
                return texts.length > 0 ? /*#__PURE__*/ react.createElement(StyledDescription, {
                    key: texts[0].data,
                    dangerouslySetInnerHTML: markup(texts[0].data),
                    $maxLines: MAX_LINES
                }) : null;
            }
        case expert_types/* ContentTypes.GUIDE */.b.GUIDE:
        case expert_types/* ContentTypes.ARTICLE */.b.ARTICLE:
            return /*#__PURE__*/ react.createElement(StyledDescription, {
                $maxLines: MAX_LINES
            }, /*#__PURE__*/ react.createElement("p", null, item.description));
        case expert_types/* ContentTypes.SPONSORED_ARTICLE */.b.SPONSORED_ARTICLE:
            return /*#__PURE__*/ react.createElement(StyledDescription, {
                $maxLines: MAX_LINES
            }, /*#__PURE__*/ react.createElement("p", null, item.preamble));
        default:
            return null;
    }
};

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/shared/image/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 140px;\n  height: 140px;\n  object-fit: cover;\n  rotate: 6deg;\n  border-radius: 16px;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  border-radius: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var StyledRotatedImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledRotatedImage",
    componentId: "sc-0-0"
})(styles_templateObject());
var StyledFullImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledFullImage",
    componentId: "sc-0-1"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/shared/image/index.tsx



var Image = function(param) {
    var item = param.item;
    switch(item.__typename){
        case expert_types/* ContentTypes.GUIDE */.b.GUIDE:
        case expert_types/* ContentTypes.ARTICLE */.b.ARTICLE:
        case expert_types/* ContentTypes.TOPLIST */.b.TOPLIST:
            return (item === null || item === void 0 ? void 0 : item.image) && /*#__PURE__*/ react.createElement(StyledRotatedImage, {
                src: item.image.src,
                alt: item.image.alt
            });
        case expert_types/* ContentTypes.SPONSORED_ARTICLE */.b.SPONSORED_ARTICLE:
            return (item === null || item === void 0 ? void 0 : item.thumbnail) && /*#__PURE__*/ react.createElement(StyledRotatedImage, {
                src: item.thumbnail,
                alt: item.title
            });
        case expert_types/* ContentTypes.VIDEO */.b.VIDEO:
            return item.previewImage ? /*#__PURE__*/ react.createElement(StyledFullImage, {
                src: item.previewImage
            }) : null;
        default:
            return null;
    }
};

// EXTERNAL MODULE: ./src/areas/expert/components/expert-avatar/index.tsx + 1 modules
var expert_avatar = __webpack_require__(53973);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/arrow-right/index.js
var arrow_right = __webpack_require__(86401);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/link-card/link-text/styles.ts
function link_text_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function link_text_styles_templateObject() {
    var data = link_text_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: ",
        "px 1fr;\n  gap: ",
        ";\n  align-items: center;\n"
    ]);
    link_text_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = link_text_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: center;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = link_text_styles_taggedTemplateLiteral([
        "\n  flex: 0 1 auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var EXPERT_AVATAR_SIZE = 40;
var StyledExpert = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledExpert",
    componentId: "sc-0-0"
})(link_text_styles_templateObject(), EXPERT_AVATAR_SIZE, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledLinkTextWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledLinkTextWrapper",
    componentId: "sc-0-1"
})(styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledLinkText = (0,styled_components_browser_esm["default"])(variants.TitleMediumText).withConfig({
    displayName: "StyledLinkText",
    componentId: "sc-0-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/link-card/link-text/index.tsx






var LinkText = function(param) {
    var item = param.item;
    var ref;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var linktext = t("search", "mixed-content.".concat((ref = item.__typename) === null || ref === void 0 ? void 0 : ref.toLowerCase(), "-link-text"));
    var linkIconSize = 18;
    switch(item.__typename){
        case expert_types/* ContentTypes.TOPLIST */.b.TOPLIST:
        case expert_types/* ContentTypes.GUIDE */.b.GUIDE:
            var ref1;
            if ((ref1 = item.expert) === null || ref1 === void 0 ? void 0 : ref1.name) {
                return /*#__PURE__*/ react.createElement(StyledExpert, null, /*#__PURE__*/ react.createElement(expert_avatar/* default */.Z, {
                    size: EXPERT_AVATAR_SIZE,
                    displayName: item.expert.name,
                    avatar: item.expert.avatar
                }), " ", /*#__PURE__*/ react.createElement(StyledLinkTextWrapper, null, /*#__PURE__*/ react.createElement(StyledLinkText, null, "".concat(linktext, " ").concat(item.expert.name)), /*#__PURE__*/ react.createElement(arrow_right/* IconArrowRight */.E, {
                    size: linkIconSize
                })));
            }
            return null;
        case expert_types/* ContentTypes.ARTICLE */.b.ARTICLE:
            return /*#__PURE__*/ react.createElement(StyledLinkTextWrapper, null, /*#__PURE__*/ react.createElement(StyledLinkText, null, linktext), /*#__PURE__*/ react.createElement(arrow_right/* IconArrowRight */.E, {
                size: linkIconSize
            }));
        case expert_types/* ContentTypes.SPONSORED_ARTICLE */.b.SPONSORED_ARTICLE:
            return /*#__PURE__*/ react.createElement(StyledLinkTextWrapper, null, /*#__PURE__*/ react.createElement(StyledLinkText, null, linktext), /*#__PURE__*/ react.createElement(arrow_right/* IconArrowRight */.E, {
                size: linkIconSize
            }));
        default:
            return null;
    }
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(89695);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/link-card/styles.ts
function link_card_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function link_card_styles_templateObject() {
    var data = link_card_styles_taggedTemplateLiteral([
        "\n    padding: ",
        ";\n  "
    ]);
    link_card_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function link_card_styles_templateObject1() {
    var data = link_card_styles_taggedTemplateLiteral([
        "\n  flex: 1 0 auto;\n  justify-content: space-between;\n  padding: ",
        ";\n  row-gap: ",
        ";\n\n  ",
        "\n"
    ]);
    link_card_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = link_card_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = link_card_styles_taggedTemplateLiteral([
        "\n  width: fit-content;\n  padding: 0 6px;\n  margin-bottom: 5px;\n  border-radius: 4px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var StyledCardActionArea = (0,styled_components_browser_esm["default"])(card.CardActionArea).withConfig({
    displayName: "StyledCardActionArea",
    componentId: "sc-0-0"
})(link_card_styles_templateObject1(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* media.smallOnly */.BC.smallOnly(link_card_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var StyledDescriptionWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledDescriptionWrapper",
    componentId: "sc-0-1"
})(styles_templateObject2(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var SponsoredBadge = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SponsoredBadge",
    componentId: "sc-0-2"
})(_templateObject3(), base/* colors.lightTheme.yellove500 */.O9.lightTheme.yellove500);

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/link-card/index.tsx









var LinkCard = function(props) {
    var item = props.item, link = props.link, query = props.query;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var preTitle = getPreTitle(item, t);
    return /*#__PURE__*/ react.createElement(StyledCardActionArea, {
        container: link ? clickable/* Clickable */.P : "div",
        containerProps: {
            onClick: function() {
                return handleOnClick(item, link, query);
            },
            to: link
        }
    }, /*#__PURE__*/ react.createElement("div", null, preTitle, /*#__PURE__*/ react.createElement(variants.H2Text, null, item.title), /*#__PURE__*/ react.createElement(StyledDescriptionWrapper, null, /*#__PURE__*/ react.createElement(Description, {
        item: item
    }), /*#__PURE__*/ react.createElement(Image, {
        item: item
    }))), /*#__PURE__*/ react.createElement(LinkText, {
        item: item
    }));
};
var getPreTitle = function(item, t) {
    if (!item.__typename) {
        return null;
    }
    if (item.__typename === "SearchSponsoredArticle") {
        return /*#__PURE__*/ react.createElement(SponsoredBadge, null, /*#__PURE__*/ react.createElement(variants.BodySmallText, {
            scale: variants.FontScale.XS,
            color: variants.FontColor.DARK
        }, t("search", "mixed-content.".concat(item.__typename.toLowerCase(), "-pre-title"), {
            sponsor: item.sponsorName
        })));
    }
    return /*#__PURE__*/ react.createElement(variants.BodySmallText, null, t("search", "mixed-content.".concat(item.__typename.toLowerCase(), "-pre-title")));
};

// EXTERNAL MODULE: ./src/areas/product/components/carousel-products/components/partner-video-carousel/components/partner-video-modal/index.tsx + 1 modules
var partner_video_modal = __webpack_require__(46890);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
// EXTERNAL MODULE: ./src/components/youtube-icon/index.tsx + 1 modules
var youtube_icon = __webpack_require__(21284);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/modal-card/styles.ts
function modal_card_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function modal_card_styles_templateObject() {
    var data = modal_card_styles_taggedTemplateLiteral([
        "\n    padding: ",
        ";\n  "
    ]);
    modal_card_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function modal_card_styles_templateObject1() {
    var data = modal_card_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  row-gap: ",
        ";\n  padding: ",
        ";\n  cursor: pointer;\n\n  ",
        "\n"
    ]);
    modal_card_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function modal_card_styles_templateObject2() {
    var data = modal_card_styles_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    modal_card_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = modal_card_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var styles_StyledCardActionArea = (0,styled_components_browser_esm["default"])(card.CardActionArea).withConfig({
    displayName: "StyledCardActionArea",
    componentId: "sc-0-0"
})(modal_card_styles_templateObject1(), design_tokens.measurements.spacing075, design_tokens.measurements.spacing150, base/* media.smallOnly */.BC.smallOnly(modal_card_styles_templateObject(), design_tokens.measurements.spacing100));
var StyledImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledImageWrapper",
    componentId: "sc-0-1"
})(modal_card_styles_templateObject2());
var StyledYoutubeIcon = (0,styled_components_browser_esm["default"])(youtube_icon/* YoutubeIcon */.L).withConfig({
    displayName: "StyledYoutubeIcon",
    componentId: "sc-0-2"
})(styles_templateObject3());

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/modal-card/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var ModalCard = function(props) {
    var item = props.item;
    var ref = _slicedToArray((0,react.useState)(false), 2), isPartnerVideoModalOpen = ref[0], setIsPartnerVideoModalOpen = ref[1];
    if (!item.previewImage) return null;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, isPartnerVideoModalOpen && /*#__PURE__*/ react.createElement(partner_video_modal/* PartnerVideoModal */.o, {
        closeModal: function() {
            return setIsPartnerVideoModalOpen(false);
        },
        isOpen: isPartnerVideoModalOpen,
        thumbnail: item.previewImage,
        title: item.title,
        videoId: item.youtubeId
    }), /*#__PURE__*/ react.createElement(styles_StyledCardActionArea, {
        containerProps: {
            onClick: function() {
                return setIsPartnerVideoModalOpen(true);
            },
            type: "button"
        }
    }, /*#__PURE__*/ react.createElement(StyledImageWrapper, null, /*#__PURE__*/ react.createElement(StyledYoutubeIcon, {
        size: 60
    }), /*#__PURE__*/ react.createElement(Image, {
        item: item
    })), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, item.author), /*#__PURE__*/ react.createElement(variants.H2Text, null, item.title))));
};

// EXTERNAL MODULE: ./src/areas/product-collection/components/offers-grid/styles.ts
var styles = __webpack_require__(35632);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/styles.ts
function mixed_content_cards_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function mixed_content_cards_styles_templateObject() {
    var data = mixed_content_cards_styles_taggedTemplateLiteral([
        "\n      grid-column: ",
        ";\n      grid-row: ",
        ";\n    "
    ]);
    mixed_content_cards_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function mixed_content_cards_styles_templateObject1() {
    var data = mixed_content_cards_styles_taggedTemplateLiteral([
        "\n      grid-column: ",
        " / span 2;\n      grid-row: ",
        ";\n    "
    ]);
    mixed_content_cards_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function mixed_content_cards_styles_templateObject2() {
    var data = mixed_content_cards_styles_taggedTemplateLiteral([
        "\n      grid-column: ",
        " / span 2;\n      grid-row: ",
        ";\n    "
    ]);
    mixed_content_cards_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function mixed_content_cards_styles_templateObject3() {
    var data = mixed_content_cards_styles_taggedTemplateLiteral([
        "\n    ",
        "\n    ",
        "\n    ",
        "\n  "
    ]);
    mixed_content_cards_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = mixed_content_cards_styles_taggedTemplateLiteral([
        "\n    background: ",
        ";\n    height: 100%;\n    box-shadow: none;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var StyledCardWrapper = styled_components_browser_esm["default"].li.withConfig({
    displayName: "StyledCardWrapper",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(mixed_content_cards_styles_templateObject3(), base/* media.smallOnly */.BC.smallOnly(mixed_content_cards_styles_templateObject(), "1 / span ".concat(styles/* ITEMS.small */.cq.small, "}"), props.$row.mobile), base/* media.mediumOnly */.BC.mediumOnly(mixed_content_cards_styles_templateObject1(), props.$position === "right" ? "2" : "1", props.$row.tablet), base/* media.largeUp */.BC.largeUp(mixed_content_cards_styles_templateObject2(), props.$position === "right" ? "3" : "1", props.$row.desktop));
});
var StyledMixedContentCard = (0,styled_components_browser_esm["default"])(card.Card).withConfig({
    displayName: "StyledMixedContentCard",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), props.theme.colors.base100);
});

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/index.tsx







var MixedContentCards = function(props) {
    var viewportContext = (0,context/* useViewportContext */.Ak)();
    var currentPage = props.currentPage, items = props.items, productsCount = props.productsCount, query = props.query;
    if (currentPage !== 1) return null;
    var currentViewport = Object.keys(viewportContext).find(function(index) {
        return viewportContext[index];
    });
    var visibleItems = getVisibleCards(items, productsCount, currentViewport);
    return visibleItems.map(function(item, index) {
        var link = getLinkByType(item);
        return /*#__PURE__*/ react.createElement(StyledCardWrapper, {
            key: item.id,
            $position: index % 2 ? "left" : "right",
            $row: getRowPosition(index)
        }, /*#__PURE__*/ react.createElement(StyledMixedContentCard, null, item.__typename === expert_types/* ContentTypes.VIDEO */.b.VIDEO ? /*#__PURE__*/ react.createElement(ModalCard, {
            item: item
        }) : /*#__PURE__*/ react.createElement(LinkCard, {
            item: item,
            link: link,
            query: query
        })));
    });
};

// EXTERNAL MODULE: ./src/components/product-card-old/product-card-context.tsx
var product_card_context = __webpack_require__(5780);
// EXTERNAL MODULE: ./src/components/action-buttons/add-to-list/index.tsx
var add_to_list = __webpack_require__(90814);
// EXTERNAL MODULE: ./src/areas/product-collection/components/products/highlighted-search-result.tsx
var highlighted_search_result = __webpack_require__(85029);
// EXTERNAL MODULE: ./src/components/product-card-old/index.tsx + 24 modules
var product_card_old = __webpack_require__(99686);
// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(73426);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/product-cards/grid-product-card.tsx






var GridProductCard = function(props) {
    var ref;
    var deselectProductById = props.deselectProductById, hasExpertBadge = props.hasExpertBadge, id = props.id, isSelectingProducts = props.isSelectingProducts, lazyLoadImage = props.lazyLoadImage, onClick = props.onClick, product = props.product, selectedProducts = props.selectedProducts, selectProductById = props.selectProductById, showCategoryButton = props.showCategoryButton;
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var dealsDiffPercentage = product === null || product === void 0 ? void 0 : (ref = product.dealInfo) === null || ref === void 0 ? void 0 : ref.dealPercentage;
    var onSelect = (0,react.useCallback)(function(productId) {
        return selectProductById && selectProductById(productId);
    }, [
        selectProductById
    ]);
    var onDeselect = (0,react.useCallback)(function(productId) {
        return deselectProductById && deselectProductById(productId);
    }, [
        deselectProductById
    ]);
    return /*#__PURE__*/ react.createElement(product_card_context/* ProductCardContextContainer */.h, {
        ActionArea: isAuthenticated && !isSelectingProducts && /*#__PURE__*/ react.createElement(add_to_list/* AddToListButton */.a, {
            productId: product.id,
            productName: product.name
        }),
        diffPercentage: dealsDiffPercentage,
        hasExpertBadge: hasExpertBadge,
        highlightedName: product.highlight ? /*#__PURE__*/ react.createElement(highlighted_search_result/* default */.Z, null, product.highlight) : undefined,
        onClick: onClick,
        product: product,
        selectStates: {
            onDeselect: function() {
                return onDeselect(product.id);
            },
            onSelect: function() {
                return onSelect(product.id);
            },
            selectable: isSelectingProducts,
            selected: selectedProducts ? selectedProducts.some(function(p) {
                return p.id === id;
            }) : false
        },
        shouldLazyLoadImage: lazyLoadImage,
        showCategoryButton: showCategoryButton
    }, /*#__PURE__*/ react.createElement(product_card_old/* ProductGridCard */.r4, null));
};

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/product-cards/grid-raw-product-card.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var GridRawProductCard = function(props) {
    var ref;
    var onClick = props.onClick, product = props.product, showCategoryButton = props.showCategoryButton;
    var getPrice = function() {
        switch(product.__typename){
            case "Offer":
                return product.offerPrice.regular;
            case "Raw":
                return product.price;
            default:
                return undefined;
        }
    };
    return /*#__PURE__*/ react.createElement(product_card_context/* ProductCardContextContainer */.h, {
        onClick: onClick,
        product: _objectSpreadProps(_objectSpread({}, product), {
            media: product.__typename === "Offer" ? product.media : undefined,
            pathName: ((ref = product.store) === null || ref === void 0 ? void 0 : ref.featured) ? product.externalUri : undefined,
            priceSummary: {
                regular: getPrice()
            }
        }),
        showCategoryButton: showCategoryButton,
        type: "offer"
    }, /*#__PURE__*/ react.createElement(product_card_old/* ProductGridCard */.r4, null));
};

// EXTERNAL MODULE: ./src/components/product-card/index.ts + 66 modules
var product_card = __webpack_require__(23148);
// EXTERNAL MODULE: ./src/components/product-of-the-year/hooks.ts
var hooks = __webpack_require__(44266);
// EXTERNAL MODULE: ./src/areas/product-collection/components/products/types.ts
var products_types = __webpack_require__(60);
// EXTERNAL MODULE: ./src/components/base/styles/variables.ts
var variables = __webpack_require__(76323);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/styles.ts
function layout_grid_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function layout_grid_styles_templateObject() {
    var data = layout_grid_styles_taggedTemplateLiteral([
        "grid-column: 1 / span ",
        ""
    ]);
    layout_grid_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function layout_grid_styles_templateObject1() {
    var data = layout_grid_styles_taggedTemplateLiteral([
        "\n  grid-row: ",
        ";\n  ",
        "\n"
    ]);
    layout_grid_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




// This should work because OffersGrid (src/areas/product-collection/components/offers-grid/styles) renders first and mutates ITEMS during that render
// Therefore, ITEMS here should match the items number used to render the offers grid
var StyledFeedbackPrompt = styled_components_browser_esm["default"].li.withConfig({
    displayName: "StyledFeedbackPrompt",
    componentId: "sc-0-0"
})(layout_grid_styles_templateObject1(), function(p) {
    return p.$position;
}, variables/* breakpointNames.map */.PS.map(function(bp) {
    return base/* media */.BC["".concat(bp, "Only")](layout_grid_styles_templateObject(), styles/* ITEMS */.cq[bp]);
}));

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/layout-grid.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}















var IMAGES_PER_ROW_MOBILE = 2;
var ProductCardWrapper = function(param) {
    var deselectProductById = param.deselectProductById, isSelectingProducts = param.isSelectingProducts, _lazyLoadImage = param.lazyLoadImage, lazyLoadImage = _lazyLoadImage === void 0 ? true : _lazyLoadImage, _showCategoryButton = param.showCategoryButton, showCategoryButton = _showCategoryButton === void 0 ? false : _showCategoryButton, onClick = param.onClick, product = param.product, hasExpertBadge = param.hasExpertBadge, selectProductById = param.selectProductById, selectedProducts = param.selectedProducts, pageType = param.pageType;
    var productOfTheYear = (0,hooks/* useGetProductOfTheYear */.i)(product.id);
    var raw = (0,utils_products/* isRaw */._)(product);
    var id = product.id;
    if (product.__typename === "Offer") {
        var _offerId;
        id = (_offerId = product.offerId) !== null && _offerId !== void 0 ? _offerId : "";
    }
    var onClickHandler = (0,react.useCallback)(function() {
        return onClick && onClick({
            id: id,
            name: product.name,
            type: product.__typename
        });
    }, [
        id,
        onClick,
        product.__typename,
        product.name
    ]);
    var renderProductCardByPageType = function() {
        switch(pageType){
            case products_types/* PageTypeEnum.SEARCH */.D.SEARCH:
                return /*#__PURE__*/ react.createElement(product_card/* SearchProductCard */.xJ, {
                    product: product,
                    productOfTheYear: productOfTheYear
                });
            default:
                return /*#__PURE__*/ react.createElement(GridProductCard, {
                    deselectProductById: deselectProductById,
                    hasExpertBadge: hasExpertBadge,
                    id: id,
                    isSelectingProducts: isSelectingProducts,
                    lazyLoadImage: lazyLoadImage,
                    onClick: onClickHandler,
                    product: product,
                    selectedProducts: selectedProducts,
                    selectProductById: selectProductById,
                    showCategoryButton: showCategoryButton
                });
        }
    };
    return raw ? /*#__PURE__*/ react.createElement(GridRawProductCard, {
        onClick: onClickHandler,
        product: product,
        showCategoryButton: showCategoryButton
    }) : renderProductCardByPageType();
};
var GridLayout = function(_param) {
    var feedbackPrompt = _param.feedbackPrompt, onClick = _param.onClick, products = _param.products, expert = _param.expert, adsLayoutConfig = _param.adsLayoutConfig, isExtraWide = _param.isExtraWide, hasFeedback = _param.hasFeedback, _showCategoryButton = _param.showCategoryButton, showCategoryButton = _showCategoryButton === void 0 ? false : _showCategoryButton, mixedContentCards = _param.mixedContentCards, query = _param.query, currentPage = _param.currentPage, pageType = _param.pageType, productComparisonProps = _objectWithoutProperties(_param, [
        "feedbackPrompt",
        "onClick",
        "products",
        "expert",
        "adsLayoutConfig",
        "isExtraWide",
        "hasFeedback",
        "showCategoryButton",
        "mixedContentCards",
        "query",
        "currentPage",
        "pageType"
    ]);
    return /*#__PURE__*/ react.createElement(offers_grid/* OffersGrid */.u, {
        isExtraWide: isExtraWide,
        offers: products.map(function(product, index) {
            var raw = (0,utils_products/* isRaw */._)(product);
            return /*#__PURE__*/ react.createElement(ProductCardWrapper, _extends({
                key: !raw ? product.id : "".concat(product.name, "-").concat(index.toString()),
                onClick: function(productData) {
                    onClick === null || onClick === void 0 ? void 0 : onClick(productData.id, productData.name, productData.type, index);
                    if (!raw) (0,tracking/* trackInternalNavigationClick */.p)({
                        scope: tracking/* InternalNavigationScope.GRID_LAYOUT_PRODUCT_CARD */.U.GRID_LAYOUT_PRODUCT_CARD,
                        nextPage: product.pathName,
                        index: index
                    });
                },
                product: product,
                hasExpertBadge: !raw && product.isExpertTopRated,
                // Lazy loading is disabled for the first row of images (two first for mobile)
                // to enable images to load before React is loaded. The goal of this strategy
                // is to improve our Lighthouse performance score, and specifically the
                // "Largest Contentful Paint" metric.
                lazyLoadImage: index >= IMAGES_PER_ROW_MOBILE * 2,
                showCategoryButton: showCategoryButton,
                pageType: pageType
            }, productComparisonProps));
        })
    }, /*#__PURE__*/ react.createElement(ads/* Ads */.f, {
        offersLength: products.length,
        layout: types/* LayoutMode.GRID */.X.GRID,
        layoutConfig: adsLayoutConfig
    }), expert && /*#__PURE__*/ react.createElement(advized/* AdvizedCarousel */._, _extends({}, expert, {
        grid: true
    })), hasFeedback && /*#__PURE__*/ react.createElement(StyledFeedbackPrompt, {
        $position: FEEDBACK_PROMPT_ROW_POSITION
    }, feedbackPrompt), mixedContentCards && /*#__PURE__*/ react.createElement(MixedContentCards, {
        currentPage: currentPage,
        items: mixedContentCards,
        productsCount: products.length,
        query: query
    }));
};

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/index.tsx



/***/ }),

/***/ 60:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": () => (/* binding */ PageTypeEnum)
/* harmony export */ });
var PageTypeEnum;
(function(PageTypeEnum) {
    PageTypeEnum["SEARCH"] = "search";
})(PageTypeEnum || (PageTypeEnum = {}));


/***/ }),

/***/ 96772:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_P": () => (/* binding */ trackProductCollectionWordCloudClick),
/* harmony export */   "ds": () => (/* binding */ trackProductCollectionSecondaryNavigationClick),
/* harmony export */   "kQ": () => (/* binding */ trackProductCollectionProductClick)
/* harmony export */ });
/* unused harmony export trackProductCollectionQuickFilterOpen */
/* harmony import */ var _client_data_layer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24005);

/**
 * Tracks when a product collection quick filter panel is opened.
 * @param property Quick filter property
 */ var trackProductCollectionQuickFilterOpen = function(property) {
    pushEvent("productCollectionQuickFilterOpen", {
        property: property
    });
};
/**
 * Tracks when a product in a product collection is clicked.
 * @param productId ID of product clicked
 */ var trackProductCollectionProductClick = function(productId) {
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .AB)("productCollectionProductClick", {
        productId: productId
    });
};
/**
 * Tracks when a link in the secondary navigation in product collection is clicked.
 * @param categoryUrl Url of category clicked
 */ var trackProductCollectionSecondaryNavigationClick = function(categoryUrl) {
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .AB)("productCollectionSecondaryNavigationClick", {
        categoryUrl: categoryUrl
    });
};
/**
 * Tracks when a link in the word cloud in product collection is clicked.
 * @param keywordId Url of keyword clicked
 */ var trackProductCollectionWordCloudClick = function(keywordUrl) {
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .AB)("productCollectionWordCloudClick", {
        keywordUrl: keywordUrl
    });
};


/***/ }),

/***/ 37424:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": () => (/* binding */ isRaw)
/* harmony export */ });
var isRaw = function(variableToCheck) {
    return variableToCheck.__typename === "Raw" || variableToCheck.__typename === "Offer";
};


/***/ }),

/***/ 82968:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AA": () => (/* binding */ trackSearchResultExpertArticleClicked),
/* harmony export */   "fL": () => (/* binding */ trackSearchResultSwitchLayout),
/* harmony export */   "gj": () => (/* binding */ trackSearchNoResultViewed),
/* harmony export */   "yw": () => (/* binding */ trackSearch500ErrorViewed)
/* harmony export */ });
/* harmony import */ var src_client_data_layer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24005);

var trackSearchNoResultViewed = function(value) {
    // Disallow empty strings (bad data) to be sent to this event.
    if (!value) return;
    (0,src_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .AB)("searchNoResultViewed", {
        value: value
    });
};
var trackSearch500ErrorViewed = function(value) {
    // Disallow empty strings (bad data) to be sent to this event.
    if (!value) return;
    (0,src_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .AB)("search500ErrorViewed", {
        value: value
    });
};
var trackSearchResultExpertArticleClicked = function(id, title, type, url, query) {
    (0,src_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .AB)("searchResultExpertArticleClicked", {
        id: id,
        title: title,
        type: type,
        url: url,
        query: query
    });
};
var trackSearchResultSwitchLayout = function(previousLayout, layout) {
    (0,src_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .AB)("LayoutChange", {
        from: previousLayout,
        to: layout
    });
};


/***/ }),

/***/ 69988:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": () => (/* binding */ AdvizedCarousel)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25349);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3616);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89218);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71016);
/* harmony import */ var src_areas_expert_components_list_of_content_cards__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69223);
/* harmony import */ var _tracking__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98864);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33222);
/* harmony import */ var src_ui_block__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84234);
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57735);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}










var MIN_INFO_LIST_COUNT = 5;
var AdvizedContent = function(param) {
    var testsCount = param.testsCount, toplistsCount = param.toplistsCount, guidesCount = param.guidesCount, category = param.category, toplists = param.toplists, tests = param.tests, _numberOfCards = param.numberOfCards, numberOfCards = _numberOfCards === void 0 ? 5 : _numberOfCards, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset, _hideExperts = param.hideExperts, hideExperts = _hideExperts === void 0 ? true : _hideExperts;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il), linkTo = ref.linkTo, renderMode = ref.renderMode, t = ref.t;
    if (!category || !(testsCount || toplistsCount || guidesCount)) return null;
    var content = _toConsumableArray(tests || []).concat(_toConsumableArray(toplists || []));
    var getInfoListItems = function() {
        return [
            toplistsCount ? "".concat(toplistsCount, " ").concat(t("expert", "toplist.lists")) : null,
            testsCount ? "".concat(testsCount, " ").concat(t("expert", "test.tests")) : null,
            guidesCount ? "".concat(guidesCount, " ").concat(t("expert", "guide.guides")) : null
        ].filter(function(item) {
            return item;
        });
    };
    var showInfoList = (toplistsCount !== null && toplistsCount !== void 0 ? toplistsCount : 0) - offset >= MIN_INFO_LIST_COUNT;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .Header */ .h4, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__.H3Text, null, t("expert", "widget.category-page-title")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
        to: linkTo("experts"),
        onClick: function() {
            (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_9__/* .trackInternalNavigationClick */ .p)({
                scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_9__/* .InternalNavigationScope.EXPERT_ADVISE_SHOW_ALL */ .U.EXPERT_ADVISE_SHOW_ALL,
                nextPage: linkTo("experts")
            });
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__.TitleSmallText, {
        color: _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__.FontColor.PRIMARY
    }, t("expert", "widget.category-page-link")))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .Cards */ .oy, null, showInfoList && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .Card */ .Zb, {
        outlined: false
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .CardActionArea */ .MU, {
        container: src_components_clickable__WEBPACK_IMPORTED_MODULE_3__/* .Clickable */ .P,
        containerProps: {
            onClick: function() {
                (0,_tracking__WEBPACK_IMPORTED_MODULE_6__/* .trackCategoryPageExpertCarouselInfoList */ .e)(category.url, "infoList");
                (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_9__/* .trackInternalNavigationClick */ .p)({
                    scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_9__/* .InternalNavigationScope.EXPERT_ADVISE_SHOW_ALL */ .U.EXPERT_ADVISE_SHOW_ALL,
                    nextPage: linkTo("experts")
                });
            },
            to: linkTo("expertCategory", {
                semantic_id: category.url
            }, renderMode === "native" ? {
                view: "native"
            } : undefined)
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .CardBackgroundImage */ .Gl, {
        src: category.descriptionImage || ""
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .CardContent */ .aY, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .Description */ .dk, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, t("expert", "widget.category-page-description", {
        category: category.name.toLowerCase()
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .InfoList */ .Q4, {
        list: getInfoListItems()
    })))))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .ContentCards */ .g1, {
        offset: offset,
        category: category,
        items: content,
        limit: numberOfCards,
        hideExperts: hideExperts,
        trackingSource: src_areas_expert_components_list_of_content_cards__WEBPACK_IMPORTED_MODULE_5__/* .TrackingSource.ADVIZED_WIDGET */ .e.ADVIZED_WIDGET,
        onClick: function(onClickData) {
            return (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_9__/* .trackInternalNavigationClick */ .p)({
                scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_9__/* .InternalNavigationScope.ARTICLE_CONTENT_CARD */ .U.ARTICLE_CONTENT_CARD,
                nextPage: onClickData.url,
                index: onClickData.index
            });
        }
    })));
};
var AdvizedCarousel = function(props) {
    var _isList = props.isList, isList = _isList === void 0 ? true : _isList, grid = props.grid;
    return isList ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_ui_block__WEBPACK_IMPORTED_MODULE_8__/* .MobileOnly */ .iB, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .AdvizedListWrapper */ .hI, {
        grid: grid || false
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(AdvizedContent, _extends({}, props)))) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_ui_block__WEBPACK_IMPORTED_MODULE_8__/* .MediumUp */ .TD, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .Wrapper */ .im, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(AdvizedContent, _extends({}, props))));
};


/***/ }),

/***/ 33222:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gl": () => (/* binding */ CardBackgroundImage),
/* harmony export */   "MU": () => (/* binding */ CardActionArea),
/* harmony export */   "Q4": () => (/* binding */ InfoList),
/* harmony export */   "Zb": () => (/* binding */ Card),
/* harmony export */   "aY": () => (/* binding */ CardContent),
/* harmony export */   "dk": () => (/* binding */ Description),
/* harmony export */   "g1": () => (/* binding */ ContentCards),
/* harmony export */   "h4": () => (/* binding */ Header),
/* harmony export */   "hI": () => (/* binding */ AdvizedListWrapper),
/* harmony export */   "im": () => (/* binding */ Wrapper),
/* harmony export */   "oy": () => (/* binding */ Cards)
/* harmony export */ });
/* unused harmony exports PreTitle, Title */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89695);
/* harmony import */ var src_components_info_list__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29089);
/* harmony import */ var _prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35967);
/* harmony import */ var _areas_expert_components_list_of_content_cards__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69223);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      display: flex;\n      padding: ",
        ";\n      padding-bottom: 0;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    display: none;\n\n    ",
        "\n  }\n\n  a {\n    max-width: max-content;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    height: 100%;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(6, minmax(240px, 1fr));\n  overflow-x: auto;\n  column-gap: ",
        ";\n  padding: ",
        ";\n\n  > * {\n    /* Set a white background color to all cards */\n    background: ",
        ";\n  }\n\n  &::after {\n    /* Adds spacing to the end of the scroll area */\n    content: '';\n    display: block;\n    width: ",
        ";\n    margin-left: -",
        ";\n    pointer-events: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    order: 2;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    grid-area: 4 / 1 / auto / -1;\n    display: grid;\n    background: ",
        ";\n    margin: ",
        " -",
        ";\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      min-width: 25%;\n      flex: 1 1 25%;\n\n      @media screen and (max-width: 820px) and (min-width: 520px) {\n        min-width: 33%;\n        flex: 1 1 33%;\n        order: 2 !important;\n      }\n\n      @media screen and (max-width: 520px) {\n        min-width: 50%;\n        flex: 1 1 50%;\n        order: 1 !important;\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  order: 3;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n      margin-bottom: ",
        ";\n\n      ",
        " {\n        grid-template-columns: repeat(6, minmax(235px, 1fr));\n        padding: ",
        ";\n      }\n\n      ",
        " {\n        display: flex;\n        padding: ",
        ";\n        padding-bottom: 0;\n      }\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        " {\n      overflow-x: hidden;\n    }\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  background: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  background-position: center center;\n  flex: 1 0 auto;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  font-weight: bold;\n  line-height: 1.25;\n  color: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  font-weight: 800;\n  line-height: 1.5;\n  text-transform: uppercase;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-row-gap: ",
        ";\n\n  ",
        " {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 0 auto;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  font-weight: bold;\n  line-height: 1.25;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}






var ContentCards = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_areas_expert_components_list_of_content_cards__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    displayName: "ContentCards",
    componentId: "sc-0-0"
})(_templateObject1(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumUp */ .BC.mediumUp(_templateObject()));
var Header = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_4__.Column).withConfig({
    displayName: "Header",
    componentId: "sc-0-1"
})(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100));
var Cards = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Cards",
    componentId: "sc-0-2"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, function(p) {
    return p.theme.bg.primary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumUp */ .BC.mediumUp(_templateObject4()));
var AdvizedListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].li.withConfig({
    displayName: "AdvizedListWrapper",
    componentId: "sc-0-3"
})(_templateObject9(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject6()), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject7(), function(p) {
    return p.theme.colors.maybeBlue100;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050), function(props) {
    return !props.grid && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject8());
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-4"
})(_templateObject12(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumUp */ .BC.mediumUp(_templateObject10(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200, Cards, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, Header, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.largeUp */ .BC.largeUp(_templateObject11(), Cards));
var Card = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_2__.Card).withConfig({
    displayName: "Card",
    componentId: "sc-0-5"
})(_templateObject13(), function(p) {
    return p.theme.bg.primary;
});
var CardBackgroundImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_2__.CardBackgroundImage).withConfig({
    displayName: "CardBackgroundImage",
    componentId: "sc-0-6"
})(_templateObject14());
var PreTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "PreTitle",
    componentId: "sc-0-7"
})(_templateObject15(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium, function(p) {
    return src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .colorUtils.setRgbaAlpha */ .$n.setRgbaAlpha(p.theme.colors.base0, 0.72);
});
var Title = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "Title",
    componentId: "sc-0-8"
})(_templateObject16(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeLarge */ .bK.measurements.fontSizeLarge);
var CardContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_2__.CardContent).withConfig({
    displayName: "CardContent",
    componentId: "sc-0-9"
})(_templateObject17(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, PreTitle);
var CardActionArea = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_2__.CardActionArea).withConfig({
    displayName: "CardActionArea",
    componentId: "sc-0-10"
})(_templateObject18());
var Description = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Description",
    componentId: "sc-0-11"
})(_templateObject19(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium);
var InfoList = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_info_list__WEBPACK_IMPORTED_MODULE_3__/* .InfoList */ .Q).withConfig({
    displayName: "InfoList",
    componentId: "sc-0-12"
})(_templateObject20(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, function(p) {
    return p.theme.colors.staticBase0;
});


/***/ }),

/***/ 98864:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": () => (/* binding */ trackCategoryPageExpertCarouselInfoList),
/* harmony export */   "t": () => (/* binding */ trackCategoryPageExpertCarouselCard)
/* harmony export */ });
/* harmony import */ var _client_data_layer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24005);

var trackCategoryPageExpertCarouselCard = function(pageUrl, cardType) {
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .AB)("productCollectionExpertCarouselCardClick", {
        pageUrl: pageUrl,
        cardType: cardType
    });
};
var trackCategoryPageExpertCarouselInfoList = function(pageUrl, cardType) {
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .AB)("productCollectionExpertCarouselInfoClick", {
        pageUrl: pageUrl,
        cardType: cardType
    });
};


/***/ }),

/***/ 7688:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ category_description)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(82691);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/user-product-feedback/index.tsx + 1 modules
var user_product_feedback = __webpack_require__(57920);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/components/category-description/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      flex-direction: column;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border-top: 1px solid ",
        ";\n  margin: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  padding: ",
        " 0 0 0;\n  display: flex;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0 0 ",
        " 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  margin: 0;\n  max-width: 600px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var DescriptionContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DescriptionContainer",
    componentId: "sc-0-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.lines.secondary;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* media.smallDown */.BC.smallDown(_templateObject()));
var DescriptionTitle = (0,styled_components_browser_esm["default"])(variants.H2Text).withConfig({
    displayName: "DescriptionTitle",
    componentId: "sc-0-1"
})(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var DescriptionText = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "DescriptionText",
    componentId: "sc-0-2"
})(_templateObject3());
var DescriptionBox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DescriptionBox",
    componentId: "sc-0-3"
})(_templateObject4());
var AliasLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "AliasLink",
    componentId: "sc-0-4"
})(_templateObject5(), function(p) {
    return p.theme.text.linkExternal;
}, function(p) {
    return p.theme.text.linkExternalHover;
});

// EXTERNAL MODULE: ./src/components/user-product-feedback/useFeedbackEnabled.ts
var useFeedbackEnabled = __webpack_require__(52619);
;// CONCATENATED MODULE: ./src/components/category-description/index.tsx






var CategoryDescription = function(param) {
    var name = param.name, description = param.description, aliases = param.aliases, categoryUrl = param.categoryUrl;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var feedbackEnabled = (0,useFeedbackEnabled/* useFeedbackEnabled */.F)();
    var scrollToTop = react.useCallback(function() {
        return window.scroll(0, 0);
    }, []);
    var aliasLinks = react.useMemo(function() {
        if (!aliases) {
            return null;
        }
        var arr = aliases.filter(function(alias) {
            return typeof alias === "string";
        }).filter(// We don't want empty aliases
        function(alias) {
            return alias.trim();
        });
        if (isEmpty_default()(arr)) {
            return null;
        }
        var aliasElements = arr.map(function(alias, index) {
            if (categoryUrl) {
                return /*#__PURE__*/ react.createElement(react.Fragment, {
                    key: alias
                }, /*#__PURE__*/ react.createElement(AliasLink, {
                    to: categoryUrl,
                    onClick: scrollToTop
                }, alias), arr.length > 2 && index < arr.length - 2 && /*#__PURE__*/ react.createElement(react.Fragment, null, ", "));
            }
            return /*#__PURE__*/ react.createElement(react.Fragment, {
                key: alias
            }, /*#__PURE__*/ react.createElement("span", null, alias), arr.length > 2 && index < arr.length - 2 && /*#__PURE__*/ react.createElement(react.Fragment, null, ", "));
        });
        if (aliasElements.length === 1) {
            return t("category", "product-collection.aliases-single", {
                alias: aliasElements[0]
            });
        }
        return t("category", "product-collection.aliases-plural", {
            aliasesExceptLast: aliasElements.slice(0, aliasElements.length - 1),
            last: aliasElements[aliasElements.length - 1]
        });
    }, [
        t,
        aliases,
        categoryUrl,
        scrollToTop
    ]);
    var hasDescriptionOrAliases = !!(description || aliasLinks);
    return /*#__PURE__*/ react.createElement(DescriptionContainer, null, hasDescriptionOrAliases ? /*#__PURE__*/ react.createElement(DescriptionBox, null, name ? /*#__PURE__*/ react.createElement(DescriptionTitle, null, name) : null, /*#__PURE__*/ react.createElement(DescriptionText, {
        containerProps: {
            "data-test": "CategoryDescription"
        }
    }, description, description && aliasLinks && " ", aliasLinks)) : null, feedbackEnabled && /*#__PURE__*/ react.createElement(user_product_feedback/* default */.Z, {
        withLeftMargin: hasDescriptionOrAliases
    }));
};
/* harmony default export */ const category_description = (CategoryDescription);


/***/ }),

/***/ 75318:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": () => (/* binding */ CategoryList)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(7336);
// EXTERNAL MODULE: ./src/components/ads/index.tsx
var ads = __webpack_require__(13261);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(71016);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/category-list/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    width: 56px;\n    height: 56px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  width: 40px;\n  height: 40px;\n  ",
        "\n\n  /* stylelint-disable */\n  image-rendering: -webkit-optimize-contrast;\n  transform: translateZ(0);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    grid-column-gap: ",
        ";\n    grid-row-gap: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      grid-template-columns: repeat(4, 1fr);\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    justify-content: ",
        ";\n    padding: 0;\n    list-style: none;\n    margin-bottom: 0;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.5;\n  letter-spacing: 0;\n  :hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  display: flex;\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        '\n              /* Remove the bottom border as the list of sub-categories constitutes the "bottom" of the box */\n              border-bottom: 1px solid ',
        ";\n              border-bottom-left-radius: 0;\n              border-bottom-right-radius: 0;\n              transition: ",
        ";\n            "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom: none;\n      padding: 0;\n\n      &:hover {\n        ",
        " {\n          ",
        "    \n        }\n\n        > ",
        " {\n          opacity: 1;\n          visibility: visible;\n          background: ",
        ";\n          width: 100%;\n          box-shadow: 0 5px 10px -3px rgba(0, 0, 0, 0.1);\n          border: 1px solid ",
        ";\n          border-top: none;\n          border-radius: 0 0 8px 8px;\n          z-index: 1;\n          transition: ",
        ";\n        }\n      }\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    list-style: none;\n    padding: ",
        ";\n    border-bottom: 1px solid ",
        ";\n    /* Hides the items with display:none instead of not rendering them due to SEO reasons */\n    display: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    order: 99;\n    display: none;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  order: 4;\n  flex-basis: 100%;\n  margin: 0;\n  list-style: none;\n\n  ",
        ";\n\n  > *:not(:empty) {\n    margin: 5px 0;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  list-style: none;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  list-style: none;\n  + ",
        " {\n    margin-top: 10px;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n    border-radius: 8px;\n    padding: ",
        " ",
        "\n    ",
        " ",
        ";\n    border: ",
        ";\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    height: 100%;\n    margin: 0;\n    padding: ",
        " ",
        "\n      ",
        " ",
        ";\n\n    :hover {\n      color: ",
        ";\n    }\n\n    ",
        "\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  padding: 2px 0;\n  color: ",
        ";\n\n  &:hover {\n    text-decoration-line: underline;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n    display: block;\n    position: absolute;\n    background: ",
        ";\n    top: 100%;\n    z-index: 1;\n    visibility: hidden;\n    opacity: 0;\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0;\n  display: none;\n  padding: ",
        ";\n  padding-top: 0;\n\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n    margin: ",
        ";\n  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "grid-column: span 3"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "grid-column: span 4"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n\n  ",
        "\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}




var HOVER_DELAY = 150;
var CategoryImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "CategoryImage",
    componentId: "sc-0-0"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.largeOnly */.BC.largeOnly(_templateObject()));
var StyledCategoryList = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "StyledCategoryList",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), props.$few ? "flex-start" : "space-between", base/* media.mediumUp */.BC.mediumUp(_templateObject2(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing075 */.bK.measurements.spacing075), base/* media.largeUp */.BC.largeUp(_templateObject3()));
});
var TopLevelName = styled_components_browser_esm["default"].span.withConfig({
    displayName: "TopLevelName",
    componentId: "sc-0-2"
})(_templateObject5(), text_variants.FontWeight.HEAVIER, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var TopLevelIcon = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TopLevelIcon",
    componentId: "sc-0-3"
})(_templateObject7(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* media.mediumUp */.BC.mediumUp(_templateObject6()));
var TopLevelItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "TopLevelItem",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject10(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, props.theme.colors.base200, props.$hidden ? "none" : "block", base/* media.mediumUp */.BC.mediumUp(_templateObject9(), TopLevelLink, props.$hasChildren && (0,styled_components_browser_esm.css)(_templateObject8(), props.theme.colors.base0, "border 200ms ease ".concat(HOVER_DELAY, "ms, border-radius 200ms ease ").concat(HOVER_DELAY, "ms")), SubLevelList, props.theme.bg.primary, props.theme.colors.base200, "opacity 200ms ease ".concat(HOVER_DELAY, "ms")));
});
var AdItem = (0,styled_components_browser_esm["default"])(TopLevelItem).withConfig({
    displayName: "AdItem",
    componentId: "sc-0-5"
})(_templateObject12(), base/* media.mediumUp */.BC.mediumUp(_templateObject11()));
var SubLevelItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "SubLevelItem",
    componentId: "sc-0-6"
})(_templateObject13());
var SubLevelItemShowAll = styled_components_browser_esm["default"].li.withConfig({
    displayName: "SubLevelItemShowAll",
    componentId: "sc-0-7"
})(_templateObject14(), SubLevelItem);
var TopLevelLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "TopLevelLink",
    componentId: "sc-0-8"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject16(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
        return p.theme.text.linkInternalHover;
    }, base/* media.mediumUp */.BC.mediumUp(_templateObject15(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, "1px solid ".concat(props.theme.colors.base200)));
});
var SubLevelLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "SubLevelLink",
    componentId: "sc-0-9"
})(_templateObject17(), function(p) {
    return p.theme.text.linkInternal;
});
var SubLevelList = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "SubLevelList",
    componentId: "sc-0-10"
})(_templateObject19(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.mediumUp */.BC.mediumUp(_templateObject18(), function(p) {
    return p.theme.bg.primary;
}));
var ShowMoreButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShowMoreButtonWrapper",
    componentId: "sc-0-11"
})(_templateObject23(), base/* media.smallOnly */.BC.smallOnly(_templateObject20(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100), base/* media.mediumOnly */.BC.mediumOnly(_templateObject21()), base/* media.largeUp */.BC.largeUp(_templateObject22()));

;// CONCATENATED MODULE: ./src/components/category-list/components/category-item-ad.tsx



var CategoryItemAd = function() {
    return /*#__PURE__*/ react.createElement(AdItem, {
        $hasChildren: false
    }, /*#__PURE__*/ react.createElement(ads/* default */.Z, {
        onlyWithServices: [
            "appnexus"
        ],
        placement: "dubbelpanorama1",
        format: "panorama_1",
        min: 0,
        max: 860,
        spacing: {
            bottom: "20px"
        }
    }));
};
/* harmony default export */ const category_item_ad = (CategoryItemAd);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/arrow-right/index.js
var arrow_right = __webpack_require__(86401);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(24005);
;// CONCATENATED MODULE: ./src/components/category-list/utils.ts

var atLeast = function(count) {
    return function(item) {
        return item && Array.isArray(item) && item.length >= count;
    };
};
var atLeastOne = atLeast(1);
var haveChildren = function(item) {
    return atLeastOne(item.children);
};
var MAIN_LINK = "main";
var SUBCATEGORY_LINK = "subcategory";
var SHOW_ALL_LINK = "showAll";
var trackClick = function(category, linkKind) {
    (0,data_layer/* pushEvent */.AB)("categoryListClick", {
        category: category,
        linkKind: linkKind,
        isSubcategory: linkKind === SUBCATEGORY_LINK,
        insideHoverMenu: linkKind !== MAIN_LINK
    });
};

;// CONCATENATED MODULE: ./src/components/category-list/components/category-item-show-all.tsx




var CategoryItemShowAll = function(props) {
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var topLevel = props.item;
    return /*#__PURE__*/ react.createElement(SubLevelItemShowAll, {
        key: "show-all"
    }, topLevel.externalUri && /*#__PURE__*/ react.createElement(SubLevelLink, {
        as: "a",
        href: topLevel.externalUri
    }, t("category", "subcategories.show-all")), !topLevel.externalUri && /*#__PURE__*/ react.createElement(SubLevelLink, {
        to: props.linkToItem(topLevel),
        onClick: function() {
            return trackClick(topLevel, SHOW_ALL_LINK);
        }
    }, t("category", "subcategories.show-all")));
};
/* harmony default export */ const category_item_show_all = (CategoryItemShowAll);

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/components/category-list/components/category-item-children.tsx





var CategoryItemChildren = function(props) {
    var topLevel = props.item;
    var subCategoryMap = props.subCategoryMap, linkToItem = props.linkToItem;
    return haveChildren(topLevel) ? /*#__PURE__*/ react.createElement(SubLevelList, null, subCategoryMap[topLevel.id].map(function(subLevel) {
        return /*#__PURE__*/ react.createElement(SubLevelItem, {
            key: subLevel.id
        }, subLevel.externalUri && /*#__PURE__*/ react.createElement(SubLevelLink, {
            as: "a",
            href: subLevel.externalUri
        }, subLevel.name), !subLevel.externalUri && /*#__PURE__*/ react.createElement(SubLevelLink, {
            to: linkToItem(subLevel),
            onClick: function() {
                trackClick(subLevel, SUBCATEGORY_LINK);
                (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.CATEGORY_LIST_SUB_LVL */.U.CATEGORY_LIST_SUB_LVL,
                    nextPage: linkToItem(subLevel)
                });
            }
        }, subLevel.name));
    }), /*#__PURE__*/ react.createElement(category_item_show_all, {
        item: topLevel,
        linkToItem: linkToItem
    })) : null;
};
/* harmony default export */ const category_item_children = (CategoryItemChildren);

// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
;// CONCATENATED MODULE: ./src/components/category-list/components/sub-links/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: ",
        " 0 ",
        "\n    0;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Root = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Root",
    componentId: "sc-0-0"
})(styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing150 */.bK.measurements.spacing150);

;// CONCATENATED MODULE: ./src/components/category-list/components/sub-links/category-item-sub-links.tsx






var CategoryItemSubLinks = function(props) {
    var topLevel = props.item;
    var subCategoryMap = props.subCategoryMap, linkToItem = props.linkToItem;
    return haveChildren(topLevel) ? /*#__PURE__*/ react.createElement(Root, null, subCategoryMap[topLevel.id].map(function(subLevel) {
        if (!subLevel.externalUri) {
            return /*#__PURE__*/ react.createElement(variants.TonalButton, {
                key: subLevel.id,
                container: clickable/* Clickable */.P,
                containerProps: {
                    to: linkToItem(subLevel)
                },
                onClick: function() {
                    trackClick(subLevel, SUBCATEGORY_LINK);
                    (0,tracking/* trackInternalNavigationClick */.p)({
                        scope: tracking/* InternalNavigationScope.CATEGORY_LIST_SUB_LVL */.U.CATEGORY_LIST_SUB_LVL,
                        nextPage: linkToItem(subLevel)
                    });
                },
                size: variants.ButtonSize.SMALL
            }, subLevel.name);
        }
        return /*#__PURE__*/ react.createElement(variants.TonalButton, {
            key: subLevel.id,
            container: clickable/* Clickable */.P,
            containerProps: {
                to: subLevel.externalUri,
                isExternal: true
            },
            size: variants.ButtonSize.SMALL
        }, subLevel.name);
    })) : null;
};


;// CONCATENATED MODULE: ./src/components/category-list/components/category-item.tsx









var CategoryListItem = function(props) {
    var subCategoryMap = props.subCategoryMap, _displayMobileSubLinks = props.displayMobileSubLinks, displayMobileSubLinks = _displayMobileSubLinks === void 0 ? true : _displayMobileSubLinks, hidden = props.hidden;
    var topLevel = props.item;
    var linkTo = (0,app_context/* useAppContext */.bp)().linkTo;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    // Use pathName if set in order to handle campaign items
    var linkToItem = function(item) {
        return item.pathName || linkTo("category", item);
    };
    var logo = topLevel.logo;
    var logoUrl = typeof logo === "string" ? logo : logo && logo["192"];
    var topLevelIcon = displayMobileSubLinks ? /*#__PURE__*/ react.createElement(TopLevelIcon, null, /*#__PURE__*/ react.createElement(arrow_right/* IconArrowRight */.E, {
        size: 24
    })) : null;
    return /*#__PURE__*/ react.createElement(TopLevelItem, {
        $hasChildren: haveChildren(topLevel),
        $hidden: hidden,
        "data-test": "CategoryListItem",
        "data-test-level": "top"
    }, topLevel.externalUri && /*#__PURE__*/ react.createElement(TopLevelLink, {
        href: topLevel.externalUri,
        as: "a"
    }, topLevel.logo && /*#__PURE__*/ react.createElement(CategoryImage, {
        src: logoUrl,
        alt: "Category Logo"
    }), /*#__PURE__*/ react.createElement(TopLevelName, null, topLevel.name), topLevelIcon), !topLevel.externalUri && /*#__PURE__*/ react.createElement(TopLevelLink, {
        to: linkToItem(topLevel),
        onClick: function() {
            trackClick(topLevel, MAIN_LINK);
            (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.CATEGORY_LIST_TOP_LVL */.U.CATEGORY_LIST_TOP_LVL,
                nextPage: linkToItem(topLevel)
            });
        }
    }, topLevel.logo && /*#__PURE__*/ react.createElement(CategoryImage, {
        src: logoUrl,
        alt: "Category Logo"
    }), /*#__PURE__*/ react.createElement(TopLevelName, null, topLevel.name), topLevelIcon), /*#__PURE__*/ react.createElement(category_item_children, {
        item: topLevel,
        subCategoryMap: subCategoryMap,
        linkToItem: linkToItem
    }), isMobile && displayMobileSubLinks && /*#__PURE__*/ react.createElement(CategoryItemSubLinks, {
        item: topLevel,
        subCategoryMap: subCategoryMap,
        linkToItem: linkToItem
    }));
};
/* harmony default export */ const category_item = (CategoryListItem);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(2600);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
;// CONCATENATED MODULE: ./src/components/category-list/sub-category-map.ts
/* eslint-disable camelcase */ function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var getSubCategoryMap = function(categories, limitSubCategories, displayLinkedCategories) {
    var result = categories.reduce(function(map, param) {
        var id = param.id, children = param.children, path = param.semantic_id;
        if (displayLinkedCategories || typeof path !== "string" || !Array.isArray(children) || !children.length) {
            return _objectSpreadProps(_objectSpread({}, map), _defineProperty({}, id, Array.isArray(children) ? children.slice(0, limitSubCategories) : []));
        }
        // Filter out product collection duplicates
        var uniqueSubCategories = uniqBy_default()(children, function(param) {
            var subCategoryId = param.id, product_collection = param.product_collection;
            return product_collection || subCategoryId;
        });
        /**
       * HACK: Use semantic URL to filter out linked categories
       *
       * Semantic URL will contain a category's true path, so we can use it
       * here to determine if a category is linked (virtual) or in the correct
       * part of the tree.
       *
       * Example:
       * "Memory Cards" is listed under "Phones & GPS" > "Mobile Phone Accessories"
       * (/phones-gps/mobile-phone-accessories--c1307). But from the semantic URL
       * /computers-accessories/storage-media/memory-cards--c156 we can tell that it
       * actually belongs Under "Computers & Accessories" > "Storage Media".
       */ var pathWithoutId = path.replace(/--c\d+$/, "");
        var pathLength = pathWithoutId.length;
        return _objectSpreadProps(_objectSpread({}, map), _defineProperty({}, id, uniqueSubCategories.filter(function(param) {
            var subCategoryPath = param.semantic_id;
            return subCategoryPath.substring(0, pathLength) === pathWithoutId;
        }).slice(0, limitSubCategories)));
    }, {});
    // Special case - categories with only virtual children will become empty
    // In this case we will fall back to display children of linked categories
    if (!displayLinkedCategories) {
        Object.keys(result).forEach(function(key) {
            var subCategories = result[key];
            var category = categories.find(function(param) {
                var id = param.id;
                return id === key;
            });
            if (!subCategories.length && category && Array.isArray(category.children) && category.children.length) {
                // Create list with all other categories children
                var otherSubCategories = Object.keys(result).filter(function(k) {
                    return k !== key;
                }).flatMap(function(k) {
                    return result[k].map(function(param) {
                        var product_collection = param.product_collection, id = param.id;
                        return "".concat(product_collection, "|").concat(id);
                    });
                });
                var subCategoriesWithLinks = category.children.filter(function(param) {
                    var id = param.id, product_collection = param.product_collection;
                    return !otherSubCategories.includes("".concat(product_collection, "|").concat(id));
                });
                result[key] = subCategoriesWithLinks.length ? subCategoriesWithLinks.slice(0, limitSubCategories) : category.children.slice(0, limitSubCategories);
            }
        });
    }
    return result;
};

// EXTERNAL MODULE: ./src/hooks/experiments.ts + 1 modules
var experiments = __webpack_require__(11396);
;// CONCATENATED MODULE: ./src/components/category-list/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}










var category_list_ads = {
    mobileInlineAd1: /*#__PURE__*/ react.createElement(category_item_ad, null)
};
var CategoryList = function(props) {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    var newAdsExperiment = (0,experiments/* useNewAds */.Lf)();
    var _limitCategories = props.limitCategories, limitCategories = _limitCategories === void 0 ? isMobile ? 5 : undefined : _limitCategories, _limitSubCategories = props.limitSubCategories, limitSubCategories = _limitSubCategories === void 0 ? 5 : _limitSubCategories, _withAds = props.withAds, withAds = _withAds === void 0 ? false : _withAds, _displayLinkedCategories = props.displayLinkedCategories, displayLinkedCategories = _displayLinkedCategories === void 0 ? true : _displayLinkedCategories, _displayMobileSubLinks = props.displayMobileSubLinks, displayMobileSubLinks = _displayMobileSubLinks === void 0 ? true : _displayMobileSubLinks, className = props.className;
    var ref = _slicedToArray((0,react.useState)(false), 2), showMoreCategories = ref[0], setShowMoreCategories = ref[1];
    var fewThreshold = 4;
    var categories = props.categories;
    var subCategoryMap = (0,react.useMemo)(function() {
        return getSubCategoryMap(categories, limitSubCategories, displayLinkedCategories);
    }, [
        categories,
        limitSubCategories,
        displayLinkedCategories
    ]);
    var shouldDisplayShowMoreButton = !!limitCategories && categories.length > limitCategories;
    var shouldLimitCategories = shouldDisplayShowMoreButton && !showMoreCategories;
    return atLeastOne(categories) ? /*#__PURE__*/ react.createElement(StyledCategoryList, {
        $few: categories.length < fewThreshold,
        "data-test": "CategoryList",
        className: className
    }, withAds && !newAdsExperiment && category_list_ads.mobileInlineAd1, categories.map(function(topLevel, index) {
        return /*#__PURE__*/ react.createElement(category_item, {
            key: topLevel.id,
            item: topLevel,
            index: index,
            subCategoryMap: subCategoryMap,
            displayMobileSubLinks: displayMobileSubLinks,
            hidden: shouldLimitCategories && index >= limitCategories
        });
    }), shouldDisplayShowMoreButton && /*#__PURE__*/ react.createElement(ShowMoreButtonWrapper, null, /*#__PURE__*/ react.createElement(variants.TonalButton, {
        fullWidth: isMobile,
        onClick: function() {
            return setShowMoreCategories(!showMoreCategories);
        }
    }, showMoreCategories ? t("category", "category-limit.show-less") : t("category", "category-limit.show-more")))) : null;
};



/***/ }),

/***/ 62960:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ compare_products_basket)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(95242);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(37702);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(95088);
// EXTERNAL MODULE: ./src/components/product-row/index.tsx + 1 modules
var product_row = __webpack_require__(24562);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(92873);
;// CONCATENATED MODULE: ./src/components/compare-products-basket/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    width: 760px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  max-height: 70vh;\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  position: fixed;\n  bottom: 0;\n  z-index: ",
        ";\n  max-width: ",
        ";\n  box-shadow: 0 0 2px rgba(0, 0, 0, 0.15);\n\n  ",
        "\n\n  @supports (position: sticky) {\n    position: sticky;\n    width: 100%;\n    left: calc(\n      ",
        " +\n        ",
        "\n    );\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  background-color: ",
        ";\n  padding: 10px;\n  cursor: pointer;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: 10px;\n\n  svg {\n    display: block;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 5px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n  border-bottom: 1px solid ",
        ";\n  padding: 5px 10px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 12px;\n  font-style: italic;\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 12px;\n  font-weight: 600;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 0 ",
        ";\n  padding-bottom: ",
        ";\n  box-sizing: border-box;\n  transition: max-height 0.15s\n    ",
        ";\n  overflow: hidden;\n  overflow-y: auto;\n  max-height: ",
        "px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    min-height: unset;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}





var productRowHeight = 55;
var FlexWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FlexWrapper",
    componentId: "sc-0-0"
})(_templateObject());
// Use position: sticky when supported
// otherwise fallback to position: fixed
// and set specific width for desktop viewport size
var Container = styled_components_browser_esm["default"].div.attrs({
    "data-test": "CompareProductsBasket"
}).withConfig({
    displayName: "Container",
    componentId: "sc-0-1"
})(_templateObject2(), zindex/* zindex.menu.sticky.background.isSticky */.Y.menu.sticky.background.isSticky, base/* layout.siteWidth.rem */.bK.siteWidth.rem, base/* media.largeUp */.BC.largeUp(_templateObject1()), base/* layout.sidebarMenuWidth.desktop.rem */.bK.sidebarMenuWidth.desktop.rem, function(p) {
    return p.sidebarOpen ? base/* layout.sidebarContentWidth.desktop.rem */.bK.sidebarContentWidth.desktop.rem : "0px";
});
var Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-2"
})(_templateObject3(), function(p) {
    return p.theme.colors.yellove500;
});
var ExpandIcon = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExpandIcon",
    componentId: "sc-0-3"
})(_templateObject4());
var ClearButton = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).withConfig({
    displayName: "ClearButton",
    componentId: "sc-0-4"
})(_templateObject5());
var ProductDeleteButton = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).withConfig({
    displayName: "ProductDeleteButton",
    componentId: "sc-0-5"
})(_templateObject6());
var InfoBar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InfoBar",
    componentId: "sc-0-6"
})(_templateObject7(), function(p) {
    return p.theme.colors.base200;
});
var InfoText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InfoText",
    componentId: "sc-0-7"
})(_templateObject8(), function(p) {
    return p.theme.colors.base600;
});
var ProductCount = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductCount",
    componentId: "sc-0-8"
})(_templateObject9());
var ProductWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductWrapper",
    componentId: "sc-0-9"
})(_templateObject10(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(props) {
    return props.expanded ? base/* layout.measurements.spacing100 */.bK.measurements.spacing100 : 0;
}, function(props) {
    return props.expanded ? "ease-out" : "ease-in";
}, function(props) {
    return props.expanded ? props.count * productRowHeight + productRowHeight : 0;
});
var ProductRow = (0,styled_components_browser_esm["default"])(product_row/* default */.Z).withConfig({
    displayName: "ProductRow",
    componentId: "sc-0-10"
})(_templateObject11());


// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-down/index.js
var chevron_down = __webpack_require__(70796);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-up/index.js
var chevron_up = __webpack_require__(912);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(15309);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/compare/index.js
var compare = __webpack_require__(19975);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(7336);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
;// CONCATENATED MODULE: ./src/components/compare-products-basket/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}











var CompareProductsBasket = function(param) {
    var products = param.products, compareUrl = param.compareUrl, onEmpty = param.onEmpty, onProductDelete = param.onProductDelete;
    var ref = _slicedToArray((0,react.useState)(false), 2), expanded = ref[0], setExpanded = ref[1];
    var toggleExpanded = (0,react.useCallback)(function() {
        return setExpanded(!expanded);
    }, [
        expanded
    ]);
    var stopPropagation = function(e) {
        e.stopPropagation();
    };
    var productsWithImage = (0,react.useMemo)(function() {
        return products.map(function(product) {
            return _objectSpreadProps(_objectSpread({}, product), {
                image: /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                    name: product.name,
                    src: product.media.first || ""
                })
            });
        });
    }, [
        products
    ]);
    var isSidebarOpen = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.sidebar.tab != null && state.areas.sidebar.tab !== "none";
    });
    return /*#__PURE__*/ react.createElement(Container, {
        sidebarOpen: isSidebarOpen
    }, /*#__PURE__*/ react.createElement(Header, {
        onClick: toggleExpanded
    }, /*#__PURE__*/ react.createElement(FlexWrapper, null, /*#__PURE__*/ react.createElement(ExpandIcon, null, expanded ? /*#__PURE__*/ react.createElement(chevron_down/* IconChevronDown */.C, null) : /*#__PURE__*/ react.createElement(chevron_up.IconChevronUp, null)), products.length === 0 ? /*#__PURE__*/ react.createElement(InfoText, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "product"
    }, "product-compare.choose-products")) : /*#__PURE__*/ react.createElement(ProductCount, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "lists",
        n: products.length
    }, "list.n-products"))), /*#__PURE__*/ react.createElement(variants.OutlinedButton, {
        onClick: stopPropagation,
        container: products.length < 2 ? "button" : react_router_dom/* Link */.rU,
        disabled: true // Won't affect the link ☝️
        ,
        containerProps: {
            "data-test": "CompareButton",
            to: compareUrl
        },
        style: {
            backgroundColor: "white"
        }
    }, /*#__PURE__*/ react.createElement(variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(compare/* IconCompare */.P, {
        size: 18
    })), /*#__PURE__*/ react.createElement(variants.ButtonText, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "product"
    }, "product-compare.compare")))), /*#__PURE__*/ react.createElement(ProductWrapper, {
        count: products.length,
        expanded: expanded
    }, /*#__PURE__*/ react.createElement(InfoBar, null, products.length < 2 && /*#__PURE__*/ react.createElement(InfoText, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "product"
    }, "product-compare.choose-more-products")), /*#__PURE__*/ react.createElement(ClearButton, {
        variant: "text",
        color: "link",
        onClick: onEmpty
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "product"
    }, "product-compare.cancel-compare"))), productsWithImage.map(function(product) {
        return /*#__PURE__*/ react.createElement(CompareProductsBasketRow, {
            key: product.id,
            product: product,
            onProductDelete: onProductDelete
        });
    })));
};
var CompareProductsBasketRow = function(param) {
    var product = param.product, onProductDelete = param.onProductDelete;
    var productImage = (0,react.useMemo)(function() {
        return /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
            name: product.name,
            src: product.media.first || ""
        });
    }, [
        product.name,
        product.media.first
    ]);
    var onProductClick = (0,react.useCallback)(function(e) {
        return e.preventDefault();
    }, []);
    var onDelete = (0,react.useCallback)(function() {
        return onProductDelete(product.id);
    }, [
        onProductDelete,
        product.id
    ]);
    return /*#__PURE__*/ react.createElement(ProductRow, {
        key: product.id,
        link: product.pathName,
        onClick: onProductClick,
        name: product.name,
        image: productImage,
        price: product.priceSummary.regular || product.priceSummary.alternative,
        showDivider: true
    }, /*#__PURE__*/ react.createElement(ProductDeleteButton, {
        size: "small",
        variant: "icon",
        color: "primary",
        icon: /*#__PURE__*/ react.createElement(icon_close.IconClose, null),
        onClick: onDelete
    }));
};
/* harmony default export */ const compare_products_basket = (CompareProductsBasket);


/***/ }),

/***/ 25687:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ compare_products_toggle)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(7336);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/compare/index.js
var compare = __webpack_require__(19975);
// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(84234);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(714);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(54262);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/compare-products-toggle/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  align-self: stretch;\n  outline: none;\n  cursor: pointer;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n      box-shadow: 0 0 0 1px ",
        ";\n      color: ",
        ";\n\n      &:active,\n      &:hover,\n      &:focus {\n        background-color: ",
        ";\n        box-shadow: 0 0 0 1px ",
        ";\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  background-color: transparent;\n  ",
        ";\n\n  ",
        ";\n\n  & > span {\n    flex-grow: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  padding: 0 ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: block;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  width: 32px;\n\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var sharedCompareButtonStyled = (0,styled_components_browser_esm.css)(_templateObject());
var CompareProductButtonMobile = (0,styled_components_browser_esm["default"])(variants.OutlinedButton).attrs({
    "data-test": "CompareProductButtonMobile"
}).withConfig({
    displayName: "CompareProductButtonMobile",
    componentId: "sc-0-0"
})(_templateObject2(), sharedCompareButtonStyled, function(props) {
    return props.$selected && (0,styled_components_browser_esm.css)(_templateObject1(), props.theme.bg.productCompare, props.theme.bg.productCompare, props.theme.text.primary, props.theme.bg.productCompare, props.theme.bg.productCompare, props.theme.text.primary);
});
var CompareProductButtonDesktop = styled_components_browser_esm["default"].button.attrs({
    "data-test": "CompareProductButtonDesktop"
}).withConfig({
    displayName: "CompareProductButtonDesktop",
    componentId: "sc-0-1"
})(_templateObject3(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, sharedCompareButtonStyled);
var Title = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Title",
    componentId: "sc-0-2"
})(_templateObject5(), base/* media.mediumDown */.BC.mediumDown(_templateObject4()));
var CompareIconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CompareIconWrapper",
    componentId: "sc-0-3"
})(_templateObject6(), function(param) {
    var theme = param.theme, active = param.active;
    return active ? theme.bg.productCompare : "transparent";
}, base/* layout.borderRadius */.bK.borderRadius, function(param) {
    var theme = param.theme, active = param.active;
    return active ? theme.colors.base700 : theme.icons.callToAction;
}, function(param) {
    var theme = param.theme, active = param.active;
    return active ? theme.colors.base700 : theme.icons.callToActionHover;
});


;// CONCATENATED MODULE: ./src/components/compare-products-toggle/index.tsx








var CompareProductsToggle = function(param) {
    var active = param.active, activate = param.activate, className = param.className, deactivate = param.deactivate, _showTitle = param.showTitle, showTitle = _showTitle === void 0 ? true : _showTitle;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var label = active ? t("product", "product-compare.cancel-compare") : t("product", "product-compare.choose-products");
    return /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        placement: ui/* Direction.Left */.Nm.Left,
        title: label,
        className: className
    }, /*#__PURE__*/ react.createElement(block/* MediumDown */.H5, null, /*#__PURE__*/ react.createElement(CompareProductButtonMobile, {
        ariaLabel: label,
        onClick: active ? deactivate : activate,
        $selected: active
    }, /*#__PURE__*/ react.createElement(variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(compare/* IconCompare */.P, {
        size: 24
    })), showTitle && /*#__PURE__*/ react.createElement(variants.ButtonText, null, t("product", "product-compare.compare")))), /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, /*#__PURE__*/ react.createElement(CompareProductButtonDesktop, {
        onClick: active ? deactivate : activate,
        "aria-label": label
    }, /*#__PURE__*/ react.createElement(CompareIconWrapper, {
        active: active
    }, /*#__PURE__*/ react.createElement(compare/* IconCompare */.P, {
        size: 24
    })))));
};
/* harmony default export */ const compare_products_toggle = (/*#__PURE__*/(0,react.memo)(CompareProductsToggle));


/***/ }),

/***/ 28839:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": () => (/* reexport */ DropdownItem)
});

// UNUSED EXPORTS: SharedListItemStyles

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/dropdown-item/dropdown-item.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: ",
        " ",
        ";\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  svg {\n    margin-right: ",
        ";\n  }\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var SharedListItemStyles = (0,styled_components_browser_esm.css)(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.dropdowns.secondary.hoverBackground;
});
var DropdownItem = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "DropdownItem",
    componentId: "sc-0-0"
})(_templateObject1(), SharedListItemStyles);

;// CONCATENATED MODULE: ./src/components/dropdown-item/index.ts



/***/ }),

/***/ 83068:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": () => (/* binding */ FeaturedArticle)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/areas/campaign/components/campaign-group/index.js + 1 modules
var campaign_group = __webpack_require__(13066);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(89695);
;// CONCATENATED MODULE: ./src/components/featured-article/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    margin-right: ",
        ";\n    padding-right: ",
        ";\n    flex: 1 0 70%;\n      max-width: 70%;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 1 0 640px;\n    max-width: 640px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  flex: 1 0 100%;\n  max-width: 100%;\n  margin-right: 0;\n  padding-right: 0;\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 1;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      flex: 1 0 100%;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 0 100%;\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  > * {\n    margin-bottom: 1rem;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: 185px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var StyledArticle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledArticle",
    componentId: "sc-0-0"
})(_templateObject2(), base/* layout.measurements.spacing300 */.bK.measurements.spacing300, base/* media.mediumUp */.BC.mediumUp(_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing150 */.bK.measurements.spacing150), base/* media.largeUp */.BC.largeUp(_templateObject1()));
var RelatedArticleContainer = styled_components_browser_esm["default"].section.withConfig({
    displayName: "RelatedArticleContainer",
    componentId: "sc-0-1"
})(_templateObject5(), base/* media.mediumUp */.BC.mediumUp(_templateObject3()), function(p) {
    return p.fullWidth && (0,styled_components_browser_esm.css)(_templateObject4());
});
var StyledFeaturedArticle = styled_components_browser_esm["default"].section.withConfig({
    displayName: "StyledFeaturedArticle",
    componentId: "sc-0-2"
})(_templateObject6(), base/* layout.measurements.spacing300 */.bK.measurements.spacing300);
var RelatedArticleWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RelatedArticleWrapper",
    componentId: "sc-0-3"
})(_templateObject7());
var StyledCardMedia = (0,styled_components_browser_esm["default"])(card.CardMedia).withConfig({
    displayName: "StyledCardMedia",
    componentId: "sc-0-4"
})(_templateObject8());

;// CONCATENATED MODULE: ./src/components/article/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n    margin-bottom: 1.2rem;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-size: 1.6rem;\n  line-height: 1.4;\n  margin: 0 0 1rem;\n\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n    h4 {margin-bottom: 1.4rem;}\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-size: 1.15rem;\n  color: ",
        ";\n\n  figure {\n    margin-bottom: 1rem;\n    img {\n      display: block;\n      margin: 0 auto;\n      max-width: 100%;\n    }\n    figcaption {\n      color: ",
        ";\n      text-align: right;\n    }\n  }\n  ",
        " {\n    font-size: 1.6rem;\n  }\n  h2 {\n    font-size: 1.3rem;\n  }\n  h3 {\n    font-size: 1.15rem;\n  }\n  h4 {\n    margin-bottom: 1rem;\n  }\n  ol,\n  ul {\n    list-style-position: inside;\n    line-height: 1.6;\n  }\n  p {\n    line-height: 1.6;\n  }\n  a {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n  .caption {\n    text-align: right;\n  }\n\n  ",
        "\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-size: 1.15rem;\n  font-weight: 600;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var StyledArticleHeading = styled_components_browser_esm["default"].h1.withConfig({
    displayName: "StyledArticleHeading",
    componentId: "sc-0-0"
})(styles_templateObject1(), base/* media.largeUp */.BC.largeUp(styles_templateObject()));
var styles_StyledArticle = styled_components_browser_esm["default"].article.withConfig({
    displayName: "StyledArticle",
    componentId: "sc-0-1"
})(styles_templateObject3(), function(p) {
    return p.theme.text.primary;
}, function(p) {
    return p.theme.text.secondary;
}, StyledArticleHeading, function(p) {
    return p.theme.text.linkExternal;
}, base/* media.largeUp */.BC.largeUp(styles_templateObject2()));
var Preamble = styled_components_browser_esm["default"].p.withConfig({
    displayName: "Preamble",
    componentId: "sc-0-2"
})(styles_templateObject4());

;// CONCATENATED MODULE: ./src/components/article/article-heading.tsx


var ArticleHeading = function(param) {
    var title = param.title, _embedded = param.embedded, embedded = _embedded === void 0 ? false : _embedded;
    return embedded ? /*#__PURE__*/ react.createElement(StyledArticleHeading, {
        as: "h2"
    }, title) : /*#__PURE__*/ react.createElement(StyledArticleHeading, null, title);
};

// EXTERNAL MODULE: ./src/components/lazy/index.tsx
var lazy = __webpack_require__(85518);
;// CONCATENATED MODULE: ./src/components/article/article.tsx
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var Article = function(_param) {
    var _embedded = _param.embedded, embedded = _embedded === void 0 ? true : _embedded, props = _objectWithoutProperties(_param, [
        "embedded"
    ]);
    return /*#__PURE__*/ react.createElement(styles_StyledArticle, null, props.imageUrl && /*#__PURE__*/ react.createElement("figure", null, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
        loadOnIdle: true
    }, /*#__PURE__*/ react.createElement("img", {
        src: props.imageUrl,
        alt: props.imageCaption || ""
    })), props.imageCaption && /*#__PURE__*/ react.createElement("figcaption", null, props.imageCaption)), /*#__PURE__*/ react.createElement(ArticleHeading, {
        title: props.title,
        embedded: embedded
    }), props.preamble && /*#__PURE__*/ react.createElement(Preamble, null, props.preamble), props.body && /*#__PURE__*/ react.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: props.body
        }
    }), props.byline && /*#__PURE__*/ react.createElement("span", null, props.byline));
};

// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./src/areas/expert/styles.ts
var styles = __webpack_require__(96674);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/components/featured-article/related-article.tsx








var RelatedArticle = function(param) {
    var article = param.article, _preambleMaxLength = param.preambleMaxLength, preambleMaxLength = _preambleMaxLength === void 0 ? 80 : _preambleMaxLength;
    return /*#__PURE__*/ react.createElement(card.Card, null, /*#__PURE__*/ react.createElement(card.CardActionArea, {
        container: clickable/* Clickable */.P,
        containerProps: {
            to: article.pathName,
            onClick: function() {
                return (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.RELATED_ARTICLE */.U.RELATED_ARTICLE,
                    nextPage: article.pathName
                });
            }
        }
    }, article.imageUrl && /*#__PURE__*/ react.createElement(StyledCardMedia, null, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
        loadOnIdle: true
    }, /*#__PURE__*/ react.createElement("img", {
        alt: article.title,
        src: article.imageUrl,
        height: 124
    }))), /*#__PURE__*/ react.createElement(card.CardContent, null, /*#__PURE__*/ react.createElement(styles/* CardTitle */.ll, null, article.title), article.preamble && /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        container: "p"
    }, formatPreamble(article.preamble, preambleMaxLength)))));
};
function formatPreamble(str, maxLength) {
    return str && str.length > maxLength ? "".concat(str.substr(0, str.substr(0, maxLength).lastIndexOf(" ")).trim(), "\xa0…") : str;
}

;// CONCATENATED MODULE: ./src/components/featured-article/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}





var FeaturedArticle = function(param) {
    var article = param.article, _embedded = param.embedded, embedded = _embedded === void 0 ? true : _embedded, _related = param.related, related = _related === void 0 ? [] : _related;
    var ref;
    var articleId = article ? article.id : null;
    var relatedArticles = (article && article.related && article.related.articles ? related.concat(article.related.articles) : related).filter(Boolean).filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.id) !== articleId;
    }).sort(function(a, b) {
        return new Date((b === null || b === void 0 ? void 0 : b.publishedAt) || "1971-1-1").getTime() - new Date((a === null || a === void 0 ? void 0 : a.publishedAt) || "1971-1-1").getTime();
    });
    return /*#__PURE__*/ react.createElement(StyledFeaturedArticle, null, !!article && /*#__PURE__*/ react.createElement(StyledArticle, null, /*#__PURE__*/ react.createElement(Article, _extends({}, article, {
        embedded: embedded
    }))), /*#__PURE__*/ react.createElement(RelatedArticleContainer, {
        fullWidth: !article
    }, /*#__PURE__*/ react.createElement(RelatedArticleWrapper, null, relatedArticles.map(function(item) {
        return /*#__PURE__*/ react.createElement(RelatedArticle, {
            key: item.id,
            article: item
        });
    })), (article === null || article === void 0 ? void 0 : (ref = article.related) === null || ref === void 0 ? void 0 : ref.campaign) && /*#__PURE__*/ react.createElement(campaign_group/* default */.Z, {
        campaigns: [
            article.related.campaign
        ]
    })));
};


/***/ }),

/***/ 57737:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony exports ActionBar, ProductCount */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94141);
/* harmony import */ var src_components_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95088);
/* harmony import */ var src_components_translate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37702);
/* harmony import */ var _prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35967);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55586);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  color: ",
        ";\n  width: 100%;\n  padding: 10px;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  z-index: 100;\n\n  /* Set explicit height in order to account for that height in the wrapper */\n  height: ",
        "px;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var ApplyFilterButton = function(param) {
    var _count = param.count, count = _count === void 0 ? 0 : _count, _hasFiltered = param.hasFiltered, hasFiltered = _hasFiltered === void 0 ? true : _hasFiltered, onClick = param.onClick, onClear = param.onClear, _canClear = param.canClear, canClear = _canClear === void 0 ? true : _canClear;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActionBar, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_5__.Column, {
        gap: parseFloat(src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050)
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductCount, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_translate__WEBPACK_IMPORTED_MODULE_4__/* .Translate */ .v, {
        domain: "filter",
        n: count
    }, "result.n-products")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_5__.GridRow, {
        gap: parseFloat(src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050)
    }, onClear && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
        color: "tertiary",
        variant: "outlined",
        onClick: onClear,
        disabled: !canClear
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_translate__WEBPACK_IMPORTED_MODULE_4__/* .Translate */ .v, {
        domain: "filter"
    }, "button.clear-filter")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
        color: "primary",
        onClick: onClick,
        disabled: !hasFiltered
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_translate__WEBPACK_IMPORTED_MODULE_4__/* .Translate */ .v, {
        domain: "filter"
    }, "button.apply-filter")))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ApplyFilterButton);
var ActionBar = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "ActionBar",
    componentId: "sc-0-0"
})(_templateObject1(), function(p) {
    return p.theme.actionBar.bg;
}, function(p) {
    return p.theme.actionBar.boxShadow;
}, function(p) {
    return p.theme.actionBar.fg;
}, _constants__WEBPACK_IMPORTED_MODULE_6__/* .applyFilterAreaHeight */ .e, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.largeUp */ .BC.largeUp(_templateObject()));
var ProductCount = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "ProductCount",
    componentId: "sc-0-1"
})(_templateObject2());


/***/ }),

/***/ 55586:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": () => (/* binding */ applyFilterAreaHeight)
/* harmony export */ });
var applyFilterAreaHeight = 90;


/***/ }),

/***/ 91441:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": () => (/* binding */ ListItem)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40889);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



var ListItem = function(param) {
    var children = param.children, name = param.name, link = param.link, image = param.image, callToActionText = param.callToActionText, showArrow = param.showArrow, showBackArrow = param.showBackArrow, _onClick = param.onClick, onClick = _onClick === void 0 ? src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT : _onClick, className = param.className, isExternal = param.isExternal, linkAttributes = param.linkAttributes, dataTest = param["data-test"], disabled = param.disabled;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .ListItem */ .HC, _extends({
        onClick: onClick,
        className: className,
        to: link,
        isExternal: isExternal
    }, linkAttributes || {}, {
        "data-test": dataTest,
        disabled: disabled
    }), showBackArrow && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .LeftArrow */ .IT, null), image && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, null, image), children, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Name */ .VG, null, name), callToActionText && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .CallToAction */ .Jd, null, callToActionText), showArrow && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RightArrow */ .UV, null));
};


/***/ }),

/***/ 40889:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": () => (/* binding */ Image),
/* harmony export */   "HC": () => (/* binding */ ListItem),
/* harmony export */   "IT": () => (/* binding */ LeftArrow),
/* harmony export */   "Jd": () => (/* binding */ CallToAction),
/* harmony export */   "UV": () => (/* binding */ RightArrow),
/* harmony export */   "VG": () => (/* binding */ Name)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var _prisjakt_ui_icon_chevron_left__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22062);
/* harmony import */ var _prisjakt_ui_icon_chevron_right__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46695);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89218);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71016);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      cursor: default;\n      opacity: 0.5;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  cursor: pointer;\n  min-height: 48px;\n  padding: ",
        " ",
        ";\n  text-align: left;\n  display: flex;\n  align-items: center;\n\n  /* Set the width and box-sizing to account for inconsistencies between <button> and <a> */\n  box-sizing: border-box;\n  width: 100%;\n\n  &:hover,\n  &.focus-visible {\n    background-color: ",
        ";\n    outline: 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  flex: 0 1 50%;\n  margin-left: ",
        ";\n  overflow: hidden;\n  text-align: right;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  margin-left: ",
        ";\n  path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  margin-right: ",
        ";\n  path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var padding = src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050;
var ListItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_clickable__WEBPACK_IMPORTED_MODULE_3__/* .Clickable */ .P).withConfig({
    displayName: "ListItem",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.theme.text.primary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025, padding, function(props) {
    return props.theme.bg.secondary;
}, function(props) {
    return props.disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject());
});
var Image = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Image",
    componentId: "sc-0-1"
})(_templateObject2(), padding);
var Name = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__.TitleSmallText).withConfig({
    displayName: "Name",
    componentId: "sc-0-2"
})(_templateObject3());
var CallToAction = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "CallToAction",
    componentId: "sc-0-3"
})(_templateObject4(), function(props) {
    return props.theme.text.callToAction;
}, padding);
var RightArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_right__WEBPACK_IMPORTED_MODULE_2__.IconChevronRight).attrs({
    size: 20
}).withConfig({
    displayName: "RightArrow",
    componentId: "sc-0-4"
})(_templateObject5(), padding);
var LeftArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_left__WEBPACK_IMPORTED_MODULE_1__.IconChevronLeft).attrs({
    size: 20
}).withConfig({
    displayName: "LeftArrow",
    componentId: "sc-0-5"
})(_templateObject6(), padding);


/***/ }),

/***/ 49192:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": () => (/* binding */ NumberPagination)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./src/components/number-pagination/pagination-items.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function notNull(item) {
    return item !== null;
}
function getPrevPageItem(currentPage, alwaysShowStepButtons) {
    if (currentPage === 1 && !alwaysShowStepButtons) {
        return null;
    }
    return {
        type: "prev",
        pageNumber: currentPage - 1,
        disabled: currentPage === 1
    };
}
function getFirstPageItem(nearbyPages) {
    var _Math;
    var firstNearbyPage = (_Math = Math).min.apply(_Math, _toConsumableArray(nearbyPages));
    if (firstNearbyPage === 1) {
        return null;
    }
    return {
        type: "first",
        pageNumber: 1,
        indicateOmittedPages: firstNearbyPage > 2 ? "after" : undefined
    };
}
function getNearbyPages(currentPage, totalPages) {
    var from = Math.max(1, Math.min(totalPages - 4, currentPage - 2));
    var to = Math.min(totalPages, Math.max(5, currentPage + 2));
    var pages = [];
    for(var i = from; i <= to; i += 1){
        var page = {
            type: "nearby-page",
            pageNumber: i,
            isCurrent: currentPage === i
        };
        if ([
            from,
            to
        ].includes(i) && !page.isCurrent) {
            page.omitOnSmallDevices = true;
        }
        pages.push(page);
    }
    return pages;
}
var getMidrangePage = function(position, nearbyPages, totalPages) {
    var _Math, _Math1;
    var threshold = 5;
    var firstNearbyPage = (_Math = Math).min.apply(_Math, _toConsumableArray(nearbyPages));
    var lastNearByPage = (_Math1 = Math).max.apply(_Math1, _toConsumableArray(nearbyPages));
    switch(position){
        case "before":
            if (firstNearbyPage < threshold) {
                return null;
            }
            return {
                type: "midrange",
                pageNumber: Math.ceil(firstNearbyPage / 2),
                indicateOmittedPages: "after"
            };
        case "after":
            if (lastNearByPage + threshold > totalPages) {
                return null;
            }
            return {
                type: "midrange",
                pageNumber: Math.floor((totalPages - lastNearByPage) / 2) + lastNearByPage,
                indicateOmittedPages: "before"
            };
        default:
            return null;
    }
};
function getLastPageItem(nearbyPages, totalPages) {
    var _Math;
    var lastNearbyPage = (_Math = Math).max.apply(_Math, _toConsumableArray(nearbyPages));
    if (lastNearbyPage === totalPages) {
        return null;
    }
    return {
        type: "last",
        pageNumber: totalPages,
        indicateOmittedPages: lastNearbyPage < totalPages - 1 ? "before" : undefined
    };
}
function getNextPageItem(currentPage, totalPages, alwaysShowStepButtons) {
    if (currentPage === totalPages && !alwaysShowStepButtons) {
        return null;
    }
    return {
        type: "next",
        pageNumber: currentPage + 1,
        disabled: currentPage === totalPages
    };
}
function getPaginationItems(currentPage, totalPages) {
    var ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _alwaysShowStepButtons = ref.alwaysShowStepButtons, alwaysShowStepButtons = _alwaysShowStepButtons === void 0 ? false : _alwaysShowStepButtons;
    if (totalPages <= 1) {
        return [];
    }
    var clampedCurrentPage = Math.max(1, Math.min(totalPages, currentPage));
    var nearbyPages = getNearbyPages(clampedCurrentPage, totalPages);
    var nearbyPageNrs = nearbyPages.map(function(page) {
        return page.pageNumber;
    });
    return [
        getPrevPageItem(clampedCurrentPage, alwaysShowStepButtons),
        getFirstPageItem(nearbyPageNrs),
        getMidrangePage("before", nearbyPageNrs, totalPages)
    ].concat(_toConsumableArray(nearbyPages), [
        getMidrangePage("after", nearbyPageNrs, totalPages),
        getLastPageItem(nearbyPageNrs, totalPages),
        getNextPageItem(clampedCurrentPage, totalPages, alwaysShowStepButtons)
    ]).filter(notNull);
}

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/number-pagination/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  list-style: none;\n  margin: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      margin-left: ",
        ";\n      margin-right: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n\n    ",
        "\n\n    @media screen and (max-width: 420px) {\n      ",
        "\n\n      @media screen and (max-width: 350px) {\n        margin: 0 ",
        " 0 0;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      padding: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  border-radius: 8px;\n  display: flex;\n  font-weight: 600;\n  height: 30px;\n  justify-content: center;\n  min-width: 30px;\n  padding: ",
        ";\n  transition: all ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  color: ",
        ";\n\n  &:hover,\n  &.focus-visible {\n    background: ",
        ";\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  box-shadow: ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n  cursor: default;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  background: ",
        ";\n  color: ",
        ";\n  cursor: default;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var measurements = base/* layout.measurements */.bK.measurements, animations = base/* layout.animations */.bK.animations;
var Pagination = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "Pagination",
    componentId: "sc-0-0"
})(_templateObject());
var PaginationListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "PaginationListItem",
    componentId: "sc-0-1"
})(function(param) {
    var indicateOmittedPages = param.indicateOmittedPages, omitOnSmallDevices = param.omitOnSmallDevices;
    return (0,styled_components_browser_esm.css)(_templateObject2(), indicateOmittedPages === "before" ? measurements.spacing150 : 0, indicateOmittedPages === "after" ? measurements.spacing150 : measurements.spacing025, base/* media.smallOnly */.BC.smallOnly(_templateObject1(), indicateOmittedPages === "before" ? measurements.spacing050 : 0, indicateOmittedPages === "after" ? measurements.spacing050 : measurements.spacing025), omitOnSmallDevices ? "display: none;" : "", measurements.spacing025);
});
var paginationLinkStyles = (0,styled_components_browser_esm.css)(_templateObject4(), measurements.spacing050, animations.buttonTransition, base/* media.smallOnly */.BC.smallOnly(_templateObject3(), measurements.spacing025));
var PaginationLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "PaginationLink",
    componentId: "sc-0-2"
})(_templateObject5(), paginationLinkStyles, function(props) {
    return props.theme.colors.base800;
}, function(props) {
    return props.theme.colors.base200;
}, function(props) {
    return "transparent 0px 0px ".concat(props.theme.colors.base800, " 0px 0px 0px 1px");
});
var DisabledPaginationLink = styled_components_browser_esm["default"].span.withConfig({
    displayName: "DisabledPaginationLink",
    componentId: "sc-0-3"
})(_templateObject6(), paginationLinkStyles, function(props) {
    return "inset 0 0 0 1px ".concat(props.theme.lines.primary);
}, function(props) {
    return props.theme.text.quaternary;
}, function(props) {
    return props.theme.bg.secondary;
});
var CurrentPaginationLink = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CurrentPaginationLink",
    componentId: "sc-0-4"
})(_templateObject7(), paginationLinkStyles, function(props) {
    return props.theme.colors.maybeBlue500;
}, function(props) {
    return props.theme.colors.base0;
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-left/index.js
var chevron_left = __webpack_require__(22062);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(46695);
;// CONCATENATED MODULE: ./src/components/number-pagination/pagination-item.tsx





var PaginationItem = function(param) {
    var item = param.item, linkToPage = param.linkToPage, onClick = param.onClick;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var label = (0,react.useMemo)(function() {
        switch(item.type){
            case "prev":
                return /*#__PURE__*/ react.createElement(chevron_left.IconChevronLeft, null);
            case "next":
                return /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, null);
            default:
                return /*#__PURE__*/ react.createElement(react.Fragment, null, item.pageNumber);
        }
    }, [
        item.type,
        item.pageNumber
    ]);
    var ariaLabel = (0,react.useMemo)(function() {
        switch(item.type){
            case "prev":
                return t("symbols", "symbol.show-prev");
            case "next":
                return t("symbols", "symbol.show-next");
            default:
                return t("common", "pagination.page-number", {
                    number: item.pageNumber
                });
        }
    }, [
        item.type,
        item.pageNumber,
        t
    ]);
    var onClickHandler = (0,react.useCallback)(function() {
        return typeof onClick === "function" && onClick(item);
    }, [
        item,
        onClick
    ]);
    if (item.disabled) {
        return /*#__PURE__*/ react.createElement(DisabledPaginationLink, null, label);
    }
    if (item.isCurrent) {
        return /*#__PURE__*/ react.createElement(CurrentPaginationLink, {
            "data-test": "CurrentPaginationLink"
        }, label);
    }
    return /*#__PURE__*/ react.createElement(PaginationLink, {
        to: linkToPage(item.pageNumber),
        "data-test": "PaginationLink",
        "data-test-page": item.pageNumber,
        onClick: onClickHandler,
        "aria-label": ariaLabel
    }, label);
};
/* harmony default export */ const pagination_item = (PaginationItem);

;// CONCATENATED MODULE: ./src/components/number-pagination/index.tsx




var NumberPagination = function(param) {
    var currentPage = param.currentPage, totalPages = param.totalPages, linkToPage = param.linkToPage, onClick = param.onClick, alwaysShowStepButtons = param.alwaysShowStepButtons;
    var paginationItems = (0,react.useMemo)(function() {
        return getPaginationItems(currentPage, totalPages, {
            alwaysShowStepButtons: alwaysShowStepButtons
        });
    }, [
        currentPage,
        totalPages,
        alwaysShowStepButtons
    ]);
    return /*#__PURE__*/ react.createElement(Pagination, {
        "data-test": "Pagination"
    }, paginationItems.map(function(item) {
        return /*#__PURE__*/ react.createElement(PaginationListItem, {
            key: "".concat(item.type, ":").concat(item.pageNumber),
            indicateOmittedPages: item.indicateOmittedPages,
            omitOnSmallDevices: item.omitOnSmallDevices
        }, /*#__PURE__*/ react.createElement(pagination_item, {
            item: item,
            linkToPage: linkToPage,
            onClick: onClick
        }));
    }));
};


/***/ }),

/***/ 53692:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mr": () => (/* reexport */ SIZE),
  "WX": () => (/* binding */ ProductCheckbox),
  "lo": () => (/* reexport */ hoverStyle)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/check/index.js
var check = __webpack_require__(35964);
;// CONCATENATED MODULE: ./src/components/product-checkbox/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  box-shadow: inset 0 0 0 2px ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  align-self: center;\n  background: ",
        ";\n  box-shadow: inset 0 0 0 1px ",
        ";\n  color: ",
        ";\n  border-radius: 3px;\n  cursor: pointer;\n  height: ",
        "px;\n  width: ",
        "px;\n  flex: 0 0 auto;\n  transition:\n    0.05s box-shadow linear,\n    0.05s background-color linear;\n\n  &:hover {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  appearance: none;\n  outline: 0;\n  opacity: 0;\n  position: absolute;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var SIZE = 20;
var hoverStyle = (0,styled_components_browser_esm.css)(_templateObject(), function(props) {
    return props.theme.bg.productCompare;
});
var Wrapper = styled_components_browser_esm["default"].label.attrs({
    "data-test": "ProductCheckbox"
}).withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.selected ? props.theme.bg.productCompare : "transparent";
}, function(props) {
    return props.theme.bg.productCompare;
}, function(props) {
    return props.theme.colors.base0;
}, SIZE, SIZE, hoverStyle);
var Input = styled_components_browser_esm["default"].input.attrs({
    type: "checkbox"
}).withConfig({
    displayName: "Input",
    componentId: "sc-0-1"
})(_templateObject2());
var Icon = (0,styled_components_browser_esm["default"])(check/* IconCheck */.N).attrs({
    size: SIZE
}).withConfig({
    displayName: "Icon",
    componentId: "sc-0-2"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/components/product-checkbox/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var ProductCheckbox = function(_param) {
    var selected = _param.selected, name = _param.name, onSelect = _param.onSelect, onDeselect = _param.onDeselect, wrapperProps = _objectWithoutProperties(_param, [
        "selected",
        "name",
        "onSelect",
        "onDeselect"
    ]);
    var onChange = (0,react.useCallback)(function(e) {
        return e.target.checked ? onSelect === null || onSelect === void 0 ? void 0 : onSelect() : onDeselect === null || onDeselect === void 0 ? void 0 : onDeselect();
    }, [
        onSelect,
        onDeselect
    ]);
    return /*#__PURE__*/ react.createElement(Wrapper, _extends({
        selected: selected
    }, wrapperProps), /*#__PURE__*/ react.createElement(Input, {
        id: name,
        name: name,
        type: "checkbox",
        checked: selected,
        onChange: onChange,
        tabIndex: 0,
        value: selected ? "1" : "0"
    }), selected && /*#__PURE__*/ react.createElement(Icon, null));
};


/***/ }),

/***/ 24562:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ product_row)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/offer/price/price-label/index.tsx + 1 modules
var price_label = __webpack_require__(75695);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(34990);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/product-checkbox/index.tsx + 1 modules
var product_checkbox = __webpack_require__(53692);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
;// CONCATENATED MODULE: ./src/components/product-row/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding: 5px 10px;\n  outline: none;\n\n  :hover::after,\n  :focus::after {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom: 1px solid ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        " {\n        padding-left: ",
        "px;\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "::before {\n        ",
        "\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  line-height: 1.2em;\n  min-height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  ",
        "\n  ",
        "\n  ",
        "\n\n  .pj-ui-product-core-properties {\n    margin: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  margin-right: 10px;\n  background: ",
        ";\n  border-radius: ",
        ";\n\n  .pj-ui-product-image {\n    display: block;\n    max-width: 40px;\n    max-height: 40px;\n    width: auto;\n    height: auto;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 100%;\n  margin-right: 3px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  :not(:last-child) {\n    margin-bottom: 1px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 12px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  margin-left: 10px;\n  white-space: nowrap;\n  text-align: right;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  font-size: 12px;\n  color: ",
        ";\n  fill: ",
        ";\n  align-items: center;\n\n  svg {\n    height: 16px !important;\n    width: 16px !important;\n    margin-left: 2px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  left: ",
        ";\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n\n  ",
        ":hover & {\n    ",
        "\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  min-width: 80px;\n  margin: ",
        ";\n  display: flex;\n  justify-content: end;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: -",
        ";\n  z-index: 2;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}




var ProductLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ProductLink",
    componentId: "sc-0-0"
})(_templateObject(), base/* styledUtils.overlay */.au.overlay());
var Row = styled_components_browser_esm["default"].div.attrs({
    "data-test": "ProductRow"
}).withConfig({
    displayName: "Row",
    componentId: "sc-0-1"
})(_templateObject4(), function(props) {
    return props.showDivider && (0,styled_components_browser_esm.css)(_templateObject1(), function(p) {
        return p.theme.lines.primary;
    });
}, function(props) {
    return props.selectable && (0,styled_components_browser_esm.css)(_templateObject2(), ProductLink, product_checkbox/* PRODUCT_CHECKBOX_SIZE */.mr + (0,base/* pixelCalc */.A)(base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
}, function(props) {
    return props.selected && (0,styled_components_browser_esm.css)(_templateObject3(), ProductLink, base/* styledUtils.overlay */.au.overlay(props.theme.bg.productCompareLight));
});
var ProductImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductImage",
    componentId: "sc-0-2"
})(_templateObject5(), function(p) {
    return p.theme.colors.base200;
}, base/* layout.borderRadius */.bK.borderRadius);
var BasicInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BasicInfo",
    componentId: "sc-0-3"
})(_templateObject6());
var ProductName = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductName",
    componentId: "sc-0-4"
})(_templateObject7());
var Subtitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-5"
})(_templateObject8(), function(p) {
    return p.theme.text.tertiary;
});
var PriceLabelWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "PriceLabelWrapper",
    componentId: "sc-0-6"
})(_templateObject9());
var StoreCount = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StoreCount",
    componentId: "sc-0-7"
})(_templateObject10(), function(p) {
    return p.theme.text.tertiary;
}, function(p) {
    return p.theme.icons.tertiary;
});
var Gutter = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Gutter",
    componentId: "sc-0-8"
})(_templateObject11());
var SelectBox = (0,styled_components_browser_esm["default"])(product_checkbox/* ProductCheckbox */.WX).withConfig({
    displayName: "SelectBox",
    componentId: "sc-0-9"
})(_templateObject12(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, Row, product_checkbox/* productCheckboxHoverStyle */.lo);
var CampaignBadgeWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CampaignBadgeWrapper",
    componentId: "sc-0-10"
})(_templateObject13(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var CampaignBadge = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CampaignBadge",
    componentId: "sc-0-11"
})(_templateObject14(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/shopping-cart/index.js
var shopping_cart = __webpack_require__(54234);
;// CONCATENATED MODULE: ./src/components/product-row/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}





var ProductRow = function(param) {
    var onClick = param.onClick, linkAttributes = param.linkAttributes, _link = param.link, link = _link === void 0 ? "" : _link, image = param.image, name = param.name, rating = param.rating, subtitle = param.subtitle, campaignBadge = param.campaignBadge, ratingCount = param.ratingCount, _ratingCountTranslation = param.ratingCountTranslation, ratingCountTranslation = _ratingCountTranslation === void 0 ? {
        domain: "product",
        key: "product-card.n-ratings"
    } : _ratingCountTranslation, price = param.price, storesCount = param.storesCount, storesCountText = param.storesCountText, children = param.children, className = param.className, showDivider = param.showDivider, selectable = param.selectable, selected = param.selected, onSelect = param.onSelect, onDeselect = param.onDeselect;
    var onToggle = selected ? onDeselect : onSelect;
    var clickHandler = (0,react.useCallback)(function(e) {
        if (selectable) {
            e.preventDefault();
            onToggle === null || onToggle === void 0 ? void 0 : onToggle();
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [
        selectable,
        onToggle,
        onClick
    ]);
    return /*#__PURE__*/ react.createElement(Row, {
        className: className,
        showDivider: showDivider,
        selectable: selectable,
        selected: selected
    }, /*#__PURE__*/ react.createElement(ProductLink, _extends({
        onClick: clickHandler
    }, linkAttributes || {}, {
        to: link,
        "aria-label": name
    }), image && /*#__PURE__*/ react.createElement(ProductImage, null, image), /*#__PURE__*/ react.createElement(BasicInfo, null, /*#__PURE__*/ react.createElement(ProductName, null, name), rating ? /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        hide: rating === null,
        rate: rating,
        showRate: true,
        size: "small",
        count: ratingCount,
        countTranslation: ratingCountTranslation,
        showCounter: true
    }) : null, subtitle && /*#__PURE__*/ react.createElement(Subtitle, null, subtitle)), campaignBadge && /*#__PURE__*/ react.createElement(CampaignBadgeWrapper, null, /*#__PURE__*/ react.createElement(CampaignBadge, null, campaignBadge)), price && /*#__PURE__*/ react.createElement(PriceLabelWrapper, null, /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
        value: price
    }), storesCount !== null && /*#__PURE__*/ react.createElement(StoreCount, {
        title: storesCountText
    }, /*#__PURE__*/ react.createElement("span", null, storesCount), " ", /*#__PURE__*/ react.createElement(shopping_cart/* IconShoppingCart */.w, {
        color: "base500"
    })))), children && /*#__PURE__*/ react.createElement(Gutter, null, children), selectable && /*#__PURE__*/ react.createElement(SelectBox, {
        selected: selected,
        onSelect: onSelect,
        onDeselect: onDeselect,
        "aria-label": name
    }));
};
/* harmony default export */ const product_row = (ProductRow);


/***/ }),

/***/ 57920:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ user_product_feedback)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(7336);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/modal/index.js
var modal = __webpack_require__(58709);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(71016);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/modal-v2/index.tsx
var modal_v2 = __webpack_require__(42574);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(24005);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/light-theme-colors.js
var light_theme_colors = __webpack_require__(24774);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(714);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(32741);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/components/user-product-feedback/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    padding-bottom: 0;\n    padding-top: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  padding-bottom: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      min-height: 110px;\n      margin-left: 0;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n        margin-left: 0;\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      margin-left: ",
        ";\n\n      ",
        "\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    min-height: 132px;\n    background-color: ",
        ";\n    padding: ",
        ";\n    border-radius: ",
        ";\n    display: flex;\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin: auto;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  padding-left: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        ";\n  padding-top: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        ";\n  padding-top: ",
        ";\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  margin: ",
        " 0;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  textarea {\n    resize: none;\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    visibility: ",
        ";\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 0.7rem;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  padding-bottom: ",
        ";\n  justify-content: flex-end;\n  display: flex;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}






var UserQuestion = styled_components_browser_esm["default"].div.withConfig({
    displayName: "UserQuestion",
    componentId: "sc-0-0"
})(_templateObject1(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200, base/* media.smallDown */.BC.smallDown(_templateObject(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200));
var UserQuestionBox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "UserQuestionBox",
    componentId: "sc-0-1"
})(function(param) {
    var _$withLeftMargin = param.$withLeftMargin, $withLeftMargin = _$withLeftMargin === void 0 ? true : _$withLeftMargin;
    return (0,styled_components_browser_esm.css)(_templateObject5(), light_theme_colors.staticMaybeBlue100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.smallDown */.BC.smallDown(_templateObject2()), $withLeftMargin && (0,styled_components_browser_esm.css)(_templateObject4(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallDown */.BC.smallDown(_templateObject3())));
});
var QuestionImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "QuestionImage",
    componentId: "sc-0-2"
})(_templateObject6());
var QuestionText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "QuestionText",
    componentId: "sc-0-3"
})(_templateObject7(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var QuestionModalBody = styled_components_browser_esm["default"].div.withConfig({
    displayName: "QuestionModalBody",
    componentId: "sc-0-4"
})(_templateObject8(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing200 */.bK.measurements.spacing200);
var QuestionModalBodyCenteredContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "QuestionModalBodyCenteredContent",
    componentId: "sc-0-5"
})(_templateObject9(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing200 */.bK.measurements.spacing200);
var BodyMediumTextCentered = (0,styled_components_browser_esm["default"])(text_variants.H4Text).withConfig({
    displayName: "BodyMediumTextCentered",
    componentId: "sc-0-6"
})(_templateObject10(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var QuestionTextInput = (0,styled_components_browser_esm["default"])(inputs/* TextArea */.Kx).withConfig({
    displayName: "QuestionTextInput",
    componentId: "sc-0-7"
})(_templateObject11(), base/* layout.borderRadius */.bK.borderRadius);
var StrongTextWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StrongTextWrapper",
    componentId: "sc-0-8"
})(_templateObject12(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var SetTooltip = (0,styled_components_browser_esm["default"])(tooltip/* Tooltip */.u).withConfig({
    displayName: "SetTooltip",
    componentId: "sc-0-9"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject13(), props.visible ? "visible" : "hidden");
});
var StrongText = (0,styled_components_browser_esm["default"])(text_variants.CaptionStrongText).withConfig({
    displayName: "StrongText",
    componentId: "sc-0-10"
})(_templateObject14());
var WordCount = (0,styled_components_browser_esm["default"])(text_variants.CaptionStrongText).withConfig({
    displayName: "WordCount",
    componentId: "sc-0-11"
})(_templateObject15(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

// EXTERNAL MODULE: ./src/components/user-product-feedback/useFeedbackEnabled.ts
var useFeedbackEnabled = __webpack_require__(52619);
;// CONCATENATED MODULE: ./src/components/user-product-feedback/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}









/**
 * Tracks when a user leaves feedback for a product collection
 * @param userMessage message that the user left
 */ var trackProductCollectionUserProductFeedback = function(userMessage) {
    (0,data_layer/* pushEvent */.AB)("productCollectionUserProductFeedback", {
        userMessage: userMessage
    });
};
var UserProductFeedback = function(param) {
    var withLeftMargin = param.withLeftMargin;
    var ref = (0,app_context/* useAppContext */.bp)(), t = ref.t, market = ref.market;
    var ref1 = _slicedToArray((0,react.useState)(false), 2), isQuestionModalOpen = ref1[0], setIsQuestionModalOpen = ref1[1];
    var ref2 = _slicedToArray((0,react.useState)(false), 2), isQuestionnaireSent = ref2[0], setIsQuestionnaireSent = ref2[1];
    var ref3 = _slicedToArray((0,react.useState)(""), 2), questionnaireInputText = ref3[0], setQuestionnaireInputText = ref3[1];
    var feedbackEnabled = (0,useFeedbackEnabled/* useFeedbackEnabled */.F)();
    var imageSrcQuestionBox = "".concat(market.cdn, "/g/rfe/feedback/question-box.png");
    var imageSrcThankYouThumb = "".concat(market.cdn, "/g/rfe/illustrations/thumb-up-144px.png");
    var MAX_AMOUNT_OF_CHARACTERS = 250;
    var sendQuestionnaire = function() {
        var questionnaireInputTextModified = removeEmail(questionnaireInputText);
        setIsQuestionnaireSent(true);
        if (questionnaireInputTextModified.length > 0) {
            trackProductCollectionUserProductFeedback(questionnaireInputTextModified);
        }
    };
    if (!feedbackEnabled) {
        return null;
    }
    var removeEmail = function(value) {
        var regex = /\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+/;
        return value.replace(regex, "");
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(UserQuestion, null, /*#__PURE__*/ react.createElement(UserQuestionBox, {
        $withLeftMargin: withLeftMargin
    }, /*#__PURE__*/ react.createElement(QuestionImage, {
        src: imageSrcQuestionBox,
        height: "56",
        width: "56"
    }), /*#__PURE__*/ react.createElement(QuestionText, null, /*#__PURE__*/ react.createElement(text_variants.H4Text, null, t("feedback", "uup.product-feedback-title")), /*#__PURE__*/ react.createElement(variants.PrimaryButton, {
        onClick: function() {
            return setIsQuestionModalOpen(true);
        }
    }, t("feedback", "uup.tip-us"))))), isQuestionModalOpen ? /*#__PURE__*/ react.createElement(modal_v2/* default */.Z, {
        isOpen: true,
        onRequestClose: function() {
            setIsQuestionModalOpen(false);
            setIsQuestionnaireSent(false);
        },
        size: modal/* ModalSizeEnum.SMALL */.E$.SMALL
    }, isQuestionnaireSent ? /*#__PURE__*/ react.createElement(QuestionModalBodyCenteredContent, null, /*#__PURE__*/ react.createElement(QuestionImage, {
        src: imageSrcThankYouThumb,
        height: "72",
        width: "72"
    }), /*#__PURE__*/ react.createElement(BodyMediumTextCentered, null, t("feedback", "uup.thank-you"))) : /*#__PURE__*/ react.createElement(QuestionModalBody, null, /*#__PURE__*/ react.createElement(text_variants.BodyMediumText, null, t("feedback", "uup.product-feedback-explanation")), /*#__PURE__*/ react.createElement(StrongTextWrapper, null, /*#__PURE__*/ react.createElement(StrongText, null, t("feedback", "dialog.personal-information-warning"))), /*#__PURE__*/ react.createElement(QuestionTextInput, {
        name: "QuestionnaireInput",
        onChange: function(e) {
            return setQuestionnaireInputText(e.target.value);
        }
    }), /*#__PURE__*/ react.createElement(WordCount, null, questionnaireInputText.length, "/", MAX_AMOUNT_OF_CHARACTERS), /*#__PURE__*/ react.createElement(variants.PrimaryButton, {
        disabled: questionnaireInputText.length === 0 || questionnaireInputText.length > MAX_AMOUNT_OF_CHARACTERS,
        onClick: sendQuestionnaire
    }, t("feedback", "dialog.send-button")))) : null);
};
/* harmony default export */ const user_product_feedback = (UserProductFeedback);


/***/ }),

/***/ 52619:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": () => (/* binding */ useFeedbackEnabled)
/* harmony export */ });
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25349);

function useFeedbackEnabled() {
    var market = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_0__/* .useAppContext */ .bp)().market;
    return market.code === "se";
}


/***/ }),

/***/ 55330:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ word_cloud)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/areas/product-collection/tracking.ts
var tracking = __webpack_require__(96772);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(46695);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
;// CONCATENATED MODULE: ./src/components/word-cloud/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0;\n  max-width: 250px;\n  margin: 4px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin: ",
        ";\n  overflow: hidden;\n  max-width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var Title = (0,styled_components_browser_esm["default"])(variants.H3Text).withConfig({
    displayName: "Title",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ShowMoreButton = styled_components_browser_esm["default"].li.withConfig({
    displayName: "ShowMoreButton",
    componentId: "sc-0-1"
})(_templateObject1());
var ShowMoreIcon = (0,styled_components_browser_esm["default"])(chevron_right.IconChevronRight).attrs({
    size: 16
}).withConfig({
    displayName: "ShowMoreIcon",
    componentId: "sc-0-2"
})(_templateObject2());
var List = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "List",
    componentId: "sc-0-3"
})(_templateObject3());
var ListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "ListItem",
    componentId: "sc-0-4"
})(_templateObject4(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(7336);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/magnifier/index.js
var magnifier = __webpack_require__(38314);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(49955);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking_tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/components/word-cloud/index.tsx









var WordCloud = function(param) {
    var title = param.title, items = param.items, showMoreUrl = param.showMoreUrl, numberOfVisibleItems = param.numberOfVisibleItems, className = param.className;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var onClickWord = (0,react.useCallback)(function(event, index) {
        var href = event.currentTarget.getAttribute("href");
        (0,tracking/* trackProductCollectionWordCloudClick */._P)(href);
        (0,tracking_tracking/* trackInternalNavigationClick */.p)({
            scope: tracking_tracking/* InternalNavigationScope.RELATED_SEARCHES_WORD */.U.RELATED_SEARCHES_WORD,
            nextPage: href,
            index: index
        });
    }, []);
    var onClickShowMore = (0,react.useCallback)(function(event) {
        var href = event.currentTarget.getAttribute("href");
        (0,tracking/* trackProductCollectionWordCloudClick */._P)(href);
        (0,tracking_tracking/* trackInternalNavigationClick */.p)({
            scope: tracking_tracking/* InternalNavigationScope.RELATED_SEARCHES_SHOW_MORE */.U.RELATED_SEARCHES_SHOW_MORE,
            nextPage: href
        });
    }, []);
    var wordCloudItems = numberOfVisibleItems ? items.slice(0, numberOfVisibleItems) : items;
    return /*#__PURE__*/ react.createElement("div", {
        className: className
    }, /*#__PURE__*/ react.createElement(Title, null, title), /*#__PURE__*/ react.createElement(List, null, wordCloudItems.map(function(param, index) {
        var name = param.name, url = param.url;
        return /*#__PURE__*/ react.createElement(ListItem, {
            key: url
        }, /*#__PURE__*/ react.createElement(button_variants.TonalButton, {
            size: button_variants.ButtonSize.SMALL,
            onClick: function(e) {
                return onClickWord(e, index);
            },
            container: clickable/* Clickable */.P,
            containerProps: {
                to: url,
                title: name
            },
            fullWidth: true
        }, /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(magnifier/* IconMagnifier */.j, null)), /*#__PURE__*/ react.createElement(button_variants.ButtonText, {
            behavior: ui_text.Behavior.OnelineEllipsis
        }, name)));
    }), showMoreUrl && /*#__PURE__*/ react.createElement(ShowMoreButton, null, /*#__PURE__*/ react.createElement(button_variants.TonalButton, {
        container: clickable/* Clickable */.P,
        containerProps: {
            to: showMoreUrl
        },
        onClick: onClickShowMore,
        size: button_variants.ButtonSize.SMALL
    }, /*#__PURE__*/ react.createElement(button_variants.ButtonText, null, t("common", "button.show-more")), /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(ShowMoreIcon, null))))));
};
/* harmony default export */ const word_cloud = (WordCloud);


/***/ }),

/***/ 51836:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": () => (/* binding */ useCompareProductsSelection)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var MAX_PRODUCTS_TO_COMPARE = 40;
/**
 * Does not store state in a context or anything like that, so you cannot use
 * it multiple times in the same context/page and expect state to be shared across usages
 */ var useCompareProductsSelection = function() {
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), isSelectingProducts = ref[0], setIsSelectingProducts = ref[1];
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), 2), selectedProducts = ref1[0], setSelectedProducts = ref1[1];
    var startProductSelection = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setIsSelectingProducts(true);
    }, []);
    var abortProductSelection = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setIsSelectingProducts(false);
        setSelectedProducts([]);
    }, []);
    var selectProduct = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(product) {
        if (selectedProducts.some(function(param) {
            var id = param.id;
            return id === product.id;
        }) || selectedProducts.length > MAX_PRODUCTS_TO_COMPARE) {
            return;
        }
        var products = _toConsumableArray(selectedProducts).concat([
            product
        ]);
        setSelectedProducts(products);
    }, [
        selectedProducts
    ]);
    var deselectProduct = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(product) {
        var products = selectedProducts.filter(function(param) {
            var id = param.id;
            return id !== product.id;
        });
        setSelectedProducts(products);
    }, [
        selectedProducts
    ]);
    return {
        isSelectingProducts: isSelectingProducts,
        selectedProducts: selectedProducts,
        startProductSelection: startProductSelection,
        abortProductSelection: abortProductSelection,
        selectProduct: selectProduct,
        deselectProduct: deselectProduct
    };
};


/***/ })

}]);